// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Asphalt_Default = {
  Default: {
    templateId: 420,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_CT_Landmark_Pro = {
  L: {
    CT_Landmark: {
      CT_Landmark_BlackShadow: {
        layerConfigId: 275,
        templateId: 129,
      },
      CT_Landmark_BlackWalnut: {
        layerConfigId: 233,
        templateId: 129,
      },
      CT_Landmark_BurntSienna: {
        layerConfigId: 234,
        templateId: 129,
      },
      CT_Landmark_CharcoalBlack: {
        layerConfigId: 20,
        templateId: 129,
      },
      CT_Landmark_CinderBlack: {
        layerConfigId: 235,
        templateId: 129,
      },
      CT_Landmark_CobblestoneGray: {
        layerConfigId: 236,
        templateId: 129,
      },
      CT_Landmark_ColonialSlate: {
        layerConfigId: 237,
        templateId: 129,
      },
      CT_Landmark_Driftwood: {
        layerConfigId: 21,
        templateId: 129,
      },
      CT_Landmark_GeorgetownGray: {
        layerConfigId: 22,
        templateId: 129,
      },
      CT_Landmark_GeorgetownGray_MaxDef: {
        layerConfigId: 88,
        templateId: 129,
      },
      CT_Landmark_HeatherBlend: {
        layerConfigId: 23,
        templateId: 129,
      },
      CT_Landmark_HunterGreen: {
        layerConfigId: 238,
        templateId: 129,
      },
      CT_Landmark_MoireBlack: {
        layerConfigId: 24,
        templateId: 129,
      },
      CT_Landmark_MoireBlack_MaxDef: {
        layerConfigId: 239,
        templateId: 129,
      },
      CT_Landmark_MojaveTan: {
        layerConfigId: 240,
        templateId: 129,
      },
      CT_Landmark_PaintedDesert: {
        layerConfigId: 241,
        templateId: 129,
      },
      CT_Landmark_Pewter: {
        layerConfigId: 242,
        templateId: 129,
      },
      CT_Landmark_Pewterwood: {
        layerConfigId: 243,
        templateId: 129,
      },
      CT_Landmark_ResawnShake: {
        layerConfigId: 244,
        templateId: 129,
      },
      CT_Landmark_SilverBirch: {
        layerConfigId: 245,
        templateId: 129,
      },
      CT_Landmark_SlateGray: {
        layerConfigId: 644,
        templateId: 129,
      },
      CT_Landmark_SunriseCedar: {
        layerConfigId: 246,
        templateId: 129,
      },
      CT_Landmark_ThunderstormGray: {
        layerConfigId: 247,
        templateId: 129,
      },
      CT_Landmark_WeatheredWood: {
        layerConfigId: 25,
        templateId: 129,
      },
      CT_Landmark_WeatheredWood_MaxDef: {
        layerConfigId: 89,
        templateId: 129,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Carpet = {
  L: {
    Carpet_Texture: {
      Carpet_Texture_Oatmeal: {
        layerConfigId: 0,
        templateId: 0,
      },
      Carpet_Texture_Rawwood: {
        layerConfigId: 1,
        templateId: 0,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Color = {
  C: {
    templateId: 2,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Color_PlanFloor = {
  Default: {
    templateId: 1,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Floor_Concrete = {
  C: {
    templateId: 3,
  },
  Default: {
    templateId: 3,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Floor_ConcreteBroomFinish = {
  C: {
    templateId: 492,
  },
  Default: {
    templateId: 492,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Floor_Tile = {
  Default: {
    templateId: 5,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Floor_Tile_Carrara = {
  Default: {
    templateId: 4,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Floor_Vinyl = {
  Default: {
    templateId: 483,
  },
  L: {
    Vinyl_Duradek: {
      Vinyl_Duradek_SupremeSonomaChip: {
        layerConfigId: 1071,
        templateId: 483,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Floor_Vinyl_NaturalStone = {
  L: {
    Vinyl_TrafficMaster: {
      VinylStone_NaturalSlate: {
        layerConfigId: 102,
        templateId: 107,
      },
      VinylStone_NaturalSlateGray: {
        layerConfigId: 1243,
        templateId: 107,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Floor_Wood = {
  Default: {
    templateId: 6,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Garage = {
  C: {
    templateId: 7,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Glass_Base = {
  Default: {
    templateId: 8,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Grass_Lawn_01 = {
  Default: {
    templateId: 10,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Gravel = {
  Default: {
    templateId: 106,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Gutter = {
  C: {
    templateId: 11,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Lattice_45deg_1x1 = {
  C: {
    templateId: 146,
  },
  Default: {
    templateId: 146,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickDoubleMonarch_StackBond = {
  C: {
    templateId: 458,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 458,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 458,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 458,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 458,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 458,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 458,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 458,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 458,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 458,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 458,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 458,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 458,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 458,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 458,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 458,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 458,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 458,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 458,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 458,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 458,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 458,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 458,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 458,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 458,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 458,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 458,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 458,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 458,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 458,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 458,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 458,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 458,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 458,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 458,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 458,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 458,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 458,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 458,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 458,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 458,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 458,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 458,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 458,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 458,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 458,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 458,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 458,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 458,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 458,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 458,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 458,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 458,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 458,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 458,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 458,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 458,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 458,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 458,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 458,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 458,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 458,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 458,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 458,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 458,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 458,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 458,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 458,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 458,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 458,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 458,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 458,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 458,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 458,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 458,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 458,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 458,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 458,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 458,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 458,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 458,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 458,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 458,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 458,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 458,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 458,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 458,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 458,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 458,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 458,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 458,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 458,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 458,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 458,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 458,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 458,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 458,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 458,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 458,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 458,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 458,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 458,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 458,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 458,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 458,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 458,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 458,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 458,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 458,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 458,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 458,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 458,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 458,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 458,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 458,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 458,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 458,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 458,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 458,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 458,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 458,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 458,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 458,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 458,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 458,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 458,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 458,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 458,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 458,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 458,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 458,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 458,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 458,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 458,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 458,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 458,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 458,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 458,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 458,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 458,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 458,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 458,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 458,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 458,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 458,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 458,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 458,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 458,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 458,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 458,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 458,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 458,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 458,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 458,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 458,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 458,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 458,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 458,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 458,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 458,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 458,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 458,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 458,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 458,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 458,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 458,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 458,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 458,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 458,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 458,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 458,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 458,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 458,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 458,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 458,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 458,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 458,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 458,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 458,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 458,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 458,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 458,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 458,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 458,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 458,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 458,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 458,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 458,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 458,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 458,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 458,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 458,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 458,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 458,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 458,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 458,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 458,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 458,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 458,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 458,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 458,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 458,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 458,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 458,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 458,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 458,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 458,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 458,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 458,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 458,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 458,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 458,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 458,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 458,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 458,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 458,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 458,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 458,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 458,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 458,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 458,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 458,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 458,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 458,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 458,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 458,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 458,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 458,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 458,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 458,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 458,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 458,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 458,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 458,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 458,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 458,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 458,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 458,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 458,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 458,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 458,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 458,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 458,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickEngineer = {
  C: {
    templateId: 470,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 470,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 470,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 470,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 470,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 470,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 470,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 470,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 470,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 470,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 470,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 470,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 470,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 470,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 470,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 470,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 470,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 470,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 470,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 470,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 470,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 470,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 470,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 470,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 470,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 470,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 470,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 470,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 470,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 470,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 470,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 470,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 470,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 470,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 470,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 470,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 470,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 470,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 470,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 470,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 470,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 470,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 470,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 470,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 470,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 470,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 470,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 470,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 470,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 470,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 470,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 470,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 470,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 470,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 470,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 470,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 470,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 470,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 470,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 470,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 470,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 470,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 470,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 470,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 470,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 470,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 470,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 470,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 470,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 470,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 470,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 470,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 470,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 470,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 470,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 470,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 470,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 470,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 470,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 470,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 470,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 470,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 470,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 470,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 470,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 470,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 470,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 470,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 470,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 470,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 470,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 470,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 470,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 470,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 470,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 470,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 470,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 470,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 470,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 470,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 470,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 470,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 470,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 470,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 470,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 470,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 470,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 470,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 470,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 470,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 470,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 470,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 470,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 470,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 470,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 470,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 470,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 470,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 470,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 470,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 470,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 470,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 470,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 470,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 470,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 470,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 470,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 470,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 470,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 470,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 470,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 470,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 470,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 470,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 470,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 470,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 470,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 470,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 470,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 470,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 470,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 470,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 470,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 470,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 470,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 470,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 470,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 470,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 470,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 470,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 470,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 470,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 470,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 470,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 470,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 470,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 470,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 470,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 470,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 470,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 470,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 470,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 470,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 470,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 470,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 470,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 470,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 470,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 470,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 470,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 470,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 470,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 470,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 470,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 470,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 470,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 470,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 470,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 470,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 470,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 470,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 470,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 470,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 470,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 470,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 470,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 470,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 470,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 470,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 470,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 470,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 470,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 470,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 470,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 470,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 470,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 470,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 470,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 470,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 470,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 470,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 470,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 470,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 470,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 470,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 470,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 470,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 470,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 470,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 470,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 470,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 470,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 470,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 470,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 470,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 470,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 470,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 470,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 470,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 470,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 470,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 470,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 470,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 470,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 470,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 470,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 470,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 470,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 470,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 470,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 470,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 470,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 470,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 470,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 470,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 470,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 470,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 470,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 470,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 470,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 470,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 470,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 470,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickEstate = {
  C: {
    templateId: 149,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 149,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 149,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 149,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 149,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 149,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 149,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 149,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 149,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 149,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 149,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 149,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 149,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 149,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 149,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 149,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 149,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 149,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 149,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 149,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 149,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 149,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 149,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 149,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 149,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 149,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 149,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 149,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 149,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 149,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 149,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 149,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 149,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 149,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 149,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 149,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 149,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 149,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 149,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 149,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 149,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 149,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 149,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 149,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 149,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 149,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 149,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 149,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 149,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 149,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 149,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 149,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 149,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 149,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 149,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 149,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 149,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 149,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 149,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 149,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 149,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 149,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 149,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 149,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 149,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 149,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 149,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 149,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 149,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 149,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 149,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 149,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 149,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 149,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 149,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 149,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 149,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 149,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 149,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 149,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 149,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 149,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 149,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 149,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 149,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 149,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 149,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 149,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 149,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 149,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 149,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 149,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 149,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 149,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 149,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 149,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 149,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 149,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 149,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 149,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 149,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 149,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 149,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 149,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 149,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 149,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 149,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 149,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 149,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 149,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 149,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 149,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 149,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 149,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 149,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 149,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 149,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 149,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 149,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 149,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 149,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 149,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 149,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 149,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 149,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 149,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 149,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 149,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 149,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 149,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 149,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 149,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 149,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 149,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 149,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 149,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 149,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 149,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 149,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 149,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 149,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 149,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 149,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 149,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 149,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 149,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 149,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 149,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 149,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 149,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 149,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 149,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 149,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 149,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 149,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 149,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 149,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 149,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 149,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 149,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 149,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 149,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 149,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 149,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 149,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 149,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 149,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 149,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 149,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 149,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 149,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 149,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 149,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 149,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 149,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 149,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 149,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 149,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 149,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 149,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 149,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 149,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 149,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 149,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 149,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 149,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 149,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 149,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 149,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 149,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 149,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 149,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 149,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 149,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 149,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 149,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 149,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 149,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 149,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 149,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 149,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 149,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 149,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 149,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 149,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 149,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 149,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 149,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 149,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 149,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 149,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 149,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 149,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 149,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 149,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 149,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 149,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 149,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 149,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 149,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 149,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 149,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 149,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 149,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 149,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 149,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 149,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 149,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 149,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 149,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 149,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 149,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 149,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 149,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 149,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 149,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 149,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 149,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 149,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 149,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 149,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 149,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 149,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickExecutive = {
  C: {
    templateId: 359,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 359,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 359,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 359,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 359,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 359,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 359,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 359,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 359,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 359,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 359,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 359,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 359,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 359,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 359,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 359,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 359,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 359,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 359,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 359,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 359,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 359,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 359,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 359,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 359,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 359,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 359,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 359,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 359,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 359,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 359,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 359,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 359,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 359,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 359,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 359,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 359,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 359,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 359,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 359,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 359,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 359,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 359,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 359,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 359,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 359,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 359,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 359,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 359,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 359,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 359,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 359,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 359,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 359,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 359,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 359,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 359,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 359,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 359,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 359,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 359,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 359,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 359,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 359,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 359,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 359,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 359,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 359,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 359,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 359,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 359,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 359,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 359,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 359,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 359,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 359,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 359,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 359,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 359,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 359,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 359,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 359,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 359,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 359,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 359,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 359,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 359,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 359,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 359,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 359,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 359,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 359,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 359,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 359,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 359,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 359,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 359,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 359,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 359,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 359,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 359,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 359,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 359,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 359,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 359,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 359,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 359,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 359,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 359,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 359,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 359,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 359,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 359,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 359,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 359,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 359,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 359,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 359,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 359,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 359,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 359,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 359,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 359,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 359,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 359,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 359,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 359,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 359,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 359,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 359,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 359,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 359,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 359,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 359,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 359,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 359,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 359,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 359,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 359,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 359,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 359,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 359,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 359,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 359,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 359,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 359,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 359,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 359,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 359,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 359,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 359,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 359,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 359,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 359,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 359,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 359,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 359,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 359,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 359,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 359,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 359,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 359,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 359,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 359,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 359,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 359,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 359,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 359,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 359,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 359,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 359,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 359,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 359,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 359,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 359,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 359,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 359,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 359,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 359,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 359,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 359,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 359,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 359,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 359,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 359,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 359,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 359,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 359,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 359,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 359,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 359,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 359,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 359,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 359,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 359,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 359,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 359,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 359,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 359,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 359,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 359,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 359,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 359,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 359,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 359,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 359,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 359,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 359,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 359,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 359,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 359,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 359,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 359,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 359,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 359,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 359,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 359,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 359,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 359,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 359,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 359,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 359,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 359,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 359,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 359,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 359,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 359,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 359,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 359,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 359,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 359,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 359,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 359,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 359,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 359,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 359,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 359,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 359,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 359,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 359,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 359,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 359,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 359,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickExecutive_HalfHeight = {
  C: {
    templateId: 354,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 354,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 354,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 354,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 354,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 354,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 354,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 354,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 354,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 354,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 354,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 354,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 354,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 354,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 354,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 354,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 354,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 354,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 354,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 354,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 354,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 354,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 354,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 354,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 354,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 354,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 354,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 354,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 354,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 354,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 354,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 354,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 354,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 354,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 354,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 354,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 354,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 354,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 354,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 354,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 354,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 354,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 354,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 354,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 354,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 354,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 354,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 354,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 354,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 354,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 354,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 354,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 354,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 354,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 354,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 354,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 354,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 354,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 354,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 354,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 354,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 354,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 354,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 354,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 354,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 354,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 354,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 354,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 354,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 354,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 354,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 354,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 354,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 354,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 354,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 354,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 354,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 354,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 354,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 354,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 354,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 354,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 354,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 354,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 354,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 354,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 354,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 354,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 354,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 354,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 354,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 354,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 354,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 354,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 354,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 354,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 354,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 354,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 354,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 354,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 354,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 354,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 354,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 354,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 354,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 354,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 354,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 354,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 354,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 354,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 354,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 354,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 354,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 354,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 354,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 354,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 354,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 354,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 354,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 354,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 354,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 354,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 354,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 354,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 354,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 354,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 354,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 354,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 354,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 354,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 354,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 354,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 354,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 354,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 354,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 354,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 354,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 354,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 354,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 354,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 354,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 354,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 354,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 354,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 354,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 354,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 354,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 354,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 354,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 354,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 354,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 354,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 354,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 354,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 354,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 354,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 354,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 354,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 354,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 354,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 354,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 354,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 354,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 354,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 354,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 354,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 354,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 354,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 354,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 354,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 354,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 354,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 354,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 354,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 354,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 354,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 354,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 354,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 354,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 354,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 354,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 354,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 354,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 354,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 354,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 354,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 354,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 354,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 354,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 354,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 354,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 354,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 354,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 354,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 354,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 354,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 354,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 354,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 354,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 354,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 354,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 354,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 354,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 354,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 354,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 354,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 354,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 354,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 354,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 354,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 354,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 354,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 354,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 354,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 354,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 354,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 354,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 354,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 354,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 354,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 354,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 354,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 354,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 354,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 354,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 354,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 354,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 354,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 354,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 354,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 354,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 354,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 354,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 354,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 354,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 354,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 354,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 354,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 354,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 354,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 354,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 354,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 354,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickExecutive_Header = {
  C: {
    templateId: 355,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 355,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 355,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 355,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 355,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 355,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 355,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 355,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 355,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 355,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 355,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 355,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 355,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 355,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 355,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 355,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 355,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 355,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 355,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 355,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 355,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 355,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 355,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 355,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 355,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 355,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 355,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 355,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 355,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 355,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 355,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 355,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 355,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 355,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 355,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 355,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 355,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 355,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 355,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 355,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 355,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 355,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 355,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 355,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 355,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 355,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 355,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 355,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 355,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 355,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 355,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 355,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 355,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 355,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 355,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 355,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 355,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 355,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 355,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 355,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 355,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 355,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 355,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 355,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 355,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 355,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 355,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 355,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 355,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 355,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 355,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 355,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 355,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 355,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 355,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 355,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 355,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 355,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 355,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 355,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 355,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 355,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 355,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 355,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 355,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 355,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 355,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 355,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 355,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 355,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 355,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 355,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 355,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 355,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 355,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 355,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 355,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 355,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 355,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 355,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 355,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 355,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 355,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 355,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 355,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 355,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 355,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 355,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 355,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 355,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 355,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 355,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 355,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 355,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 355,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 355,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 355,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 355,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 355,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 355,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 355,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 355,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 355,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 355,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 355,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 355,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 355,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 355,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 355,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 355,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 355,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 355,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 355,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 355,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 355,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 355,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 355,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 355,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 355,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 355,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 355,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 355,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 355,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 355,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 355,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 355,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 355,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 355,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 355,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 355,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 355,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 355,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 355,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 355,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 355,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 355,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 355,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 355,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 355,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 355,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 355,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 355,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 355,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 355,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 355,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 355,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 355,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 355,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 355,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 355,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 355,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 355,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 355,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 355,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 355,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 355,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 355,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 355,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 355,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 355,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 355,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 355,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 355,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 355,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 355,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 355,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 355,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 355,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 355,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 355,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 355,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 355,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 355,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 355,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 355,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 355,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 355,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 355,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 355,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 355,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 355,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 355,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 355,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 355,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 355,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 355,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 355,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 355,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 355,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 355,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 355,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 355,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 355,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 355,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 355,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 355,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 355,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 355,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 355,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 355,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 355,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 355,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 355,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 355,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 355,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 355,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 355,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 355,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 355,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 355,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 355,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 355,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 355,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 355,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 355,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 355,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 355,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 355,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 355,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 355,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 355,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 355,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 355,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickExecutive_Herringbone = {
  C: {
    templateId: 356,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 356,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 356,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 356,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 356,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 356,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 356,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 356,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 356,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 356,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 356,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 356,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 356,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 356,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 356,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 356,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 356,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 356,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 356,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 356,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 356,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 356,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 356,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 356,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 356,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 356,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 356,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 356,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 356,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 356,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 356,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 356,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 356,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 356,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 356,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 356,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 356,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 356,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 356,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 356,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 356,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 356,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 356,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 356,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 356,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 356,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 356,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 356,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 356,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 356,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 356,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 356,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 356,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 356,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 356,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 356,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 356,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 356,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 356,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 356,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 356,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 356,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 356,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 356,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 356,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 356,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 356,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 356,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 356,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 356,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 356,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 356,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 356,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 356,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 356,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 356,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 356,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 356,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 356,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 356,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 356,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 356,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 356,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 356,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 356,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 356,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 356,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 356,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 356,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 356,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 356,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 356,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 356,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 356,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 356,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 356,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 356,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 356,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 356,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 356,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 356,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 356,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 356,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 356,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 356,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 356,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 356,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 356,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 356,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 356,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 356,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 356,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 356,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 356,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 356,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 356,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 356,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 356,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 356,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 356,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 356,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 356,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 356,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 356,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 356,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 356,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 356,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 356,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 356,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 356,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 356,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 356,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 356,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 356,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 356,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 356,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 356,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 356,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 356,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 356,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 356,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 356,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 356,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 356,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 356,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 356,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 356,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 356,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 356,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 356,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 356,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 356,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 356,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 356,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 356,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 356,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 356,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 356,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 356,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 356,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 356,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 356,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 356,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 356,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 356,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 356,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 356,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 356,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 356,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 356,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 356,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 356,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 356,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 356,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 356,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 356,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 356,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 356,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 356,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 356,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 356,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 356,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 356,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 356,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 356,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 356,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 356,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 356,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 356,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 356,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 356,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 356,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 356,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 356,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 356,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 356,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 356,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 356,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 356,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 356,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 356,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 356,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 356,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 356,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 356,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 356,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 356,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 356,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 356,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 356,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 356,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 356,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 356,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 356,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 356,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 356,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 356,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 356,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 356,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 356,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 356,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 356,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 356,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 356,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 356,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 356,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 356,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 356,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 356,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 356,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 356,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 356,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 356,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 356,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 356,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 356,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 356,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 356,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 356,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 356,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 356,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 356,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 356,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickExecutive_Rowlock = {
  C: {
    templateId: 357,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 357,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 357,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 357,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 357,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 357,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 357,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 357,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 357,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 357,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 357,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 357,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 357,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 357,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 357,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 357,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 357,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 357,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 357,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 357,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 357,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 357,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 357,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 357,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 357,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 357,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 357,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 357,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 357,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 357,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 357,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 357,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 357,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 357,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 357,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 357,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 357,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 357,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 357,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 357,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 357,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 357,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 357,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 357,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 357,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 357,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 357,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 357,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 357,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 357,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 357,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 357,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 357,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 357,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 357,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 357,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 357,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 357,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 357,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 357,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 357,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 357,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 357,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 357,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 357,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 357,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 357,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 357,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 357,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 357,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 357,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 357,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 357,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 357,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 357,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 357,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 357,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 357,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 357,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 357,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 357,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 357,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 357,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 357,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 357,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 357,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 357,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 357,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 357,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 357,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 357,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 357,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 357,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 357,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 357,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 357,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 357,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 357,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 357,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 357,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 357,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 357,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 357,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 357,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 357,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 357,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 357,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 357,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 357,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 357,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 357,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 357,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 357,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 357,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 357,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 357,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 357,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 357,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 357,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 357,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 357,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 357,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 357,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 357,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 357,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 357,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 357,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 357,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 357,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 357,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 357,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 357,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 357,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 357,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 357,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 357,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 357,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 357,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 357,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 357,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 357,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 357,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 357,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 357,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 357,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 357,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 357,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 357,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 357,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 357,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 357,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 357,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 357,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 357,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 357,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 357,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 357,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 357,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 357,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 357,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 357,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 357,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 357,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 357,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 357,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 357,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 357,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 357,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 357,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 357,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 357,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 357,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 357,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 357,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 357,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 357,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 357,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 357,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 357,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 357,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 357,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 357,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 357,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 357,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 357,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 357,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 357,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 357,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 357,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 357,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 357,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 357,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 357,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 357,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 357,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 357,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 357,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 357,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 357,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 357,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 357,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 357,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 357,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 357,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 357,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 357,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 357,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 357,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 357,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 357,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 357,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 357,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 357,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 357,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 357,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 357,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 357,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 357,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 357,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 357,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 357,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 357,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 357,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 357,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 357,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 357,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 357,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 357,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 357,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 357,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 357,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 357,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 357,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 357,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 357,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 357,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 357,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 357,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 357,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 357,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 357,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 357,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 357,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickExecutive_ThinCut = {
  C: {
    templateId: 358,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 358,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 358,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 358,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 358,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 358,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 358,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 358,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 358,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 358,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 358,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 358,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 358,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 358,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 358,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 358,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 358,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 358,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 358,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 358,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 358,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 358,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 358,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 358,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 358,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 358,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 358,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 358,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 358,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 358,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 358,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 358,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 358,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 358,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 358,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 358,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 358,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 358,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 358,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 358,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 358,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 358,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 358,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 358,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 358,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 358,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 358,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 358,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 358,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 358,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 358,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 358,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 358,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 358,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 358,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 358,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 358,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 358,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 358,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 358,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 358,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 358,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 358,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 358,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 358,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 358,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 358,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 358,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 358,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 358,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 358,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 358,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 358,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 358,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 358,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 358,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 358,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 358,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 358,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 358,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 358,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 358,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 358,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 358,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 358,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 358,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 358,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 358,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 358,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 358,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 358,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 358,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 358,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 358,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 358,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 358,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 358,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 358,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 358,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 358,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 358,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 358,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 358,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 358,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 358,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 358,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 358,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 358,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 358,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 358,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 358,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 358,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 358,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 358,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 358,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 358,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 358,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 358,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 358,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 358,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 358,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 358,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 358,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 358,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 358,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 358,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 358,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 358,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 358,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 358,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 358,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 358,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 358,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 358,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 358,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 358,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 358,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 358,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 358,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 358,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 358,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 358,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 358,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 358,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 358,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 358,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 358,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 358,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 358,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 358,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 358,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 358,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 358,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 358,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 358,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 358,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 358,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 358,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 358,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 358,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 358,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 358,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 358,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 358,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 358,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 358,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 358,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 358,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 358,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 358,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 358,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 358,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 358,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 358,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 358,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 358,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 358,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 358,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 358,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 358,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 358,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 358,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 358,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 358,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 358,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 358,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 358,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 358,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 358,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 358,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 358,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 358,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 358,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 358,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 358,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 358,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 358,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 358,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 358,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 358,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 358,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 358,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 358,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 358,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 358,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 358,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 358,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 358,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 358,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 358,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 358,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 358,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 358,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 358,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 358,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 358,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 358,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 358,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 358,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 358,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 358,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 358,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 358,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 358,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 358,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 358,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 358,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 358,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 358,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 358,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 358,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 358,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 358,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 358,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 358,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 358,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 358,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 358,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 358,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 358,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 358,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 358,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 358,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickKing = {
  C: {
    templateId: 61,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 61,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 61,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 61,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 61,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 61,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 61,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 61,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 61,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 61,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 61,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 61,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 61,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 61,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 61,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 61,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 61,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 61,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 61,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 61,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 61,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 61,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 61,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 61,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 61,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 61,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 61,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 61,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 61,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 61,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 61,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 61,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 61,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 61,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 61,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 61,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 61,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 61,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 61,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 61,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 61,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 61,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 61,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 61,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 61,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 61,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 61,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 61,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 61,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 61,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 61,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 61,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 61,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 61,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 61,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 61,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 61,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 61,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 61,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 61,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 61,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 61,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 61,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 61,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 61,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 61,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 61,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 61,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 61,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 61,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 61,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 61,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 61,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 61,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 61,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 61,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 61,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 61,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 61,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 61,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 61,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 61,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 61,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 61,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 61,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 61,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 61,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 61,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 61,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 61,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 61,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 61,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 61,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 61,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 61,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 61,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 61,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 61,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 61,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 61,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 61,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 61,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 61,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 61,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 61,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 61,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 61,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 61,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 61,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 61,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 61,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 61,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 61,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 61,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 61,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 61,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 61,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 61,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 61,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 61,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 61,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 61,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 61,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 61,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 61,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 61,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 61,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 61,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 61,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 61,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 61,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 61,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 61,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 61,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 61,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 61,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 61,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 61,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 61,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 61,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 61,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 61,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 61,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 61,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 61,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 61,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 61,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 61,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 61,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 61,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 61,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 61,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 61,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 61,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 61,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 61,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 61,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 61,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 61,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 61,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 61,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 61,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 61,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 61,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 61,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 61,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 61,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 61,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 61,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 61,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 61,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 61,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 61,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 61,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 61,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 61,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 61,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 61,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 61,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 61,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 61,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 61,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 61,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 61,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 61,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 61,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 61,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 61,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 61,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 61,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 61,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 61,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 61,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 61,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 61,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 61,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 61,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 61,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 61,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 61,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 61,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 61,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 61,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 61,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 61,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 61,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 61,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 61,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 61,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 61,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 61,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 61,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 61,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 61,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 61,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 61,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 61,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 61,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 61,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 61,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 61,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 61,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 61,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 61,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 61,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 61,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 61,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 61,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 61,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 61,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 61,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 61,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 61,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 61,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 61,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 61,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 61,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 61,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 61,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 61,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 61,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 61,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 61,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickKing_HalfHeight = {
  C: {
    templateId: 140,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 140,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 140,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 140,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 140,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 140,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 140,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 140,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 140,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 140,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 140,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 140,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 140,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 140,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 140,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 140,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 140,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 140,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 140,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 140,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 140,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 140,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 140,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 140,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 140,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 140,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 140,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 140,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 140,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 140,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 140,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 140,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 140,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 140,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 140,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 140,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 140,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 140,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 140,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 140,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 140,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 140,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 140,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 140,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 140,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 140,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 140,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 140,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 140,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 140,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 140,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 140,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 140,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 140,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 140,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 140,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 140,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 140,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 140,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 140,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 140,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 140,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 140,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 140,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 140,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 140,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 140,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 140,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 140,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 140,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 140,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 140,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 140,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 140,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 140,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 140,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 140,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 140,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 140,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 140,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 140,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 140,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 140,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 140,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 140,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 140,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 140,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 140,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 140,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 140,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 140,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 140,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 140,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 140,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 140,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 140,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 140,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 140,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 140,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 140,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 140,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 140,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 140,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 140,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 140,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 140,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 140,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 140,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 140,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 140,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 140,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 140,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 140,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 140,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 140,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 140,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 140,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 140,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 140,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 140,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 140,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 140,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 140,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 140,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 140,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 140,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 140,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 140,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 140,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 140,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 140,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 140,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 140,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 140,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 140,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 140,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 140,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 140,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 140,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 140,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 140,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 140,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 140,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 140,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 140,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 140,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 140,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 140,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 140,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 140,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 140,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 140,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 140,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 140,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 140,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 140,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 140,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 140,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 140,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 140,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 140,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 140,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 140,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 140,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 140,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 140,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 140,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 140,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 140,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 140,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 140,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 140,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 140,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 140,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 140,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 140,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 140,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 140,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 140,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 140,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 140,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 140,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 140,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 140,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 140,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 140,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 140,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 140,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 140,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 140,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 140,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 140,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 140,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 140,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 140,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 140,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 140,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 140,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 140,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 140,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 140,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 140,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 140,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 140,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 140,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 140,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 140,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 140,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 140,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 140,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 140,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 140,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 140,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 140,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 140,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 140,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 140,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 140,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 140,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 140,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 140,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 140,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 140,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 140,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 140,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 140,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 140,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 140,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 140,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 140,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 140,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 140,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 140,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 140,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 140,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 140,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 140,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 140,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 140,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 140,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 140,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 140,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 140,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickKing_Header = {
  C: {
    templateId: 59,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 59,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 59,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 59,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 59,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 59,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 59,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 59,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 59,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 59,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 59,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 59,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 59,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 59,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 59,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 59,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 59,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 59,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 59,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 59,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 59,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 59,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 59,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 59,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 59,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 59,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 59,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 59,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 59,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 59,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 59,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 59,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 59,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 59,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 59,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 59,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 59,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 59,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 59,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 59,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 59,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 59,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 59,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 59,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 59,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 59,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 59,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 59,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 59,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 59,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 59,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 59,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 59,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 59,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 59,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 59,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 59,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 59,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 59,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 59,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 59,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 59,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 59,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 59,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 59,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 59,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 59,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 59,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 59,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 59,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 59,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 59,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 59,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 59,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 59,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 59,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 59,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 59,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 59,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 59,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 59,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 59,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 59,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 59,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 59,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 59,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 59,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 59,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 59,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 59,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 59,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 59,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 59,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 59,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 59,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 59,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 59,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 59,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 59,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 59,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 59,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 59,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 59,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 59,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 59,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 59,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 59,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 59,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 59,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 59,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 59,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 59,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 59,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 59,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 59,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 59,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 59,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 59,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 59,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 59,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 59,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 59,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 59,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 59,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 59,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 59,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 59,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 59,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 59,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 59,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 59,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 59,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 59,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 59,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 59,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 59,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 59,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 59,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 59,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 59,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 59,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 59,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 59,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 59,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 59,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 59,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 59,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 59,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 59,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 59,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 59,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 59,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 59,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 59,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 59,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 59,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 59,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 59,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 59,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 59,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 59,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 59,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 59,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 59,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 59,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 59,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 59,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 59,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 59,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 59,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 59,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 59,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 59,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 59,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 59,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 59,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 59,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 59,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 59,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 59,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 59,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 59,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 59,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 59,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 59,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 59,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 59,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 59,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 59,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 59,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 59,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 59,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 59,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 59,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 59,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 59,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 59,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 59,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 59,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 59,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 59,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 59,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 59,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 59,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 59,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 59,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 59,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 59,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 59,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 59,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 59,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 59,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 59,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 59,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 59,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 59,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 59,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 59,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 59,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 59,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 59,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 59,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 59,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 59,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 59,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 59,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 59,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 59,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 59,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 59,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 59,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 59,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 59,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 59,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 59,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 59,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 59,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 59,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 59,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 59,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 59,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 59,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 59,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickKing_Herringbone = {
  C: {
    templateId: 121,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 121,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 121,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 121,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 121,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 121,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 121,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 121,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 121,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 121,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 121,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 121,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 121,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 121,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 121,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 121,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 121,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 121,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 121,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 121,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 121,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 121,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 121,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 121,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 121,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 121,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 121,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 121,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 121,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 121,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 121,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 121,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 121,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 121,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 121,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 121,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 121,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 121,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 121,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 121,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 121,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 121,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 121,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 121,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 121,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 121,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 121,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 121,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 121,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 121,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 121,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 121,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 121,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 121,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 121,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 121,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 121,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 121,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 121,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 121,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 121,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 121,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 121,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 121,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 121,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 121,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 121,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 121,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 121,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 121,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 121,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 121,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 121,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 121,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 121,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 121,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 121,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 121,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 121,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 121,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 121,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 121,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 121,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 121,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 121,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 121,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 121,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 121,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 121,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 121,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 121,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 121,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 121,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 121,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 121,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 121,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 121,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 121,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 121,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 121,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 121,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 121,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 121,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 121,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 121,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 121,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 121,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 121,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 121,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 121,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 121,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 121,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 121,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 121,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 121,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 121,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 121,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 121,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 121,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 121,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 121,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 121,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 121,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 121,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 121,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 121,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 121,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 121,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 121,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 121,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 121,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 121,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 121,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 121,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 121,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 121,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 121,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 121,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 121,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 121,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 121,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 121,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 121,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 121,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 121,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 121,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 121,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 121,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 121,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 121,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 121,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 121,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 121,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 121,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 121,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 121,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 121,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 121,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 121,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 121,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 121,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 121,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 121,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 121,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 121,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 121,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 121,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 121,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 121,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 121,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 121,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 121,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 121,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 121,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 121,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 121,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 121,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 121,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 121,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 121,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 121,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 121,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 121,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 121,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 121,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 121,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 121,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 121,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 121,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 121,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 121,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 121,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 121,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 121,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 121,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 121,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 121,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 121,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 121,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 121,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 121,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 121,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 121,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 121,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 121,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 121,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 121,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 121,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 121,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 121,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 121,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 121,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 121,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 121,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 121,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 121,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 121,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 121,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 121,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 121,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 121,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 121,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 121,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 121,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 121,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 121,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 121,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 121,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 121,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 121,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 121,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 121,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 121,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 121,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 121,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 121,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 121,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 121,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 121,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 121,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 121,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 121,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 121,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickKing_Rowlock = {
  C: {
    templateId: 60,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 60,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 60,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 60,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 60,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 60,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 60,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 60,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 60,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 60,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 60,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 60,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 60,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 60,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 60,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 60,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 60,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 60,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 60,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 60,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 60,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 60,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 60,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 60,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 60,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 60,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 60,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 60,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 60,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 60,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 60,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 60,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 60,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 60,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 60,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 60,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 60,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 60,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 60,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 60,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 60,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 60,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 60,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 60,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 60,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 60,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 60,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 60,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 60,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 60,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 60,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 60,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 60,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 60,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 60,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 60,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 60,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 60,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 60,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 60,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 60,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 60,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 60,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 60,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 60,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 60,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 60,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 60,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 60,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 60,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 60,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 60,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 60,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 60,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 60,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 60,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 60,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 60,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 60,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 60,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 60,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 60,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 60,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 60,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 60,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 60,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 60,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 60,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 60,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 60,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 60,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 60,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 60,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 60,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 60,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 60,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 60,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 60,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 60,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 60,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 60,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 60,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 60,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 60,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 60,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 60,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 60,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 60,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 60,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 60,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 60,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 60,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 60,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 60,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 60,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 60,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 60,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 60,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 60,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 60,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 60,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 60,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 60,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 60,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 60,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 60,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 60,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 60,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 60,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 60,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 60,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 60,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 60,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 60,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 60,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 60,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 60,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 60,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 60,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 60,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 60,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 60,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 60,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 60,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 60,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 60,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 60,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 60,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 60,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 60,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 60,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 60,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 60,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 60,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 60,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 60,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 60,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 60,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 60,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 60,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 60,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 60,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 60,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 60,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 60,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 60,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 60,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 60,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 60,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 60,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 60,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 60,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 60,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 60,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 60,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 60,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 60,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 60,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 60,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 60,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 60,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 60,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 60,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 60,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 60,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 60,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 60,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 60,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 60,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 60,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 60,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 60,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 60,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 60,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 60,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 60,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 60,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 60,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 60,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 60,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 60,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 60,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 60,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 60,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 60,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 60,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 60,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 60,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 60,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 60,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 60,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 60,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 60,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 60,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 60,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 60,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 60,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 60,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 60,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 60,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 60,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 60,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 60,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 60,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 60,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 60,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 60,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 60,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 60,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 60,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 60,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 60,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 60,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 60,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 60,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 60,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 60,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 60,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 60,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 60,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 60,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 60,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 60,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickKing_ThinCut = {
  C: {
    templateId: 147,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 147,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 147,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 147,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 147,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 147,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 147,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 147,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 147,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 147,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 147,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 147,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 147,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 147,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 147,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 147,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 147,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 147,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 147,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 147,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 147,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 147,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 147,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 147,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 147,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 147,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 147,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 147,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 147,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 147,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 147,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 147,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 147,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 147,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 147,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 147,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 147,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 147,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 147,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 147,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 147,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 147,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 147,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 147,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 147,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 147,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 147,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 147,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 147,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 147,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 147,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 147,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 147,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 147,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 147,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 147,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 147,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 147,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 147,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 147,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 147,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 147,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 147,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 147,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 147,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 147,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 147,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 147,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 147,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 147,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 147,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 147,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 147,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 147,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 147,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 147,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 147,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 147,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 147,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 147,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 147,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 147,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 147,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 147,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 147,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 147,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 147,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 147,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 147,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 147,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 147,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 147,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 147,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 147,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 147,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 147,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 147,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 147,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 147,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 147,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 147,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 147,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 147,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 147,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 147,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 147,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 147,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 147,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 147,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 147,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 147,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 147,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 147,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 147,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 147,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 147,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 147,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 147,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 147,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 147,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 147,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 147,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 147,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 147,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 147,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 147,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 147,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 147,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 147,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 147,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 147,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 147,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 147,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 147,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 147,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 147,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 147,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 147,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 147,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 147,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 147,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 147,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 147,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 147,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 147,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 147,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 147,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 147,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 147,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 147,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 147,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 147,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 147,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 147,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 147,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 147,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 147,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 147,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 147,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 147,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 147,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 147,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 147,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 147,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 147,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 147,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 147,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 147,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 147,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 147,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 147,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 147,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 147,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 147,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 147,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 147,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 147,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 147,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 147,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 147,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 147,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 147,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 147,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 147,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 147,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 147,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 147,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 147,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 147,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 147,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 147,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 147,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 147,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 147,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 147,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 147,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 147,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 147,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 147,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 147,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 147,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 147,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 147,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 147,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 147,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 147,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 147,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 147,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 147,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 147,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 147,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 147,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 147,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 147,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 147,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 147,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 147,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 147,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 147,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 147,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 147,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 147,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 147,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 147,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 147,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 147,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 147,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 147,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 147,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 147,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 147,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 147,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 147,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 147,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 147,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 147,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 147,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 147,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 147,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 147,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 147,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 147,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 147,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickModular = {
  C: {
    templateId: 109,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 109,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 109,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 109,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 109,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 109,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 109,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 109,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 109,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 109,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 109,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 109,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 109,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 109,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 109,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 109,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 109,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 109,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 109,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 109,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 109,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 109,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 109,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 109,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 109,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 109,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 109,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 109,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 109,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 109,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 109,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 109,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 109,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 109,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 109,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 109,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 109,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 109,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 109,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 109,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 109,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 109,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 109,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 109,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 109,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 109,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 109,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 109,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 109,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 109,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 109,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 109,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 109,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 109,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 109,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 109,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 109,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 109,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 109,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 109,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 109,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 109,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 109,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 109,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 109,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 109,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 109,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 109,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 109,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 109,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 109,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 109,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 109,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 109,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 109,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 109,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 109,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 109,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 109,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 109,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 109,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 109,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 109,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 109,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 109,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 109,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 109,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 109,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 109,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 109,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 109,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 109,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 109,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 109,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 109,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 109,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 109,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 109,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 109,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 109,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 109,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 109,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 109,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 109,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 109,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 109,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 109,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 109,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 109,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 109,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 109,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 109,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 109,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 109,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 109,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 109,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 109,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 109,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 109,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 109,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 109,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 109,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 109,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 109,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 109,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 109,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 109,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 109,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 109,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 109,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 109,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 109,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 109,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 109,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 109,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 109,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 109,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 109,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 109,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 109,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 109,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 109,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 109,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 109,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 109,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 109,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 109,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 109,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 109,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 109,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 109,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 109,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 109,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 109,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 109,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 109,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 109,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 109,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 109,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 109,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 109,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 109,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 109,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 109,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 109,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 109,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 109,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 109,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 109,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 109,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 109,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 109,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 109,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 109,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 109,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 109,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 109,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 109,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 109,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 109,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 109,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 109,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 109,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 109,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 109,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 109,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 109,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 109,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 109,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 109,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 109,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 109,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 109,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 109,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 109,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 109,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 109,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 109,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 109,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 109,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 109,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 109,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 109,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 109,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 109,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 109,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 109,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 109,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 109,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 109,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 109,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 109,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 109,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 109,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 109,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 109,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 109,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 109,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 109,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 109,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 109,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 109,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 109,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 109,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 109,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 109,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 109,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 109,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 109,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 109,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 109,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 109,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 109,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 109,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 109,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 109,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 109,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 109,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 109,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 109,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 109,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 109,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 109,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickModular_HalfHeight = {
  C: {
    templateId: 380,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 380,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 380,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 380,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 380,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 380,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 380,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 380,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 380,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 380,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 380,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 380,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 380,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 380,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 380,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 380,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 380,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 380,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 380,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 380,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 380,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 380,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 380,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 380,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 380,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 380,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 380,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 380,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 380,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 380,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 380,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 380,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 380,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 380,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 380,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 380,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 380,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 380,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 380,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 380,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 380,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 380,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 380,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 380,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 380,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 380,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 380,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 380,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 380,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 380,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 380,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 380,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 380,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 380,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 380,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 380,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 380,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 380,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 380,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 380,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 380,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 380,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 380,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 380,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 380,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 380,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 380,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 380,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 380,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 380,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 380,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 380,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 380,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 380,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 380,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 380,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 380,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 380,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 380,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 380,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 380,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 380,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 380,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 380,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 380,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 380,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 380,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 380,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 380,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 380,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 380,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 380,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 380,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 380,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 380,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 380,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 380,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 380,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 380,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 380,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 380,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 380,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 380,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 380,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 380,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 380,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 380,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 380,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 380,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 380,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 380,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 380,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 380,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 380,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 380,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 380,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 380,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 380,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 380,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 380,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 380,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 380,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 380,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 380,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 380,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 380,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 380,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 380,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 380,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 380,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 380,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 380,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 380,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 380,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 380,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 380,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 380,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 380,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 380,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 380,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 380,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 380,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 380,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 380,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 380,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 380,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 380,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 380,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 380,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 380,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 380,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 380,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 380,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 380,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 380,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 380,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 380,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 380,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 380,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 380,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 380,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 380,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 380,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 380,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 380,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 380,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 380,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 380,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 380,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 380,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 380,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 380,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 380,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 380,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 380,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 380,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 380,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 380,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 380,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 380,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 380,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 380,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 380,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 380,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 380,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 380,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 380,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 380,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 380,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 380,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 380,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 380,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 380,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 380,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 380,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 380,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 380,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 380,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 380,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 380,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 380,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 380,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 380,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 380,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 380,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 380,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 380,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 380,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 380,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 380,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 380,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 380,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 380,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 380,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 380,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 380,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 380,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 380,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 380,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 380,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 380,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 380,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 380,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 380,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 380,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 380,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 380,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 380,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 380,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 380,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 380,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 380,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 380,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 380,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 380,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 380,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 380,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 380,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 380,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 380,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 380,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 380,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 380,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickModular_Header = {
  C: {
    templateId: 110,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 110,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 110,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 110,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 110,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 110,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 110,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 110,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 110,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 110,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 110,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 110,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 110,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 110,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 110,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 110,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 110,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 110,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 110,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 110,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 110,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 110,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 110,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 110,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 110,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 110,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 110,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 110,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 110,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 110,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 110,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 110,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 110,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 110,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 110,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 110,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 110,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 110,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 110,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 110,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 110,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 110,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 110,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 110,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 110,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 110,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 110,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 110,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 110,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 110,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 110,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 110,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 110,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 110,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 110,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 110,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 110,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 110,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 110,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 110,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 110,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 110,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 110,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 110,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 110,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 110,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 110,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 110,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 110,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 110,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 110,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 110,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 110,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 110,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 110,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 110,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 110,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 110,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 110,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 110,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 110,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 110,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 110,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 110,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 110,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 110,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 110,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 110,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 110,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 110,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 110,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 110,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 110,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 110,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 110,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 110,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 110,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 110,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 110,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 110,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 110,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 110,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 110,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 110,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 110,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 110,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 110,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 110,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 110,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 110,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 110,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 110,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 110,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 110,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 110,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 110,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 110,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 110,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 110,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 110,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 110,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 110,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 110,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 110,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 110,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 110,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 110,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 110,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 110,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 110,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 110,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 110,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 110,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 110,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 110,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 110,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 110,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 110,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 110,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 110,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 110,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 110,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 110,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 110,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 110,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 110,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 110,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 110,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 110,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 110,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 110,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 110,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 110,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 110,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 110,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 110,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 110,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 110,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 110,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 110,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 110,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 110,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 110,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 110,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 110,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 110,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 110,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 110,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 110,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 110,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 110,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 110,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 110,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 110,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 110,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 110,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 110,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 110,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 110,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 110,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 110,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 110,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 110,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 110,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 110,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 110,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 110,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 110,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 110,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 110,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 110,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 110,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 110,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 110,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 110,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 110,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 110,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 110,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 110,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 110,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 110,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 110,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 110,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 110,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 110,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 110,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 110,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 110,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 110,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 110,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 110,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 110,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 110,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 110,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 110,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 110,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 110,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 110,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 110,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 110,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 110,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 110,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 110,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 110,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 110,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 110,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 110,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 110,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 110,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 110,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 110,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 110,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 110,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 110,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 110,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 110,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 110,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 110,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 110,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 110,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 110,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 110,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 110,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickModular_Herringbone = {
  C: {
    templateId: 122,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 122,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 122,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 122,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 122,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 122,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 122,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 122,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 122,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 122,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 122,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 122,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 122,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 122,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 122,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 122,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 122,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 122,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 122,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 122,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 122,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 122,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 122,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 122,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 122,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 122,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 122,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 122,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 122,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 122,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 122,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 122,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 122,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 122,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 122,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 122,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 122,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 122,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 122,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 122,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 122,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 122,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 122,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 122,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 122,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 122,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 122,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 122,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 122,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 122,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 122,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 122,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 122,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 122,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 122,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 122,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 122,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 122,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 122,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 122,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 122,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 122,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 122,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 122,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 122,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 122,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 122,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 122,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 122,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 122,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 122,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 122,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 122,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 122,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 122,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 122,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 122,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 122,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 122,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 122,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 122,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 122,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 122,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 122,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 122,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 122,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 122,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 122,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 122,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 122,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 122,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 122,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 122,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 122,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 122,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 122,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 122,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 122,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 122,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 122,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 122,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 122,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 122,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 122,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 122,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 122,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 122,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 122,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 122,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 122,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 122,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 122,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 122,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 122,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 122,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 122,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 122,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 122,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 122,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 122,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 122,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 122,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 122,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 122,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 122,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 122,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 122,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 122,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 122,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 122,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 122,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 122,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 122,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 122,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 122,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 122,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 122,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 122,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 122,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 122,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 122,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 122,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 122,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 122,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 122,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 122,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 122,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 122,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 122,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 122,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 122,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 122,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 122,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 122,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 122,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 122,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 122,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 122,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 122,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 122,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 122,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 122,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 122,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 122,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 122,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 122,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 122,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 122,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 122,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 122,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 122,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 122,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 122,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 122,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 122,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 122,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 122,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 122,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 122,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 122,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 122,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 122,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 122,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 122,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 122,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 122,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 122,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 122,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 122,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 122,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 122,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 122,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 122,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 122,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 122,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 122,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 122,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 122,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 122,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 122,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 122,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 122,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 122,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 122,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 122,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 122,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 122,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 122,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 122,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 122,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 122,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 122,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 122,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 122,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 122,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 122,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 122,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 122,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 122,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 122,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 122,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 122,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 122,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 122,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 122,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 122,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 122,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 122,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 122,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 122,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 122,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 122,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 122,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 122,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 122,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 122,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 122,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 122,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 122,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 122,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 122,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 122,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 122,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickModular_Rowlock = {
  C: {
    templateId: 111,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 111,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 111,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 111,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 111,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 111,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 111,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 111,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 111,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 111,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 111,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 111,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 111,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 111,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 111,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 111,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 111,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 111,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 111,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 111,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 111,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 111,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 111,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 111,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 111,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 111,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 111,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 111,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 111,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 111,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 111,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 111,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 111,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 111,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 111,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 111,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 111,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 111,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 111,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 111,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 111,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 111,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 111,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 111,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 111,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 111,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 111,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 111,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 111,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 111,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 111,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 111,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 111,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 111,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 111,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 111,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 111,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 111,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 111,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 111,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 111,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 111,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 111,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 111,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 111,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 111,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 111,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 111,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 111,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 111,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 111,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 111,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 111,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 111,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 111,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 111,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 111,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 111,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 111,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 111,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 111,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 111,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 111,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 111,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 111,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 111,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 111,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 111,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 111,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 111,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 111,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 111,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 111,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 111,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 111,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 111,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 111,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 111,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 111,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 111,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 111,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 111,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 111,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 111,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 111,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 111,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 111,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 111,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 111,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 111,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 111,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 111,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 111,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 111,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 111,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 111,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 111,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 111,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 111,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 111,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 111,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 111,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 111,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 111,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 111,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 111,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 111,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 111,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 111,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 111,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 111,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 111,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 111,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 111,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 111,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 111,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 111,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 111,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 111,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 111,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 111,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 111,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 111,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 111,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 111,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 111,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 111,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 111,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 111,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 111,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 111,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 111,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 111,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 111,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 111,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 111,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 111,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 111,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 111,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 111,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 111,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 111,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 111,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 111,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 111,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 111,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 111,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 111,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 111,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 111,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 111,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 111,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 111,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 111,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 111,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 111,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 111,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 111,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 111,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 111,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 111,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 111,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 111,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 111,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 111,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 111,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 111,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 111,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 111,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 111,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 111,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 111,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 111,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 111,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 111,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 111,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 111,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 111,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 111,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 111,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 111,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 111,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 111,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 111,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 111,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 111,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 111,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 111,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 111,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 111,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 111,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 111,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 111,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 111,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 111,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 111,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 111,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 111,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 111,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 111,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 111,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 111,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 111,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 111,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 111,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 111,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 111,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 111,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 111,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 111,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 111,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 111,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 111,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 111,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 111,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 111,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 111,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 111,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 111,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 111,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 111,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 111,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 111,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickModular_Weave3 = {
  C: {
    templateId: 379,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 379,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 379,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 379,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 379,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 379,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 379,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 379,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 379,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 379,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 379,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 379,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 379,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 379,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 379,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 379,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 379,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 379,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 379,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 379,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 379,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 379,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 379,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 379,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 379,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 379,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 379,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 379,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 379,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 379,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 379,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 379,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 379,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 379,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 379,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 379,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 379,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 379,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 379,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 379,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 379,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 379,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 379,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 379,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 379,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 379,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 379,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 379,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 379,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 379,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 379,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 379,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 379,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 379,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 379,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 379,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 379,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 379,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 379,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 379,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 379,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 379,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 379,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 379,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 379,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 379,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 379,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 379,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 379,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 379,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 379,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 379,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 379,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 379,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 379,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 379,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 379,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 379,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 379,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 379,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 379,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 379,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 379,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 379,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 379,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 379,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 379,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 379,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 379,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 379,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 379,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 379,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 379,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 379,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 379,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 379,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 379,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 379,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 379,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 379,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 379,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 379,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 379,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 379,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 379,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 379,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 379,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 379,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 379,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 379,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 379,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 379,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 379,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 379,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 379,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 379,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 379,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 379,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 379,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 379,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 379,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 379,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 379,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 379,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 379,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 379,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 379,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 379,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 379,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 379,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 379,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 379,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 379,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 379,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 379,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 379,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 379,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 379,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 379,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 379,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 379,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 379,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 379,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 379,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 379,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 379,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 379,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 379,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 379,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 379,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 379,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 379,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 379,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 379,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 379,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 379,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 379,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 379,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 379,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 379,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 379,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 379,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 379,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 379,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 379,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 379,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 379,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 379,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 379,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 379,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 379,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 379,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 379,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 379,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 379,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 379,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 379,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 379,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 379,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 379,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 379,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 379,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 379,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 379,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 379,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 379,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 379,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 379,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 379,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 379,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 379,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 379,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 379,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 379,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 379,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 379,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 379,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 379,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 379,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 379,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 379,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 379,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 379,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 379,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 379,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 379,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 379,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 379,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 379,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 379,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 379,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 379,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 379,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 379,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 379,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 379,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 379,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 379,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 379,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 379,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 379,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 379,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 379,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 379,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 379,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 379,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 379,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 379,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 379,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 379,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 379,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 379,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 379,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 379,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 379,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 379,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 379,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 379,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 379,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 379,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 379,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 379,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 379,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickQueen = {
  C: {
    templateId: 64,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 64,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 64,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 64,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 64,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 64,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 64,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 64,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 64,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 64,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 64,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 64,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 64,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 64,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 64,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 64,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 64,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 64,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 64,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 64,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 64,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 64,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 64,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 64,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 64,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 64,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 64,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 64,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 64,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 64,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 64,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 64,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 64,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 64,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 64,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 64,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 64,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 64,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 64,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 64,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 64,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 64,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 64,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 64,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 64,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 64,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 64,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 64,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 64,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 64,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 64,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 64,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 64,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 64,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 64,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 64,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 64,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 64,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 64,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 64,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 64,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 64,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 64,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 64,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 64,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 64,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 64,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 64,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 64,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 64,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 64,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 64,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 64,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 64,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 64,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 64,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 64,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 64,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 64,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 64,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 64,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 64,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 64,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 64,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 64,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 64,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 64,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 64,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 64,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 64,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 64,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 64,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 64,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 64,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 64,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 64,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 64,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 64,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 64,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 64,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 64,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 64,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 64,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 64,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 64,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 64,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 64,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 64,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 64,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 64,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 64,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 64,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 64,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 64,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 64,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 64,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 64,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 64,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 64,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 64,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 64,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 64,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 64,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 64,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 64,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 64,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 64,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 64,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 64,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 64,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 64,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 64,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 64,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 64,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 64,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 64,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 64,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 64,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 64,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 64,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 64,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 64,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 64,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 64,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 64,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 64,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 64,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 64,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 64,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 64,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 64,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 64,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 64,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 64,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 64,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 64,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 64,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 64,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 64,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 64,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 64,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 64,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 64,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 64,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 64,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 64,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 64,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 64,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 64,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 64,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 64,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 64,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 64,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 64,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 64,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 64,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 64,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 64,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 64,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 64,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 64,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 64,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 64,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 64,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 64,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 64,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 64,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 64,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 64,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 64,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 64,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 64,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 64,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 64,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 64,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 64,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 64,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 64,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 64,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 64,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 64,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 64,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 64,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 64,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 64,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 64,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 64,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 64,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 64,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 64,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 64,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 64,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 64,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 64,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 64,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 64,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 64,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 64,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 64,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 64,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 64,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 64,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 64,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 64,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 64,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 64,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 64,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 64,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 64,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 64,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 64,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 64,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 64,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 64,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 64,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 64,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 64,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 64,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 64,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 64,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 64,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 64,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 64,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickQueen_HalfHeight = {
  C: {
    templateId: 141,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 141,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 141,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 141,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 141,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 141,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 141,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 141,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 141,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 141,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 141,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 141,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 141,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 141,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 141,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 141,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 141,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 141,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 141,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 141,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 141,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 141,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 141,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 141,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 141,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 141,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 141,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 141,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 141,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 141,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 141,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 141,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 141,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 141,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 141,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 141,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 141,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 141,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 141,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 141,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 141,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 141,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 141,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 141,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 141,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 141,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 141,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 141,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 141,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 141,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 141,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 141,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 141,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 141,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 141,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 141,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 141,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 141,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 141,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 141,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 141,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 141,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 141,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 141,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 141,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 141,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 141,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 141,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 141,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 141,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 141,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 141,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 141,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 141,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 141,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 141,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 141,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 141,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 141,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 141,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 141,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 141,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 141,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 141,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 141,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 141,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 141,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 141,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 141,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 141,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 141,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 141,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 141,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 141,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 141,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 141,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 141,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 141,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 141,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 141,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 141,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 141,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 141,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 141,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 141,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 141,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 141,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 141,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 141,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 141,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 141,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 141,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 141,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 141,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 141,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 141,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 141,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 141,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 141,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 141,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 141,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 141,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 141,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 141,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 141,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 141,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 141,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 141,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 141,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 141,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 141,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 141,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 141,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 141,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 141,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 141,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 141,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 141,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 141,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 141,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 141,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 141,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 141,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 141,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 141,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 141,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 141,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 141,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 141,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 141,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 141,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 141,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 141,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 141,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 141,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 141,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 141,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 141,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 141,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 141,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 141,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 141,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 141,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 141,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 141,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 141,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 141,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 141,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 141,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 141,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 141,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 141,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 141,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 141,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 141,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 141,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 141,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 141,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 141,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 141,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 141,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 141,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 141,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 141,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 141,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 141,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 141,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 141,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 141,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 141,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 141,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 141,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 141,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 141,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 141,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 141,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 141,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 141,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 141,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 141,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 141,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 141,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 141,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 141,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 141,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 141,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 141,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 141,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 141,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 141,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 141,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 141,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 141,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 141,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 141,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 141,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 141,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 141,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 141,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 141,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 141,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 141,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 141,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 141,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 141,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 141,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 141,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 141,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 141,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 141,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 141,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 141,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 141,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 141,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 141,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 141,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 141,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 141,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 141,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 141,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 141,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 141,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 141,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickQueen_Header = {
  C: {
    templateId: 62,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 62,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 62,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 62,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 62,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 62,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 62,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 62,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 62,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 62,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 62,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 62,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 62,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 62,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 62,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 62,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 62,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 62,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 62,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 62,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 62,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 62,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 62,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 62,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 62,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 62,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 62,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 62,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 62,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 62,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 62,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 62,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 62,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 62,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 62,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 62,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 62,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 62,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 62,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 62,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 62,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 62,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 62,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 62,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 62,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 62,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 62,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 62,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 62,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 62,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 62,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 62,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 62,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 62,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 62,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 62,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 62,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 62,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 62,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 62,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 62,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 62,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 62,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 62,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 62,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 62,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 62,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 62,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 62,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 62,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 62,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 62,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 62,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 62,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 62,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 62,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 62,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 62,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 62,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 62,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 62,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 62,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 62,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 62,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 62,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 62,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 62,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 62,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 62,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 62,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 62,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 62,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 62,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 62,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 62,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 62,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 62,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 62,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 62,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 62,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 62,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 62,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 62,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 62,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 62,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 62,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 62,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 62,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 62,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 62,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 62,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 62,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 62,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 62,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 62,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 62,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 62,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 62,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 62,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 62,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 62,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 62,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 62,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 62,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 62,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 62,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 62,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 62,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 62,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 62,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 62,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 62,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 62,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 62,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 62,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 62,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 62,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 62,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 62,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 62,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 62,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 62,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 62,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 62,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 62,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 62,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 62,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 62,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 62,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 62,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 62,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 62,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 62,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 62,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 62,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 62,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 62,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 62,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 62,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 62,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 62,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 62,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 62,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 62,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 62,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 62,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 62,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 62,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 62,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 62,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 62,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 62,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 62,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 62,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 62,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 62,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 62,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 62,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 62,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 62,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 62,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 62,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 62,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 62,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 62,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 62,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 62,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 62,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 62,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 62,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 62,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 62,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 62,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 62,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 62,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 62,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 62,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 62,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 62,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 62,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 62,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 62,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 62,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 62,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 62,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 62,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 62,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 62,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 62,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 62,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 62,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 62,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 62,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 62,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 62,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 62,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 62,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 62,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 62,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 62,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 62,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 62,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 62,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 62,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 62,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 62,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 62,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 62,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 62,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 62,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 62,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 62,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 62,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 62,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 62,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 62,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 62,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 62,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 62,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 62,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 62,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 62,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 62,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickQueen_Herringbone = {
  C: {
    templateId: 123,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 123,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 123,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 123,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 123,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 123,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 123,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 123,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 123,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 123,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 123,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 123,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 123,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 123,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 123,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 123,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 123,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 123,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 123,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 123,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 123,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 123,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 123,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 123,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 123,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 123,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 123,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 123,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 123,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 123,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 123,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 123,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 123,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 123,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 123,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 123,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 123,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 123,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 123,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 123,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 123,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 123,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 123,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 123,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 123,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 123,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 123,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 123,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 123,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 123,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 123,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 123,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 123,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 123,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 123,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 123,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 123,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 123,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 123,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 123,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 123,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 123,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 123,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 123,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 123,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 123,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 123,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 123,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 123,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 123,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 123,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 123,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 123,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 123,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 123,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 123,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 123,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 123,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 123,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 123,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 123,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 123,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 123,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 123,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 123,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 123,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 123,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 123,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 123,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 123,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 123,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 123,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 123,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 123,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 123,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 123,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 123,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 123,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 123,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 123,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 123,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 123,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 123,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 123,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 123,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 123,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 123,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 123,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 123,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 123,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 123,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 123,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 123,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 123,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 123,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 123,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 123,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 123,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 123,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 123,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 123,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 123,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 123,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 123,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 123,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 123,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 123,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 123,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 123,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 123,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 123,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 123,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 123,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 123,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 123,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 123,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 123,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 123,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 123,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 123,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 123,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 123,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 123,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 123,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 123,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 123,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 123,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 123,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 123,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 123,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 123,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 123,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 123,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 123,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 123,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 123,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 123,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 123,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 123,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 123,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 123,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 123,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 123,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 123,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 123,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 123,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 123,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 123,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 123,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 123,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 123,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 123,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 123,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 123,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 123,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 123,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 123,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 123,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 123,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 123,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 123,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 123,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 123,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 123,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 123,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 123,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 123,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 123,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 123,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 123,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 123,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 123,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 123,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 123,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 123,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 123,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 123,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 123,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 123,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 123,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 123,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 123,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 123,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 123,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 123,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 123,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 123,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 123,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 123,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 123,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 123,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 123,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 123,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 123,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 123,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 123,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 123,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 123,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 123,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 123,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 123,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 123,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 123,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 123,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 123,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 123,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 123,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 123,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 123,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 123,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 123,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 123,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 123,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 123,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 123,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 123,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 123,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 123,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 123,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 123,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 123,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 123,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 123,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickQueen_Rowlock = {
  C: {
    templateId: 63,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 63,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 63,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 63,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 63,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 63,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 63,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 63,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 63,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 63,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 63,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 63,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 63,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 63,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 63,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 63,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 63,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 63,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 63,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 63,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 63,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 63,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 63,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 63,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 63,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 63,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 63,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 63,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 63,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 63,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 63,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 63,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 63,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 63,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 63,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 63,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 63,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 63,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 63,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 63,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 63,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 63,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 63,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 63,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 63,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 63,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 63,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 63,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 63,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 63,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 63,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 63,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 63,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 63,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 63,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 63,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 63,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 63,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 63,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 63,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 63,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 63,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 63,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 63,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 63,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 63,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 63,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 63,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 63,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 63,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 63,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 63,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 63,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 63,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 63,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 63,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 63,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 63,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 63,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 63,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 63,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 63,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 63,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 63,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 63,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 63,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 63,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 63,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 63,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 63,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 63,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 63,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 63,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 63,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 63,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 63,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 63,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 63,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 63,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 63,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 63,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 63,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 63,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 63,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 63,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 63,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 63,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 63,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 63,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 63,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 63,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 63,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 63,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 63,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 63,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 63,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 63,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 63,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 63,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 63,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 63,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 63,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 63,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 63,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 63,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 63,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 63,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 63,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 63,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 63,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 63,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 63,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 63,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 63,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 63,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 63,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 63,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 63,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 63,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 63,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 63,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 63,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 63,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 63,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 63,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 63,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 63,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 63,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 63,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 63,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 63,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 63,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 63,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 63,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 63,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 63,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 63,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 63,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 63,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 63,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 63,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 63,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 63,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 63,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 63,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 63,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 63,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 63,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 63,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 63,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 63,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 63,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 63,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 63,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 63,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 63,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 63,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 63,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 63,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 63,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 63,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 63,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 63,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 63,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 63,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 63,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 63,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 63,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 63,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 63,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 63,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 63,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 63,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 63,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 63,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 63,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 63,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 63,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 63,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 63,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 63,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 63,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 63,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 63,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 63,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 63,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 63,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 63,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 63,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 63,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 63,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 63,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 63,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 63,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 63,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 63,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 63,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 63,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 63,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 63,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 63,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 63,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 63,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 63,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 63,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 63,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 63,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 63,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 63,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 63,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 63,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 63,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 63,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 63,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 63,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 63,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 63,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 63,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 63,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 63,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 63,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 63,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 63,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_BrickQueen_ThinCut = {
  C: {
    templateId: 148,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 148,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 148,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 148,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 148,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 148,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 148,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 148,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 148,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 148,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 148,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 148,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 148,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 148,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 148,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 148,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 148,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 148,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 148,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 148,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 148,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 148,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 148,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 148,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 148,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 148,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 148,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 148,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 148,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 148,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 148,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 148,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 148,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 148,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 148,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 148,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 148,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 148,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 148,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 148,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 148,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 148,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 148,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 148,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 148,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 148,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 148,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 148,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 148,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 148,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 148,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 148,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 148,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 148,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 148,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 148,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 148,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 148,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 148,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 148,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 148,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 148,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 148,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 148,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 148,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 148,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 148,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 148,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 148,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 148,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 148,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 148,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 148,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 148,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 148,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 148,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 148,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 148,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 148,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 148,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 148,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 148,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 148,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 148,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 148,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 148,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 148,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 148,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 148,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 148,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 148,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 148,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 148,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 148,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 148,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 148,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 148,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 148,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 148,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 148,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 148,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 148,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 148,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 148,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 148,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 148,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 148,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 148,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 148,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 148,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 148,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 148,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 148,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 148,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 148,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 148,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 148,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 148,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 148,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 148,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 148,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 148,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 148,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 148,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 148,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 148,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 148,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 148,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 148,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 148,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 148,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 148,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 148,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 148,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 148,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 148,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 148,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 148,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 148,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 148,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 148,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 148,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 148,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 148,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 148,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 148,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 148,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 148,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 148,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 148,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 148,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 148,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 148,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 148,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 148,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 148,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 148,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 148,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 148,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 148,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 148,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 148,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 148,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 148,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 148,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 148,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 148,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 148,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 148,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 148,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 148,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 148,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 148,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 148,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 148,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 148,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 148,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 148,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 148,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 148,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 148,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 148,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 148,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 148,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 148,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 148,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 148,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 148,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 148,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 148,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 148,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 148,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 148,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 148,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 148,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 148,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 148,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 148,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 148,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 148,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 148,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 148,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 148,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 148,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 148,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 148,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 148,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 148,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 148,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 148,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 148,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 148,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 148,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 148,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 148,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 148,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 148,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 148,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 148,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 148,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 148,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 148,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 148,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 148,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 148,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 148,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 148,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 148,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 148,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 148,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 148,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 148,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 148,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 148,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 148,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 148,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 148,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 148,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 148,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 148,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 148,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 148,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 148,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_03 = {
  C: {
    templateId: 49,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 49,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 49,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 49,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 49,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 49,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 49,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 49,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 49,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 49,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 49,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 49,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 49,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 49,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 49,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 49,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 49,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 49,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 49,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 49,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 49,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 49,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 49,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 49,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 49,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 49,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 49,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 49,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 49,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 49,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 49,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 49,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 49,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 49,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 49,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 49,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 49,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 49,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 49,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 49,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 49,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 49,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 49,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 49,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 49,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 49,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 49,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 49,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 49,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 49,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 49,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 49,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 49,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 49,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 49,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 49,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 49,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 49,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 49,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 49,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 49,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 49,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 49,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 49,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 49,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 49,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 49,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 49,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 49,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 49,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 49,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 49,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 49,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 49,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 49,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 49,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 49,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 49,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 49,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 49,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 49,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 49,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 49,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 49,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 49,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 49,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 49,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 49,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 49,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 49,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 49,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 49,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 49,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 49,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 49,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 49,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 49,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 49,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 49,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 49,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 49,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 49,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 49,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 49,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 49,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 49,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 49,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 49,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 49,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 49,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 49,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 49,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 49,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 49,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 49,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 49,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 49,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 49,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 49,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 49,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 49,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 49,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 49,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 49,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 49,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 49,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 49,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 49,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 49,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 49,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 49,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 49,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 49,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 49,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 49,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 49,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 49,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 49,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 49,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 49,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 49,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 49,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 49,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 49,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 49,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 49,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 49,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 49,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 49,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 49,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 49,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 49,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 49,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 49,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 49,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 49,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 49,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 49,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 49,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 49,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 49,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 49,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 49,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 49,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 49,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 49,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 49,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 49,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 49,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 49,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 49,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 49,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 49,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 49,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 49,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 49,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 49,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 49,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 49,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 49,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 49,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 49,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 49,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 49,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 49,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 49,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 49,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 49,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 49,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 49,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 49,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 49,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 49,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 49,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 49,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 49,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 49,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 49,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 49,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 49,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 49,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 49,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 49,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 49,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 49,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 49,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 49,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 49,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 49,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 49,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 49,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 49,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 49,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 49,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 49,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 49,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 49,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 49,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 49,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 49,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 49,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 49,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 49,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 49,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 49,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 49,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 49,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 49,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 49,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 49,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 49,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 49,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 49,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 49,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 49,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 49,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 49,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 49,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 49,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 49,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 49,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 49,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 49,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_03_Header = {
  C: {
    templateId: 47,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 47,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 47,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 47,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 47,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 47,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 47,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 47,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 47,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 47,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 47,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 47,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 47,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 47,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 47,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 47,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 47,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 47,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 47,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 47,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 47,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 47,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 47,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 47,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 47,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 47,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 47,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 47,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 47,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 47,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 47,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 47,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 47,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 47,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 47,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 47,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 47,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 47,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 47,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 47,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 47,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 47,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 47,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 47,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 47,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 47,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 47,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 47,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 47,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 47,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 47,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 47,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 47,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 47,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 47,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 47,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 47,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 47,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 47,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 47,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 47,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 47,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 47,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 47,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 47,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 47,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 47,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 47,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 47,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 47,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 47,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 47,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 47,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 47,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 47,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 47,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 47,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 47,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 47,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 47,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 47,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 47,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 47,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 47,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 47,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 47,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 47,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 47,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 47,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 47,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 47,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 47,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 47,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 47,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 47,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 47,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 47,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 47,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 47,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 47,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 47,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 47,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 47,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 47,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 47,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 47,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 47,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 47,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 47,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 47,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 47,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 47,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 47,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 47,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 47,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 47,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 47,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 47,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 47,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 47,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 47,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 47,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 47,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 47,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 47,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 47,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 47,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 47,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 47,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 47,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 47,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 47,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 47,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 47,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 47,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 47,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 47,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 47,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 47,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 47,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 47,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 47,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 47,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 47,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 47,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 47,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 47,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 47,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 47,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 47,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 47,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 47,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 47,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 47,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 47,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 47,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 47,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 47,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 47,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 47,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 47,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 47,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 47,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 47,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 47,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 47,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 47,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 47,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 47,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 47,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 47,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 47,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 47,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 47,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 47,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 47,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 47,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 47,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 47,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 47,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 47,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 47,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 47,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 47,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 47,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 47,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 47,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 47,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 47,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 47,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 47,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 47,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 47,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 47,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 47,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 47,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 47,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 47,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 47,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 47,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 47,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 47,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 47,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 47,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 47,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 47,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 47,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 47,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 47,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 47,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 47,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 47,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 47,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 47,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 47,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 47,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 47,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 47,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 47,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 47,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 47,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 47,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 47,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 47,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 47,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 47,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 47,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 47,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 47,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 47,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 47,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 47,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 47,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 47,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 47,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 47,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 47,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 47,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 47,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 47,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 47,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 47,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 47,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_03_Rowlock = {
  C: {
    templateId: 48,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 48,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 48,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 48,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 48,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 48,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 48,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 48,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 48,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 48,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 48,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 48,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 48,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 48,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 48,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 48,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 48,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 48,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 48,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 48,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 48,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 48,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 48,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 48,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 48,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 48,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 48,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 48,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 48,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 48,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 48,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 48,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 48,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 48,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 48,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 48,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 48,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 48,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 48,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 48,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 48,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 48,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 48,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 48,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 48,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 48,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 48,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 48,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 48,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 48,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 48,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 48,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 48,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 48,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 48,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 48,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 48,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 48,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 48,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 48,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 48,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 48,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 48,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 48,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 48,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 48,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 48,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 48,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 48,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 48,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 48,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 48,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 48,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 48,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 48,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 48,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 48,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 48,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 48,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 48,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 48,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 48,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 48,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 48,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 48,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 48,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 48,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 48,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 48,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 48,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 48,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 48,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 48,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 48,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 48,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 48,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 48,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 48,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 48,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 48,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 48,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 48,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 48,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 48,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 48,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 48,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 48,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 48,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 48,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 48,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 48,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 48,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 48,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 48,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 48,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 48,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 48,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 48,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 48,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 48,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 48,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 48,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 48,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 48,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 48,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 48,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 48,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 48,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 48,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 48,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 48,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 48,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 48,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 48,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 48,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 48,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 48,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 48,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 48,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 48,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 48,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 48,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 48,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 48,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 48,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 48,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 48,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 48,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 48,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 48,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 48,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 48,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 48,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 48,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 48,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 48,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 48,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 48,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 48,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 48,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 48,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 48,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 48,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 48,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 48,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 48,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 48,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 48,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 48,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 48,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 48,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 48,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 48,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 48,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 48,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 48,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 48,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 48,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 48,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 48,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 48,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 48,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 48,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 48,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 48,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 48,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 48,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 48,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 48,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 48,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 48,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 48,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 48,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 48,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 48,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 48,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 48,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 48,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 48,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 48,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 48,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 48,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 48,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 48,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 48,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 48,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 48,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 48,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 48,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 48,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 48,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 48,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 48,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 48,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 48,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 48,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 48,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 48,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 48,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 48,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 48,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 48,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 48,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 48,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 48,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 48,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 48,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 48,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 48,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 48,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 48,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 48,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 48,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 48,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 48,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 48,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 48,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 48,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 48,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 48,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 48,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 48,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 48,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_05 = {
  C: {
    templateId: 52,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 52,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 52,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 52,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 52,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 52,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 52,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 52,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 52,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 52,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 52,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 52,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 52,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 52,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 52,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 52,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 52,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 52,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 52,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 52,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 52,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 52,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 52,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 52,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 52,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 52,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 52,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 52,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 52,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 52,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 52,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 52,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 52,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 52,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 52,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 52,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 52,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 52,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 52,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 52,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 52,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 52,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 52,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 52,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 52,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 52,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 52,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 52,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 52,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 52,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 52,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 52,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 52,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 52,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 52,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 52,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 52,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 52,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 52,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 52,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 52,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 52,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 52,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 52,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 52,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 52,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 52,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 52,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 52,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 52,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 52,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 52,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 52,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 52,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 52,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 52,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 52,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 52,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 52,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 52,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 52,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 52,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 52,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 52,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 52,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 52,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 52,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 52,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 52,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 52,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 52,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 52,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 52,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 52,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 52,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 52,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 52,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 52,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 52,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 52,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 52,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 52,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 52,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 52,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 52,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 52,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 52,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 52,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 52,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 52,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 52,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 52,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 52,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 52,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 52,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 52,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 52,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 52,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 52,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 52,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 52,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 52,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 52,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 52,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 52,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 52,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 52,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 52,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 52,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 52,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 52,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 52,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 52,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 52,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 52,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 52,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 52,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 52,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 52,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 52,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 52,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 52,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 52,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 52,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 52,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 52,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 52,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 52,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 52,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 52,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 52,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 52,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 52,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 52,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 52,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 52,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 52,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 52,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 52,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 52,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 52,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 52,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 52,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 52,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 52,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 52,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 52,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 52,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 52,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 52,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 52,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 52,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 52,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 52,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 52,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 52,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 52,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 52,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 52,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 52,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 52,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 52,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 52,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 52,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 52,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 52,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 52,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 52,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 52,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 52,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 52,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 52,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 52,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 52,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 52,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 52,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 52,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 52,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 52,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 52,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 52,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 52,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 52,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 52,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 52,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 52,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 52,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 52,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 52,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 52,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 52,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 52,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 52,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 52,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 52,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 52,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 52,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 52,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 52,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 52,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 52,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 52,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 52,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 52,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 52,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 52,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 52,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 52,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 52,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 52,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 52,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 52,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 52,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 52,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 52,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 52,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 52,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 52,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 52,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 52,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 52,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 52,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 52,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_05_Header = {
  C: {
    templateId: 50,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 50,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 50,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 50,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 50,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 50,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 50,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 50,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 50,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 50,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 50,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 50,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 50,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 50,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 50,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 50,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 50,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 50,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 50,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 50,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 50,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 50,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 50,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 50,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 50,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 50,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 50,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 50,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 50,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 50,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 50,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 50,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 50,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 50,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 50,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 50,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 50,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 50,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 50,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 50,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 50,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 50,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 50,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 50,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 50,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 50,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 50,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 50,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 50,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 50,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 50,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 50,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 50,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 50,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 50,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 50,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 50,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 50,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 50,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 50,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 50,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 50,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 50,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 50,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 50,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 50,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 50,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 50,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 50,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 50,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 50,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 50,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 50,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 50,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 50,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 50,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 50,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 50,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 50,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 50,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 50,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 50,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 50,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 50,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 50,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 50,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 50,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 50,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 50,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 50,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 50,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 50,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 50,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 50,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 50,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 50,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 50,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 50,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 50,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 50,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 50,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 50,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 50,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 50,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 50,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 50,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 50,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 50,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 50,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 50,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 50,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 50,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 50,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 50,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 50,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 50,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 50,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 50,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 50,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 50,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 50,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 50,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 50,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 50,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 50,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 50,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 50,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 50,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 50,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 50,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 50,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 50,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 50,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 50,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 50,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 50,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 50,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 50,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 50,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 50,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 50,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 50,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 50,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 50,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 50,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 50,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 50,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 50,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 50,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 50,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 50,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 50,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 50,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 50,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 50,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 50,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 50,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 50,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 50,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 50,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 50,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 50,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 50,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 50,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 50,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 50,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 50,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 50,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 50,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 50,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 50,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 50,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 50,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 50,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 50,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 50,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 50,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 50,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 50,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 50,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 50,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 50,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 50,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 50,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 50,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 50,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 50,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 50,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 50,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 50,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 50,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 50,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 50,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 50,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 50,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 50,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 50,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 50,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 50,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 50,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 50,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 50,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 50,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 50,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 50,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 50,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 50,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 50,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 50,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 50,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 50,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 50,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 50,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 50,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 50,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 50,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 50,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 50,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 50,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 50,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 50,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 50,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 50,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 50,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 50,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 50,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 50,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 50,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 50,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 50,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 50,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 50,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 50,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 50,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 50,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 50,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 50,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 50,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 50,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 50,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 50,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 50,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 50,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_05_Rowlock = {
  C: {
    templateId: 51,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 51,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 51,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 51,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 51,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 51,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 51,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 51,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 51,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 51,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 51,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 51,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 51,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 51,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 51,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 51,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 51,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 51,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 51,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 51,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 51,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 51,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 51,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 51,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 51,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 51,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 51,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 51,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 51,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 51,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 51,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 51,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 51,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 51,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 51,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 51,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 51,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 51,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 51,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 51,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 51,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 51,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 51,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 51,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 51,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 51,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 51,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 51,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 51,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 51,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 51,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 51,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 51,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 51,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 51,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 51,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 51,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 51,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 51,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 51,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 51,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 51,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 51,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 51,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 51,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 51,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 51,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 51,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 51,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 51,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 51,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 51,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 51,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 51,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 51,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 51,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 51,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 51,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 51,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 51,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 51,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 51,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 51,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 51,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 51,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 51,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 51,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 51,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 51,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 51,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 51,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 51,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 51,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 51,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 51,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 51,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 51,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 51,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 51,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 51,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 51,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 51,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 51,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 51,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 51,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 51,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 51,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 51,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 51,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 51,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 51,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 51,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 51,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 51,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 51,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 51,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 51,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 51,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 51,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 51,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 51,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 51,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 51,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 51,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 51,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 51,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 51,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 51,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 51,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 51,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 51,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 51,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 51,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 51,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 51,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 51,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 51,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 51,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 51,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 51,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 51,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 51,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 51,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 51,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 51,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 51,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 51,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 51,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 51,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 51,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 51,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 51,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 51,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 51,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 51,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 51,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 51,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 51,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 51,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 51,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 51,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 51,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 51,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 51,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 51,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 51,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 51,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 51,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 51,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 51,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 51,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 51,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 51,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 51,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 51,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 51,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 51,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 51,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 51,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 51,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 51,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 51,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 51,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 51,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 51,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 51,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 51,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 51,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 51,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 51,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 51,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 51,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 51,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 51,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 51,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 51,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 51,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 51,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 51,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 51,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 51,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 51,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 51,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 51,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 51,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 51,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 51,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 51,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 51,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 51,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 51,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 51,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 51,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 51,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 51,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 51,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 51,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 51,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 51,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 51,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 51,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 51,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 51,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 51,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 51,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 51,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 51,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 51,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 51,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 51,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 51,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 51,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 51,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 51,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 51,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 51,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 51,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 51,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 51,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 51,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 51,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 51,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 51,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_075 = {
  C: {
    templateId: 55,
  },
  Default: {
    templateId: 55,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 55,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 55,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 55,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 55,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 55,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 55,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 55,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 55,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 55,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 55,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 55,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 55,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 55,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 55,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 55,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 55,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 55,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 55,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 55,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 55,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 55,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 55,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 55,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 55,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 55,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 55,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 55,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 55,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 55,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 55,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 55,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 55,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 55,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 55,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 55,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 55,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 55,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 55,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 55,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 55,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 55,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 55,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 55,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 55,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 55,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 55,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 55,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 55,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 55,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 55,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 55,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 55,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 55,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 55,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 55,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 55,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 55,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 55,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 55,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 55,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 55,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 55,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 55,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 55,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 55,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 55,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 55,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 55,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 55,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 55,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 55,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 55,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 55,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 55,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 55,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 55,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 55,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 55,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 55,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 55,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 55,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 55,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 55,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 55,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 55,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 55,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 55,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 55,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 55,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 55,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 55,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 55,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 55,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 55,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 55,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 55,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 55,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 55,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 55,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 55,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 55,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 55,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 55,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 55,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 55,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 55,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 55,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 55,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 55,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 55,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 55,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 55,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 55,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 55,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 55,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 55,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 55,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 55,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 55,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 55,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 55,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 55,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 55,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 55,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 55,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 55,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 55,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 55,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 55,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 55,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 55,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 55,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 55,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 55,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 55,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 55,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 55,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 55,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 55,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 55,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 55,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 55,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 55,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 55,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 55,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 55,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 55,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 55,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 55,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 55,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 55,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 55,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 55,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 55,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 55,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 55,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 55,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 55,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 55,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 55,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 55,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 55,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 55,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 55,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 55,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 55,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 55,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 55,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 55,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 55,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 55,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 55,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 55,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 55,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 55,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 55,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 55,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 55,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 55,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 55,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 55,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 55,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 55,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 55,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 55,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 55,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 55,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 55,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 55,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 55,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 55,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 55,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 55,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 55,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 55,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 55,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 55,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 55,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 55,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 55,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 55,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 55,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 55,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 55,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 55,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 55,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 55,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 55,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 55,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 55,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 55,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 55,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 55,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 55,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 55,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 55,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 55,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 55,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 55,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 55,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 55,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 55,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 55,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 55,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 55,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 55,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 55,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 55,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 55,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 55,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 55,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 55,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 55,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 55,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 55,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 55,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 55,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 55,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 55,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 55,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 55,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 55,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_075_Header = {
  C: {
    templateId: 53,
  },
  Default: {
    templateId: 53,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 53,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 53,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 53,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 53,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 53,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 53,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 53,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 53,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 53,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 53,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 53,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 53,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 53,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 53,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 53,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 53,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 53,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 53,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 53,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 53,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 53,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 53,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 53,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 53,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 53,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 53,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 53,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 53,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 53,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 53,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 53,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 53,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 53,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 53,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 53,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 53,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 53,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 53,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 53,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 53,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 53,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 53,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 53,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 53,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 53,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 53,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 53,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 53,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 53,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 53,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 53,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 53,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 53,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 53,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 53,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 53,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 53,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 53,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 53,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 53,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 53,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 53,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 53,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 53,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 53,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 53,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 53,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 53,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 53,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 53,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 53,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 53,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 53,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 53,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 53,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 53,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 53,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 53,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 53,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 53,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 53,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 53,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 53,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 53,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 53,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 53,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 53,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 53,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 53,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 53,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 53,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 53,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 53,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 53,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 53,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 53,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 53,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 53,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 53,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 53,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 53,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 53,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 53,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 53,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 53,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 53,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 53,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 53,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 53,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 53,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 53,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 53,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 53,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 53,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 53,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 53,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 53,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 53,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 53,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 53,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 53,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 53,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 53,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 53,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 53,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 53,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 53,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 53,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 53,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 53,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 53,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 53,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 53,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 53,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 53,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 53,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 53,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 53,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 53,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 53,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 53,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 53,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 53,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 53,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 53,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 53,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 53,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 53,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 53,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 53,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 53,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 53,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 53,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 53,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 53,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 53,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 53,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 53,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 53,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 53,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 53,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 53,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 53,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 53,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 53,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 53,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 53,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 53,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 53,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 53,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 53,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 53,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 53,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 53,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 53,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 53,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 53,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 53,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 53,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 53,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 53,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 53,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 53,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 53,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 53,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 53,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 53,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 53,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 53,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 53,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 53,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 53,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 53,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 53,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 53,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 53,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 53,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 53,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 53,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 53,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 53,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 53,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 53,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 53,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 53,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 53,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 53,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 53,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 53,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 53,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 53,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 53,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 53,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 53,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 53,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 53,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 53,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 53,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 53,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 53,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 53,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 53,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 53,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 53,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 53,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 53,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 53,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 53,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 53,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 53,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 53,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 53,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 53,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 53,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 53,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 53,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 53,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 53,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 53,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 53,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 53,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 53,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_075_Rowlock = {
  C: {
    templateId: 54,
  },
  Default: {
    templateId: 54,
  },
  L: {
    Brick_Acme: {
      Brick_Acme_Abbeville: {
        layerConfigId: 845,
        templateId: 54,
      },
      Brick_Acme_AdenBlend: {
        layerConfigId: 844,
        templateId: 54,
      },
      Brick_Acme_AdobeWells: {
        layerConfigId: 249,
        templateId: 54,
      },
      Brick_Acme_AnsleyPark: {
        layerConfigId: 761,
        templateId: 54,
      },
      Brick_Acme_ArcticMist: {
        layerConfigId: 893,
        templateId: 54,
      },
      Brick_Acme_AuburnHills: {
        layerConfigId: 879,
        templateId: 54,
      },
      Brick_Acme_Augusta: {
        layerConfigId: 294,
        templateId: 54,
      },
      Brick_Acme_Brookstone: {
        layerConfigId: 441,
        templateId: 54,
      },
      Brick_Acme_Callisburg: {
        layerConfigId: 607,
        templateId: 54,
      },
      Brick_Acme_CameronHills: {
        layerConfigId: 608,
        templateId: 54,
      },
      Brick_Acme_CasaBlanca: {
        layerConfigId: 597,
        templateId: 54,
      },
      Brick_Acme_DentonAntique: {
        layerConfigId: 609,
        templateId: 54,
      },
      Brick_Acme_ForestHills: {
        layerConfigId: 530,
        templateId: 54,
      },
      Brick_Acme_FrenchChateaux: {
        layerConfigId: 568,
        templateId: 54,
      },
      Brick_Acme_Frostwood: {
        layerConfigId: 250,
        templateId: 54,
      },
      Brick_Acme_GlacierBay: {
        layerConfigId: 452,
        templateId: 54,
      },
      Brick_Acme_GlacierWhite: {
        layerConfigId: 915,
        templateId: 54,
      },
      Brick_Acme_HamptonMill: {
        layerConfigId: 295,
        templateId: 54,
      },
      Brick_Acme_Highstone: {
        layerConfigId: 453,
        templateId: 54,
      },
      Brick_Acme_Inverness: {
        layerConfigId: 894,
        templateId: 54,
      },
      Brick_Acme_Menawa: {
        layerConfigId: 762,
        templateId: 54,
      },
      Brick_Acme_MochaBrownAntique: {
        layerConfigId: 569,
        templateId: 54,
      },
      Brick_Acme_MountainBrook: {
        layerConfigId: 442,
        templateId: 54,
      },
      Brick_Acme_MushroomBrown: {
        layerConfigId: 763,
        templateId: 54,
      },
      Brick_Acme_OldFrancisco: {
        layerConfigId: 610,
        templateId: 54,
      },
      Brick_Acme_OldTavern: {
        layerConfigId: 809,
        templateId: 54,
      },
      Brick_Acme_OysterBay: {
        layerConfigId: 296,
        templateId: 54,
      },
      Brick_Acme_ParkShadows: {
        layerConfigId: 251,
        templateId: 54,
      },
      Brick_Acme_PineRidge: {
        layerConfigId: 297,
        templateId: 54,
      },
      Brick_Acme_RapidFalls: {
        layerConfigId: 298,
        templateId: 54,
      },
      Brick_Acme_Rockwell: {
        layerConfigId: 443,
        templateId: 54,
      },
      Brick_Acme_Saltgrass: {
        layerConfigId: 881,
        templateId: 54,
      },
      Brick_Acme_SanJose: {
        layerConfigId: 531,
        templateId: 54,
      },
      Brick_Acme_Scottsdale: {
        layerConfigId: 299,
        templateId: 54,
      },
      Brick_Acme_Seabrook: {
        layerConfigId: 532,
        templateId: 54,
      },
      Brick_Acme_Shenandoah: {
        layerConfigId: 888,
        templateId: 54,
      },
      Brick_Acme_Silvercreek: {
        layerConfigId: 598,
        templateId: 54,
      },
      Brick_Acme_Silverthorn: {
        layerConfigId: 252,
        templateId: 54,
      },
      Brick_Acme_SpanishBay: {
        layerConfigId: 889,
        templateId: 54,
      },
      Brick_Acme_StoneBay: {
        layerConfigId: 253,
        templateId: 54,
      },
      Brick_Acme_SummerSage: {
        layerConfigId: 882,
        templateId: 54,
      },
      Brick_Acme_Texas: {
        layerConfigId: 764,
        templateId: 54,
      },
      Brick_Acme_WhiteBluff: {
        layerConfigId: 890,
        templateId: 54,
      },
      Brick_Acme_WhiteRiverRock: {
        layerConfigId: 454,
        templateId: 54,
      },
      Brick_Acme_Winterstone: {
        layerConfigId: 611,
        templateId: 54,
      },
    },
    Brick_Belden: {
      Brick_Belden_BlackDiamondVelour: {
        layerConfigId: 916,
        templateId: 54,
      },
      Brick_Belden_GraphiteVelour: {
        layerConfigId: 917,
        templateId: 54,
      },
    },
    Brick_Bilco: {
      Brick_Bilco_Camel: {
        layerConfigId: 710,
        templateId: 54,
      },
      Brick_Bilco_Everest: {
        layerConfigId: 599,
        templateId: 54,
      },
      Brick_Bilco_GrayMist: {
        layerConfigId: 600,
        templateId: 54,
      },
      Brick_Bilco_Graystone: {
        layerConfigId: 711,
        templateId: 54,
      },
      Brick_Bilco_Onyx: {
        layerConfigId: 712,
        templateId: 54,
      },
      Brick_Bilco_Phoenix: {
        layerConfigId: 713,
        templateId: 54,
      },
      Brick_Bilco_Scottsdale: {
        layerConfigId: 601,
        templateId: 54,
      },
      Brick_Bilco_Stardust: {
        layerConfigId: 455,
        templateId: 54,
      },
    },
    Brick_Binsa: {
      Brick_Binsa_AmericanAntique: {
        layerConfigId: 570,
        templateId: 54,
      },
      Brick_Binsa_EnglishDove: {
        layerConfigId: 818,
        templateId: 54,
      },
      Brick_Binsa_HillStone: {
        layerConfigId: 571,
        templateId: 54,
      },
      Brick_Binsa_Monroe: {
        layerConfigId: 1131,
        templateId: 54,
      },
      Brick_Binsa_Smokey: {
        layerConfigId: 1132,
        templateId: 54,
      },
    },
    Brick_CasaDaSassi: {
      Brick_CdS_FullBrown: {
        layerConfigId: 107,
        templateId: 54,
      },
    },
    Brick_Cherokee: {
      Brick_Che_Augusta: {
        layerConfigId: 48,
        templateId: 54,
      },
      Brick_Che_Magnolia: {
        layerConfigId: 843,
        templateId: 54,
      },
      Brick_Che_Natchez: {
        layerConfigId: 49,
        templateId: 54,
      },
    },
    Brick_Claymex: {
      Brick_Claymex_Alpine: {
        layerConfigId: 647,
        templateId: 54,
      },
      Brick_Claymex_Aspen: {
        layerConfigId: 819,
        templateId: 54,
      },
      Brick_Claymex_Brownfield: {
        layerConfigId: 648,
        templateId: 54,
      },
      Brick_Claymex_Cobblestone: {
        layerConfigId: 649,
        templateId: 54,
      },
      Brick_Claymex_Keystone: {
        layerConfigId: 650,
        templateId: 54,
      },
      Brick_Claymex_LeMont: {
        layerConfigId: 405,
        templateId: 54,
      },
      Brick_Claymex_Onyx: {
        layerConfigId: 653,
        templateId: 54,
      },
      Brick_Claymex_Oxford: {
        layerConfigId: 406,
        templateId: 54,
      },
      Brick_Claymex_Pewter: {
        layerConfigId: 654,
        templateId: 54,
      },
      Brick_Claymex_Woodcreek: {
        layerConfigId: 655,
        templateId: 54,
      },
      Brick_Claymex_York: {
        layerConfigId: 656,
        templateId: 54,
      },
    },
    Brick_Columbus: {
      Brick_Columbus_MagnoliaBay: {
        layerConfigId: 1072,
        templateId: 54,
      },
      Brick_Columbus_Weracoba2: {
        layerConfigId: 1073,
        templateId: 54,
      },
    },
    Brick_CommercialBrickCompany: {
      Brick_CBC_ChandlerWhite: {
        layerConfigId: 883,
        templateId: 54,
      },
      Brick_CBC_Hollister: {
        layerConfigId: 884,
        templateId: 54,
      },
    },
    Brick_FAKE: {
      Brick_FAKE_Chalk: {
        layerConfigId: 40,
        templateId: 54,
      },
    },
    Brick_GeneralShale: {
      Brick_GS_AlpineSelect: {
        layerConfigId: 584,
        templateId: 54,
      },
      Brick_GS_Ashview: {
        layerConfigId: 431,
        templateId: 54,
      },
      Brick_GS_BarnsleyTudor: {
        layerConfigId: 563,
        templateId: 54,
      },
      Brick_GS_BourbonTrail: {
        layerConfigId: 391,
        templateId: 54,
      },
      Brick_GS_BradfordHall: {
        layerConfigId: 729,
        templateId: 54,
      },
      Brick_GS_CapersIsland: {
        layerConfigId: 633,
        templateId: 54,
      },
      Brick_GS_CavalryGray: {
        layerConfigId: 392,
        templateId: 54,
      },
      Brick_GS_ClaytonFalls: {
        layerConfigId: 748,
        templateId: 54,
      },
      Brick_GS_ColonyPointe: {
        layerConfigId: 1238,
        templateId: 54,
      },
      Brick_GS_Cortez: {
        layerConfigId: 727,
        templateId: 54,
      },
      Brick_GS_CumberlandTudor: {
        layerConfigId: 1239,
        templateId: 54,
      },
      Brick_GS_Domino: {
        layerConfigId: 390,
        templateId: 54,
      },
      Brick_GS_EnglishPub: {
        layerConfigId: 1219,
        templateId: 54,
      },
      Brick_GS_Graymoor: {
        layerConfigId: 746,
        templateId: 54,
      },
      Brick_GS_Graysburg: {
        layerConfigId: 919,
        templateId: 54,
      },
      Brick_GS_HeritageTrail: {
        layerConfigId: 635,
        templateId: 54,
      },
      Brick_GS_Ironworks: {
        layerConfigId: 1220,
        templateId: 54,
      },
      Brick_GS_KeenelandElite: {
        layerConfigId: 564,
        templateId: 54,
      },
      Brick_GS_ManorHouseTudor: {
        layerConfigId: 567,
        templateId: 54,
      },
      Brick_GS_ModenaPaver: {
        layerConfigId: 936,
        templateId: 54,
      },
      Brick_GS_MorningSmoke: {
        layerConfigId: 920,
        templateId: 54,
      },
      Brick_GS_NewcastleGray: {
        layerConfigId: 593,
        templateId: 54,
      },
      Brick_GS_NolinRiver: {
        layerConfigId: 393,
        templateId: 54,
      },
      Brick_GS_OldEdisto: {
        layerConfigId: 594,
        templateId: 54,
      },
      Brick_GS_OldEnglishTutor: {
        layerConfigId: 921,
        templateId: 54,
      },
      Brick_GS_Peppermill: {
        layerConfigId: 1221,
        templateId: 54,
      },
      Brick_GS_RedColonial: {
        layerConfigId: 750,
        templateId: 54,
      },
      Brick_GS_ShadowGrey: {
        layerConfigId: 565,
        templateId: 54,
      },
      Brick_GS_SpanishMoss: {
        layerConfigId: 630,
        templateId: 54,
      },
      Brick_GS_StoneMountain: {
        layerConfigId: 634,
        templateId: 54,
      },
      Brick_GS_SwanCreek: {
        layerConfigId: 394,
        templateId: 54,
      },
      Brick_GS_Valor: {
        layerConfigId: 755,
        templateId: 54,
      },
      Brick_GS_VintagePort: {
        layerConfigId: 585,
        templateId: 54,
      },
      Brick_GS_Winstar: {
        layerConfigId: 432,
        templateId: 54,
      },
      Brick_GS_Winterhaven: {
        layerConfigId: 960,
        templateId: 54,
      },
      Brick_GS_Wynnewood: {
        layerConfigId: 586,
        templateId: 54,
      },
    },
    Brick_GlenGery: {
      Brick_GlenGery_Americano: {
        layerConfigId: 1213,
        templateId: 54,
      },
      Brick_GlenGery_AnthraciteSmooth: {
        layerConfigId: 1214,
        templateId: 54,
      },
      Brick_GlenGery_AntiqueWhite: {
        layerConfigId: 254,
        templateId: 54,
      },
      Brick_GlenGery_AspenWhite: {
        layerConfigId: 1215,
        templateId: 54,
      },
      Brick_GlenGery_AztecWhite: {
        layerConfigId: 255,
        templateId: 54,
      },
      Brick_GlenGery_BaxterBrownSmooth: {
        layerConfigId: 1216,
        templateId: 54,
      },
      Brick_GlenGery_Birch: {
        layerConfigId: 256,
        templateId: 54,
      },
      Brick_GlenGery_Casablanca: {
        layerConfigId: 257,
        templateId: 54,
      },
      Brick_GlenGery_ClassicCreamSmooth: {
        layerConfigId: 1217,
        templateId: 54,
      },
      Brick_GlenGery_RusticGrayWaterstruck: {
        layerConfigId: 1218,
        templateId: 54,
      },
      Brick_GlenGery_WilliamsburgBradford: {
        layerConfigId: 258,
        templateId: 54,
      },
      Brick_GlenGery_WilliamsburgCherryCreek: {
        layerConfigId: 259,
        templateId: 54,
      },
      Brick_GlenGery_WilliamsburgHampton: {
        layerConfigId: 260,
        templateId: 54,
      },
    },
    Brick_Harristone: {
      Brick_Harristone_Charleston: {
        layerConfigId: 668,
        templateId: 54,
      },
      Brick_Harristone_DoveGrey: {
        layerConfigId: 669,
        templateId: 54,
      },
      Brick_Harristone_Midnight: {
        layerConfigId: 1021,
        templateId: 54,
      },
      Brick_Harristone_WhiteSand: {
        layerConfigId: 670,
        templateId: 54,
      },
    },
    Brick_HenryBrick: {
      Brick_HB_Avondale: {
        layerConfigId: 1022,
        templateId: 54,
      },
      Brick_HB_CypressPoint: {
        layerConfigId: 395,
        templateId: 54,
      },
    },
    Brick_Heritage: {
      Brick_Heritage_Ashwood: {
        layerConfigId: 724,
        templateId: 54,
      },
    },
    Brick_Lusco: {
      Brick_Lusco_PearlRiver: {
        layerConfigId: 273,
        templateId: 54,
      },
    },
    Brick_Meridian: {
      Brick_Mer_Alamo: {
        layerConfigId: 90,
        templateId: 54,
      },
      Brick_Mer_AlpineSelect: {
        layerConfigId: 50,
        templateId: 54,
      },
      Brick_Mer_Baytown: {
        layerConfigId: 99,
        templateId: 54,
      },
      Brick_Mer_Belhaven: {
        layerConfigId: 91,
        templateId: 54,
      },
      Brick_Mer_ChimneyMountain: {
        layerConfigId: 290,
        templateId: 54,
      },
      Brick_Mer_Dover: {
        layerConfigId: 100,
        templateId: 54,
      },
      Brick_Mer_FireOak: {
        layerConfigId: 1133,
        templateId: 54,
      },
      Brick_Mer_Laredo: {
        layerConfigId: 92,
        templateId: 54,
      },
      Brick_Mer_MtRushmore: {
        layerConfigId: 93,
        templateId: 54,
      },
      Brick_Mer_NorthHighland: {
        layerConfigId: 94,
        templateId: 54,
      },
      Brick_Mer_OldGuignard: {
        layerConfigId: 95,
        templateId: 54,
      },
      Brick_Mer_OldJackson: {
        layerConfigId: 96,
        templateId: 54,
      },
      Brick_Mer_PortHuron: {
        layerConfigId: 291,
        templateId: 54,
      },
      Brick_Mer_SaltPlains: {
        layerConfigId: 45,
        templateId: 54,
      },
      Brick_Mer_ShadowFalls: {
        layerConfigId: 46,
        templateId: 54,
      },
      Brick_Mer_Smithsonian: {
        layerConfigId: 97,
        templateId: 54,
      },
      Brick_Mer_StAndrews: {
        layerConfigId: 101,
        templateId: 54,
      },
      Brick_Mer_StLorain: {
        layerConfigId: 98,
        templateId: 54,
      },
      Brick_Mer_SummerAsh: {
        layerConfigId: 47,
        templateId: 54,
      },
      Brick_Mer_WhiteHillstone: {
        layerConfigId: 1134,
        templateId: 54,
      },
      Brick_Mer_WhiteRiverRock: {
        layerConfigId: 1135,
        templateId: 54,
      },
    },
    Brick_Paint_SW: {
      Brick_SW_6246_NorthStar: {
        layerConfigId: 134,
        templateId: 54,
      },
      Brick_SW_7004_Snowbound: {
        layerConfigId: 324,
        templateId: 54,
      },
      Brick_SW_7068_GrizzleGray: {
        layerConfigId: 41,
        templateId: 54,
      },
      Brick_SW_9171_FeltedWool: {
        layerConfigId: 135,
        templateId: 54,
      },
      Brick_SW_9174_MothWing: {
        layerConfigId: 136,
        templateId: 54,
      },
    },
    Brick_PGH: {
      Brick_PGH_Bark: {
        layerConfigId: 665,
        templateId: 54,
      },
      Brick_PGH_CharacterPutty: {
        layerConfigId: 666,
        templateId: 54,
      },
      Brick_PGH_CharacterRedRock: {
        layerConfigId: 667,
        templateId: 54,
      },
    },
    Brick_PrestigeStone: {
      Brick_PS_Farmhouse: {
        layerConfigId: 864,
        templateId: 54,
      },
    },
    Brick_ProVia: {
      Brick_ProVia_Boston: {
        layerConfigId: 720,
        templateId: 54,
      },
      Brick_ProVia_Cobblestone: {
        layerConfigId: 721,
        templateId: 54,
      },
      Brick_ProVia_Delaware: {
        layerConfigId: 722,
        templateId: 54,
      },
      Brick_ProVia_Midnight: {
        layerConfigId: 723,
        templateId: 54,
      },
    },
    Brick_PVStone: {
      Brick_PVStone_Colonial: {
        layerConfigId: 810,
        templateId: 54,
      },
      Brick_PVStone_Neptune: {
        layerConfigId: 811,
        templateId: 54,
      },
    },
    Brick_RedRiver: {
      Brick_RedRiver_AlpineFog: {
        layerConfigId: 261,
        templateId: 54,
      },
      Brick_RedRiver_Amarylis: {
        layerConfigId: 389,
        templateId: 54,
      },
      Brick_RedRiver_BurlingtonAntique: {
        layerConfigId: 302,
        templateId: 54,
      },
      Brick_RedRiver_Caprock: {
        layerConfigId: 303,
        templateId: 54,
      },
      Brick_RedRiver_CrescentGrove: {
        layerConfigId: 262,
        templateId: 54,
      },
      Brick_RedRiver_CypressSprings: {
        layerConfigId: 304,
        templateId: 54,
      },
      Brick_RedRiver_FireOak: {
        layerConfigId: 263,
        templateId: 54,
      },
      Brick_RedRiver_FlintRanch: {
        layerConfigId: 885,
        templateId: 54,
      },
      Brick_RedRiver_FoggyMorning: {
        layerConfigId: 602,
        templateId: 54,
      },
      Brick_RedRiver_Glenwood: {
        layerConfigId: 264,
        templateId: 54,
      },
      Brick_RedRiver_GlisteningSprings: {
        layerConfigId: 572,
        templateId: 54,
      },
      Brick_RedRiver_Mayfield: {
        layerConfigId: 305,
        templateId: 54,
      },
      Brick_RedRiver_OzarkSmoke: {
        layerConfigId: 886,
        templateId: 54,
      },
      Brick_RedRiver_Ridgemont: {
        layerConfigId: 306,
        templateId: 54,
      },
      Brick_RedRiver_SaltPlains: {
        layerConfigId: 265,
        templateId: 54,
      },
      Brick_RedRiver_ShadowFalls: {
        layerConfigId: 266,
        templateId: 54,
      },
      Brick_RedRiver_ShelteredBluff: {
        layerConfigId: 267,
        templateId: 54,
      },
      Brick_RedRiver_Silverado: {
        layerConfigId: 307,
        templateId: 54,
      },
      Brick_RedRiver_SnowMist: {
        layerConfigId: 603,
        templateId: 54,
      },
      Brick_RedRiver_Tecomate: {
        layerConfigId: 268,
        templateId: 54,
      },
      Brick_RedRiver_WellsValley: {
        layerConfigId: 274,
        templateId: 54,
      },
      Brick_RedRiver_WhiteRiverRock: {
        layerConfigId: 604,
        templateId: 54,
      },
    },
    Brick_Ryder: {
      Brick_Ryder_AntiqueWhite: {
        layerConfigId: 891,
        templateId: 54,
      },
      Brick_Ryder_Casablanca: {
        layerConfigId: 892,
        templateId: 54,
      },
    },
    Brick_Spaulding: {
      Brick_Spaulding_Onslow: {
        layerConfigId: 1023,
        templateId: 54,
      },
      Brick_Spaulding_YankeeHill: {
        layerConfigId: 918,
        templateId: 54,
      },
    },
    Brick_TexasStone: {
      Brick_TexasStone_DarkGrayLuxbrick: {
        layerConfigId: 913,
        templateId: 54,
      },
      Brick_TexasStone_OldTownLux: {
        layerConfigId: 914,
        templateId: 54,
      },
    },
    Brick_Triangle: {
      Brick_Tri_BessemerGray: {
        layerConfigId: 42,
        templateId: 54,
      },
      Brick_Tri_CapeFear: {
        layerConfigId: 747,
        templateId: 54,
      },
      Brick_Tri_ChesapeakeGrey: {
        layerConfigId: 808,
        templateId: 54,
      },
      Brick_Tri_DoverWhite: {
        layerConfigId: 420,
        templateId: 54,
      },
      Brick_Tri_EvelynBay: {
        layerConfigId: 51,
        templateId: 54,
      },
      Brick_Tri_FederalHill: {
        layerConfigId: 784,
        templateId: 54,
      },
      Brick_Tri_FortMill: {
        layerConfigId: 631,
        templateId: 54,
      },
      Brick_Tri_JeffersonPark: {
        layerConfigId: 407,
        templateId: 54,
      },
      Brick_Tri_LibbyMill: {
        layerConfigId: 632,
        templateId: 54,
      },
      Brick_Tri_MountainBranchSelect: {
        layerConfigId: 52,
        templateId: 54,
      },
      Brick_Tri_Nantucket: {
        layerConfigId: 751,
        templateId: 54,
      },
      Brick_Tri_Northampton: {
        layerConfigId: 106,
        templateId: 54,
      },
      Brick_Tri_Oakton: {
        layerConfigId: 826,
        templateId: 54,
      },
      Brick_Tri_OldColony: {
        layerConfigId: 105,
        templateId: 54,
      },
      Brick_Tri_Oxford: {
        layerConfigId: 43,
        templateId: 54,
      },
      Brick_Tri_Porter: {
        layerConfigId: 573,
        templateId: 54,
      },
      Brick_Tri_Portsmouth: {
        layerConfigId: 785,
        templateId: 54,
      },
      Brick_Tri_RiverStreet: {
        layerConfigId: 786,
        templateId: 54,
      },
      Brick_Tri_SeelyTown: {
        layerConfigId: 408,
        templateId: 54,
      },
      Brick_Tri_ShadowRidge: {
        layerConfigId: 1155,
        templateId: 54,
      },
      Brick_Tri_SouthHampton: {
        layerConfigId: 44,
        templateId: 54,
      },
      Brick_Tri_Wilmington: {
        layerConfigId: 787,
        templateId: 54,
      },
    },
    Brick_USBrick: {
      Brick_US_Alamo: {
        layerConfigId: 961,
        templateId: 54,
      },
      Brick_US_AspenChase: {
        layerConfigId: 962,
        templateId: 54,
      },
      Brick_US_Belhaven: {
        layerConfigId: 963,
        templateId: 54,
      },
      Brick_US_BelleMeade: {
        layerConfigId: 964,
        templateId: 54,
      },
      Brick_US_Blackberry: {
        layerConfigId: 566,
        templateId: 54,
      },
      Brick_US_Magnolia: {
        layerConfigId: 871,
        templateId: 54,
      },
      Brick_US_Monaco: {
        layerConfigId: 728,
        templateId: 54,
      },
      Brick_US_MtRushmore: {
        layerConfigId: 965,
        templateId: 54,
      },
      Brick_US_NatchezTrace: {
        layerConfigId: 872,
        templateId: 54,
      },
      Brick_US_Newcastle: {
        layerConfigId: 966,
        templateId: 54,
      },
      Brick_US_NorthHighland: {
        layerConfigId: 967,
        templateId: 54,
      },
      Brick_US_OldJackson: {
        layerConfigId: 754,
        templateId: 54,
      },
      Brick_US_OldOverton: {
        layerConfigId: 968,
        templateId: 54,
      },
      Brick_US_OldWaverly: {
        layerConfigId: 827,
        templateId: 54,
      },
      Brick_US_OysterCove: {
        layerConfigId: 873,
        templateId: 54,
      },
      Brick_US_ShadowStone: {
        layerConfigId: 874,
        templateId: 54,
      },
      Brick_US_StLorain: {
        layerConfigId: 969,
        templateId: 54,
      },
      Brick_US_TimberWood: {
        layerConfigId: 875,
        templateId: 54,
      },
      Brick_US_Twilight: {
        layerConfigId: 1147,
        templateId: 54,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_Bracciano = {
  C: {
    templateId: 58,
  },
  Default: {
    templateId: 58,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_Bracciano_Header = {
  C: {
    templateId: 56,
  },
  Default: {
    templateId: 56,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Brick_Bracciano_Rowlock = {
  C: {
    templateId: 57,
  },
  Default: {
    templateId: 57,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_CinderBlock08x16 = {
  C: {
    templateId: 473,
  },
  Default: {
    templateId: 473,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Porcelain_Mandarin_CementoLightGrey = {
  Default: {
    templateId: 69,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 81,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 81,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 81,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 81,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 81,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 81,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 81,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 81,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 81,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 81,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 81,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 81,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_StoneField_Tan = {
  Default: {
    templateId: 82,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_StoneLimestone_Banks = {
  Default: {
    templateId: 83,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_StoneLimestone_Bridgeport = {
  Default: {
    templateId: 84,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_StoneMixedStack_GrayWarm = {
  Default: {
    templateId: 85,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_StoneRoughCut_Moonlight = {
  Default: {
    templateId: 86,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_StoneThinStack_Gray = {
  Default: {
    templateId: 87,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_05_Trim = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 78,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 78,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 78,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 78,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 78,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 78,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 78,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_05_Trim_V = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 299,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 299,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 299,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 299,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 299,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 299,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 299,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_12_Trim = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 210,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 210,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 210,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 210,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 210,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 210,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 210,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_12_Trim_V = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 300,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 300,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 300,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 300,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 300,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 300,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 300,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_24_Trim = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 211,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 211,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 211,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 211,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 211,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 211,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 211,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_24_Trim_V = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 301,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 301,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 301,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 301,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 301,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 301,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 301,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_BC_CountryLedge = {
  L: {
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 517,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_BC_MontanaLedge = {
  L: {
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 512,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_BC_OhioRubble = {
  L: {
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 513,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_BC_PrairieBluff = {
  L: {
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 514,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_BC_StoneVeneerSangria = {
  L: {
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 469,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Bello_Cobblestone = {
  L: {
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 529,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 529,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Bello_Fieldstone = {
  L: {
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 530,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Bello_Ledgestone = {
  L: {
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 531,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 531,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 531,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 531,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_BrandCo_Drystack = {
  L: {
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 532,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_BrandCo_Ledgestone = {
  L: {
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 533,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_CDS_Blend = {
  L: {
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 407,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 407,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 407,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_CDS_CountryRubble = {
  L: {
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 408,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 408,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 408,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 408,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 408,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 408,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 408,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 408,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 408,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 408,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 408,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 408,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 408,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 408,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 408,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_CDS_Ledgestone = {
  L: {
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 534,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 534,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 534,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 534,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_CDS_Volterra = {
  L: {
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 410,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 410,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 410,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 410,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 410,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 410,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 410,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_CH_ChiseledEdge = {
  L: {
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 535,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 535,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 535,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Centurion_Elkmont = {
  L: {
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 488,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Centurion_Hackett = {
  L: {
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 556,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Centurion_Ledgestone = {
  L: {
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 557,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 557,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 557,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 557,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 557,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 557,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 557,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Centurion_Rubble = {
  L: {
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 558,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 558,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 558,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 558,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 558,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 558,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Centurion_Stack = {
  L: {
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 522,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 522,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 522,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 522,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 522,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cobblestone = {
  L: {
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 383,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 383,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 383,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 383,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 383,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 383,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cobra_TexasLimestone = {
  L: {
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 536,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 536,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 536,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_AlpineLedgestone = {
  L: {
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 285,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_CountryLedgestone = {
  L: {
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 135,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 135,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 135,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 135,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 135,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 135,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 135,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 135,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 135,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_CountryLedgestone_03_Trim = {
  L: {
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 212,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 212,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 212,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 212,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 212,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 212,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 212,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 212,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_CountryLedgestone_03_Trim_V = {
  L: {
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 302,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 302,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 302,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 302,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 302,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 302,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 302,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 302,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_CountryLedgestone_05_Trim = {
  L: {
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 134,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 134,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 134,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 134,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 134,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 134,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 134,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 134,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_CountryLedgestone_05_Trim_V = {
  L: {
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 303,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 303,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 303,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 303,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 303,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 303,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 303,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 303,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_CountryLedgestone_12_Trim = {
  L: {
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 213,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 213,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 213,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 213,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 213,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 213,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 213,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 213,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_CountryLedgestone_12_Trim_V = {
  L: {
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 304,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 304,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 304,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 304,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 304,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 304,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 304,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 304,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_CountryLedgestone_24_Trim = {
  L: {
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 214,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 214,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 214,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 214,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 214,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 214,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 214,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 214,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_CountryLedgestone_24_Trim_V = {
  L: {
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 305,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 305,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 305,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 305,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 305,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 305,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 305,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 305,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_DrystackLedgestone = {
  L: {
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 286,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_Limestone = {
  L: {
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 559,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 559,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 559,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Cultured_SouthernLedgestone = {
  L: {
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 282,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 282,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 282,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 282,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 282,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_DP_Vener_Cobblestone = {
  L: {
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 560,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_DQ_Drystack = {
  L: {
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 489,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 489,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 489,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 489,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 489,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 489,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_DQ_Ledgestone = {
  L: {
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 524,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 524,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 524,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 524,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 524,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 524,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 524,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 524,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_DQ_Limestone = {
  L: {
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 464,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 464,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 464,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 464,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 464,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 464,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_DQ_RoughAshlar = {
  L: {
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 465,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 465,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 465,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 465,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 465,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_DQ_StackLedge = {
  L: {
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 523,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 523,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 523,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 523,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 523,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 523,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_DQ_Weatherledge = {
  L: {
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 525,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 525,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 525,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 525,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 525,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 525,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 525,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 525,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 525,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 525,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 525,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Drystack = {
  L: {
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 382,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 382,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 382,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 382,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 382,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 382,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 382,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 382,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 382,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 382,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 382,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 382,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 382,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 382,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 382,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 382,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 382,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 382,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 382,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 382,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 382,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 382,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 382,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 382,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 382,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 382,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 382,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 382,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 382,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 382,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 382,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 382,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 382,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 382,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 382,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 382,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 382,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 382,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 382,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 382,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 382,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 382,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 382,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 382,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 382,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 382,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 382,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 382,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 382,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 382,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 382,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 382,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 382,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 382,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 382,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 382,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 382,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 382,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 382,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 382,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 382,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 382,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 382,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 382,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 382,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 382,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 382,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 382,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 382,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 382,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 382,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 382,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 382,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 382,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 382,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 382,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 382,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 382,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 382,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 382,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 382,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 382,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 382,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 382,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 382,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eco_CountryRidge = {
  L: {
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 454,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eco_Ridgestone = {
  L: {
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 456,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_Bluffstone = {
  L: {
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 561,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_Cliffstone = {
  L: {
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 482,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 482,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 482,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 482,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 482,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 482,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_Cliffstone_OLD = {
  L: {
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 283,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 283,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 283,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 283,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 283,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 283,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 283,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 283,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 283,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 283,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 283,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 283,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 283,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 283,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 283,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 283,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 283,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 283,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 283,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_CoarseCutStone = {
  L: {
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 515,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_CypressRidge = {
  L: {
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 516,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_EuropeanLedge = {
  L: {
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 287,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 287,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 287,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 287,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_FieldLedge = {
  L: {
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 455,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_Limestone = {
  L: {
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 493,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_Monument = {
  Default: {
    templateId: 74,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_MountainLedge = {
  L: {
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 137,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 137,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 137,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_MountainLedge_03_Trim = {
  L: {
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 215,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 215,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_MountainLedge_03_Trim_V = {
  L: {
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 306,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 306,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_MountainLedge_05_Trim = {
  L: {
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 136,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 136,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_MountainLedge_05_Trim_V = {
  L: {
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 307,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 307,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_MountainLedge_12_Trim = {
  L: {
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 216,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 216,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_MountainLedge_12_Trim_V = {
  L: {
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 308,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 308,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_MountainLedge_24_Trim = {
  L: {
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 217,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 217,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_MountainLedge_24_Trim_V = {
  L: {
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 309,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 309,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_Ridgetop = {
  Default: {
    templateId: 449,
  },
  L: {
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 449,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_Roughcut = {
  L: {
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 284,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 284,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 284,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 284,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 284,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 284,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_RusticLedge = {
  L: {
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 288,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_SierraCut = {
  L: {
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 526,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_StackedStone = {
  L: {
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 481,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 481,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 481,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 481,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 481,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 481,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Eldorado_TundraBrick = {
  L: {
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 457,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 457,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 457,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 457,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 457,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Env_Chisel = {
  L: {
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 546,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 546,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Env_Cutstone = {
  L: {
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 112,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 112,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 112,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 112,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 112,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 112,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 112,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 112,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 112,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 112,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 112,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 112,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 112,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 112,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 112,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 112,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 112,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 112,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 112,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 112,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 112,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 112,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 112,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 112,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 112,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 112,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 112,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Env_Fieldstone = {
  L: {
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 547,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 547,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 547,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 547,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Env_Grezzo = {
  L: {
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 548,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 548,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 548,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Env_Ledgestone = {
  L: {
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 519,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 519,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 519,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 519,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 519,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 519,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 519,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 519,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 519,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 519,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 519,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 519,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 519,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Env_ProstackLite = {
  L: {
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 549,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 549,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 549,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 549,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 549,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 549,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 549,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Env_Tivoli = {
  L: {
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 550,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 550,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_CreamChisel = {
  Default: {
    templateId: 258,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_CreamChisel_Trim = {
  Default: {
    templateId: 259,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_CreamChisel_Trim_V = {
  Default: {
    templateId: 310,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_CreamTivoli = {
  Default: {
    templateId: 263,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_CreamTivoli_Trim = {
  Default: {
    templateId: 262,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_CreamTivoli_Trim_V = {
  Default: {
    templateId: 311,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_Cutstone_03_Trim = {
  L: {
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 218,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 218,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 218,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 218,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 218,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 218,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 218,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 218,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 218,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 218,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 218,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 218,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 218,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 218,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 218,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 218,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 218,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 218,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_Cutstone_03_Trim_V = {
  L: {
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 312,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 312,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 312,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 312,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 312,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 312,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 312,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 312,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 312,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 312,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 312,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 312,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 312,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 312,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 312,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 312,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 312,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 312,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_Cutstone_05_Trim = {
  L: {
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 120,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 120,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 120,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 120,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 120,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 120,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 120,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 120,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 120,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 120,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 120,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 120,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 120,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 120,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 120,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 120,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 120,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 120,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_Cutstone_05_Trim_V = {
  L: {
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 313,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 313,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 313,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 313,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 313,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 313,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 313,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 313,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 313,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 313,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 313,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 313,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 313,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 313,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 313,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 313,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 313,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 313,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_Cutstone_12_Trim = {
  L: {
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 219,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 219,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 219,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 219,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 219,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 219,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 219,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 219,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 219,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 219,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 219,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 219,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 219,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 219,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 219,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 219,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 219,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 219,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_Cutstone_12_Trim_V = {
  L: {
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 314,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 314,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 314,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 314,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 314,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 314,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 314,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 314,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 314,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 314,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 314,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 314,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 314,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 314,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 314,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 314,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 314,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 314,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_Cutstone_24_Trim = {
  L: {
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 150,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 150,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 150,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 150,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 150,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 150,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 150,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 150,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 150,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 150,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 150,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 150,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 150,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 150,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 150,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 150,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 150,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 150,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_Cutstone_24_Trim_V = {
  L: {
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 315,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 315,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 315,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 315,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 315,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 315,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 315,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 315,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 315,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 315,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 315,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 315,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 315,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 315,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 315,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 315,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 315,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 315,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_GrezzoRosa = {
  Default: {
    templateId: 265,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_GrezzoRosa_Trim = {
  Default: {
    templateId: 264,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Environmental_GrezzoRosa_Trim_V = {
  Default: {
    templateId: 316,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_FDL_Biltmore = {
  L: {
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 527,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_FDL_Country = {
  L: {
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 528,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Fieldstone = {
  L: {
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 384,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 384,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 384,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 384,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 384,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 384,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 384,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 384,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 384,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 384,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 384,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 384,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 384,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 384,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 384,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 384,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 384,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 384,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 384,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 384,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 384,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 384,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 384,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_03_Trim = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 289,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 289,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 289,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 289,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 289,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 289,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 289,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 289,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 289,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 289,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 289,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 289,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 289,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 289,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 289,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 289,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 289,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 289,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 289,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 289,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 289,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 289,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 289,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 289,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 289,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 289,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 289,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 289,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 289,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 289,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 289,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 289,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 289,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 289,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 289,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 289,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 289,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 289,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 289,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 289,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 289,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 289,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 289,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 289,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 289,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 289,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 289,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 289,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 289,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 289,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 289,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 289,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 289,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 289,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 289,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 289,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 289,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 289,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 289,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 289,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 289,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 289,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 289,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 289,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 289,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 289,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 289,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 289,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 289,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 289,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 289,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 289,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 289,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 289,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 289,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 289,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 289,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 289,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 289,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 289,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 289,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 289,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 289,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 289,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 289,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 289,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 289,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 289,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 289,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 289,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 289,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 289,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 289,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 289,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 289,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 289,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 289,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 289,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 289,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 289,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 289,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 289,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 289,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 289,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 289,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 289,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 289,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 289,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 289,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 289,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 289,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 289,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 289,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 289,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 289,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 289,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 289,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 289,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 289,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 289,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 289,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 289,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 289,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 289,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 289,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 289,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 289,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 289,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 289,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 289,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 289,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 289,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 289,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 289,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 289,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 289,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 289,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 289,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 289,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 289,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 289,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 289,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 289,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 289,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 289,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 289,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 289,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 289,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 289,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 289,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 289,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 289,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 289,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 289,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 289,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 289,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 289,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 289,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 289,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 289,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 289,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 289,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 289,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 289,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 289,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 289,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 289,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 289,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 289,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 289,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 289,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 289,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 289,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 289,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 289,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 289,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 289,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 289,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 289,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 289,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 289,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 289,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 289,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 289,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 289,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 289,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 289,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 289,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 289,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 289,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 289,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 289,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 289,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 289,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 289,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 289,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 289,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 289,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 289,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 289,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 289,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 289,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 289,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 289,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 289,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 289,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 289,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 289,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 289,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 289,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 289,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 289,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 289,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 289,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 289,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 289,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 289,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 289,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 289,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 289,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 289,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 289,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 289,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 289,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 289,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 289,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 289,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 289,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 289,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 289,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 289,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 289,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 289,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 289,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 289,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 289,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 289,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 289,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 289,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 289,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 289,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 289,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 289,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 289,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 289,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 289,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 289,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 289,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 289,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 289,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 289,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 289,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 289,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 289,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 289,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 289,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 289,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 289,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 289,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 289,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 289,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 289,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 289,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 289,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 289,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 289,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 289,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 289,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 289,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 289,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 289,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 289,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 289,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 289,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 289,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 289,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 289,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 289,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 289,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 289,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 289,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 289,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 289,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 289,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 289,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 289,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 289,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 289,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 289,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 289,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 289,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 289,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 289,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 289,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 289,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 289,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 289,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 289,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 289,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 289,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 289,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 289,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 289,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 289,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 289,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 289,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 289,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 289,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 289,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 289,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 289,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 289,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 289,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 289,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 289,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 289,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 289,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 289,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 289,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 289,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 289,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 289,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 289,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 289,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 289,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 289,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 289,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 289,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 289,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 289,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 289,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 289,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 289,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 289,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 289,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 289,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 289,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 289,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 289,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 289,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 289,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 289,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 289,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 289,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 289,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 289,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 289,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 289,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 289,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 289,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 289,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 289,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 289,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 289,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 289,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 289,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 289,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 289,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 289,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 289,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 289,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 289,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 289,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 289,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 289,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 289,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 289,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 289,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 289,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 289,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 289,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 289,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 289,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 289,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 289,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 289,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 289,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 289,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 289,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 289,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 289,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 289,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 289,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 289,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 289,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 289,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 289,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 289,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 289,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 289,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 289,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 289,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 289,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 289,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 289,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 289,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 289,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 289,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 289,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 289,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 289,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 289,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 289,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 289,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 289,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 289,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 289,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 289,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 289,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 289,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 289,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 289,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 289,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 289,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 289,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 289,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 289,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 289,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 289,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 289,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 289,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 289,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 289,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 289,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 289,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 289,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 289,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 289,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 289,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 289,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 289,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 289,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 289,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 289,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 289,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 289,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 289,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 289,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 289,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 289,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 289,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 289,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 289,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 289,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 289,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 289,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 289,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 289,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 289,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 289,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 289,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 289,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 289,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 289,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 289,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 289,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 289,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 289,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 289,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 289,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 289,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 289,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 289,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 289,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 289,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 289,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 289,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 289,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 289,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 289,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 289,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 289,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 289,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 289,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 289,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 289,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 289,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 289,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 289,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 289,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 289,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 289,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 289,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 289,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 289,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 289,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 289,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 289,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 289,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 289,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 289,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 289,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 289,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 289,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 289,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 289,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 289,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 289,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 289,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 289,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 289,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 289,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 289,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 289,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 289,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 289,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 289,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 289,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 289,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 289,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 289,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 289,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 289,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 289,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 289,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 289,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 289,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 289,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 289,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 289,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 289,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 289,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 289,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 289,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 289,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 289,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 289,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 289,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 289,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 289,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 289,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 289,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 289,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 289,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 289,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 289,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 289,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 289,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 289,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 289,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 289,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 289,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 289,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 289,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 289,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 289,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 289,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 289,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 289,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 289,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 289,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 289,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 289,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 289,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 289,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 289,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 289,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 289,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 289,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 289,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 289,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 289,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 289,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 289,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 289,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 289,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 289,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 289,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 289,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 289,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 289,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 289,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 289,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 289,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 289,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 289,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 289,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 289,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 289,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 289,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 289,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 289,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 289,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 289,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 289,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 289,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 289,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 289,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 289,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 289,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 289,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 289,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 289,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 289,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 289,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 289,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 289,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 289,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 289,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 289,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 289,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 289,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 289,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 289,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 289,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 289,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 289,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 289,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 289,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 289,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 289,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 289,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 289,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 289,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 289,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 289,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 289,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 289,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 289,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 289,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 289,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 289,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 289,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 289,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 289,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 289,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 289,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 289,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 289,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 289,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 289,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_03_Trim_V = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 317,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 317,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 317,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 317,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 317,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 317,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 317,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 317,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 317,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 317,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 317,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 317,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 317,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 317,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 317,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 317,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 317,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 317,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 317,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 317,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 317,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 317,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 317,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 317,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 317,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 317,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 317,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 317,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 317,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 317,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 317,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 317,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 317,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 317,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 317,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 317,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 317,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 317,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 317,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 317,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 317,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 317,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 317,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 317,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 317,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 317,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 317,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 317,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 317,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 317,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 317,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 317,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 317,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 317,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 317,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 317,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 317,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 317,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 317,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 317,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 317,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 317,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 317,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 317,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 317,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 317,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 317,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 317,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 317,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 317,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 317,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 317,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 317,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 317,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 317,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 317,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 317,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 317,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 317,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 317,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 317,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 317,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 317,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 317,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 317,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 317,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 317,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 317,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 317,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 317,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 317,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 317,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 317,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 317,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 317,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 317,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 317,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 317,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 317,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 317,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 317,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 317,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 317,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 317,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 317,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 317,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 317,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 317,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 317,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 317,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 317,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 317,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 317,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 317,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 317,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 317,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 317,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 317,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 317,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 317,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 317,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 317,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 317,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 317,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 317,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 317,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 317,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 317,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 317,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 317,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 317,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 317,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 317,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 317,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 317,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 317,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 317,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 317,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 317,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 317,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 317,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 317,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 317,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 317,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 317,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 317,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 317,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 317,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 317,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 317,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 317,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 317,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 317,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 317,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 317,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 317,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 317,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 317,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 317,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 317,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 317,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 317,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 317,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 317,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 317,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 317,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 317,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 317,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 317,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 317,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 317,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 317,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 317,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 317,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 317,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 317,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 317,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 317,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 317,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 317,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 317,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 317,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 317,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 317,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 317,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 317,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 317,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 317,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 317,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 317,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 317,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 317,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 317,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 317,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 317,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 317,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 317,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 317,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 317,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 317,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 317,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 317,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 317,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 317,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 317,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 317,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 317,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 317,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 317,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 317,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 317,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 317,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 317,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 317,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 317,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 317,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 317,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 317,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 317,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 317,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 317,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 317,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 317,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 317,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 317,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 317,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 317,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 317,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 317,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 317,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 317,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 317,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 317,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 317,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 317,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 317,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 317,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 317,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 317,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 317,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 317,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 317,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 317,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 317,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 317,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 317,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 317,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 317,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 317,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 317,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 317,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 317,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 317,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 317,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 317,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 317,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 317,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 317,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 317,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 317,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 317,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 317,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 317,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 317,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 317,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 317,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 317,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 317,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 317,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 317,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 317,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 317,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 317,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 317,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 317,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 317,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 317,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 317,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 317,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 317,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 317,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 317,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 317,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 317,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 317,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 317,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 317,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 317,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 317,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 317,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 317,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 317,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 317,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 317,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 317,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 317,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 317,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 317,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 317,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 317,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 317,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 317,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 317,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 317,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 317,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 317,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 317,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 317,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 317,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 317,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 317,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 317,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 317,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 317,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 317,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 317,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 317,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 317,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 317,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 317,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 317,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 317,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 317,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 317,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 317,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 317,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 317,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 317,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 317,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 317,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 317,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 317,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 317,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 317,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 317,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 317,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 317,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 317,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 317,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 317,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 317,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 317,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 317,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 317,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 317,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 317,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 317,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 317,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 317,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 317,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 317,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 317,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 317,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 317,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 317,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 317,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 317,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 317,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 317,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 317,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 317,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 317,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 317,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 317,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 317,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 317,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 317,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 317,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 317,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 317,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 317,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 317,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 317,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 317,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 317,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 317,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 317,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 317,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 317,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 317,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 317,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 317,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 317,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 317,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 317,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 317,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 317,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 317,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 317,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 317,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 317,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 317,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 317,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 317,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 317,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 317,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 317,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 317,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 317,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 317,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 317,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 317,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 317,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 317,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 317,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 317,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 317,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 317,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 317,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 317,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 317,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 317,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 317,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 317,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 317,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 317,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 317,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 317,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 317,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 317,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 317,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 317,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 317,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 317,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 317,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 317,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 317,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 317,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 317,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 317,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 317,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 317,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 317,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 317,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 317,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 317,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 317,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 317,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 317,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 317,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 317,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 317,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 317,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 317,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 317,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 317,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 317,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 317,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 317,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 317,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 317,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 317,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 317,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 317,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 317,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 317,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 317,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 317,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 317,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 317,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 317,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 317,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 317,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 317,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 317,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 317,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 317,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 317,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 317,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 317,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 317,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 317,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 317,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 317,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 317,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 317,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 317,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 317,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 317,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 317,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 317,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 317,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 317,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 317,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 317,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 317,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 317,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 317,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 317,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 317,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 317,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 317,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 317,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 317,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 317,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 317,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 317,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 317,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 317,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 317,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 317,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 317,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 317,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 317,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 317,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 317,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 317,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 317,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 317,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 317,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 317,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 317,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 317,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 317,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 317,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 317,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 317,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 317,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 317,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 317,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 317,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 317,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 317,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 317,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 317,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 317,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 317,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 317,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 317,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 317,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 317,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 317,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 317,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 317,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 317,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 317,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 317,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 317,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 317,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 317,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 317,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 317,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 317,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 317,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 317,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 317,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 317,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 317,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 317,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 317,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 317,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 317,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 317,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 317,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 317,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 317,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 317,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 317,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 317,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 317,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 317,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 317,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 317,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 317,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 317,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 317,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 317,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 317,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 317,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 317,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 317,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 317,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 317,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 317,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 317,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 317,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 317,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 317,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 317,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 317,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 317,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 317,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 317,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 317,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 317,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 317,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 317,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 317,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 317,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 317,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 317,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 317,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 317,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 317,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 317,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 317,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 317,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 317,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 317,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 317,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 317,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 317,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 317,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 317,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 317,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 317,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 317,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 317,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 317,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 317,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 317,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 317,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 317,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 317,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 317,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 317,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 317,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 317,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 317,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 317,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 317,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 317,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 317,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 317,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 317,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 317,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 317,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 317,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 317,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 317,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 317,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_05_Trim = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 290,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 290,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 290,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 290,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 290,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 290,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 290,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 290,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 290,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 290,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 290,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 290,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 290,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 290,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 290,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 290,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 290,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 290,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 290,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 290,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 290,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 290,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 290,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 290,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 290,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 290,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 290,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 290,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 290,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 290,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 290,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 290,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 290,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 290,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 290,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 290,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 290,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 290,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 290,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 290,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 290,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 290,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 290,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 290,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 290,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 290,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 290,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 290,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 290,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 290,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 290,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 290,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 290,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 290,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 290,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 290,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 290,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 290,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 290,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 290,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 290,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 290,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 290,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 290,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 290,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 290,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 290,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 290,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 290,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 290,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 290,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 290,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 290,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 290,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 290,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 290,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 290,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 290,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 290,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 290,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 290,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 290,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 290,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 290,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 290,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 290,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 290,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 290,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 290,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 290,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 290,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 290,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 290,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 290,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 290,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 290,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 290,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 290,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 290,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 290,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 290,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 290,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 290,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 290,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 290,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 290,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 290,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 290,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 290,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 290,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 290,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 290,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 290,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 290,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 290,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 290,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 290,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 290,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 290,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 290,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 290,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 290,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 290,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 290,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 290,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 290,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 290,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 290,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 290,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 290,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 290,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 290,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 290,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 290,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 290,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 290,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 290,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 290,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 290,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 290,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 290,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 290,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 290,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 290,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 290,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 290,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 290,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 290,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 290,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 290,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 290,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 290,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 290,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 290,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 290,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 290,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 290,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 290,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 290,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 290,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 290,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 290,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 290,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 290,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 290,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 290,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 290,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 290,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 290,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 290,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 290,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 290,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 290,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 290,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 290,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 290,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 290,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 290,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 290,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 290,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 290,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 290,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 290,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 290,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 290,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 290,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 290,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 290,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 290,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 290,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 290,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 290,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 290,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 290,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 290,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 290,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 290,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 290,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 290,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 290,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 290,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 290,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 290,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 290,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 290,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 290,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 290,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 290,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 290,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 290,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 290,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 290,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 290,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 290,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 290,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 290,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 290,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 290,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 290,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 290,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 290,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 290,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 290,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 290,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 290,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 290,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 290,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 290,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 290,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 290,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 290,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 290,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 290,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 290,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 290,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 290,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 290,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 290,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 290,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 290,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 290,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 290,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 290,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 290,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 290,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 290,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 290,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 290,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 290,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 290,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 290,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 290,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 290,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 290,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 290,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 290,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 290,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 290,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 290,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 290,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 290,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 290,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 290,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 290,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 290,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 290,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 290,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 290,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 290,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 290,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 290,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 290,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 290,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 290,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 290,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 290,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 290,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 290,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 290,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 290,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 290,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 290,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 290,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 290,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 290,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 290,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 290,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 290,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 290,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 290,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 290,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 290,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 290,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 290,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 290,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 290,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 290,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 290,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 290,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 290,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 290,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 290,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 290,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 290,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 290,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 290,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 290,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 290,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 290,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 290,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 290,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 290,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 290,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 290,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 290,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 290,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 290,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 290,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 290,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 290,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 290,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 290,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 290,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 290,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 290,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 290,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 290,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 290,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 290,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 290,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 290,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 290,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 290,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 290,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 290,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 290,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 290,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 290,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 290,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 290,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 290,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 290,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 290,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 290,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 290,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 290,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 290,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 290,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 290,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 290,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 290,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 290,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 290,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 290,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 290,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 290,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 290,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 290,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 290,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 290,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 290,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 290,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 290,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 290,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 290,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 290,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 290,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 290,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 290,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 290,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 290,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 290,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 290,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 290,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 290,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 290,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 290,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 290,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 290,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 290,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 290,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 290,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 290,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 290,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 290,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 290,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 290,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 290,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 290,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 290,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 290,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 290,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 290,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 290,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 290,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 290,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 290,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 290,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 290,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 290,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 290,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 290,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 290,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 290,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 290,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 290,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 290,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 290,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 290,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 290,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 290,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 290,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 290,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 290,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 290,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 290,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 290,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 290,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 290,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 290,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 290,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 290,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 290,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 290,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 290,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 290,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 290,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 290,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 290,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 290,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 290,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 290,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 290,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 290,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 290,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 290,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 290,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 290,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 290,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 290,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 290,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 290,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 290,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 290,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 290,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 290,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 290,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 290,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 290,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 290,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 290,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 290,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 290,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 290,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 290,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 290,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 290,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 290,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 290,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 290,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 290,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 290,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 290,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 290,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 290,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 290,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 290,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 290,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 290,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 290,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 290,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 290,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 290,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 290,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 290,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 290,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 290,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 290,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 290,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 290,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 290,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 290,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 290,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 290,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 290,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 290,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 290,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 290,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 290,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 290,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 290,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 290,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 290,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 290,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 290,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 290,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 290,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 290,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 290,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 290,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 290,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 290,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 290,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 290,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 290,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 290,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 290,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 290,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 290,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 290,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 290,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 290,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 290,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 290,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 290,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 290,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 290,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 290,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 290,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 290,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 290,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 290,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 290,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 290,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 290,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 290,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 290,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 290,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 290,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 290,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 290,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 290,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 290,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 290,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 290,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 290,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 290,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 290,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 290,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 290,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 290,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 290,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 290,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 290,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 290,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 290,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 290,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 290,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 290,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 290,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 290,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 290,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 290,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 290,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 290,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 290,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 290,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 290,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 290,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 290,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 290,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 290,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 290,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 290,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 290,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 290,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 290,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 290,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 290,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 290,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 290,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 290,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 290,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 290,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 290,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 290,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 290,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 290,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 290,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 290,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 290,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 290,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 290,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 290,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 290,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 290,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 290,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 290,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 290,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 290,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 290,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 290,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 290,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 290,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 290,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 290,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 290,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 290,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 290,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 290,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 290,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 290,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 290,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 290,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 290,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 290,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 290,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 290,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 290,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 290,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 290,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 290,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 290,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 290,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 290,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 290,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 290,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 290,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 290,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 290,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 290,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 290,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 290,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 290,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 290,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 290,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 290,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 290,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 290,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 290,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 290,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_05_Trim_V = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 318,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 318,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 318,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 318,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 318,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 318,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 318,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 318,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 318,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 318,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 318,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 318,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 318,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 318,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 318,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 318,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 318,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 318,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 318,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 318,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 318,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 318,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 318,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 318,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 318,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 318,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 318,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 318,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 318,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 318,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 318,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 318,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 318,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 318,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 318,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 318,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 318,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 318,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 318,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 318,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 318,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 318,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 318,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 318,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 318,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 318,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 318,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 318,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 318,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 318,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 318,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 318,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 318,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 318,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 318,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 318,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 318,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 318,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 318,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 318,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 318,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 318,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 318,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 318,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 318,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 318,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 318,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 318,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 318,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 318,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 318,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 318,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 318,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 318,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 318,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 318,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 318,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 318,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 318,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 318,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 318,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 318,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 318,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 318,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 318,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 318,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 318,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 318,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 318,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 318,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 318,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 318,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 318,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 318,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 318,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 318,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 318,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 318,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 318,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 318,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 318,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 318,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 318,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 318,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 318,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 318,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 318,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 318,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 318,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 318,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 318,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 318,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 318,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 318,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 318,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 318,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 318,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 318,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 318,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 318,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 318,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 318,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 318,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 318,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 318,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 318,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 318,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 318,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 318,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 318,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 318,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 318,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 318,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 318,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 318,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 318,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 318,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 318,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 318,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 318,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 318,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 318,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 318,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 318,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 318,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 318,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 318,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 318,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 318,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 318,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 318,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 318,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 318,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 318,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 318,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 318,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 318,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 318,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 318,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 318,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 318,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 318,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 318,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 318,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 318,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 318,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 318,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 318,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 318,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 318,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 318,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 318,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 318,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 318,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 318,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 318,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 318,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 318,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 318,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 318,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 318,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 318,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 318,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 318,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 318,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 318,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 318,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 318,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 318,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 318,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 318,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 318,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 318,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 318,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 318,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 318,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 318,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 318,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 318,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 318,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 318,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 318,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 318,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 318,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 318,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 318,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 318,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 318,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 318,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 318,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 318,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 318,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 318,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 318,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 318,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 318,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 318,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 318,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 318,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 318,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 318,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 318,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 318,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 318,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 318,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 318,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 318,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 318,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 318,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 318,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 318,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 318,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 318,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 318,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 318,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 318,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 318,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 318,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 318,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 318,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 318,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 318,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 318,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 318,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 318,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 318,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 318,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 318,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 318,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 318,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 318,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 318,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 318,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 318,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 318,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 318,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 318,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 318,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 318,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 318,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 318,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 318,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 318,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 318,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 318,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 318,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 318,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 318,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 318,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 318,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 318,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 318,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 318,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 318,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 318,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 318,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 318,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 318,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 318,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 318,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 318,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 318,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 318,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 318,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 318,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 318,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 318,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 318,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 318,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 318,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 318,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 318,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 318,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 318,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 318,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 318,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 318,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 318,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 318,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 318,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 318,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 318,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 318,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 318,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 318,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 318,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 318,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 318,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 318,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 318,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 318,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 318,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 318,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 318,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 318,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 318,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 318,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 318,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 318,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 318,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 318,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 318,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 318,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 318,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 318,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 318,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 318,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 318,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 318,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 318,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 318,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 318,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 318,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 318,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 318,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 318,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 318,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 318,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 318,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 318,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 318,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 318,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 318,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 318,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 318,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 318,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 318,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 318,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 318,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 318,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 318,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 318,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 318,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 318,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 318,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 318,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 318,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 318,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 318,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 318,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 318,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 318,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 318,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 318,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 318,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 318,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 318,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 318,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 318,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 318,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 318,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 318,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 318,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 318,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 318,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 318,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 318,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 318,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 318,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 318,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 318,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 318,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 318,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 318,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 318,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 318,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 318,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 318,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 318,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 318,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 318,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 318,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 318,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 318,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 318,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 318,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 318,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 318,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 318,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 318,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 318,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 318,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 318,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 318,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 318,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 318,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 318,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 318,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 318,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 318,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 318,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 318,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 318,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 318,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 318,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 318,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 318,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 318,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 318,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 318,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 318,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 318,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 318,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 318,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 318,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 318,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 318,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 318,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 318,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 318,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 318,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 318,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 318,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 318,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 318,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 318,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 318,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 318,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 318,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 318,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 318,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 318,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 318,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 318,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 318,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 318,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 318,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 318,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 318,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 318,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 318,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 318,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 318,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 318,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 318,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 318,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 318,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 318,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 318,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 318,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 318,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 318,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 318,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 318,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 318,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 318,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 318,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 318,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 318,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 318,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 318,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 318,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 318,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 318,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 318,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 318,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 318,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 318,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 318,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 318,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 318,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 318,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 318,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 318,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 318,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 318,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 318,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 318,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 318,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 318,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 318,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 318,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 318,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 318,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 318,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 318,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 318,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 318,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 318,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 318,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 318,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 318,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 318,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 318,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 318,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 318,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 318,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 318,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 318,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 318,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 318,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 318,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 318,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 318,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 318,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 318,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 318,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 318,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 318,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 318,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 318,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 318,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 318,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 318,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 318,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 318,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 318,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 318,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 318,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 318,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 318,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 318,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 318,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 318,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 318,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 318,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 318,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 318,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 318,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 318,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 318,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 318,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 318,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 318,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 318,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 318,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 318,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 318,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 318,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 318,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 318,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 318,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 318,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 318,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 318,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 318,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 318,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 318,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 318,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 318,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 318,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 318,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 318,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 318,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 318,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 318,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 318,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 318,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 318,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 318,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 318,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 318,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 318,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 318,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 318,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 318,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 318,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 318,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 318,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 318,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 318,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 318,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 318,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 318,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 318,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 318,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 318,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 318,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 318,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 318,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 318,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 318,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 318,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 318,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 318,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 318,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 318,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 318,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 318,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 318,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 318,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 318,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 318,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 318,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 318,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 318,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 318,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 318,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 318,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 318,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 318,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 318,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 318,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 318,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 318,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 318,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 318,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 318,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 318,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 318,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 318,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 318,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 318,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 318,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 318,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 318,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 318,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 318,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 318,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 318,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 318,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_08_Trim = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 511,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 511,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 511,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 511,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 511,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 511,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 511,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 511,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 511,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 511,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 511,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 511,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 511,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 511,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 511,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 511,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 511,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 511,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 511,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 511,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 511,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 511,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 511,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 511,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 511,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 511,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 511,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 511,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 511,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 511,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 511,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 511,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 511,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 511,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 511,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 511,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 511,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 511,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 511,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 511,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 511,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 511,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 511,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 511,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 511,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 511,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 511,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 511,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 511,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 511,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 511,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 511,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 511,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 511,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 511,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 511,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 511,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 511,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 511,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 511,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 511,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 511,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 511,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 511,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 511,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 511,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 511,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 511,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 511,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 511,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 511,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 511,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 511,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 511,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 511,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 511,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 511,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 511,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 511,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 511,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 511,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 511,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 511,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 511,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 511,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 511,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 511,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 511,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 511,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 511,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 511,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 511,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 511,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 511,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 511,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 511,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 511,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 511,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 511,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 511,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 511,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 511,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 511,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 511,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 511,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 511,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 511,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 511,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 511,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 511,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 511,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 511,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 511,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 511,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 511,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 511,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 511,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 511,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 511,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 511,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 511,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 511,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 511,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 511,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 511,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 511,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 511,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 511,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 511,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 511,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 511,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 511,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 511,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 511,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 511,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 511,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 511,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 511,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 511,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 511,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 511,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 511,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 511,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 511,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 511,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 511,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 511,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 511,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 511,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 511,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 511,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 511,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 511,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 511,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 511,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 511,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 511,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 511,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 511,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 511,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 511,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 511,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 511,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 511,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 511,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 511,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 511,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 511,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 511,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 511,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 511,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 511,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 511,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 511,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 511,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 511,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 511,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 511,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 511,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 511,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 511,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 511,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 511,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 511,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 511,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 511,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 511,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 511,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 511,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 511,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 511,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 511,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 511,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 511,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 511,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 511,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 511,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 511,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 511,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 511,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 511,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 511,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 511,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 511,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 511,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 511,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 511,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 511,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 511,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 511,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 511,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 511,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 511,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 511,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 511,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 511,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 511,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 511,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 511,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 511,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 511,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 511,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 511,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 511,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 511,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 511,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 511,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 511,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 511,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 511,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 511,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 511,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 511,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 511,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 511,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 511,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 511,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 511,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 511,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 511,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 511,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 511,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 511,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 511,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 511,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 511,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 511,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 511,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 511,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 511,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 511,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 511,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 511,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 511,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 511,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 511,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 511,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 511,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 511,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 511,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 511,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 511,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 511,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 511,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 511,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 511,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 511,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 511,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 511,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 511,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 511,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 511,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 511,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 511,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 511,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 511,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 511,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 511,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 511,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 511,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 511,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 511,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 511,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 511,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 511,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 511,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 511,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 511,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 511,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 511,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 511,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 511,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 511,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 511,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 511,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 511,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 511,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 511,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 511,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 511,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 511,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 511,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 511,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 511,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 511,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 511,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 511,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 511,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 511,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 511,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 511,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 511,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 511,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 511,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 511,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 511,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 511,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 511,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 511,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 511,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 511,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 511,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 511,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 511,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 511,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 511,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 511,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 511,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 511,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 511,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 511,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 511,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 511,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 511,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 511,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 511,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 511,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 511,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 511,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 511,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 511,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 511,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 511,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 511,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 511,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 511,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 511,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 511,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 511,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 511,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 511,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 511,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 511,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 511,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 511,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 511,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 511,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 511,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 511,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 511,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 511,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 511,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 511,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 511,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 511,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 511,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 511,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 511,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 511,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 511,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 511,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 511,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 511,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 511,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 511,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 511,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 511,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 511,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 511,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 511,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 511,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 511,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 511,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 511,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 511,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 511,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 511,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 511,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 511,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 511,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 511,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 511,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 511,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 511,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 511,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 511,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 511,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 511,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 511,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 511,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 511,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 511,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 511,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 511,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 511,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 511,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 511,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 511,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 511,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 511,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 511,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 511,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 511,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 511,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 511,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 511,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 511,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 511,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 511,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 511,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 511,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 511,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 511,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 511,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 511,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 511,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 511,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 511,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 511,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 511,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 511,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 511,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 511,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 511,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 511,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 511,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 511,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 511,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 511,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 511,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 511,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 511,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 511,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 511,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 511,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 511,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 511,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 511,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 511,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 511,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 511,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 511,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 511,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 511,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 511,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 511,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 511,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 511,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 511,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 511,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 511,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 511,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 511,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 511,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 511,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 511,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 511,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 511,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 511,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 511,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 511,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 511,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 511,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 511,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 511,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 511,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 511,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 511,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 511,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 511,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 511,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 511,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 511,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 511,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 511,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 511,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 511,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 511,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 511,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 511,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 511,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 511,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 511,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 511,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 511,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 511,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 511,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 511,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 511,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 511,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 511,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 511,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 511,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 511,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 511,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 511,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 511,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 511,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 511,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 511,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 511,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 511,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 511,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 511,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 511,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 511,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 511,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 511,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 511,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 511,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 511,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 511,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 511,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 511,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 511,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 511,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 511,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 511,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 511,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 511,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 511,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 511,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 511,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 511,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 511,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 511,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 511,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 511,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 511,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 511,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 511,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 511,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 511,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 511,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 511,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 511,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 511,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 511,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 511,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 511,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 511,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 511,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 511,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 511,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 511,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 511,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 511,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 511,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 511,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 511,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 511,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 511,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 511,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 511,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 511,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 511,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 511,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 511,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 511,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 511,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 511,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 511,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 511,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 511,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 511,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 511,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 511,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 511,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 511,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 511,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 511,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 511,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 511,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 511,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 511,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 511,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 511,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 511,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 511,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 511,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 511,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 511,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 511,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 511,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 511,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 511,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 511,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 511,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 511,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 511,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 511,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 511,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 511,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 511,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 511,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 511,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 511,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 511,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 511,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 511,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 511,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 511,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 511,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 511,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 511,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 511,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 511,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 511,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 511,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 511,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 511,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 511,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 511,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 511,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 511,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 511,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 511,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 511,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 511,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 511,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 511,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_08_Trim_V = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 510,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 510,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 510,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 510,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 510,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 510,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 510,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 510,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 510,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 510,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 510,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 510,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 510,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 510,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 510,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 510,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 510,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 510,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 510,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 510,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 510,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 510,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 510,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 510,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 510,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 510,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 510,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 510,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 510,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 510,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 510,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 510,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 510,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 510,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 510,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 510,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 510,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 510,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 510,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 510,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 510,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 510,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 510,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 510,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 510,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 510,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 510,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 510,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 510,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 510,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 510,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 510,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 510,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 510,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 510,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 510,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 510,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 510,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 510,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 510,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 510,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 510,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 510,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 510,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 510,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 510,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 510,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 510,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 510,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 510,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 510,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 510,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 510,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 510,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 510,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 510,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 510,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 510,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 510,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 510,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 510,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 510,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 510,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 510,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 510,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 510,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 510,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 510,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 510,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 510,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 510,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 510,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 510,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 510,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 510,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 510,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 510,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 510,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 510,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 510,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 510,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 510,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 510,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 510,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 510,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 510,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 510,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 510,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 510,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 510,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 510,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 510,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 510,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 510,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 510,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 510,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 510,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 510,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 510,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 510,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 510,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 510,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 510,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 510,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 510,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 510,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 510,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 510,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 510,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 510,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 510,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 510,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 510,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 510,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 510,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 510,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 510,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 510,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 510,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 510,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 510,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 510,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 510,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 510,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 510,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 510,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 510,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 510,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 510,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 510,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 510,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 510,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 510,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 510,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 510,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 510,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 510,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 510,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 510,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 510,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 510,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 510,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 510,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 510,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 510,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 510,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 510,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 510,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 510,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 510,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 510,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 510,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 510,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 510,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 510,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 510,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 510,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 510,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 510,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 510,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 510,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 510,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 510,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 510,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 510,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 510,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 510,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 510,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 510,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 510,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 510,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 510,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 510,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 510,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 510,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 510,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 510,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 510,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 510,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 510,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 510,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 510,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 510,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 510,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 510,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 510,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 510,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 510,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 510,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 510,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 510,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 510,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 510,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 510,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 510,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 510,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 510,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 510,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 510,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 510,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 510,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 510,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 510,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 510,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 510,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 510,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 510,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 510,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 510,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 510,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 510,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 510,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 510,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 510,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 510,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 510,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 510,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 510,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 510,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 510,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 510,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 510,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 510,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 510,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 510,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 510,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 510,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 510,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 510,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 510,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 510,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 510,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 510,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 510,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 510,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 510,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 510,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 510,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 510,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 510,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 510,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 510,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 510,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 510,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 510,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 510,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 510,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 510,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 510,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 510,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 510,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 510,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 510,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 510,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 510,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 510,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 510,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 510,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 510,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 510,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 510,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 510,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 510,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 510,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 510,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 510,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 510,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 510,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 510,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 510,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 510,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 510,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 510,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 510,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 510,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 510,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 510,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 510,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 510,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 510,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 510,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 510,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 510,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 510,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 510,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 510,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 510,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 510,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 510,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 510,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 510,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 510,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 510,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 510,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 510,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 510,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 510,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 510,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 510,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 510,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 510,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 510,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 510,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 510,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 510,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 510,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 510,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 510,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 510,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 510,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 510,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 510,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 510,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 510,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 510,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 510,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 510,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 510,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 510,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 510,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 510,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 510,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 510,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 510,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 510,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 510,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 510,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 510,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 510,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 510,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 510,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 510,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 510,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 510,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 510,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 510,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 510,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 510,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 510,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 510,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 510,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 510,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 510,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 510,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 510,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 510,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 510,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 510,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 510,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 510,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 510,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 510,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 510,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 510,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 510,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 510,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 510,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 510,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 510,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 510,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 510,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 510,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 510,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 510,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 510,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 510,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 510,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 510,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 510,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 510,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 510,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 510,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 510,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 510,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 510,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 510,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 510,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 510,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 510,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 510,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 510,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 510,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 510,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 510,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 510,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 510,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 510,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 510,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 510,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 510,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 510,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 510,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 510,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 510,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 510,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 510,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 510,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 510,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 510,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 510,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 510,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 510,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 510,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 510,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 510,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 510,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 510,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 510,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 510,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 510,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 510,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 510,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 510,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 510,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 510,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 510,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 510,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 510,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 510,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 510,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 510,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 510,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 510,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 510,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 510,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 510,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 510,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 510,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 510,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 510,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 510,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 510,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 510,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 510,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 510,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 510,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 510,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 510,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 510,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 510,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 510,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 510,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 510,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 510,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 510,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 510,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 510,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 510,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 510,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 510,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 510,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 510,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 510,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 510,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 510,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 510,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 510,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 510,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 510,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 510,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 510,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 510,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 510,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 510,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 510,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 510,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 510,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 510,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 510,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 510,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 510,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 510,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 510,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 510,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 510,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 510,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 510,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 510,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 510,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 510,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 510,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 510,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 510,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 510,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 510,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 510,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 510,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 510,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 510,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 510,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 510,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 510,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 510,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 510,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 510,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 510,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 510,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 510,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 510,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 510,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 510,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 510,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 510,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 510,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 510,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 510,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 510,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 510,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 510,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 510,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 510,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 510,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 510,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 510,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 510,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 510,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 510,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 510,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 510,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 510,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 510,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 510,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 510,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 510,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 510,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 510,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 510,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 510,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 510,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 510,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 510,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 510,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 510,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 510,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 510,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 510,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 510,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 510,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 510,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 510,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 510,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 510,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 510,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 510,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 510,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 510,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 510,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 510,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 510,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 510,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 510,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 510,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 510,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 510,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 510,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 510,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 510,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 510,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 510,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 510,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 510,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 510,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 510,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 510,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 510,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 510,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 510,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 510,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 510,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 510,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 510,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 510,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 510,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 510,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 510,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 510,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 510,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 510,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 510,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 510,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 510,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 510,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 510,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 510,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 510,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 510,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 510,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 510,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 510,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 510,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 510,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 510,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 510,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 510,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 510,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 510,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 510,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 510,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 510,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 510,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 510,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 510,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 510,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 510,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 510,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 510,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 510,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 510,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 510,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 510,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 510,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_12_Trim = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 291,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 291,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 291,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 291,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 291,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 291,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 291,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 291,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 291,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 291,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 291,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 291,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 291,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 291,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 291,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 291,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 291,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 291,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 291,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 291,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 291,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 291,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 291,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 291,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 291,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 291,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 291,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 291,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 291,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 291,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 291,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 291,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 291,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 291,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 291,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 291,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 291,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 291,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 291,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 291,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 291,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 291,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 291,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 291,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 291,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 291,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 291,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 291,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 291,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 291,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 291,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 291,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 291,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 291,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 291,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 291,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 291,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 291,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 291,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 291,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 291,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 291,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 291,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 291,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 291,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 291,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 291,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 291,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 291,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 291,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 291,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 291,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 291,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 291,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 291,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 291,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 291,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 291,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 291,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 291,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 291,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 291,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 291,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 291,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 291,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 291,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 291,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 291,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 291,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 291,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 291,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 291,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 291,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 291,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 291,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 291,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 291,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 291,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 291,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 291,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 291,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 291,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 291,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 291,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 291,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 291,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 291,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 291,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 291,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 291,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 291,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 291,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 291,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 291,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 291,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 291,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 291,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 291,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 291,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 291,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 291,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 291,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 291,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 291,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 291,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 291,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 291,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 291,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 291,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 291,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 291,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 291,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 291,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 291,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 291,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 291,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 291,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 291,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 291,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 291,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 291,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 291,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 291,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 291,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 291,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 291,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 291,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 291,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 291,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 291,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 291,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 291,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 291,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 291,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 291,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 291,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 291,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 291,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 291,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 291,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 291,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 291,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 291,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 291,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 291,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 291,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 291,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 291,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 291,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 291,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 291,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 291,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 291,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 291,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 291,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 291,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 291,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 291,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 291,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 291,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 291,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 291,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 291,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 291,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 291,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 291,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 291,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 291,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 291,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 291,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 291,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 291,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 291,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 291,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 291,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 291,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 291,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 291,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 291,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 291,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 291,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 291,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 291,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 291,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 291,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 291,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 291,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 291,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 291,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 291,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 291,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 291,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 291,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 291,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 291,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 291,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 291,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 291,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 291,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 291,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 291,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 291,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 291,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 291,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 291,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 291,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 291,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 291,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 291,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 291,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 291,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 291,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 291,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 291,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 291,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 291,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 291,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 291,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 291,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 291,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 291,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 291,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 291,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 291,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 291,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 291,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 291,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 291,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 291,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 291,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 291,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 291,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 291,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 291,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 291,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 291,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 291,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 291,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 291,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 291,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 291,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 291,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 291,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 291,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 291,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 291,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 291,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 291,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 291,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 291,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 291,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 291,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 291,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 291,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 291,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 291,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 291,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 291,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 291,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 291,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 291,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 291,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 291,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 291,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 291,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 291,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 291,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 291,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 291,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 291,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 291,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 291,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 291,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 291,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 291,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 291,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 291,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 291,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 291,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 291,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 291,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 291,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 291,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 291,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 291,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 291,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 291,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 291,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 291,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 291,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 291,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 291,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 291,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 291,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 291,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 291,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 291,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 291,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 291,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 291,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 291,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 291,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 291,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 291,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 291,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 291,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 291,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 291,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 291,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 291,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 291,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 291,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 291,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 291,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 291,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 291,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 291,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 291,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 291,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 291,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 291,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 291,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 291,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 291,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 291,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 291,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 291,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 291,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 291,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 291,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 291,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 291,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 291,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 291,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 291,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 291,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 291,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 291,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 291,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 291,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 291,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 291,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 291,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 291,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 291,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 291,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 291,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 291,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 291,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 291,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 291,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 291,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 291,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 291,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 291,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 291,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 291,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 291,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 291,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 291,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 291,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 291,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 291,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 291,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 291,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 291,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 291,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 291,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 291,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 291,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 291,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 291,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 291,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 291,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 291,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 291,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 291,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 291,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 291,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 291,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 291,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 291,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 291,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 291,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 291,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 291,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 291,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 291,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 291,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 291,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 291,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 291,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 291,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 291,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 291,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 291,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 291,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 291,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 291,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 291,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 291,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 291,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 291,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 291,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 291,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 291,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 291,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 291,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 291,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 291,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 291,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 291,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 291,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 291,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 291,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 291,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 291,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 291,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 291,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 291,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 291,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 291,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 291,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 291,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 291,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 291,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 291,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 291,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 291,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 291,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 291,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 291,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 291,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 291,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 291,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 291,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 291,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 291,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 291,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 291,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 291,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 291,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 291,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 291,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 291,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 291,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 291,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 291,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 291,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 291,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 291,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 291,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 291,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 291,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 291,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 291,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 291,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 291,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 291,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 291,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 291,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 291,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 291,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 291,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 291,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 291,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 291,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 291,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 291,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 291,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 291,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 291,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 291,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 291,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 291,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 291,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 291,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 291,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 291,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 291,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 291,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 291,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 291,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 291,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 291,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 291,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 291,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 291,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 291,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 291,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 291,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 291,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 291,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 291,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 291,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 291,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 291,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 291,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 291,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 291,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 291,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 291,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 291,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 291,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 291,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 291,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 291,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 291,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 291,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 291,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 291,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 291,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 291,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 291,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 291,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 291,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 291,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 291,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 291,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 291,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 291,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 291,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 291,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 291,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 291,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 291,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 291,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 291,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 291,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 291,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 291,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 291,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 291,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 291,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 291,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 291,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 291,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 291,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 291,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 291,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 291,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 291,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 291,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 291,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 291,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 291,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 291,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 291,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 291,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 291,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 291,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 291,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 291,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 291,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 291,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 291,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 291,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 291,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 291,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 291,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 291,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 291,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 291,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 291,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 291,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 291,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 291,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 291,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 291,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 291,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 291,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 291,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 291,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 291,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 291,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 291,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 291,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 291,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 291,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 291,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 291,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 291,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 291,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 291,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 291,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 291,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 291,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 291,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 291,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 291,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 291,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 291,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 291,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 291,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 291,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 291,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 291,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 291,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 291,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 291,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 291,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 291,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 291,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 291,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 291,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 291,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 291,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 291,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 291,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 291,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 291,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_12_Trim_V = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 319,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 319,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 319,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 319,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 319,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 319,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 319,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 319,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 319,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 319,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 319,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 319,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 319,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 319,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 319,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 319,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 319,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 319,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 319,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 319,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 319,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 319,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 319,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 319,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 319,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 319,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 319,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 319,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 319,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 319,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 319,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 319,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 319,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 319,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 319,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 319,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 319,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 319,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 319,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 319,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 319,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 319,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 319,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 319,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 319,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 319,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 319,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 319,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 319,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 319,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 319,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 319,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 319,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 319,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 319,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 319,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 319,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 319,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 319,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 319,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 319,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 319,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 319,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 319,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 319,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 319,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 319,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 319,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 319,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 319,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 319,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 319,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 319,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 319,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 319,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 319,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 319,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 319,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 319,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 319,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 319,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 319,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 319,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 319,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 319,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 319,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 319,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 319,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 319,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 319,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 319,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 319,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 319,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 319,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 319,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 319,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 319,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 319,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 319,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 319,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 319,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 319,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 319,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 319,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 319,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 319,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 319,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 319,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 319,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 319,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 319,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 319,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 319,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 319,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 319,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 319,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 319,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 319,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 319,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 319,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 319,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 319,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 319,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 319,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 319,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 319,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 319,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 319,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 319,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 319,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 319,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 319,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 319,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 319,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 319,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 319,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 319,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 319,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 319,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 319,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 319,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 319,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 319,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 319,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 319,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 319,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 319,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 319,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 319,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 319,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 319,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 319,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 319,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 319,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 319,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 319,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 319,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 319,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 319,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 319,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 319,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 319,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 319,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 319,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 319,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 319,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 319,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 319,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 319,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 319,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 319,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 319,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 319,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 319,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 319,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 319,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 319,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 319,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 319,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 319,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 319,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 319,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 319,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 319,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 319,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 319,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 319,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 319,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 319,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 319,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 319,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 319,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 319,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 319,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 319,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 319,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 319,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 319,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 319,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 319,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 319,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 319,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 319,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 319,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 319,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 319,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 319,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 319,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 319,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 319,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 319,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 319,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 319,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 319,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 319,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 319,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 319,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 319,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 319,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 319,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 319,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 319,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 319,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 319,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 319,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 319,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 319,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 319,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 319,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 319,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 319,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 319,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 319,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 319,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 319,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 319,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 319,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 319,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 319,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 319,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 319,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 319,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 319,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 319,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 319,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 319,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 319,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 319,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 319,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 319,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 319,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 319,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 319,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 319,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 319,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 319,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 319,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 319,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 319,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 319,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 319,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 319,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 319,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 319,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 319,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 319,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 319,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 319,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 319,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 319,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 319,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 319,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 319,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 319,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 319,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 319,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 319,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 319,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 319,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 319,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 319,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 319,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 319,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 319,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 319,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 319,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 319,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 319,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 319,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 319,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 319,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 319,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 319,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 319,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 319,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 319,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 319,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 319,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 319,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 319,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 319,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 319,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 319,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 319,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 319,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 319,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 319,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 319,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 319,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 319,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 319,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 319,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 319,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 319,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 319,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 319,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 319,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 319,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 319,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 319,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 319,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 319,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 319,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 319,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 319,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 319,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 319,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 319,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 319,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 319,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 319,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 319,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 319,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 319,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 319,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 319,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 319,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 319,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 319,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 319,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 319,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 319,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 319,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 319,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 319,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 319,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 319,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 319,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 319,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 319,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 319,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 319,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 319,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 319,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 319,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 319,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 319,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 319,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 319,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 319,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 319,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 319,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 319,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 319,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 319,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 319,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 319,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 319,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 319,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 319,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 319,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 319,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 319,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 319,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 319,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 319,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 319,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 319,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 319,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 319,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 319,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 319,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 319,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 319,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 319,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 319,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 319,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 319,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 319,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 319,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 319,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 319,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 319,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 319,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 319,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 319,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 319,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 319,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 319,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 319,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 319,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 319,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 319,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 319,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 319,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 319,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 319,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 319,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 319,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 319,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 319,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 319,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 319,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 319,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 319,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 319,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 319,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 319,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 319,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 319,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 319,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 319,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 319,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 319,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 319,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 319,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 319,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 319,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 319,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 319,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 319,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 319,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 319,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 319,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 319,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 319,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 319,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 319,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 319,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 319,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 319,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 319,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 319,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 319,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 319,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 319,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 319,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 319,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 319,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 319,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 319,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 319,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 319,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 319,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 319,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 319,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 319,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 319,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 319,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 319,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 319,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 319,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 319,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 319,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 319,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 319,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 319,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 319,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 319,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 319,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 319,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 319,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 319,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 319,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 319,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 319,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 319,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 319,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 319,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 319,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 319,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 319,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 319,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 319,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 319,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 319,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 319,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 319,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 319,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 319,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 319,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 319,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 319,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 319,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 319,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 319,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 319,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 319,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 319,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 319,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 319,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 319,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 319,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 319,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 319,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 319,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 319,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 319,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 319,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 319,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 319,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 319,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 319,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 319,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 319,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 319,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 319,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 319,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 319,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 319,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 319,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 319,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 319,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 319,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 319,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 319,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 319,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 319,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 319,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 319,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 319,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 319,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 319,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 319,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 319,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 319,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 319,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 319,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 319,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 319,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 319,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 319,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 319,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 319,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 319,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 319,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 319,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 319,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 319,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 319,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 319,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 319,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 319,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 319,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 319,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 319,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 319,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 319,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 319,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 319,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 319,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 319,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 319,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 319,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 319,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 319,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 319,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 319,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 319,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 319,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 319,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 319,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 319,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 319,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 319,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 319,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 319,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 319,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 319,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 319,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 319,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 319,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 319,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 319,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 319,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 319,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 319,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 319,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 319,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 319,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 319,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 319,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 319,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 319,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 319,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 319,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 319,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 319,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 319,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 319,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 319,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 319,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 319,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 319,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 319,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 319,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 319,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 319,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 319,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 319,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 319,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 319,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 319,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 319,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 319,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 319,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 319,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 319,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 319,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 319,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 319,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 319,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 319,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 319,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 319,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 319,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 319,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 319,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 319,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 319,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 319,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_16_Trim = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 413,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 413,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 413,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 413,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 413,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 413,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 413,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 413,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 413,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 413,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 413,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 413,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 413,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 413,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 413,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 413,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 413,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 413,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 413,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 413,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 413,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 413,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 413,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 413,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 413,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 413,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 413,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 413,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 413,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 413,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 413,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 413,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 413,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 413,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 413,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 413,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 413,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 413,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 413,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 413,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 413,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 413,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 413,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 413,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 413,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 413,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 413,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 413,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 413,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 413,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 413,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 413,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 413,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 413,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 413,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 413,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 413,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 413,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 413,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 413,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 413,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 413,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 413,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 413,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 413,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 413,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 413,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 413,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 413,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 413,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 413,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 413,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 413,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 413,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 413,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 413,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 413,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 413,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 413,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 413,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 413,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 413,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 413,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 413,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 413,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 413,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 413,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 413,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 413,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 413,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 413,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 413,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 413,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 413,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 413,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 413,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 413,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 413,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 413,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 413,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 413,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 413,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 413,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 413,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 413,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 413,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 413,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 413,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 413,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 413,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 413,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 413,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 413,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 413,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 413,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 413,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 413,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 413,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 413,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 413,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 413,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 413,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 413,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 413,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 413,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 413,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 413,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 413,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 413,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 413,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 413,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 413,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 413,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 413,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 413,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 413,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 413,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 413,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 413,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 413,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 413,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 413,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 413,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 413,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 413,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 413,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 413,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 413,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 413,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 413,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 413,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 413,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 413,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 413,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 413,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 413,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 413,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 413,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 413,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 413,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 413,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 413,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 413,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 413,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 413,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 413,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 413,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 413,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 413,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 413,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 413,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 413,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 413,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 413,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 413,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 413,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 413,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 413,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 413,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 413,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 413,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 413,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 413,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 413,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 413,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 413,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 413,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 413,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 413,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 413,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 413,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 413,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 413,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 413,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 413,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 413,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 413,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 413,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 413,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 413,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 413,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 413,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 413,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 413,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 413,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 413,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 413,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 413,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 413,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 413,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 413,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 413,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 413,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 413,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 413,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 413,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 413,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 413,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 413,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 413,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 413,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 413,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 413,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 413,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 413,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 413,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 413,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 413,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 413,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 413,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 413,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 413,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 413,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 413,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 413,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 413,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 413,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 413,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 413,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 413,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 413,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 413,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 413,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 413,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 413,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 413,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 413,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 413,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 413,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 413,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 413,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 413,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 413,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 413,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 413,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 413,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 413,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 413,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 413,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 413,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 413,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 413,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 413,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 413,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 413,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 413,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 413,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 413,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 413,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 413,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 413,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 413,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 413,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 413,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 413,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 413,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 413,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 413,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 413,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 413,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 413,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 413,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 413,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 413,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 413,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 413,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 413,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 413,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 413,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 413,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 413,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 413,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 413,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 413,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 413,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 413,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 413,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 413,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 413,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 413,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 413,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 413,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 413,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 413,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 413,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 413,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 413,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 413,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 413,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 413,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 413,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 413,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 413,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 413,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 413,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 413,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 413,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 413,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 413,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 413,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 413,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 413,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 413,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 413,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 413,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 413,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 413,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 413,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 413,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 413,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 413,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 413,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 413,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 413,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 413,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 413,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 413,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 413,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 413,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 413,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 413,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 413,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 413,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 413,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 413,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 413,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 413,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 413,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 413,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 413,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 413,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 413,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 413,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 413,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 413,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 413,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 413,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 413,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 413,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 413,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 413,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 413,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 413,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 413,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 413,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 413,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 413,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 413,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 413,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 413,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 413,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 413,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 413,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 413,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 413,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 413,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 413,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 413,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 413,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 413,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 413,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 413,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 413,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 413,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 413,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 413,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 413,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 413,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 413,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 413,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 413,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 413,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 413,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 413,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 413,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 413,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 413,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 413,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 413,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 413,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 413,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 413,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 413,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 413,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 413,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 413,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 413,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 413,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 413,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 413,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 413,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 413,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 413,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 413,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 413,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 413,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 413,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 413,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 413,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 413,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 413,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 413,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 413,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 413,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 413,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 413,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 413,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 413,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 413,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 413,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 413,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 413,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 413,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 413,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 413,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 413,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 413,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 413,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 413,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 413,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 413,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 413,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 413,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 413,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 413,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 413,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 413,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 413,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 413,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 413,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 413,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 413,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 413,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 413,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 413,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 413,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 413,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 413,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 413,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 413,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 413,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 413,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 413,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 413,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 413,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 413,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 413,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 413,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 413,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 413,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 413,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 413,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 413,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 413,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 413,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 413,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 413,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 413,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 413,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 413,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 413,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 413,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 413,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 413,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 413,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 413,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 413,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 413,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 413,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 413,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 413,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 413,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 413,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 413,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 413,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 413,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 413,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 413,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 413,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 413,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 413,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 413,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 413,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 413,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 413,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 413,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 413,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 413,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 413,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 413,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 413,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 413,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 413,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 413,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 413,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 413,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 413,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 413,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 413,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 413,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 413,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 413,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 413,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 413,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 413,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 413,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 413,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 413,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 413,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 413,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 413,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 413,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 413,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 413,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 413,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 413,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 413,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 413,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 413,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 413,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 413,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 413,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 413,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 413,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 413,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 413,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 413,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 413,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 413,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 413,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 413,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 413,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 413,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 413,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 413,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 413,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 413,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 413,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 413,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 413,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 413,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 413,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 413,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 413,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 413,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 413,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 413,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 413,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 413,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 413,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 413,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 413,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 413,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 413,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 413,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 413,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 413,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 413,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 413,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 413,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 413,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 413,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 413,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 413,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 413,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 413,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 413,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 413,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 413,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 413,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 413,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 413,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 413,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 413,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 413,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 413,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 413,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 413,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 413,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 413,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 413,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 413,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 413,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 413,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 413,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 413,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 413,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 413,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 413,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 413,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 413,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 413,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 413,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 413,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 413,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 413,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 413,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 413,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 413,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 413,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 413,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 413,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 413,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 413,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 413,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 413,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 413,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 413,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 413,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 413,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 413,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_16_Trim_V = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 412,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 412,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 412,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 412,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 412,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 412,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 412,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 412,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 412,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 412,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 412,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 412,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 412,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 412,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 412,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 412,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 412,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 412,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 412,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 412,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 412,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 412,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 412,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 412,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 412,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 412,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 412,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 412,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 412,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 412,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 412,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 412,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 412,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 412,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 412,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 412,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 412,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 412,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 412,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 412,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 412,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 412,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 412,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 412,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 412,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 412,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 412,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 412,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 412,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 412,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 412,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 412,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 412,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 412,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 412,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 412,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 412,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 412,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 412,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 412,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 412,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 412,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 412,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 412,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 412,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 412,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 412,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 412,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 412,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 412,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 412,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 412,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 412,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 412,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 412,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 412,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 412,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 412,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 412,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 412,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 412,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 412,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 412,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 412,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 412,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 412,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 412,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 412,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 412,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 412,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 412,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 412,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 412,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 412,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 412,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 412,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 412,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 412,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 412,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 412,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 412,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 412,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 412,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 412,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 412,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 412,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 412,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 412,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 412,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 412,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 412,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 412,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 412,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 412,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 412,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 412,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 412,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 412,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 412,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 412,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 412,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 412,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 412,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 412,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 412,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 412,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 412,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 412,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 412,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 412,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 412,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 412,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 412,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 412,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 412,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 412,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 412,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 412,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 412,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 412,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 412,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 412,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 412,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 412,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 412,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 412,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 412,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 412,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 412,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 412,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 412,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 412,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 412,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 412,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 412,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 412,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 412,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 412,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 412,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 412,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 412,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 412,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 412,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 412,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 412,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 412,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 412,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 412,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 412,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 412,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 412,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 412,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 412,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 412,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 412,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 412,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 412,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 412,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 412,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 412,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 412,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 412,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 412,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 412,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 412,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 412,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 412,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 412,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 412,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 412,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 412,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 412,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 412,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 412,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 412,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 412,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 412,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 412,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 412,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 412,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 412,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 412,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 412,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 412,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 412,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 412,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 412,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 412,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 412,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 412,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 412,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 412,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 412,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 412,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 412,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 412,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 412,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 412,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 412,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 412,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 412,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 412,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 412,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 412,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 412,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 412,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 412,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 412,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 412,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 412,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 412,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 412,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 412,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 412,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 412,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 412,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 412,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 412,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 412,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 412,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 412,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 412,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 412,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 412,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 412,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 412,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 412,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 412,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 412,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 412,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 412,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 412,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 412,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 412,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 412,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 412,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 412,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 412,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 412,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 412,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 412,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 412,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 412,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 412,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 412,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 412,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 412,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 412,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 412,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 412,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 412,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 412,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 412,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 412,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 412,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 412,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 412,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 412,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 412,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 412,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 412,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 412,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 412,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 412,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 412,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 412,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 412,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 412,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 412,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 412,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 412,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 412,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 412,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 412,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 412,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 412,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 412,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 412,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 412,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 412,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 412,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 412,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 412,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 412,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 412,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 412,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 412,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 412,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 412,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 412,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 412,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 412,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 412,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 412,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 412,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 412,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 412,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 412,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 412,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 412,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 412,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 412,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 412,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 412,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 412,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 412,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 412,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 412,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 412,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 412,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 412,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 412,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 412,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 412,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 412,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 412,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 412,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 412,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 412,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 412,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 412,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 412,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 412,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 412,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 412,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 412,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 412,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 412,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 412,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 412,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 412,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 412,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 412,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 412,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 412,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 412,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 412,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 412,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 412,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 412,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 412,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 412,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 412,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 412,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 412,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 412,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 412,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 412,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 412,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 412,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 412,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 412,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 412,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 412,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 412,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 412,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 412,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 412,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 412,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 412,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 412,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 412,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 412,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 412,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 412,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 412,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 412,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 412,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 412,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 412,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 412,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 412,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 412,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 412,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 412,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 412,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 412,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 412,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 412,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 412,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 412,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 412,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 412,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 412,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 412,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 412,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 412,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 412,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 412,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 412,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 412,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 412,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 412,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 412,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 412,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 412,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 412,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 412,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 412,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 412,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 412,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 412,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 412,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 412,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 412,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 412,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 412,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 412,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 412,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 412,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 412,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 412,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 412,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 412,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 412,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 412,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 412,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 412,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 412,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 412,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 412,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 412,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 412,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 412,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 412,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 412,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 412,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 412,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 412,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 412,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 412,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 412,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 412,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 412,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 412,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 412,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 412,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 412,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 412,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 412,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 412,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 412,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 412,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 412,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 412,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 412,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 412,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 412,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 412,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 412,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 412,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 412,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 412,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 412,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 412,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 412,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 412,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 412,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 412,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 412,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 412,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 412,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 412,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 412,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 412,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 412,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 412,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 412,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 412,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 412,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 412,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 412,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 412,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 412,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 412,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 412,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 412,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 412,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 412,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 412,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 412,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 412,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 412,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 412,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 412,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 412,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 412,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 412,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 412,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 412,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 412,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 412,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 412,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 412,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 412,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 412,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 412,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 412,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 412,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 412,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 412,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 412,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 412,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 412,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 412,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 412,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 412,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 412,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 412,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 412,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 412,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 412,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 412,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 412,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 412,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 412,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 412,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 412,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 412,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 412,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 412,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 412,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 412,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 412,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 412,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 412,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 412,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 412,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 412,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 412,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 412,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 412,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 412,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 412,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 412,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 412,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 412,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 412,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 412,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 412,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 412,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 412,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 412,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 412,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 412,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 412,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 412,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 412,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 412,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 412,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 412,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 412,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 412,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 412,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 412,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 412,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 412,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 412,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 412,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 412,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 412,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 412,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 412,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 412,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 412,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 412,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 412,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 412,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 412,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 412,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 412,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 412,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 412,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 412,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 412,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 412,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 412,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 412,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 412,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 412,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 412,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 412,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 412,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 412,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 412,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 412,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 412,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 412,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 412,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 412,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 412,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 412,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 412,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 412,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 412,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 412,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 412,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 412,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 412,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 412,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 412,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 412,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 412,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 412,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 412,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 412,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 412,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 412,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 412,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 412,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 412,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_20_Trim = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 448,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 448,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 448,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 448,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 448,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 448,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 448,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 448,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 448,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 448,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 448,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 448,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 448,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 448,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 448,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 448,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 448,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 448,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 448,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 448,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 448,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 448,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 448,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 448,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 448,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 448,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 448,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 448,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 448,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 448,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 448,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 448,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 448,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 448,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 448,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 448,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 448,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 448,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 448,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 448,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 448,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 448,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 448,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 448,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 448,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 448,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 448,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 448,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 448,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 448,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 448,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 448,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 448,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 448,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 448,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 448,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 448,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 448,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 448,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 448,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 448,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 448,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 448,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 448,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 448,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 448,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 448,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 448,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 448,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 448,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 448,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 448,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 448,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 448,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 448,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 448,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 448,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 448,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 448,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 448,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 448,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 448,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 448,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 448,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 448,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 448,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 448,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 448,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 448,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 448,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 448,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 448,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 448,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 448,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 448,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 448,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 448,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 448,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 448,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 448,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 448,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 448,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 448,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 448,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 448,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 448,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 448,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 448,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 448,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 448,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 448,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 448,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 448,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 448,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 448,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 448,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 448,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 448,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 448,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 448,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 448,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 448,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 448,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 448,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 448,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 448,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 448,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 448,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 448,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 448,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 448,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 448,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 448,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 448,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 448,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 448,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 448,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 448,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 448,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 448,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 448,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 448,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 448,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 448,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 448,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 448,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 448,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 448,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 448,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 448,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 448,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 448,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 448,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 448,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 448,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 448,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 448,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 448,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 448,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 448,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 448,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 448,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 448,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 448,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 448,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 448,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 448,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 448,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 448,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 448,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 448,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 448,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 448,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 448,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 448,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 448,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 448,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 448,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 448,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 448,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 448,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 448,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 448,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 448,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 448,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 448,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 448,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 448,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 448,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 448,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 448,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 448,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 448,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 448,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 448,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 448,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 448,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 448,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 448,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 448,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 448,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 448,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 448,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 448,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 448,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 448,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 448,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 448,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 448,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 448,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 448,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 448,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 448,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 448,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 448,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 448,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 448,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 448,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 448,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 448,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 448,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 448,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 448,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 448,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 448,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 448,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 448,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 448,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 448,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 448,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 448,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 448,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 448,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 448,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 448,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 448,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 448,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 448,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 448,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 448,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 448,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 448,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 448,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 448,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 448,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 448,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 448,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 448,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 448,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 448,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 448,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 448,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 448,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 448,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 448,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 448,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 448,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 448,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 448,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 448,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 448,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 448,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 448,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 448,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 448,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 448,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 448,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 448,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 448,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 448,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 448,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 448,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 448,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 448,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 448,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 448,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 448,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 448,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 448,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 448,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 448,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 448,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 448,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 448,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 448,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 448,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 448,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 448,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 448,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 448,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 448,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 448,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 448,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 448,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 448,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 448,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 448,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 448,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 448,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 448,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 448,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 448,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 448,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 448,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 448,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 448,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 448,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 448,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 448,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 448,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 448,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 448,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 448,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 448,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 448,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 448,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 448,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 448,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 448,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 448,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 448,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 448,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 448,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 448,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 448,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 448,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 448,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 448,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 448,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 448,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 448,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 448,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 448,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 448,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 448,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 448,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 448,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 448,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 448,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 448,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 448,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 448,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 448,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 448,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 448,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 448,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 448,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 448,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 448,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 448,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 448,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 448,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 448,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 448,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 448,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 448,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 448,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 448,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 448,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 448,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 448,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 448,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 448,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 448,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 448,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 448,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 448,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 448,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 448,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 448,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 448,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 448,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 448,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 448,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 448,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 448,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 448,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 448,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 448,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 448,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 448,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 448,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 448,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 448,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 448,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 448,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 448,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 448,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 448,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 448,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 448,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 448,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 448,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 448,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 448,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 448,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 448,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 448,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 448,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 448,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 448,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 448,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 448,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 448,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 448,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 448,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 448,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 448,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 448,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 448,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 448,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 448,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 448,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 448,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 448,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 448,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 448,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 448,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 448,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 448,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 448,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 448,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 448,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 448,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 448,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 448,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 448,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 448,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 448,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 448,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 448,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 448,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 448,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 448,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 448,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 448,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 448,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 448,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 448,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 448,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 448,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 448,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 448,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 448,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 448,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 448,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 448,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 448,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 448,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 448,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 448,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 448,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 448,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 448,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 448,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 448,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 448,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 448,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 448,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 448,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 448,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 448,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 448,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 448,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 448,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 448,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 448,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 448,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 448,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 448,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 448,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 448,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 448,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 448,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 448,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 448,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 448,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 448,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 448,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 448,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 448,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 448,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 448,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 448,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 448,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 448,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 448,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 448,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 448,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 448,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 448,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 448,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 448,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 448,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 448,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 448,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 448,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 448,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 448,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 448,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 448,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 448,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 448,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 448,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 448,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 448,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 448,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 448,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 448,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 448,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 448,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 448,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 448,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 448,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 448,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 448,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 448,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 448,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 448,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 448,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 448,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 448,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 448,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 448,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 448,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 448,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 448,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 448,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 448,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 448,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 448,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 448,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 448,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 448,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 448,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 448,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 448,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 448,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 448,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 448,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 448,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 448,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 448,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 448,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 448,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 448,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 448,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 448,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 448,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 448,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 448,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 448,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 448,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 448,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 448,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 448,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 448,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 448,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 448,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 448,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 448,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 448,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 448,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 448,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 448,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 448,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 448,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 448,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 448,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 448,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 448,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 448,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 448,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 448,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 448,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 448,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 448,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 448,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 448,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 448,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 448,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 448,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 448,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 448,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 448,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 448,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 448,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 448,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 448,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 448,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 448,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 448,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 448,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 448,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 448,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 448,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 448,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 448,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 448,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 448,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 448,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 448,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 448,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 448,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 448,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 448,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 448,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 448,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 448,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 448,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 448,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 448,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 448,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 448,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 448,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 448,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 448,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 448,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 448,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 448,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 448,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 448,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 448,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 448,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 448,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 448,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 448,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 448,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 448,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 448,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 448,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_20_Trim_V = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 447,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 447,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 447,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 447,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 447,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 447,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 447,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 447,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 447,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 447,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 447,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 447,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 447,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 447,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 447,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 447,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 447,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 447,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 447,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 447,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 447,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 447,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 447,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 447,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 447,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 447,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 447,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 447,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 447,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 447,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 447,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 447,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 447,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 447,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 447,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 447,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 447,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 447,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 447,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 447,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 447,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 447,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 447,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 447,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 447,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 447,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 447,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 447,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 447,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 447,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 447,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 447,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 447,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 447,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 447,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 447,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 447,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 447,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 447,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 447,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 447,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 447,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 447,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 447,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 447,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 447,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 447,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 447,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 447,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 447,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 447,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 447,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 447,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 447,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 447,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 447,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 447,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 447,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 447,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 447,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 447,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 447,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 447,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 447,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 447,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 447,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 447,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 447,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 447,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 447,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 447,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 447,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 447,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 447,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 447,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 447,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 447,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 447,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 447,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 447,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 447,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 447,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 447,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 447,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 447,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 447,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 447,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 447,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 447,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 447,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 447,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 447,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 447,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 447,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 447,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 447,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 447,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 447,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 447,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 447,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 447,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 447,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 447,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 447,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 447,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 447,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 447,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 447,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 447,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 447,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 447,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 447,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 447,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 447,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 447,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 447,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 447,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 447,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 447,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 447,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 447,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 447,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 447,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 447,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 447,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 447,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 447,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 447,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 447,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 447,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 447,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 447,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 447,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 447,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 447,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 447,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 447,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 447,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 447,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 447,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 447,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 447,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 447,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 447,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 447,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 447,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 447,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 447,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 447,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 447,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 447,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 447,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 447,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 447,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 447,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 447,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 447,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 447,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 447,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 447,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 447,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 447,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 447,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 447,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 447,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 447,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 447,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 447,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 447,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 447,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 447,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 447,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 447,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 447,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 447,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 447,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 447,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 447,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 447,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 447,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 447,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 447,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 447,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 447,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 447,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 447,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 447,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 447,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 447,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 447,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 447,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 447,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 447,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 447,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 447,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 447,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 447,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 447,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 447,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 447,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 447,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 447,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 447,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 447,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 447,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 447,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 447,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 447,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 447,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 447,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 447,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 447,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 447,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 447,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 447,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 447,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 447,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 447,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 447,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 447,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 447,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 447,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 447,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 447,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 447,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 447,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 447,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 447,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 447,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 447,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 447,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 447,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 447,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 447,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 447,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 447,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 447,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 447,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 447,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 447,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 447,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 447,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 447,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 447,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 447,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 447,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 447,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 447,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 447,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 447,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 447,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 447,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 447,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 447,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 447,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 447,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 447,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 447,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 447,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 447,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 447,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 447,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 447,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 447,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 447,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 447,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 447,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 447,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 447,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 447,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 447,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 447,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 447,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 447,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 447,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 447,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 447,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 447,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 447,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 447,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 447,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 447,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 447,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 447,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 447,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 447,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 447,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 447,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 447,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 447,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 447,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 447,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 447,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 447,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 447,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 447,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 447,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 447,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 447,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 447,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 447,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 447,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 447,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 447,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 447,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 447,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 447,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 447,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 447,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 447,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 447,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 447,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 447,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 447,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 447,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 447,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 447,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 447,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 447,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 447,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 447,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 447,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 447,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 447,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 447,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 447,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 447,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 447,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 447,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 447,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 447,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 447,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 447,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 447,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 447,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 447,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 447,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 447,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 447,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 447,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 447,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 447,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 447,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 447,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 447,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 447,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 447,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 447,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 447,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 447,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 447,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 447,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 447,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 447,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 447,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 447,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 447,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 447,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 447,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 447,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 447,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 447,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 447,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 447,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 447,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 447,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 447,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 447,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 447,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 447,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 447,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 447,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 447,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 447,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 447,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 447,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 447,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 447,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 447,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 447,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 447,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 447,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 447,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 447,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 447,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 447,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 447,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 447,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 447,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 447,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 447,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 447,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 447,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 447,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 447,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 447,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 447,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 447,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 447,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 447,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 447,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 447,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 447,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 447,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 447,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 447,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 447,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 447,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 447,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 447,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 447,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 447,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 447,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 447,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 447,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 447,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 447,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 447,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 447,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 447,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 447,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 447,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 447,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 447,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 447,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 447,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 447,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 447,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 447,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 447,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 447,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 447,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 447,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 447,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 447,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 447,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 447,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 447,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 447,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 447,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 447,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 447,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 447,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 447,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 447,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 447,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 447,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 447,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 447,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 447,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 447,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 447,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 447,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 447,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 447,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 447,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 447,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 447,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 447,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 447,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 447,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 447,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 447,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 447,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 447,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 447,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 447,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 447,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 447,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 447,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 447,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 447,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 447,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 447,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 447,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 447,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 447,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 447,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 447,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 447,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 447,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 447,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 447,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 447,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 447,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 447,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 447,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 447,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 447,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 447,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 447,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 447,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 447,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 447,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 447,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 447,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 447,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 447,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 447,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 447,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 447,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 447,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 447,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 447,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 447,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 447,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 447,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 447,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 447,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 447,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 447,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 447,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 447,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 447,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 447,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 447,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 447,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 447,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 447,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 447,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 447,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 447,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 447,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 447,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 447,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 447,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 447,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 447,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 447,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 447,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 447,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 447,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 447,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 447,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 447,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 447,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 447,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 447,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 447,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 447,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 447,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 447,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 447,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 447,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 447,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 447,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 447,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 447,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 447,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 447,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 447,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 447,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 447,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 447,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 447,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 447,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 447,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 447,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 447,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 447,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 447,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 447,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 447,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 447,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 447,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 447,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 447,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 447,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 447,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 447,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 447,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 447,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 447,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 447,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 447,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 447,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 447,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 447,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 447,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 447,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 447,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 447,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 447,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 447,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 447,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 447,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 447,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 447,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 447,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 447,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 447,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 447,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 447,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 447,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 447,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 447,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 447,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 447,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 447,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 447,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 447,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 447,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 447,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 447,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 447,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 447,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 447,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 447,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 447,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 447,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 447,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_24_Trim = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 292,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 292,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 292,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 292,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 292,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 292,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 292,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 292,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 292,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 292,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 292,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 292,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 292,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 292,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 292,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 292,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 292,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 292,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 292,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 292,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 292,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 292,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 292,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 292,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 292,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 292,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 292,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 292,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 292,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 292,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 292,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 292,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 292,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 292,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 292,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 292,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 292,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 292,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 292,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 292,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 292,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 292,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 292,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 292,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 292,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 292,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 292,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 292,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 292,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 292,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 292,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 292,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 292,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 292,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 292,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 292,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 292,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 292,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 292,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 292,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 292,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 292,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 292,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 292,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 292,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 292,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 292,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 292,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 292,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 292,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 292,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 292,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 292,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 292,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 292,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 292,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 292,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 292,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 292,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 292,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 292,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 292,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 292,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 292,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 292,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 292,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 292,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 292,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 292,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 292,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 292,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 292,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 292,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 292,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 292,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 292,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 292,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 292,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 292,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 292,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 292,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 292,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 292,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 292,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 292,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 292,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 292,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 292,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 292,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 292,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 292,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 292,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 292,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 292,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 292,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 292,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 292,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 292,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 292,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 292,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 292,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 292,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 292,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 292,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 292,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 292,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 292,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 292,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 292,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 292,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 292,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 292,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 292,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 292,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 292,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 292,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 292,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 292,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 292,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 292,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 292,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 292,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 292,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 292,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 292,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 292,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 292,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 292,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 292,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 292,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 292,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 292,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 292,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 292,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 292,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 292,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 292,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 292,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 292,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 292,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 292,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 292,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 292,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 292,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 292,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 292,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 292,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 292,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 292,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 292,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 292,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 292,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 292,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 292,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 292,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 292,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 292,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 292,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 292,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 292,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 292,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 292,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 292,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 292,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 292,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 292,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 292,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 292,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 292,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 292,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 292,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 292,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 292,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 292,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 292,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 292,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 292,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 292,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 292,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 292,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 292,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 292,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 292,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 292,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 292,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 292,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 292,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 292,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 292,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 292,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 292,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 292,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 292,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 292,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 292,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 292,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 292,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 292,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 292,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 292,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 292,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 292,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 292,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 292,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 292,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 292,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 292,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 292,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 292,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 292,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 292,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 292,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 292,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 292,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 292,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 292,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 292,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 292,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 292,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 292,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 292,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 292,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 292,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 292,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 292,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 292,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 292,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 292,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 292,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 292,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 292,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 292,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 292,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 292,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 292,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 292,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 292,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 292,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 292,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 292,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 292,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 292,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 292,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 292,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 292,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 292,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 292,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 292,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 292,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 292,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 292,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 292,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 292,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 292,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 292,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 292,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 292,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 292,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 292,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 292,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 292,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 292,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 292,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 292,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 292,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 292,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 292,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 292,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 292,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 292,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 292,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 292,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 292,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 292,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 292,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 292,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 292,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 292,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 292,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 292,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 292,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 292,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 292,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 292,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 292,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 292,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 292,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 292,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 292,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 292,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 292,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 292,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 292,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 292,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 292,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 292,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 292,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 292,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 292,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 292,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 292,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 292,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 292,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 292,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 292,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 292,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 292,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 292,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 292,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 292,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 292,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 292,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 292,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 292,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 292,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 292,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 292,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 292,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 292,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 292,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 292,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 292,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 292,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 292,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 292,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 292,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 292,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 292,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 292,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 292,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 292,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 292,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 292,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 292,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 292,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 292,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 292,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 292,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 292,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 292,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 292,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 292,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 292,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 292,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 292,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 292,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 292,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 292,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 292,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 292,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 292,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 292,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 292,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 292,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 292,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 292,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 292,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 292,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 292,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 292,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 292,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 292,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 292,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 292,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 292,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 292,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 292,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 292,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 292,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 292,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 292,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 292,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 292,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 292,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 292,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 292,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 292,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 292,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 292,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 292,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 292,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 292,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 292,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 292,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 292,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 292,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 292,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 292,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 292,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 292,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 292,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 292,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 292,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 292,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 292,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 292,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 292,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 292,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 292,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 292,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 292,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 292,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 292,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 292,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 292,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 292,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 292,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 292,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 292,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 292,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 292,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 292,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 292,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 292,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 292,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 292,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 292,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 292,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 292,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 292,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 292,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 292,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 292,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 292,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 292,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 292,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 292,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 292,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 292,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 292,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 292,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 292,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 292,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 292,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 292,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 292,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 292,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 292,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 292,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 292,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 292,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 292,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 292,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 292,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 292,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 292,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 292,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 292,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 292,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 292,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 292,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 292,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 292,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 292,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 292,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 292,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 292,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 292,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 292,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 292,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 292,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 292,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 292,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 292,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 292,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 292,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 292,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 292,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 292,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 292,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 292,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 292,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 292,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 292,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 292,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 292,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 292,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 292,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 292,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 292,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 292,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 292,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 292,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 292,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 292,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 292,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 292,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 292,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 292,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 292,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 292,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 292,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 292,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 292,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 292,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 292,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 292,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 292,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 292,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 292,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 292,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 292,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 292,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 292,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 292,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 292,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 292,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 292,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 292,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 292,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 292,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 292,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 292,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 292,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 292,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 292,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 292,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 292,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 292,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 292,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 292,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 292,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 292,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 292,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 292,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 292,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 292,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 292,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 292,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 292,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 292,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 292,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 292,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 292,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 292,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 292,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 292,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 292,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 292,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 292,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 292,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 292,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 292,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 292,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 292,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 292,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 292,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 292,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 292,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 292,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 292,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 292,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 292,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 292,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 292,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 292,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 292,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 292,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 292,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 292,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 292,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 292,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 292,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 292,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 292,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 292,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 292,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 292,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 292,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 292,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 292,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 292,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 292,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 292,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 292,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 292,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 292,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 292,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 292,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 292,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 292,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 292,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 292,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 292,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 292,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 292,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 292,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 292,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 292,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 292,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 292,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 292,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 292,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 292,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 292,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 292,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 292,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 292,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 292,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 292,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 292,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 292,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 292,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 292,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 292,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 292,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 292,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 292,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 292,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 292,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 292,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_24_Trim_V = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 320,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 320,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 320,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 320,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 320,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 320,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 320,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 320,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 320,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 320,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 320,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 320,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 320,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 320,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 320,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 320,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 320,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 320,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 320,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 320,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 320,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 320,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 320,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 320,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 320,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 320,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 320,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 320,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 320,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 320,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 320,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 320,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 320,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 320,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 320,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 320,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 320,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 320,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 320,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 320,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 320,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 320,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 320,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 320,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 320,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 320,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 320,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 320,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 320,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 320,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 320,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 320,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 320,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 320,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 320,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 320,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 320,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 320,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 320,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 320,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 320,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 320,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 320,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 320,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 320,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 320,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 320,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 320,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 320,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 320,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 320,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 320,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 320,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 320,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 320,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 320,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 320,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 320,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 320,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 320,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 320,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 320,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 320,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 320,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 320,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 320,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 320,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 320,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 320,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 320,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 320,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 320,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 320,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 320,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 320,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 320,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 320,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 320,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 320,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 320,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 320,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 320,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 320,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 320,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 320,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 320,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 320,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 320,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 320,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 320,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 320,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 320,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 320,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 320,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 320,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 320,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 320,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 320,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 320,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 320,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 320,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 320,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 320,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 320,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 320,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 320,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 320,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 320,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 320,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 320,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 320,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 320,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 320,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 320,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 320,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 320,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 320,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 320,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 320,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 320,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 320,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 320,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 320,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 320,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 320,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 320,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 320,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 320,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 320,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 320,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 320,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 320,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 320,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 320,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 320,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 320,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 320,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 320,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 320,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 320,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 320,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 320,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 320,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 320,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 320,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 320,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 320,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 320,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 320,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 320,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 320,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 320,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 320,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 320,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 320,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 320,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 320,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 320,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 320,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 320,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 320,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 320,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 320,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 320,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 320,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 320,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 320,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 320,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 320,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 320,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 320,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 320,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 320,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 320,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 320,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 320,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 320,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 320,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 320,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 320,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 320,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 320,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 320,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 320,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 320,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 320,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 320,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 320,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 320,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 320,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 320,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 320,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 320,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 320,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 320,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 320,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 320,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 320,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 320,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 320,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 320,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 320,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 320,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 320,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 320,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 320,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 320,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 320,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 320,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 320,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 320,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 320,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 320,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 320,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 320,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 320,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 320,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 320,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 320,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 320,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 320,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 320,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 320,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 320,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 320,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 320,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 320,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 320,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 320,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 320,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 320,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 320,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 320,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 320,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 320,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 320,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 320,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 320,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 320,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 320,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 320,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 320,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 320,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 320,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 320,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 320,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 320,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 320,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 320,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 320,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 320,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 320,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 320,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 320,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 320,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 320,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 320,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 320,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 320,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 320,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 320,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 320,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 320,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 320,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 320,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 320,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 320,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 320,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 320,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 320,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 320,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 320,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 320,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 320,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 320,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 320,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 320,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 320,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 320,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 320,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 320,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 320,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 320,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 320,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 320,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 320,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 320,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 320,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 320,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 320,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 320,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 320,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 320,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 320,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 320,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 320,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 320,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 320,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 320,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 320,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 320,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 320,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 320,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 320,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 320,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 320,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 320,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 320,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 320,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 320,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 320,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 320,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 320,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 320,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 320,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 320,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 320,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 320,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 320,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 320,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 320,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 320,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 320,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 320,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 320,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 320,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 320,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 320,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 320,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 320,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 320,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 320,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 320,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 320,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 320,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 320,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 320,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 320,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 320,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 320,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 320,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 320,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 320,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 320,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 320,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 320,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 320,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 320,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 320,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 320,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 320,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 320,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 320,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 320,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 320,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 320,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 320,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 320,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 320,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 320,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 320,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 320,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 320,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 320,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 320,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 320,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 320,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 320,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 320,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 320,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 320,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 320,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 320,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 320,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 320,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 320,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 320,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 320,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 320,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 320,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 320,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 320,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 320,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 320,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 320,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 320,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 320,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 320,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 320,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 320,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 320,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 320,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 320,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 320,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 320,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 320,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 320,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 320,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 320,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 320,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 320,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 320,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 320,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 320,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 320,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 320,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 320,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 320,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 320,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 320,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 320,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 320,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 320,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 320,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 320,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 320,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 320,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 320,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 320,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 320,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 320,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 320,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 320,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 320,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 320,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 320,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 320,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 320,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 320,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 320,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 320,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 320,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 320,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 320,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 320,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 320,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 320,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 320,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 320,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 320,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 320,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 320,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 320,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 320,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 320,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 320,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 320,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 320,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 320,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 320,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 320,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 320,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 320,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 320,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 320,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 320,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 320,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 320,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 320,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 320,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 320,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 320,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 320,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 320,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 320,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 320,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 320,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 320,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 320,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 320,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 320,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 320,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 320,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 320,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 320,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 320,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 320,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 320,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 320,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 320,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 320,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 320,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 320,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 320,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 320,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 320,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 320,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 320,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 320,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 320,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 320,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 320,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 320,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 320,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 320,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 320,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 320,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 320,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 320,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 320,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 320,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 320,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 320,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 320,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 320,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 320,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 320,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 320,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 320,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 320,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 320,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 320,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 320,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 320,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 320,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 320,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 320,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 320,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 320,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 320,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 320,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 320,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 320,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 320,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 320,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 320,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 320,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 320,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 320,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 320,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 320,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 320,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 320,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 320,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 320,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 320,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 320,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 320,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 320,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 320,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 320,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 320,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 320,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 320,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 320,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 320,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 320,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 320,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 320,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 320,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 320,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 320,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 320,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 320,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 320,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 320,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 320,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 320,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 320,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 320,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 320,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 320,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 320,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 320,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 320,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 320,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 320,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 320,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 320,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 320,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 320,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 320,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 320,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 320,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 320,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 320,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 320,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 320,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 320,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 320,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 320,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 320,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 320,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 320,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 320,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 320,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 320,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 320,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 320,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 320,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 320,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 320,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 320,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 320,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 320,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 320,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 320,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 320,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 320,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 320,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 320,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 320,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 320,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 320,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 320,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 320,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 320,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 320,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 320,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 320,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 320,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_48_Trim = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 506,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 506,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 506,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 506,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 506,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 506,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 506,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 506,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 506,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 506,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 506,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 506,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 506,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 506,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 506,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 506,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 506,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 506,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 506,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 506,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 506,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 506,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 506,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 506,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 506,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 506,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 506,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 506,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 506,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 506,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 506,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 506,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 506,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 506,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 506,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 506,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 506,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 506,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 506,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 506,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 506,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 506,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 506,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 506,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 506,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 506,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 506,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 506,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 506,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 506,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 506,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 506,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 506,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 506,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 506,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 506,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 506,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 506,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 506,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 506,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 506,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 506,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 506,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 506,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 506,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 506,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 506,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 506,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 506,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 506,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 506,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 506,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 506,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 506,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 506,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 506,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 506,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 506,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 506,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 506,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 506,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 506,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 506,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 506,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 506,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 506,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 506,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 506,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 506,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 506,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 506,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 506,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 506,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 506,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 506,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 506,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 506,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 506,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 506,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 506,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 506,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 506,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 506,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 506,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 506,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 506,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 506,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 506,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 506,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 506,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 506,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 506,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 506,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 506,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 506,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 506,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 506,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 506,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 506,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 506,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 506,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 506,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 506,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 506,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 506,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 506,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 506,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 506,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 506,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 506,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 506,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 506,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 506,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 506,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 506,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 506,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 506,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 506,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 506,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 506,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 506,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 506,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 506,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 506,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 506,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 506,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 506,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 506,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 506,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 506,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 506,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 506,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 506,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 506,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 506,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 506,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 506,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 506,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 506,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 506,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 506,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 506,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 506,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 506,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 506,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 506,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 506,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 506,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 506,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 506,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 506,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 506,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 506,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 506,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 506,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 506,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 506,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 506,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 506,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 506,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 506,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 506,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 506,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 506,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 506,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 506,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 506,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 506,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 506,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 506,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 506,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 506,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 506,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 506,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 506,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 506,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 506,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 506,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 506,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 506,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 506,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 506,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 506,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 506,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 506,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 506,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 506,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 506,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 506,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 506,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 506,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 506,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 506,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 506,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 506,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 506,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 506,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 506,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 506,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 506,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 506,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 506,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 506,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 506,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 506,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 506,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 506,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 506,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 506,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 506,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 506,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 506,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 506,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 506,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 506,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 506,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 506,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 506,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 506,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 506,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 506,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 506,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 506,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 506,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 506,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 506,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 506,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 506,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 506,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 506,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 506,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 506,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 506,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 506,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 506,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 506,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 506,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 506,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 506,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 506,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 506,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 506,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 506,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 506,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 506,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 506,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 506,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 506,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 506,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 506,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 506,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 506,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 506,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 506,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 506,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 506,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 506,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 506,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 506,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 506,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 506,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 506,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 506,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 506,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 506,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 506,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 506,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 506,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 506,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 506,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 506,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 506,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 506,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 506,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 506,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 506,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 506,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 506,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 506,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 506,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 506,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 506,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 506,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 506,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 506,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 506,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 506,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 506,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 506,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 506,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 506,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 506,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 506,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 506,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 506,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 506,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 506,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 506,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 506,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 506,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 506,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 506,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 506,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 506,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 506,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 506,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 506,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 506,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 506,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 506,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 506,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 506,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 506,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 506,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 506,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 506,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 506,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 506,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 506,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 506,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 506,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 506,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 506,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 506,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 506,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 506,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 506,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 506,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 506,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 506,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 506,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 506,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 506,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 506,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 506,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 506,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 506,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 506,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 506,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 506,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 506,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 506,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 506,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 506,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 506,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 506,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 506,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 506,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 506,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 506,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 506,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 506,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 506,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 506,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 506,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 506,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 506,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 506,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 506,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 506,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 506,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 506,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 506,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 506,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 506,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 506,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 506,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 506,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 506,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 506,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 506,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 506,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 506,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 506,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 506,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 506,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 506,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 506,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 506,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 506,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 506,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 506,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 506,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 506,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 506,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 506,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 506,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 506,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 506,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 506,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 506,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 506,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 506,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 506,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 506,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 506,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 506,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 506,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 506,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 506,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 506,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 506,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 506,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 506,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 506,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 506,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 506,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 506,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 506,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 506,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 506,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 506,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 506,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 506,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 506,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 506,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 506,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 506,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 506,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 506,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 506,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 506,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 506,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 506,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 506,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 506,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 506,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 506,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 506,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 506,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 506,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 506,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 506,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 506,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 506,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 506,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 506,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 506,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 506,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 506,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 506,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 506,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 506,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 506,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 506,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 506,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 506,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 506,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 506,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 506,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 506,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 506,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 506,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 506,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 506,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 506,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 506,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 506,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 506,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 506,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 506,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 506,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 506,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 506,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 506,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 506,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 506,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 506,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 506,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 506,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 506,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 506,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 506,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 506,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 506,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 506,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 506,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 506,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 506,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 506,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 506,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 506,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 506,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 506,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 506,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 506,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 506,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 506,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 506,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 506,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 506,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 506,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 506,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 506,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 506,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 506,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 506,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 506,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 506,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 506,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 506,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 506,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 506,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 506,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 506,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 506,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 506,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 506,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 506,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 506,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 506,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 506,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 506,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 506,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 506,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 506,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 506,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 506,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 506,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 506,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 506,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 506,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 506,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 506,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 506,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 506,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 506,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 506,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 506,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 506,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 506,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 506,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 506,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 506,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 506,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 506,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 506,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 506,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 506,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 506,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 506,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 506,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 506,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 506,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 506,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 506,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 506,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 506,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 506,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 506,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 506,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 506,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 506,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 506,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 506,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 506,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 506,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 506,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 506,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 506,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 506,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 506,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 506,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 506,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 506,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 506,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 506,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 506,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 506,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 506,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 506,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 506,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 506,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 506,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 506,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 506,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 506,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 506,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 506,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 506,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 506,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 506,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 506,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 506,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 506,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 506,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 506,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 506,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 506,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 506,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 506,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 506,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 506,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 506,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 506,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 506,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 506,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 506,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 506,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 506,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 506,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 506,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 506,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 506,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 506,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 506,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 506,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 506,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 506,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 506,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 506,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_48_Trim_V = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 505,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 505,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 505,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 505,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 505,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 505,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 505,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 505,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 505,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 505,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 505,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 505,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 505,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 505,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 505,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 505,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 505,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 505,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 505,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 505,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 505,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 505,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 505,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 505,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 505,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 505,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 505,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 505,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 505,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 505,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 505,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 505,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 505,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 505,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 505,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 505,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 505,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 505,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 505,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 505,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 505,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 505,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 505,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 505,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 505,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 505,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 505,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 505,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 505,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 505,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 505,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 505,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 505,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 505,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 505,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 505,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 505,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 505,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 505,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 505,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 505,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 505,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 505,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 505,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 505,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 505,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 505,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 505,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 505,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 505,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 505,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 505,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 505,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 505,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 505,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 505,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 505,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 505,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 505,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 505,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 505,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 505,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 505,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 505,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 505,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 505,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 505,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 505,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 505,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 505,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 505,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 505,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 505,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 505,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 505,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 505,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 505,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 505,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 505,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 505,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 505,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 505,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 505,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 505,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 505,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 505,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 505,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 505,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 505,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 505,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 505,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 505,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 505,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 505,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 505,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 505,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 505,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 505,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 505,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 505,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 505,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 505,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 505,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 505,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 505,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 505,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 505,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 505,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 505,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 505,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 505,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 505,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 505,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 505,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 505,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 505,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 505,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 505,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 505,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 505,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 505,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 505,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 505,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 505,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 505,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 505,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 505,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 505,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 505,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 505,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 505,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 505,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 505,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 505,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 505,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 505,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 505,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 505,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 505,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 505,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 505,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 505,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 505,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 505,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 505,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 505,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 505,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 505,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 505,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 505,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 505,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 505,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 505,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 505,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 505,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 505,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 505,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 505,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 505,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 505,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 505,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 505,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 505,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 505,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 505,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 505,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 505,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 505,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 505,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 505,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 505,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 505,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 505,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 505,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 505,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 505,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 505,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 505,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 505,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 505,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 505,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 505,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 505,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 505,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 505,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 505,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 505,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 505,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 505,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 505,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 505,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 505,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 505,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 505,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 505,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 505,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 505,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 505,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 505,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 505,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 505,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 505,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 505,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 505,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 505,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 505,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 505,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 505,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 505,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 505,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 505,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 505,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 505,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 505,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 505,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 505,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 505,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 505,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 505,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 505,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 505,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 505,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 505,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 505,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 505,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 505,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 505,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 505,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 505,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 505,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 505,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 505,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 505,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 505,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 505,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 505,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 505,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 505,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 505,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 505,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 505,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 505,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 505,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 505,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 505,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 505,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 505,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 505,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 505,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 505,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 505,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 505,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 505,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 505,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 505,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 505,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 505,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 505,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 505,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 505,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 505,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 505,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 505,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 505,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 505,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 505,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 505,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 505,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 505,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 505,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 505,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 505,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 505,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 505,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 505,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 505,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 505,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 505,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 505,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 505,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 505,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 505,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 505,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 505,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 505,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 505,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 505,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 505,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 505,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 505,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 505,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 505,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 505,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 505,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 505,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 505,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 505,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 505,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 505,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 505,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 505,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 505,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 505,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 505,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 505,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 505,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 505,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 505,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 505,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 505,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 505,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 505,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 505,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 505,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 505,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 505,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 505,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 505,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 505,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 505,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 505,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 505,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 505,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 505,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 505,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 505,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 505,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 505,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 505,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 505,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 505,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 505,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 505,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 505,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 505,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 505,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 505,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 505,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 505,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 505,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 505,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 505,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 505,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 505,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 505,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 505,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 505,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 505,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 505,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 505,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 505,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 505,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 505,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 505,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 505,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 505,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 505,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 505,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 505,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 505,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 505,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 505,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 505,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 505,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 505,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 505,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 505,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 505,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 505,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 505,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 505,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 505,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 505,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 505,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 505,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 505,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 505,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 505,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 505,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 505,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 505,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 505,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 505,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 505,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 505,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 505,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 505,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 505,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 505,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 505,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 505,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 505,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 505,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 505,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 505,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 505,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 505,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 505,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 505,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 505,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 505,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 505,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 505,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 505,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 505,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 505,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 505,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 505,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 505,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 505,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 505,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 505,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 505,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 505,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 505,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 505,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 505,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 505,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 505,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 505,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 505,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 505,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 505,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 505,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 505,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 505,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 505,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 505,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 505,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 505,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 505,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 505,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 505,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 505,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 505,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 505,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 505,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 505,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 505,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 505,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 505,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 505,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 505,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 505,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 505,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 505,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 505,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 505,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 505,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 505,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 505,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 505,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 505,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 505,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 505,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 505,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 505,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 505,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 505,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 505,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 505,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 505,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 505,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 505,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 505,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 505,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 505,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 505,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 505,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 505,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 505,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 505,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 505,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 505,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 505,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 505,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 505,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 505,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 505,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 505,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 505,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 505,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 505,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 505,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 505,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 505,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 505,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 505,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 505,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 505,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 505,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 505,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 505,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 505,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 505,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 505,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 505,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 505,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 505,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 505,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 505,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 505,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 505,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 505,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 505,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 505,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 505,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 505,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 505,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 505,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 505,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 505,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 505,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 505,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 505,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 505,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 505,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 505,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 505,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 505,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 505,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 505,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 505,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 505,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 505,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 505,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 505,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 505,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 505,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 505,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 505,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 505,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 505,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 505,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 505,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 505,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 505,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 505,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 505,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 505,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 505,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 505,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 505,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 505,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 505,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 505,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 505,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 505,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 505,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 505,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 505,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 505,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 505,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 505,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 505,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 505,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 505,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 505,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 505,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 505,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 505,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 505,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 505,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 505,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 505,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 505,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 505,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 505,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 505,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 505,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 505,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 505,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 505,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 505,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 505,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 505,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 505,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 505,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 505,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 505,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 505,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 505,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 505,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 505,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 505,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 505,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 505,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 505,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 505,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 505,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 505,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 505,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 505,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 505,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 505,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 505,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 505,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 505,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 505,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 505,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 505,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 505,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 505,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 505,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 505,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 505,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 505,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 505,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 505,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 505,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 505,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_Trim = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 422,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 422,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 422,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 422,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 422,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 422,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 422,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 422,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 422,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 422,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 422,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 422,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 422,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 422,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 422,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 422,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 422,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 422,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 422,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 422,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 422,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 422,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 422,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 422,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 422,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 422,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 422,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 422,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 422,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 422,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 422,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 422,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 422,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 422,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 422,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 422,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 422,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 422,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 422,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 422,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 422,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 422,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 422,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 422,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 422,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 422,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 422,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 422,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 422,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 422,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 422,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 422,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 422,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 422,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 422,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 422,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 422,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 422,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 422,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 422,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 422,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 422,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 422,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 422,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 422,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 422,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 422,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 422,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 422,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 422,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 422,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 422,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 422,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 422,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 422,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 422,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 422,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 422,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 422,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 422,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 422,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 422,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 422,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 422,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 422,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 422,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 422,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 422,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 422,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 422,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 422,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 422,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 422,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 422,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 422,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 422,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 422,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 422,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 422,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 422,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 422,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 422,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 422,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 422,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 422,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 422,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 422,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 422,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 422,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 422,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 422,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 422,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 422,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 422,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 422,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 422,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 422,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 422,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 422,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 422,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 422,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 422,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 422,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 422,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 422,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 422,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 422,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 422,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 422,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 422,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 422,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 422,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 422,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 422,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 422,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 422,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 422,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 422,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 422,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 422,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 422,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 422,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 422,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 422,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 422,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 422,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 422,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 422,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 422,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 422,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 422,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 422,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 422,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 422,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 422,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 422,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 422,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 422,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 422,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 422,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 422,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 422,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 422,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 422,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 422,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 422,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 422,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 422,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 422,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 422,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 422,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 422,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 422,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 422,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 422,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 422,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 422,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 422,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 422,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 422,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 422,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 422,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 422,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 422,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 422,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 422,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 422,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 422,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 422,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 422,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 422,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 422,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 422,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 422,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 422,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 422,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 422,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 422,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 422,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 422,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 422,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 422,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 422,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 422,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 422,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 422,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 422,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 422,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 422,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 422,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 422,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 422,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 422,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 422,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 422,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 422,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 422,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 422,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 422,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 422,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 422,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 422,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 422,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 422,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 422,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 422,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 422,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 422,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 422,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 422,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 422,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 422,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 422,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 422,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 422,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 422,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 422,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 422,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 422,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 422,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 422,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 422,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 422,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 422,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 422,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 422,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 422,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 422,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 422,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 422,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 422,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 422,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 422,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 422,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 422,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 422,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 422,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 422,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 422,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 422,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 422,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 422,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 422,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 422,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 422,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 422,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 422,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 422,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 422,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 422,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 422,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 422,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 422,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 422,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 422,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 422,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 422,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 422,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 422,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 422,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 422,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 422,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 422,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 422,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 422,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 422,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 422,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 422,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 422,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 422,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 422,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 422,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 422,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 422,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 422,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 422,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 422,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 422,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 422,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 422,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 422,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 422,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 422,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 422,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 422,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 422,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 422,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 422,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 422,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 422,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 422,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 422,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 422,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 422,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 422,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 422,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 422,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 422,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 422,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 422,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 422,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 422,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 422,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 422,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 422,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 422,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 422,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 422,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 422,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 422,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 422,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 422,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 422,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 422,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 422,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 422,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 422,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 422,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 422,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 422,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 422,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 422,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 422,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 422,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 422,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 422,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 422,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 422,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 422,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 422,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 422,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 422,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 422,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 422,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 422,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 422,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 422,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 422,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 422,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 422,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 422,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 422,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 422,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 422,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 422,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 422,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 422,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 422,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 422,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 422,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 422,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 422,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 422,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 422,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 422,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 422,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 422,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 422,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 422,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 422,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 422,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 422,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 422,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 422,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 422,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 422,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 422,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 422,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 422,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 422,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 422,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 422,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 422,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 422,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 422,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 422,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 422,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 422,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 422,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 422,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 422,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 422,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 422,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 422,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 422,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 422,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 422,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 422,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 422,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 422,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 422,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 422,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 422,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 422,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 422,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 422,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 422,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 422,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 422,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 422,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 422,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 422,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 422,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 422,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 422,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 422,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 422,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 422,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 422,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 422,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 422,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 422,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 422,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 422,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 422,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 422,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 422,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 422,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 422,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 422,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 422,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 422,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 422,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 422,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 422,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 422,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 422,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 422,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 422,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 422,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 422,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 422,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 422,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 422,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 422,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 422,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 422,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 422,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 422,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 422,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 422,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 422,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 422,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 422,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 422,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 422,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 422,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 422,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 422,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 422,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 422,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 422,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 422,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 422,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 422,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 422,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 422,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 422,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 422,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 422,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 422,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 422,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 422,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 422,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 422,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 422,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 422,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 422,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 422,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 422,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 422,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 422,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 422,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 422,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 422,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 422,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 422,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 422,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 422,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 422,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 422,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 422,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 422,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 422,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 422,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 422,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 422,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 422,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 422,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 422,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 422,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 422,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 422,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 422,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 422,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 422,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 422,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 422,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 422,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 422,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 422,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 422,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 422,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 422,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 422,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 422,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 422,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 422,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 422,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 422,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 422,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 422,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 422,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 422,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 422,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 422,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 422,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 422,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 422,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 422,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 422,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 422,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 422,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 422,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 422,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 422,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 422,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 422,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 422,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 422,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 422,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 422,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 422,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 422,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 422,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 422,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 422,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 422,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 422,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 422,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 422,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 422,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 422,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 422,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 422,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 422,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 422,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 422,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 422,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 422,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 422,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 422,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 422,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 422,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 422,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 422,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 422,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 422,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 422,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 422,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 422,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 422,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 422,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 422,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 422,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 422,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 422,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 422,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 422,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 422,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 422,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 422,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 422,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 422,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 422,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 422,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 422,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 422,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 422,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 422,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 422,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 422,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 422,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 422,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 422,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 422,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 422,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 422,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 422,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 422,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 422,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 422,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 422,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 422,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 422,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 422,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 422,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 422,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 422,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 422,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 422,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 422,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 422,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 422,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 422,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 422,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 422,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 422,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 422,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 422,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 422,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_General_Trim_V = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 424,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 424,
      },
    },
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 424,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 424,
      },
    },
    Stone_Bello_Cob: {
      Stone_Bello_Cob_NewEngland: {
        layerConfigId: 695,
        templateId: 424,
      },
      Stone_Bello_Cob_Pequea: {
        layerConfigId: 697,
        templateId: 424,
      },
    },
    Stone_Bello_Cobblestone_Trim: {
      Masonry_Stone_Bello_Cobblestone_NewEngland_Trim: {
        layerConfigId: 694,
        templateId: 424,
      },
      Masonry_Stone_Bello_Cobblestone_Pequea_Trim: {
        layerConfigId: 696,
        templateId: 424,
      },
    },
    Stone_Bello_FS: {
      Stone_Bello_FS_Hickory: {
        layerConfigId: 912,
        templateId: 424,
      },
    },
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 424,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 424,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 424,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 424,
      },
    },
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 424,
      },
    },
    Stone_Bello_Ledgestone_Trim: {
      Stone_Bello_Brecknock_Trim: {
        layerConfigId: 725,
        templateId: 424,
      },
    },
    Stone_BoulderCreek_CL: {
      Stone_BC_Loveland: {
        layerConfigId: 1224,
        templateId: 424,
      },
    },
    Stone_BoulderCreek_ML: {
      Stone_BC_Jasper: {
        layerConfigId: 1223,
        templateId: 424,
      },
    },
    Stone_BoulderCreek_OR: {
      Stone_BC_Stonehenge: {
        layerConfigId: 1225,
        templateId: 424,
      },
    },
    Stone_BoulderCreek_PB: {
      Stone_BC_PB_DantesPeak: {
        layerConfigId: 1222,
        templateId: 424,
      },
    },
    Stone_BoulderCreek_Sangria: {
      Stone_BC_SpanishWheat: {
        layerConfigId: 971,
        templateId: 424,
      },
    },
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 424,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 424,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 424,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 424,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 424,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 424,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 424,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 424,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 424,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 424,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 424,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 424,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 424,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 424,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 424,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 424,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 424,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 424,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 424,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 424,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 424,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 424,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 424,
      },
    },
    Stone_CastleHill_CE: {
      Stone_CH_AutumnBreeze: {
        layerConfigId: 426,
        templateId: 424,
      },
      Stone_CH_GlacialBluff: {
        layerConfigId: 428,
        templateId: 424,
      },
      Stone_CH_OldCastle: {
        layerConfigId: 430,
        templateId: 424,
      },
    },
    Stone_CastleHill_Trim: {
      Stone_CH_AutumnBreeze_Trim: {
        layerConfigId: 425,
        templateId: 424,
      },
      Stone_CH_GlacialBluff_Trim: {
        layerConfigId: 427,
        templateId: 424,
      },
      Stone_CH_OldCastle_Trim: {
        layerConfigId: 429,
        templateId: 424,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 424,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 424,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 424,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 424,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 424,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 424,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 424,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 424,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 424,
      },
    },
    Stone_Centurion_Old: {
      Stone_Centurion_Old_NorrisGray: {
        layerConfigId: 699,
        templateId: 424,
      },
    },
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 424,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 424,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 424,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 424,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 424,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 424,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 424,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 424,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 424,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 424,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 424,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 424,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 424,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 424,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 424,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 424,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 424,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 424,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 424,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 424,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 424,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 424,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 424,
      },
    },
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 424,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 424,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 424,
      },
    },
    Stone_CS_AlpineLedgestone_Trim: {
      Stone_CS_AlpineLedgestone_UmberCreek_Trim: {
        layerConfigId: 511,
        templateId: 424,
      },
    },
    Stone_CS_CountryLedgestone_Trim: {
      Stone_CS_CL_Ashfall_Trim: {
        layerConfigId: 513,
        templateId: 424,
      },
      Stone_CS_CL_BlackRundle_Trim: {
        layerConfigId: 283,
        templateId: 424,
      },
      Stone_CS_CL_BucksCounty_Trim: {
        layerConfigId: 850,
        templateId: 424,
      },
      Stone_CS_CL_EchoRidge_Trim: {
        layerConfigId: 640,
        templateId: 424,
      },
      Stone_CS_CL_GrandMesa_Trim: {
        layerConfigId: 285,
        templateId: 424,
      },
      Stone_CS_CL_Gunnison_Trim: {
        layerConfigId: 641,
        templateId: 424,
      },
      Stone_CS_CL_Wheaton_Trim: {
        layerConfigId: 642,
        templateId: 424,
      },
      Stone_CS_CL_WolfCreek_Trim: {
        layerConfigId: 514,
        templateId: 424,
      },
    },
    Stone_CS_DrystackLedgestone_Trim: {
      Stone_CS_DrystackLedgestone_Rubicon_Trim: {
        layerConfigId: 515,
        templateId: 424,
      },
    },
    Stone_CS_SouthernLedgestone_Trim: {
      Stone_CS_SouthernLedgestone_Aspen_Trim: {
        layerConfigId: 516,
        templateId: 424,
      },
      Stone_CS_SouthernLedgestone_EchoRidge_Trim: {
        layerConfigId: 517,
        templateId: 424,
      },
      Stone_CS_SouthernLedgestone_Gray_Trim: {
        layerConfigId: 518,
        templateId: 424,
      },
    },
    Stone_Cultured_AL: {
      Stone_Cultured_AL_UmberCreek: {
        layerConfigId: 503,
        templateId: 424,
      },
    },
    Stone_Cultured_CL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1256,
        templateId: 424,
      },
      Stone_Cultured_CL_Ashfall: {
        layerConfigId: 504,
        templateId: 424,
      },
      Stone_Cultured_CL_BlackRundle: {
        layerConfigId: 284,
        templateId: 424,
      },
      Stone_Cultured_CL_BucksCounty: {
        layerConfigId: 851,
        templateId: 424,
      },
      Stone_Cultured_CL_EchoRidge: {
        layerConfigId: 636,
        templateId: 424,
      },
      Stone_Cultured_CL_GrandMesa: {
        layerConfigId: 286,
        templateId: 424,
      },
      Stone_Cultured_CL_Gunnison: {
        layerConfigId: 637,
        templateId: 424,
      },
      Stone_Cultured_CL_Wheaton: {
        layerConfigId: 638,
        templateId: 424,
      },
      Stone_Cultured_CL_WolfCreek: {
        layerConfigId: 505,
        templateId: 424,
      },
    },
    Stone_Cultured_DSL: {
      Stone_Cultured_DSL_Rubicon: {
        layerConfigId: 507,
        templateId: 424,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 424,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 424,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 424,
      },
    },
    Stone_Cultured_SL: {
      Stone_Cultured_Chardonnay: {
        layerConfigId: 1257,
        templateId: 424,
      },
      Stone_Cultured_SL_Aspen: {
        layerConfigId: 499,
        templateId: 424,
      },
      Stone_Cultured_SL_BucksCounty: {
        layerConfigId: 1226,
        templateId: 424,
      },
      Stone_Cultured_SL_EchoRidge: {
        layerConfigId: 501,
        templateId: 424,
      },
      Stone_Cultured_SL_Gray: {
        layerConfigId: 508,
        templateId: 424,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 424,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 424,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 424,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 424,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 424,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 424,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 424,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 424,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 424,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 424,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 424,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 424,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 424,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 424,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 424,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 424,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 424,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 424,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 424,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 424,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 424,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 424,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 424,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 424,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 424,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 424,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 424,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 424,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 424,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 424,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 424,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 424,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 424,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 424,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 424,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 424,
      },
    },
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 424,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 424,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 424,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 424,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 424,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 424,
      },
    },
    Stone_DutchQuality_StackLedge_Trim: {
      Stone_DQ_StackLedge_Fallbrook_Trim: {
        layerConfigId: 752,
        templateId: 424,
      },
      Stone_DQ_StackLedge_Sienna_Trim: {
        layerConfigId: 828,
        templateId: 424,
      },
      Stone_DQ_StackLedge_Steinhaus_Trim: {
        layerConfigId: 806,
        templateId: 424,
      },
      Stone_DQ_StackLedge_Torino_Trim: {
        layerConfigId: 803,
        templateId: 424,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 424,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 424,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 424,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 424,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 424,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 424,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 424,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 424,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 424,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 424,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 424,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 424,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 424,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 424,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 424,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 424,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 424,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 424,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 424,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 424,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 424,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 424,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 424,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 424,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 424,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 424,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 424,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 424,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 424,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 424,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 424,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 424,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 424,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 424,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 424,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 424,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 424,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 424,
      },
    },
    Stone_Ecostone_CR: {
      Stone_Ecostone_WhiteWashed: {
        layerConfigId: 940,
        templateId: 424,
      },
    },
    Stone_Ecostone_RS: {
      Stone_Ecostone_Moraine: {
        layerConfigId: 938,
        templateId: 424,
      },
    },
    Stone_Ecostone_Trim: {
      Stone_Ecostone_Moraine_Trim: {
        layerConfigId: 937,
        templateId: 424,
      },
      Stone_Ecostone_WhiteWashed_Trim: {
        layerConfigId: 939,
        templateId: 424,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 424,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 424,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 424,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 424,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 424,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 424,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 424,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 424,
      },
    },
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 424,
      },
    },
    Stone_Eldorado_CCS: {
      Stone_Eldorado_CCS_Seashell: {
        layerConfigId: 1227,
        templateId: 424,
      },
    },
    Stone_Eldorado_CRidge: {
      Stone_Eldorado_CRidge_Orchard: {
        layerConfigId: 1228,
        templateId: 424,
      },
    },
    Stone_Eldorado_CS: {
      Stone_Eldorado_CS_BanffSprings: {
        layerConfigId: 1008,
        templateId: 424,
      },
      Stone_Eldorado_CS_Boardwalk: {
        layerConfigId: 1010,
        templateId: 424,
      },
      Stone_Eldorado_CS_Montecito: {
        layerConfigId: 1016,
        templateId: 424,
      },
      Stone_Eldorado_CS_NordicPeak: {
        layerConfigId: 1064,
        templateId: 424,
      },
      Stone_Eldorado_CS_WhiteBark: {
        layerConfigId: 500,
        templateId: 424,
      },
      Stone_Eldorado_WhiteBark: {
        layerConfigId: 1020,
        templateId: 424,
      },
    },
    Stone_Eldorado_EL: {
      Stone_Eldorado_EL_IronMill: {
        layerConfigId: 509,
        templateId: 424,
      },
      Stone_Eldorado_EL_SeaCliff: {
        layerConfigId: 1232,
        templateId: 424,
      },
      Stone_Eldorado_EL_Sidewalk: {
        layerConfigId: 1233,
        templateId: 424,
      },
      Stone_Eldorado_EL_Zinc: {
        layerConfigId: 1229,
        templateId: 424,
      },
    },
    Stone_Eldorado_FL: {
      Stone_Eldorado_FL_Andante: {
        layerConfigId: 942,
        templateId: 424,
      },
    },
    Stone_Eldorado_LS: {
      Stone_Eldorado_LS_GrandBanks: {
        layerConfigId: 1101,
        templateId: 424,
      },
    },
    Stone_Eldorado_ML: {
      Stone_Eldorado_ML_GreyDrift: {
        layerConfigId: 1311,
        templateId: 424,
      },
      Stone_Eldorado_ML_MesaVerde: {
        layerConfigId: 288,
        templateId: 424,
      },
      Stone_Eldorado_ML_Sierra: {
        layerConfigId: 506,
        templateId: 424,
      },
    },
    Stone_Eldorado_RC: {
      Stone_Eldorado_RC_AutumnLeaf: {
        layerConfigId: 502,
        templateId: 424,
      },
      Stone_Eldorado_RC_CasaBlanca: {
        layerConfigId: 1234,
        templateId: 424,
      },
      Stone_Eldorado_RC_FallingSpring: {
        layerConfigId: 1230,
        templateId: 424,
      },
      Stone_Eldorado_RC_LoireValley: {
        layerConfigId: 1235,
        templateId: 424,
      },
      Stone_Eldorado_RC_Moonlight: {
        layerConfigId: 1273,
        templateId: 424,
      },
      Stone_Eldorado_RC_VineyardTrail: {
        layerConfigId: 1236,
        templateId: 424,
      },
    },
    Stone_Eldorado_RL: {
      Stone_Eldorado_RL_Clearwater: {
        layerConfigId: 510,
        templateId: 424,
      },
    },
    Stone_Eldorado_RT: {
      Stone_Eldorado_RT_WhisperWhite: {
        layerConfigId: 906,
        templateId: 424,
      },
    },
    Stone_Eldorado_SC: {
      Stone_Eldorado_Monument: {
        layerConfigId: 1272,
        templateId: 424,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 424,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 424,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 424,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 424,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 424,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 424,
      },
    },
    Stone_Eldorado_TB: {
      Stone_Eldorado_TB_Ashland: {
        layerConfigId: 1006,
        templateId: 424,
      },
      Stone_Eldorado_TB_ChalkDust: {
        layerConfigId: 1012,
        templateId: 424,
      },
      Stone_Eldorado_TB_Hartford: {
        layerConfigId: 1103,
        templateId: 424,
      },
      Stone_Eldorado_TB_Ironside: {
        layerConfigId: 945,
        templateId: 424,
      },
      Stone_Eldorado_TB_Latigo: {
        layerConfigId: 1014,
        templateId: 424,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 424,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 424,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 424,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 424,
      },
    },
    Stone_Eldorado_Trim_OLD: {
      Stone_Eldorado_Andante_Trim: {
        layerConfigId: 941,
        templateId: 424,
      },
      Stone_Eldorado_Ashland_Trim: {
        layerConfigId: 1005,
        templateId: 424,
      },
      Stone_Eldorado_BanffSprings_Trim: {
        layerConfigId: 1007,
        templateId: 424,
      },
      Stone_Eldorado_BlackRiver_Trim: {
        layerConfigId: 1080,
        templateId: 424,
      },
      Stone_Eldorado_Boardwalk_Trim: {
        layerConfigId: 1009,
        templateId: 424,
      },
      Stone_Eldorado_ChalkDust_Trim: {
        layerConfigId: 1011,
        templateId: 424,
      },
      Stone_Eldorado_ChapelHill_Trim: {
        layerConfigId: 943,
        templateId: 424,
      },
      Stone_Eldorado_GrandBanks_Trim: {
        layerConfigId: 1100,
        templateId: 424,
      },
      Stone_Eldorado_Hartford_Trim: {
        layerConfigId: 1102,
        templateId: 424,
      },
      Stone_Eldorado_Ironside_Trim: {
        layerConfigId: 944,
        templateId: 424,
      },
      Stone_Eldorado_KoryakRidge_Trim: {
        layerConfigId: 1061,
        templateId: 424,
      },
      Stone_Eldorado_Latigo_Trim: {
        layerConfigId: 1013,
        templateId: 424,
      },
      Stone_Eldorado_Montecito_Trim: {
        layerConfigId: 1015,
        templateId: 424,
      },
      Stone_Eldorado_Nantucket_Trim: {
        layerConfigId: 946,
        templateId: 424,
      },
      Stone_Eldorado_NordicPeak_Trim: {
        layerConfigId: 1063,
        templateId: 424,
      },
      Stone_Eldorado_SilverLining_Trim: {
        layerConfigId: 1017,
        templateId: 424,
      },
      Stone_Eldorado_WhiteBark_Trim: {
        layerConfigId: 1019,
        templateId: 424,
      },
    },
    Stone_Environmental: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 438,
        templateId: 424,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 440,
        templateId: 424,
      },
      Stone_Env_Dakota: {
        layerConfigId: 108,
        templateId: 424,
      },
      Stone_Env_PASierra: {
        layerConfigId: 131,
        templateId: 424,
      },
    },
    Stone_Environmental_Trim: {
      Stone_Env_Dakota_CustomIN_Trim: {
        layerConfigId: 132,
        templateId: 424,
      },
      Stone_Env_Dakota_Trim: {
        layerConfigId: 128,
        templateId: 424,
      },
      Stone_Env_EpconCustom_Trim: {
        layerConfigId: 129,
        templateId: 424,
      },
      Stone_Env_KentuckyCutstone_Trim: {
        layerConfigId: 437,
        templateId: 424,
      },
      Stone_Env_PASierra_Trim: {
        layerConfigId: 130,
        templateId: 424,
      },
      Stone_Env_TexasCutstone_Trim: {
        layerConfigId: 439,
        templateId: 424,
      },
      Stone_StoneWorks_AppalacianCutStonePA_Trim: {
        layerConfigId: 418,
        templateId: 424,
      },
    },
    Stone_ES_Cliffstone_Trim_OLD: {
      Stone_ES_Cliffstone_WhiteBark_Trim_OLD: {
        layerConfigId: 519,
        templateId: 424,
      },
    },
    Stone_ES_EuropeanLedge_Trim: {
      Stone_ES_EuropeanLedge_IronMill_Trim: {
        layerConfigId: 520,
        templateId: 424,
      },
    },
    Stone_ES_MountainLedge_Trim: {
      Stone_ES_ML_MesaVerde_Trim: {
        layerConfigId: 287,
        templateId: 424,
      },
      Stone_ES_ML_Sierra_Trim: {
        layerConfigId: 521,
        templateId: 424,
      },
    },
    Stone_ES_Roughcut_Trim: {
      Stone_ES_Roughcut_AutumnLeaf_Trim: {
        layerConfigId: 522,
        templateId: 424,
      },
    },
    Stone_ES_RusticLedge_Trim: {
      Stone_ES_RusticLedge_Clearwater_Trim: {
        layerConfigId: 523,
        templateId: 424,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 424,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 424,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 424,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 424,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 424,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 424,
      },
    },
    Stone_Harristone: {},
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 424,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 424,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 424,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 424,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 424,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 424,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 424,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 424,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 424,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 424,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 424,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 424,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 424,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 424,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 424,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 424,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 424,
      },
    },
    Stone_Harristone_Trim: {
      Stone_Harristone_Charcoal_Trim: {
        layerConfigId: 691,
        templateId: 424,
      },
      Stone_Harristone_Chocolate_Trim: {
        layerConfigId: 671,
        templateId: 424,
      },
      Stone_Harristone_Cream_Trim: {
        layerConfigId: 672,
        templateId: 424,
      },
      Stone_Harristone_Divino_Huntington_Trim: {
        layerConfigId: 1031,
        templateId: 424,
      },
      Stone_Harristone_Divino_SilverStrand_Trim: {
        layerConfigId: 1033,
        templateId: 424,
      },
      Stone_Harristone_Divino_WhiteSand_Trim: {
        layerConfigId: 1053,
        templateId: 424,
      },
      Stone_Harristone_Drystone_Highland_Trim: {
        layerConfigId: 1035,
        templateId: 424,
      },
      Stone_Harristone_Drystone_Kingstown_Trim: {
        layerConfigId: 1037,
        templateId: 424,
      },
      Stone_Harristone_Drystone_Slate_Trim: {
        layerConfigId: 1039,
        templateId: 424,
      },
      Stone_Harristone_Drystone_Stirling_Trim: {
        layerConfigId: 1041,
        templateId: 424,
      },
      Stone_Harristone_Grey_Trim: {
        layerConfigId: 673,
        templateId: 424,
      },
      Stone_Harristone_Leuders_FlintHills_Trim: {
        layerConfigId: 1043,
        templateId: 424,
      },
      Stone_Harristone_Tan_Trim: {
        layerConfigId: 674,
        templateId: 424,
      },
      Stone_Harristone_Taupe_Trim: {
        layerConfigId: 675,
        templateId: 424,
      },
      Stone_Harristone_Uintah_Midnight_Trim: {
        layerConfigId: 1045,
        templateId: 424,
      },
      Stone_Harristone_Uintah_RockyCliff_Trim: {
        layerConfigId: 1047,
        templateId: 424,
      },
      Stone_Harristone_WhiteSand_Trim: {
        layerConfigId: 690,
        templateId: 424,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 424,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 424,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 424,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 424,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 424,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 424,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 424,
      },
    },
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 424,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 424,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 424,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 424,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 424,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 424,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 424,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 424,
      },
    },
    Stone_Horizon_Trim: {
      Stone_Horizon_CanyonRidge_Trim: {
        layerConfigId: 533,
        templateId: 424,
      },
      Stone_Horizon_Cumberland_Trim: {
        layerConfigId: 444,
        templateId: 424,
      },
      Stone_Horizon_HarborBluff_Trim: {
        layerConfigId: 545,
        templateId: 424,
      },
      Stone_Horizon_Hermitage_Trim: {
        layerConfigId: 446,
        templateId: 424,
      },
      Stone_Horizon_Hickory_Trim: {
        layerConfigId: 830,
        templateId: 424,
      },
      Stone_Horizon_MossyCreek_Trim: {
        layerConfigId: 448,
        templateId: 424,
      },
      Stone_Horizon_Sedona_Trim: {
        layerConfigId: 1078,
        templateId: 424,
      },
      Stone_Horizon_SmokyMountain_Trim: {
        layerConfigId: 832,
        templateId: 424,
      },
    },
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 424,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 424,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 424,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 424,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 424,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 424,
      },
    },
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 424,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 424,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 424,
      },
    },
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 424,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 424,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 424,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 424,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 424,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 424,
      },
    },
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 424,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 424,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 424,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 424,
      },
    },
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 424,
      },
    },
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 424,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 424,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 424,
      },
    },
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 424,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 424,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 424,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 424,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 424,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 424,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 424,
      },
    },
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 424,
      },
    },
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 424,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 424,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 424,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 424,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 424,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 424,
      },
    },
    Stone_MountainView_Trim: {
      Stone_MV_Adaline_Trim: {
        layerConfigId: 766,
        templateId: 424,
      },
      Stone_MV_Appalachian_Trim: {
        layerConfigId: 768,
        templateId: 424,
      },
      Stone_MV_BlackForest_Trim: {
        layerConfigId: 770,
        templateId: 424,
      },
      Stone_MV_Tuscany_Trim: {
        layerConfigId: 772,
        templateId: 424,
      },
    },
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 424,
      },
    },
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 424,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 424,
      },
    },
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 424,
      },
    },
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 424,
      },
    },
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 424,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 424,
      },
    },
    Stone_PlyGem_Trim: {
      Stone_PlyGem_Charcoal_Trim: {
        layerConfigId: 947,
        templateId: 424,
      },
      Stone_PlyGem_Hampton_Trim: {
        layerConfigId: 948,
        templateId: 424,
      },
      Stone_PlyGem_Mystic_Trim: {
        layerConfigId: 951,
        templateId: 424,
      },
      Stone_PlyGem_Oswego_Trim: {
        layerConfigId: 953,
        templateId: 424,
      },
      Stone_PlyGem_SandyCreek_Trim: {
        layerConfigId: 955,
        templateId: 424,
      },
      Stone_PlyGem_Trim_Lime: {
        layerConfigId: 950,
        templateId: 424,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 424,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 424,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 424,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 424,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 424,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 424,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 424,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 424,
      },
    },
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 424,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 424,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 424,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 424,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 424,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 424,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 424,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 424,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 424,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 424,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 424,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 424,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 424,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 424,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 424,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 424,
      },
    },
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 424,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 424,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 424,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 424,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 424,
      },
    },
    Stone_ProVia_DS: {
      Stone_ProVia_DS_Pearl: {
        layerConfigId: 705,
        templateId: 424,
      },
    },
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 424,
      },
    },
    Stone_ProVia_EdgeCut_Trim: {
      Stone_ProVia_EdgeCut_Tundra_Trim: {
        layerConfigId: 535,
        templateId: 424,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 424,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 424,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 424,
      },
    },
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 424,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 424,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 424,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 424,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 424,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 424,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 424,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 424,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 424,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 424,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 424,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 424,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 424,
      },
    },
    Stone_ProVia_NaturalCut_Trim: {
      Stone_ProVia_NaturalCut_Ashworth_Trim: {
        layerConfigId: 714,
        templateId: 424,
      },
    },
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 424,
      },
    },
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 424,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 424,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 424,
      },
    },
    Stone_ProVia_PrecisionFit_Trim: {
      Stone_ProVia_PrecisionFit_AdobeSands_Trim: {
        layerConfigId: 716,
        templateId: 424,
      },
      Stone_ProVia_PrecisionFit_Driftwood_Trim: {
        layerConfigId: 718,
        templateId: 424,
      },
    },
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 424,
      },
    },
    Stone_ProVia_RidgeCut_Trim: {
      Stone_ProVia_RidgeCut_Silverton_Trim: {
        layerConfigId: 537,
        templateId: 424,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 424,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 424,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 424,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 424,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 424,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 424,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 424,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 424,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 424,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 424,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 424,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 424,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 424,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 424,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 424,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 424,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 424,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 424,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 424,
      },
    },
    Stone_QRStone_Trim: {
      Stone_QR_BermudaSand_Trim: {
        layerConfigId: 1105,
        templateId: 424,
      },
      Stone_QR_CottageWhite_Trim: {
        layerConfigId: 1107,
        templateId: 424,
      },
      Stone_QR_Glacier_Trim: {
        layerConfigId: 1109,
        templateId: 424,
      },
      Stone_QR_Graphite_Trim: {
        layerConfigId: 1111,
        templateId: 424,
      },
      Stone_QR_LakeshoreLinen_Trim: {
        layerConfigId: 1113,
        templateId: 424,
      },
      Stone_QR_Midnight_Trim: {
        layerConfigId: 1115,
        templateId: 424,
      },
      Stone_QR_Onyx_Trim: {
        layerConfigId: 1117,
        templateId: 424,
      },
      Stone_QR_Slate_Trim: {
        layerConfigId: 1119,
        templateId: 424,
      },
      Stone_QR_SmokeyGray_Trim: {
        layerConfigId: 1129,
        templateId: 424,
      },
      Stone_QR_Storm_Trim: {
        layerConfigId: 1121,
        templateId: 424,
      },
      Stone_QR_Summit_Trim: {
        layerConfigId: 1123,
        templateId: 424,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 424,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 424,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 424,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 424,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 424,
      },
    },
    Stone_QualityStone_Cobblestone_Trim: {
      Stone_QS_Cobblestone_Conestoga_Trim: {
        layerConfigId: 738,
        templateId: 424,
      },
      Stone_QS_Cobblestone_Eggshell_Trim: {
        layerConfigId: 739,
        templateId: 424,
      },
      Stone_QS_Cobblestone_PALime_Trim: {
        layerConfigId: 740,
        templateId: 424,
      },
      Stone_QS_Cobblestone_Rockvale_Trim: {
        layerConfigId: 741,
        templateId: 424,
      },
    },
    Stone_QualityStone_Drystack_Trim: {
      Stone_QS_Drystack_Arizona_Trim: {
        layerConfigId: 856,
        templateId: 424,
      },
      Stone_QS_Drystack_Pumice_Trim: {
        layerConfigId: 742,
        templateId: 424,
      },
      Stone_QS_Drystack_Susquehanna_Trim: {
        layerConfigId: 743,
        templateId: 424,
      },
    },
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 424,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 424,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 424,
      },
    },
    Stone_QualityStone_Fieldstone_Trim: {
      Stone_QS_Fieldstone_LebanonLime_Trim: {
        layerConfigId: 744,
        templateId: 424,
      },
      Stone_QS_Fieldstone_NewEngland_Trim: {
        layerConfigId: 745,
        templateId: 424,
      },
    },
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 424,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 424,
      },
    },
    Stone_RA_DutchQuality_Trim: {
      Stone_RA_DQ_Greystone_Trim: {
        layerConfigId: 858,
        templateId: 424,
      },
      Stone_RA_DQ_WinterPoint_Trim: {
        layerConfigId: 643,
        templateId: 424,
      },
    },
    Stone_Realstone_Trim: {
      Stone_RS_Trim_IndianaLimestoneGrey: {
        layerConfigId: 863,
        templateId: 424,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 424,
      },
    },
    Stone_RM_Trim: {
      Stone_RM_Bluebonnet_Trim: {
        layerConfigId: 820,
        templateId: 424,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 424,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 424,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 424,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 424,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 424,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 424,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 424,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 424,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 424,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 424,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 424,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 424,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 424,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 424,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 424,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 424,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 424,
      },
    },
    Stone_Samasonry_Chopped_Trim: {
      Stone_ROCKBLUE_ChoppedBlueLueders_Trim: {
        layerConfigId: 657,
        templateId: 424,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular_Trim: {
        layerConfigId: 659,
        templateId: 424,
      },
      Stone_ROCKCWPLT_ChoppedWhite_Trim: {
        layerConfigId: 646,
        templateId: 424,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 424,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 424,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 424,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 424,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 424,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 424,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 424,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 424,
      },
    },
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 424,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 424,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 424,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 424,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 424,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 424,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 424,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 424,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 424,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 424,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 424,
      },
    },
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 424,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 424,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 424,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 424,
      },
    },
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 424,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 424,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 424,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 424,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 424,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 424,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 424,
      },
    },
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 424,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 424,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 424,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 424,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 424,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 424,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 424,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 424,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 424,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 424,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 424,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 424,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 424,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 424,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 424,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 424,
      },
    },
    Stone_StoneWorks_Chisel: {
      Stone_SW_Chisel_Cream: {
        layerConfigId: 1288,
        templateId: 424,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1289,
        templateId: 424,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 424,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 424,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 424,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 424,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 424,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 424,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 424,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 424,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 424,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 424,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 424,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 424,
      },
    },
    Stone_StoneWorks_FS: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1299,
        templateId: 424,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1298,
        templateId: 424,
      },
      Stone_SW_FS_Chardonnay: {
        layerConfigId: 880,
        templateId: 424,
      },
      Stone_SW_FS_GreyDrift: {
        layerConfigId: 1378,
        templateId: 424,
      },
    },
    Stone_StoneWorks_Grezzo: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1302,
        templateId: 424,
      },
      Stone_SW_Grezzo_SabbieNere: {
        layerConfigId: 1301,
        templateId: 424,
      },
      Stone_SW_Rosa: {
        layerConfigId: 1300,
        templateId: 424,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 424,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 424,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 424,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 424,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 424,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 424,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 424,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 424,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 424,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 424,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 424,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 424,
      },
    },
    Stone_StoneWorks_Tivoli: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1310,
        templateId: 424,
      },
      Stone_SW_Tivoli_Cream: {
        layerConfigId: 1309,
        templateId: 424,
      },
    },
    Stone_StoneWorks_Trim: {
      Stone_StoneWorks_Buckeye_Trim: {
        layerConfigId: 930,
        templateId: 424,
      },
      Stone_StoneWorks_Carolina_Trim: {
        layerConfigId: 931,
        templateId: 424,
      },
      Stone_StoneWorks_Dakota_Trim: {
        layerConfigId: 932,
        templateId: 424,
      },
      Stone_StoneWorks_GreyDrift_Trim: {
        layerConfigId: 933,
        templateId: 424,
      },
      Stone_StoneWorks_PASierra_Trim: {
        layerConfigId: 934,
        templateId: 424,
      },
      Stone_StoneWorks_SanFrancisco_Trim: {
        layerConfigId: 935,
        templateId: 424,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 424,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 424,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 424,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 424,
      },
    },
    Stone_Versetta_Trim: {
      Stone_Versetta_Charcoal_Trim: {
        layerConfigId: 835,
        templateId: 424,
      },
      Stone_Versetta_StoneGrey_Trim: {
        layerConfigId: 840,
        templateId: 424,
      },
      Stone_Versetta_Taupe_Trim: {
        layerConfigId: 841,
        templateId: 424,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Halquist_Ledge = {
  L: {
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 562,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Harristone_Divino = {
  L: {
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 474,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 474,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 474,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 474,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 474,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 474,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Harristone_Drystone = {
  L: {
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 475,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 475,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 475,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 475,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 475,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 475,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 475,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 475,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Harristone_Leuders = {
  L: {
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 476,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 476,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Harristone_Limestone = {
  L: {
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 537,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Harristone_Tumbled = {
  L: {
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 563,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 563,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Harristone_Uintah = {
  L: {
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 477,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 477,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 477,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 477,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 477,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 477,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 477,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 477,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 477,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 477,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 477,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 477,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 477,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Horizon_19thCenturyStone = {
  L: {
    Stone_Horizon_19C: {
      Stone_Horizon_CanyonRidge: {
        layerConfigId: 534,
        templateId: 484,
      },
      Stone_Horizon_Cumberland: {
        layerConfigId: 445,
        templateId: 484,
      },
      Stone_Horizon_HarborBluff: {
        layerConfigId: 546,
        templateId: 484,
      },
      Stone_Horizon_Hermitage: {
        layerConfigId: 447,
        templateId: 484,
      },
      Stone_Horizon_Hickory: {
        layerConfigId: 831,
        templateId: 484,
      },
      Stone_Horizon_MossyCreek: {
        layerConfigId: 449,
        templateId: 484,
      },
      Stone_Horizon_Sedona: {
        layerConfigId: 1079,
        templateId: 484,
      },
      Stone_Horizon_SmokyMountain: {
        layerConfigId: 833,
        templateId: 484,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_IS_Fieldstone = {
  L: {
    Stone_IrwinStone_FS: {
      Stone_Irwin_FS_Andover: {
        layerConfigId: 757,
        templateId: 551,
      },
      Stone_Irwin_FS_ChocolateGray: {
        layerConfigId: 758,
        templateId: 551,
      },
      Stone_Irwin_FS_DoveGray: {
        layerConfigId: 759,
        templateId: 551,
      },
      Stone_Irwin_FS_WesternMaryland: {
        layerConfigId: 760,
        templateId: 551,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone = {
  L: {
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 409,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 409,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 409,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 409,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 409,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 409,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 409,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 409,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 409,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 409,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 409,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 409,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 409,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 409,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 409,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 409,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 409,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 409,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 409,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 409,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 409,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 409,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 409,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 409,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 409,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 409,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 409,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 409,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 409,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 409,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 409,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 409,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 409,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 409,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 409,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 409,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 409,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 409,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 409,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 409,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 409,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 409,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 409,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 409,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 409,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 409,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 409,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 409,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 409,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 409,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 409,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 409,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 409,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 409,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 409,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 409,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 409,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 409,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 409,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 409,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 409,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 409,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 409,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 409,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 409,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 409,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 409,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 409,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 409,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 409,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 409,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 409,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 409,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 409,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 409,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 409,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 409,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 409,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 409,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 409,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 409,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 409,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 409,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 409,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 409,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 409,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 409,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 409,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 409,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 409,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 409,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 409,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 409,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 409,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 409,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 409,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 409,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 409,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 409,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 409,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 409,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 409,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 409,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 409,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 409,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone_03_Trim = {
  L: {
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 345,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 345,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 345,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone_03_Trim_V = {
  L: {
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 344,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 344,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 344,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone_05_Trim = {
  L: {
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 347,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 347,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 347,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone_05_Trim_V = {
  L: {
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 346,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 346,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 346,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone_12_Trim = {
  L: {
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 349,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 349,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 349,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone_12_Trim_V = {
  L: {
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 348,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 348,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 348,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone_24_Trim = {
  L: {
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 351,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 351,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 351,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone_24_Trim_V = {
  L: {
    Stone_ProVia_Ledgestone_Trim: {
      Stone_ProVia_Ledgestone_Osage_Trim: {
        layerConfigId: 580,
        templateId: 350,
      },
      Stone_ProVia_Ledgestone_Rushmore_Trim: {
        layerConfigId: 587,
        templateId: 350,
      },
      Stone_ProVia_Ledgestone_Saginaw_Trim: {
        layerConfigId: 589,
        templateId: 350,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone_Breakwater = {
  Default: {
    templateId: 75,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Ledgestone_OLD = {
  L: {
    Stone_Bello_Ledgestone_OLD: {
      Stone_Bello_Brecknock_OLD: {
        layerConfigId: 726,
        templateId: 352,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 352,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 352,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 352,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 352,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 352,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 352,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 352,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 352,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 352,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 352,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 352,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 352,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 352,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 352,
      },
    },
    Stone_Centurion_Elkmont: {
      Stone_Centurion_Elkmont_BrownsValley: {
        layerConfigId: 1083,
        templateId: 352,
      },
    },
    Stone_Centurion_Ledge: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1248,
        templateId: 352,
      },
      Stone_Centurion_Ledge_GrayVillage: {
        layerConfigId: 1149,
        templateId: 352,
      },
      Stone_Centurion_Ledge_Kentucky: {
        layerConfigId: 1002,
        templateId: 352,
      },
      Stone_Centurion_Ledge_Pennsylvania: {
        layerConfigId: 1077,
        templateId: 352,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1249,
        templateId: 352,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1250,
        templateId: 352,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1251,
        templateId: 352,
      },
    },
    Stone_Centurion_Rubble: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 1252,
        templateId: 352,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1253,
        templateId: 352,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 1254,
        templateId: 352,
      },
      Stone_Centurion_Rubble_Gray: {
        layerConfigId: 899,
        templateId: 352,
      },
      Stone_Centurion_Rubble_Tulsa: {
        layerConfigId: 783,
        templateId: 352,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 1255,
        templateId: 352,
      },
    },
    Stone_Centurion_Stack: {
      Stone_Centurion_GrayStainless: {
        layerConfigId: 780,
        templateId: 352,
      },
      Stone_Centurion_Limestone: {
        layerConfigId: 1151,
        templateId: 352,
      },
      Stone_Centurion_NorrisGray: {
        layerConfigId: 781,
        templateId: 352,
      },
      Stone_Centurion_Stack_Coastal: {
        layerConfigId: 779,
        templateId: 352,
      },
      Stone_Centurion_Texas: {
        layerConfigId: 782,
        templateId: 352,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 352,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 352,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 352,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 352,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 352,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 352,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 352,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 352,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 352,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 352,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 352,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 352,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 352,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 352,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 352,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 352,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 352,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 352,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 352,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 352,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 352,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 352,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 352,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 352,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 352,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 352,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 352,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 352,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 352,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 352,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 352,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 352,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 352,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 352,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 352,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 352,
      },
    },
    Stone_Harristone_Uintah: {
      Stone_Harristone_Uintah_Midnight: {
        layerConfigId: 1046,
        templateId: 352,
      },
      Stone_Harristone_Uintah_RockyCliff: {
        layerConfigId: 1048,
        templateId: 352,
      },
      Stone_Harristone_Uintah_Slate: {
        layerConfigId: 689,
        templateId: 352,
      },
      Stone_HarristoneUintah_Midnight: {
        layerConfigId: 687,
        templateId: 352,
      },
      Stone_HarristoneUintah_RockyCliff: {
        layerConfigId: 688,
        templateId: 352,
      },
    },
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 352,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 352,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 352,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 352,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 352,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 352,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 352,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 352,
      },
    },
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 352,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 352,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 352,
      },
    },
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 352,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 352,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 352,
      },
    },
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 352,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 352,
      },
    },
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 352,
      },
    },
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 352,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 352,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 352,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 352,
      },
    },
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 352,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 352,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 352,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 352,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 352,
      },
    },
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 352,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 352,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 352,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 352,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Limestone = {
  L: {
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 425,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 425,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 425,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 425,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 425,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 425,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 425,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 425,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 425,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 425,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 425,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 425,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 425,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 425,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 425,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 425,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 425,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 425,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 425,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 425,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 425,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 425,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 425,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 425,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 425,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 425,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 425,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 425,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 425,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 425,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 425,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 425,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 425,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 425,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 425,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 425,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 425,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 425,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 425,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 425,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 425,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 425,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 425,
      },
    },
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 425,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 425,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 425,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 425,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 425,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 425,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 425,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 425,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 425,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 425,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 425,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 425,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 425,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 425,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 425,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 425,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 425,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 425,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 425,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 425,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 425,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 425,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 425,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 425,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 425,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 425,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 425,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 425,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 425,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 425,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 425,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 425,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 425,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 425,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 425,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 425,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 425,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 425,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 425,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 425,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 425,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 425,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 425,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 425,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 425,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 425,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Limestone_03_Trim = {
  L: {
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 220,
      },
    },
    Stone_Cobra_Trim: {
      Stone_Cobra_FallBlend_Trim: {
        layerConfigId: 577,
        templateId: 220,
      },
      Stone_Cobra_TexasMix_Trim: {
        layerConfigId: 578,
        templateId: 220,
      },
      Stone_Cobra_White_Trim: {
        layerConfigId: 579,
        templateId: 220,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 220,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 220,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 220,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 220,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 220,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 220,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 220,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 220,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 220,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 220,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 220,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 220,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 220,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 220,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 220,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 220,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 220,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 220,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 220,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 220,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 220,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 220,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 220,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 220,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 220,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 220,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 220,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 220,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 220,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 220,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 220,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 220,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 220,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 220,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 220,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 220,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 220,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 220,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 220,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 220,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 220,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 220,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 220,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 220,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Limestone_03_Trim_V = {
  L: {
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 321,
      },
    },
    Stone_Cobra_Trim: {
      Stone_Cobra_FallBlend_Trim: {
        layerConfigId: 577,
        templateId: 321,
      },
      Stone_Cobra_TexasMix_Trim: {
        layerConfigId: 578,
        templateId: 321,
      },
      Stone_Cobra_White_Trim: {
        layerConfigId: 579,
        templateId: 321,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 321,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 321,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 321,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 321,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 321,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 321,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 321,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 321,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 321,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 321,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 321,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 321,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 321,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 321,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 321,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 321,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 321,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 321,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 321,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 321,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 321,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 321,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 321,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 321,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 321,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 321,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 321,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 321,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 321,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 321,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 321,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 321,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 321,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 321,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 321,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 321,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 321,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 321,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 321,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 321,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 321,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 321,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 321,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 321,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Limestone_05_Trim = {
  L: {
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 115,
      },
    },
    Stone_Cobra_Trim: {
      Stone_Cobra_FallBlend_Trim: {
        layerConfigId: 577,
        templateId: 115,
      },
      Stone_Cobra_TexasMix_Trim: {
        layerConfigId: 578,
        templateId: 115,
      },
      Stone_Cobra_White_Trim: {
        layerConfigId: 579,
        templateId: 115,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 115,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 115,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 115,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 115,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 115,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 115,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 115,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 115,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 115,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 115,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 115,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 115,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 115,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 115,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 115,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 115,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 115,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 115,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 115,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 115,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 115,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 115,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 115,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 115,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 115,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 115,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 115,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 115,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 115,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 115,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 115,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 115,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 115,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 115,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 115,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 115,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 115,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 115,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 115,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 115,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 115,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 115,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 115,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 115,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Limestone_05_Trim_V = {
  L: {
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 322,
      },
    },
    Stone_Cobra_Trim: {
      Stone_Cobra_FallBlend_Trim: {
        layerConfigId: 577,
        templateId: 322,
      },
      Stone_Cobra_TexasMix_Trim: {
        layerConfigId: 578,
        templateId: 322,
      },
      Stone_Cobra_White_Trim: {
        layerConfigId: 579,
        templateId: 322,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 322,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 322,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 322,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 322,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 322,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 322,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 322,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 322,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 322,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 322,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 322,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 322,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 322,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 322,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 322,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 322,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 322,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 322,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 322,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 322,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 322,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 322,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 322,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 322,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 322,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 322,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 322,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 322,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 322,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 322,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 322,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 322,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 322,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 322,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 322,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 322,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 322,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 322,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 322,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 322,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 322,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 322,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 322,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 322,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Limestone_12_Trim = {
  L: {
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 221,
      },
    },
    Stone_Cobra_Trim: {
      Stone_Cobra_FallBlend_Trim: {
        layerConfigId: 577,
        templateId: 221,
      },
      Stone_Cobra_TexasMix_Trim: {
        layerConfigId: 578,
        templateId: 221,
      },
      Stone_Cobra_White_Trim: {
        layerConfigId: 579,
        templateId: 221,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 221,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 221,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 221,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 221,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 221,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 221,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 221,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 221,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 221,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 221,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 221,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 221,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 221,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 221,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 221,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 221,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 221,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 221,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 221,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 221,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 221,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 221,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 221,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 221,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 221,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 221,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 221,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 221,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 221,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 221,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 221,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 221,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 221,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 221,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 221,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 221,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 221,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 221,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 221,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 221,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 221,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 221,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 221,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 221,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Limestone_12_Trim_V = {
  L: {
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 323,
      },
    },
    Stone_Cobra_Trim: {
      Stone_Cobra_FallBlend_Trim: {
        layerConfigId: 577,
        templateId: 323,
      },
      Stone_Cobra_TexasMix_Trim: {
        layerConfigId: 578,
        templateId: 323,
      },
      Stone_Cobra_White_Trim: {
        layerConfigId: 579,
        templateId: 323,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 323,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 323,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 323,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 323,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 323,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 323,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 323,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 323,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 323,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 323,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 323,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 323,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 323,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 323,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 323,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 323,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 323,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 323,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 323,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 323,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 323,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 323,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 323,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 323,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 323,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 323,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 323,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 323,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 323,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 323,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 323,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 323,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 323,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 323,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 323,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 323,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 323,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 323,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 323,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 323,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 323,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 323,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 323,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 323,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Limestone_24_Trim = {
  L: {
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 222,
      },
    },
    Stone_Cobra_Trim: {
      Stone_Cobra_FallBlend_Trim: {
        layerConfigId: 577,
        templateId: 222,
      },
      Stone_Cobra_TexasMix_Trim: {
        layerConfigId: 578,
        templateId: 222,
      },
      Stone_Cobra_White_Trim: {
        layerConfigId: 579,
        templateId: 222,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 222,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 222,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 222,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 222,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 222,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 222,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 222,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 222,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 222,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 222,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 222,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 222,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 222,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 222,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 222,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 222,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 222,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 222,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 222,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 222,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 222,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 222,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 222,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 222,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 222,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 222,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 222,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 222,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 222,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 222,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 222,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 222,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 222,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 222,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 222,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 222,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 222,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 222,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 222,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 222,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 222,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 222,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 222,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 222,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Limestone_24_Trim_V = {
  L: {
    Stone_Centurion_Old_Trim: {
      Stone_Centurion_Old_NorrisGray_Trim: {
        layerConfigId: 698,
        templateId: 324,
      },
    },
    Stone_Cobra_Trim: {
      Stone_Cobra_FallBlend_Trim: {
        layerConfigId: 577,
        templateId: 324,
      },
      Stone_Cobra_TexasMix_Trim: {
        layerConfigId: 578,
        templateId: 324,
      },
      Stone_Cobra_White_Trim: {
        layerConfigId: 579,
        templateId: 324,
      },
    },
    Stone_CulturedStone_Trim: {
      Stone_CS_Buckeye_Trim: {
        layerConfigId: 512,
        templateId: 324,
      },
      Stone_CS_BucksCounty_Trim: {
        layerConfigId: 124,
        templateId: 324,
      },
      Stone_CS_Chardonnay_Trim: {
        layerConfigId: 126,
        templateId: 324,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 324,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 324,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 324,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 324,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 324,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 324,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 324,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 324,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 324,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 324,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 324,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 324,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 324,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 324,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 324,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 324,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 324,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 324,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 324,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 324,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 324,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 324,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 324,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 324,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 324,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 324,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 324,
      },
    },
    Stone_ProVia_ChiselCut_Trim: {
      Stone_ProVia_ChiselCut_Brindle_Trim: {
        layerConfigId: 700,
        templateId: 324,
      },
      Stone_ProVia_ChiselCut_Silverlake_Trim: {
        layerConfigId: 702,
        templateId: 324,
      },
    },
    Stone_ProVia_DryStack_Trim: {
      Stone_ProVia_DryStack_Pearl_Trim: {
        layerConfigId: 704,
        templateId: 324,
      },
    },
    Stone_ProVia_Limestone_Trim: {
      Stone_ProVia_Limestone_Allegheny_Trim: {
        layerConfigId: 591,
        templateId: 324,
      },
      Stone_ProVia_Limestone_Amherst_Trim: {
        layerConfigId: 582,
        templateId: 324,
      },
    },
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 324,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 324,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 324,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 324,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 324,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 324,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 324,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 324,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 324,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Limestone_OLD = {
  L: {
    Stone_Cobra_TLS: {
      Stone_Cobra_FallBlend: {
        layerConfigId: 574,
        templateId: 116,
      },
      Stone_Cobra_TexasMix: {
        layerConfigId: 575,
        templateId: 116,
      },
      Stone_Cobra_White: {
        layerConfigId: 576,
        templateId: 116,
      },
    },
    Stone_Cultured_Lime: {
      Stone_Cultured_Buckeye: {
        layerConfigId: 498,
        templateId: 116,
      },
      Stone_Cultured_BucksCounty: {
        layerConfigId: 125,
        templateId: 116,
      },
      Stone_Cultured_Chardonnay: {
        layerConfigId: 127,
        templateId: 116,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 116,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 116,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 116,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 116,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 116,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 116,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 116,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 116,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 116,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 116,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 116,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 116,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 116,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 116,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 116,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 116,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 116,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 116,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 116,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 116,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 116,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 116,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 116,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 116,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 116,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 116,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 116,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 116,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 116,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 116,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 116,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 116,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 116,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 116,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 116,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 116,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 116,
      },
    },
    Stone_Harristone_Div: {
      Stone_Harristone_Div_Huntington: {
        layerConfigId: 676,
        templateId: 116,
      },
      Stone_Harristone_Div_SilverStrand: {
        layerConfigId: 677,
        templateId: 116,
      },
      Stone_Harristone_Div_WhiteSand: {
        layerConfigId: 678,
        templateId: 116,
      },
      Stone_Harristone_Divino_Huntington: {
        layerConfigId: 1032,
        templateId: 116,
      },
      Stone_Harristone_Divino_SilverStrand: {
        layerConfigId: 1034,
        templateId: 116,
      },
      Stone_Harristone_Divino_WhiteSand: {
        layerConfigId: 1054,
        templateId: 116,
      },
    },
    Stone_Harristone_DS: {
      Stone_Harristone_Drystone_Highland: {
        layerConfigId: 1036,
        templateId: 116,
      },
      Stone_Harristone_Drystone_Kingstown: {
        layerConfigId: 1038,
        templateId: 116,
      },
      Stone_Harristone_Drystone_Slate: {
        layerConfigId: 1040,
        templateId: 116,
      },
      Stone_Harristone_Drystone_Stirling: {
        layerConfigId: 1042,
        templateId: 116,
      },
      Stone_Harristone_DS_Highland: {
        layerConfigId: 679,
        templateId: 116,
      },
      Stone_Harristone_DS_Kingstown: {
        layerConfigId: 680,
        templateId: 116,
      },
      Stone_Harristone_DS_Slate: {
        layerConfigId: 681,
        templateId: 116,
      },
      Stone_Harristone_DS_Stirling: {
        layerConfigId: 682,
        templateId: 116,
      },
    },
    Stone_Harristone_Leuders: {
      Stone_Harristone_Leuders_FlintHills: {
        layerConfigId: 1044,
        templateId: 116,
      },
      Stone_Harristone_Lueders_FlintHills: {
        layerConfigId: 683,
        templateId: 116,
      },
    },
    Stone_Harristone_LS: {
      Stone_Harristone_LS_FlintHills: {
        layerConfigId: 684,
        templateId: 116,
      },
    },
    Stone_Harristone_Tumbled: {
      Stone_Harristone_Tumbled_AustinWhite: {
        layerConfigId: 685,
        templateId: 116,
      },
      Stone_Harristone_Tumbled_Sunlit: {
        layerConfigId: 686,
        templateId: 116,
      },
    },
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 116,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 116,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 116,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 116,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 116,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 116,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 116,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 116,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 116,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 116,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 116,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 116,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 116,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 116,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 116,
      },
    },
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 116,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 116,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 116,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 116,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 116,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 116,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 116,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 116,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 116,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 116,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 116,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 116,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Lurveys_Cobblestone = {
  L: {
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 564,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 564,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MES_Cobblestone = {
  L: {
    Stone_MotherEarthStone_Cob: {
      Stone_MES_Cob_GreyBlend: {
        layerConfigId: 1060,
        templateId: 480,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MES_SoutheasternLedge = {
  L: {
    Stone_MotherEarthStone_SEL: {
      Stone_MES_SEL_GainesboroGrey: {
        layerConfigId: 991,
        templateId: 466,
      },
      Stone_MES_SEL_GreyBlend: {
        layerConfigId: 993,
        templateId: 466,
      },
      Stone_MES_SEL_WestShore: {
        layerConfigId: 995,
        templateId: 466,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MES_StackedStone = {
  Default: {
    templateId: 467,
  },
  L: {
    Stone_MotherEarthStone_SS: {
      Stone_MES_SS_Ash: {
        layerConfigId: 997,
        templateId: 467,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MES_Weatheredledge = {
  L: {
    Stone_MotherEarthStone_WL: {
      Stone_MES_WL_Ash: {
        layerConfigId: 999,
        templateId: 468,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MGBS_AustinLimestone = {
  L: {
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 566,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 566,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MGBS_LeudersLimestone = {
  L: {
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 567,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 567,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MGBS_LimestoneBlends = {
  L: {
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 568,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 568,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MV_HackettStone = {
  L: {
    Stone_MountainView_Hackett: {
      Stone_MV_Appalachian: {
        layerConfigId: 1276,
        templateId: 405,
      },
    },
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 405,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 405,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MV_Ledgestone = {
  L: {
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 538,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 538,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MV_Limestone = {
  L: {
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 539,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 539,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MV_StackStone = {
  L: {
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 406,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Metrobrick_Limestone = {
  L: {
    Stone_MetroBrick_Limestone: {
      Stone_MetroBrick_AustinCreme: {
        layerConfigId: 887,
        templateId: 565,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MountainLedge_GreyDrift = {
  Default: {
    templateId: 267,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MountainLedge_GreyDrift_Trim = {
  Default: {
    templateId: 266,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_MountainLedge_GreyDrift_Trim_V = {
  Default: {
    templateId: 325,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_PS_OldCountyLedge = {
  L: {
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 426,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_PS_SouthernLimestone = {
  L: {
    Stone_PrestigeStone_SL: {
      Stone_PS_Charcoal: {
        layerConfigId: 1279,
        templateId: 427,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 1280,
        templateId: 427,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 1281,
        templateId: 427,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 1282,
        templateId: 427,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_PS_Weatherledge = {
  L: {
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 542,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 542,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 542,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 542,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 542,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 542,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 542,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 542,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_PV_Ledgestone = {
  L: {
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 544,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 544,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 544,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_PV_WesternLedge = {
  L: {
    Stone_Eldorado_BS: {
      Stone_Eldorado_BS_Prescott: {
        layerConfigId: 904,
        templateId: 411,
      },
    },
    Stone_Eldorado_SS: {
      Stone_Eldorado_BlackRiver: {
        layerConfigId: 1081,
        templateId: 411,
      },
      Stone_Eldorado_SS_BlackRiver: {
        layerConfigId: 905,
        templateId: 411,
      },
      Stone_Eldorado_SS_ChapelHill: {
        layerConfigId: 778,
        templateId: 411,
      },
      Stone_Eldorado_SS_KoryakRidge: {
        layerConfigId: 1062,
        templateId: 411,
      },
      Stone_Eldorado_SS_Nantucket: {
        layerConfigId: 777,
        templateId: 411,
      },
      Stone_Eldorado_SS_SilverLining: {
        layerConfigId: 1018,
        templateId: 411,
      },
    },
    Stone_PremierVeneer_Ledge: {
      Stone_PVStone_Dune: {
        layerConfigId: 812,
        templateId: 411,
      },
      Stone_PVStone_Havasupai: {
        layerConfigId: 814,
        templateId: 411,
      },
      Stone_PVStone_Mahogany: {
        layerConfigId: 817,
        templateId: 411,
      },
    },
    Stone_PremierVeneer_WL: {
      Stone_PVStone_Havana: {
        layerConfigId: 813,
        templateId: 411,
      },
      Stone_PVStone_Jurasic: {
        layerConfigId: 815,
        templateId: 411,
      },
      Stone_PVStone_Lermara: {
        layerConfigId: 816,
        templateId: 411,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Pioneer_StackEase = {
  L: {
    Stone_JNStone_Pioneer: {
      Stone_Pioneer_Belgrade: {
        layerConfigId: 692,
        templateId: 569,
      },
      Stone_Pioneer_Sedona: {
        layerConfigId: 693,
        templateId: 569,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_PlyGem_CanyonLedge = {
  L: {
    Stone_PlyGem_CanyonL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 952,
        templateId: 453,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_PlyGem_CascadeLedge = {
  L: {
    Stone_PlyGem_CascadeL: {
      Stone_PlyGem_Mystic: {
        layerConfigId: 1278,
        templateId: 541,
      },
      Stone_PlyGem_SandyCreek: {
        layerConfigId: 956,
        templateId: 541,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_PlyGem_Fieldstone = {
  L: {
    Stone_PlyGem_FS: {
      Stone_PlyGem_Hampton: {
        layerConfigId: 949,
        templateId: 540,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_PlyGem_Manorstone = {
  L: {
    Stone_PlyGem_Manorstone: {
      Stone_PlyGem_Oswego: {
        layerConfigId: 954,
        templateId: 460,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_PlyGem_ShadowLedgestone = {
  L: {
    Stone_PlyGem_ShadowL: {
      Stone_PlyGem_SL_Buckingham: {
        layerConfigId: 1240,
        templateId: 520,
      },
      Stone_PlyGem_SL_Hampton: {
        layerConfigId: 1241,
        templateId: 520,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Premier_HavannaRubble = {
  Default: {
    templateId: 76,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Premier_Stack = {
  L: {
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 553,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProVia_ChiselCut = {
  L: {
    Stone_ProVia_CC: {
      Stone_ProVia_CC_Brindle: {
        layerConfigId: 701,
        templateId: 570,
      },
      Stone_ProVia_CC_Silverlake: {
        layerConfigId: 703,
        templateId: 570,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProVia_DryStack = {
  L: {
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 571,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 571,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 571,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProVia_Edgecut = {
  Default: {
    templateId: 509,
  },
  L: {
    Stone_ProVia_EC: {
      Stone_ProVia_EC_Tundra: {
        layerConfigId: 536,
        templateId: 509,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProVia_Ledgestone = {
  L: {
    Stone_ProVia_Ledge: {
      Stone_ProVia_Ledge_Osage: {
        layerConfigId: 581,
        templateId: 572,
      },
      Stone_ProVia_Ledge_Rushmore: {
        layerConfigId: 588,
        templateId: 572,
      },
      Stone_ProVia_Ledge_Saginaw: {
        layerConfigId: 590,
        templateId: 572,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProVia_Limestone = {
  L: {
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 518,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 518,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 518,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 518,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 518,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 518,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 518,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 518,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProVia_NaturalCut = {
  L: {
    Stone_ProVia_NC: {
      Stone_ProVia_NC_Ashworth: {
        layerConfigId: 715,
        templateId: 377,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProVia_PrecisionFit = {
  L: {
    Stone_ProVia_PF: {
      Stone_ProVia_PF_AdobeSands: {
        layerConfigId: 717,
        templateId: 378,
      },
      Stone_ProVia_PF_Driftwood: {
        layerConfigId: 719,
        templateId: 378,
      },
      Stone_ProVia_PF_Onyx: {
        layerConfigId: 1231,
        templateId: 378,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProVia_RidgeCut = {
  L: {
    Stone_ProVia_RC: {
      Stone_ProVia_RC_Silverton: {
        layerConfigId: 538,
        templateId: 293,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProVia_TerraCut = {
  L: {
    Stone_ProVia_Lime: {
      Stone_ProVia_BlueRidge: {
        layerConfigId: 111,
        templateId: 114,
      },
      Stone_ProVia_Flintridge: {
        layerConfigId: 1284,
        templateId: 114,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 1285,
        templateId: 114,
      },
      Stone_ProVia_Lime_Allegheny: {
        layerConfigId: 592,
        templateId: 114,
      },
      Stone_ProVia_Lime_Amherst: {
        layerConfigId: 583,
        templateId: 114,
      },
      Stone_ProVia_Lime_Buff: {
        layerConfigId: 1237,
        templateId: 114,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 1286,
        templateId: 114,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 1287,
        templateId: 114,
      },
    },
    Stone_ProVia_TC: {
      Stone_ProVia_Flintridge: {
        layerConfigId: 112,
        templateId: 114,
      },
      Stone_ProVia_Frost: {
        layerConfigId: 113,
        templateId: 114,
      },
      Stone_ProVia_Slate: {
        layerConfigId: 114,
        templateId: 114,
      },
      Stone_ProVia_Summit: {
        layerConfigId: 110,
        templateId: 114,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProstackLite_IronSmoke = {
  Default: {
    templateId: 269,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProstackLite_IronSmoke_Trim = {
  Default: {
    templateId: 268,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_ProstackLite_IronSmoke_Trim_V = {
  Default: {
    templateId: 326,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Prostone_Ledgestone = {
  L: {
    Stone_ProStone_Ledge: {
      Stone_Prostone_Sawgrass: {
        layerConfigId: 1283,
        templateId: 543,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Prostone_Sawgrass = {
  Default: {
    templateId: 77,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_QR_Cobblestone = {
  L: {
    Stone_QRStone_Cob: {
      Stone_QR_Slate: {
        layerConfigId: 1120,
        templateId: 494,
      },
      Stone_QR_SmokeyGray: {
        layerConfigId: 1130,
        templateId: 494,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_QR_CountryLedgestone = {
  L: {
    Stone_QRStone_CL: {
      Stone_QR_BermudaSand: {
        layerConfigId: 1106,
        templateId: 495,
      },
      Stone_QR_Glacier: {
        layerConfigId: 1110,
        templateId: 495,
      },
      Stone_QR_Midnight: {
        layerConfigId: 1116,
        templateId: 495,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_QR_DressedFieldstone = {
  L: {
    Stone_QRStone_DFS: {
      Stone_QR_Summit: {
        layerConfigId: 1124,
        templateId: 545,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_QR_RusticLedgestone = {
  L: {
    Stone_QRStone_RL: {
      Stone_QR_CottageWhite: {
        layerConfigId: 1108,
        templateId: 498,
      },
      Stone_QR_Graphite: {
        layerConfigId: 1112,
        templateId: 498,
      },
      Stone_QR_Onyx: {
        layerConfigId: 1118,
        templateId: 498,
      },
      Stone_QR_Storm: {
        layerConfigId: 1122,
        templateId: 498,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_QR_WeatheredEdge = {
  L: {
    Stone_QRStone_WE: {
      Stone_QR_LakeshoreLinen: {
        layerConfigId: 1114,
        templateId: 496,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_QS_Cobblestone = {
  L: {
    Stone_Lurveys_Cob: {
      Stone_Lurveys_Cob_Champagne: {
        layerConfigId: 834,
        templateId: 573,
      },
      Stone_Lurveys_Cob_GraphiteManor: {
        layerConfigId: 842,
        templateId: 573,
      },
    },
    Stone_QualityStone_Cob: {
      Stone_QS_Cob_Conestoga: {
        layerConfigId: 733,
        templateId: 573,
      },
      Stone_QS_Cob_Eggshell: {
        layerConfigId: 734,
        templateId: 573,
      },
      Stone_QS_Cob_PALime: {
        layerConfigId: 731,
        templateId: 573,
      },
      Stone_QS_Cob_Rockvale: {
        layerConfigId: 735,
        templateId: 573,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_QS_Drystack = {
  L: {
    Stone_QualityStone_DS: {
      Stone_QS_DS_Arizona: {
        layerConfigId: 857,
        templateId: 574,
      },
      Stone_QS_DS_Pumice: {
        layerConfigId: 736,
        templateId: 574,
      },
      Stone_QS_DS_Susquehanna: {
        layerConfigId: 730,
        templateId: 574,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_QS_Fieldstone = {
  L: {
    Stone_QualityStone_FS: {
      Stone_QS_FS_LebanonLime: {
        layerConfigId: 732,
        templateId: 552,
      },
      Stone_QS_FS_NewEngland: {
        layerConfigId: 737,
        templateId: 552,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RM_Bluebonnet = {
  Default: {
    templateId: 414,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RM_Chopped = {
  L: {
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 367,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 367,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 367,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 367,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 367,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 367,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 367,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 367,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 367,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 367,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 367,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 367,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 367,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 367,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 367,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 367,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 367,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 367,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 367,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 367,
      },
    },
    Stone_Samasonry_Chopped: {
      Stone_ROCKBLUE_ChoppedBlueLueders: {
        layerConfigId: 658,
        templateId: 367,
      },
      Stone_ROCKCCAVE_ChoppedCaveRegular: {
        layerConfigId: 660,
        templateId: 367,
      },
      Stone_ROCKCWPLT_ChoppedWhite: {
        layerConfigId: 645,
        templateId: 367,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RM_ChoppedLimestone = {
  L: {
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 416,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 416,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 416,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 416,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 416,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 416,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 416,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 416,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 416,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 416,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 416,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 416,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 416,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RM_Sawn = {
  L: {
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 415,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 415,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 415,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 415,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 415,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 415,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 415,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 415,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 415,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 415,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 415,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 415,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 415,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RM_SawnBuilding = {
  L: {
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 575,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 575,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 575,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 575,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RM_Waterford = {
  L: {
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 576,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RockMaterials_03_Trim = {
  L: {
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 223,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 223,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 223,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 223,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 223,
      },
    },
    Stone_RM_Sawn_Trim: {
      Stone_RM_AspenBlendChopped_Trim: {
        layerConfigId: 1136,
        templateId: 223,
      },
      Stone_RM_CountryFrenchChopped_Trim: {
        layerConfigId: 1138,
        templateId: 223,
      },
      Stone_RM_Sawn_BlancoChopped_Trim: {
        layerConfigId: 318,
        templateId: 223,
      },
      Stone_RM_Sawn_CafeBlend_Trim: {
        layerConfigId: 706,
        templateId: 223,
      },
      Stone_RM_Sawn_GraphiteFawnBlend_Trim: {
        layerConfigId: 708,
        templateId: 223,
      },
      Stone_RM_Sawn_LuedersChopped_Trim: {
        layerConfigId: 319,
        templateId: 223,
      },
      Stone_RM_Sawn_LuedersOnyxChopped_Trim: {
        layerConfigId: 320,
        templateId: 223,
      },
      Stone_RM_Sawn_OpalChopped_Trim: {
        layerConfigId: 321,
        templateId: 223,
      },
      Stone_RM_Sawn_TexasMixChopped_Trim: {
        layerConfigId: 322,
        templateId: 223,
      },
      Stone_RM_Sawn_WaterfordLimestone_Trim: {
        layerConfigId: 323,
        templateId: 223,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RockMaterials_03_Trim_V = {
  L: {
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 327,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 327,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 327,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 327,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 327,
      },
    },
    Stone_RM_Sawn_Trim: {
      Stone_RM_AspenBlendChopped_Trim: {
        layerConfigId: 1136,
        templateId: 327,
      },
      Stone_RM_CountryFrenchChopped_Trim: {
        layerConfigId: 1138,
        templateId: 327,
      },
      Stone_RM_Sawn_BlancoChopped_Trim: {
        layerConfigId: 318,
        templateId: 327,
      },
      Stone_RM_Sawn_CafeBlend_Trim: {
        layerConfigId: 706,
        templateId: 327,
      },
      Stone_RM_Sawn_GraphiteFawnBlend_Trim: {
        layerConfigId: 708,
        templateId: 327,
      },
      Stone_RM_Sawn_LuedersChopped_Trim: {
        layerConfigId: 319,
        templateId: 327,
      },
      Stone_RM_Sawn_LuedersOnyxChopped_Trim: {
        layerConfigId: 320,
        templateId: 327,
      },
      Stone_RM_Sawn_OpalChopped_Trim: {
        layerConfigId: 321,
        templateId: 327,
      },
      Stone_RM_Sawn_TexasMixChopped_Trim: {
        layerConfigId: 322,
        templateId: 327,
      },
      Stone_RM_Sawn_WaterfordLimestone_Trim: {
        layerConfigId: 323,
        templateId: 327,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RockMaterials_05_Trim = {
  L: {
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 143,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 143,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 143,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 143,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 143,
      },
    },
    Stone_RM_Sawn_Trim: {
      Stone_RM_AspenBlendChopped_Trim: {
        layerConfigId: 1136,
        templateId: 143,
      },
      Stone_RM_CountryFrenchChopped_Trim: {
        layerConfigId: 1138,
        templateId: 143,
      },
      Stone_RM_Sawn_BlancoChopped_Trim: {
        layerConfigId: 318,
        templateId: 143,
      },
      Stone_RM_Sawn_CafeBlend_Trim: {
        layerConfigId: 706,
        templateId: 143,
      },
      Stone_RM_Sawn_GraphiteFawnBlend_Trim: {
        layerConfigId: 708,
        templateId: 143,
      },
      Stone_RM_Sawn_LuedersChopped_Trim: {
        layerConfigId: 319,
        templateId: 143,
      },
      Stone_RM_Sawn_LuedersOnyxChopped_Trim: {
        layerConfigId: 320,
        templateId: 143,
      },
      Stone_RM_Sawn_OpalChopped_Trim: {
        layerConfigId: 321,
        templateId: 143,
      },
      Stone_RM_Sawn_TexasMixChopped_Trim: {
        layerConfigId: 322,
        templateId: 143,
      },
      Stone_RM_Sawn_WaterfordLimestone_Trim: {
        layerConfigId: 323,
        templateId: 143,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RockMaterials_05_Trim_V = {
  L: {
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 328,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 328,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 328,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 328,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 328,
      },
    },
    Stone_RM_Sawn_Trim: {
      Stone_RM_AspenBlendChopped_Trim: {
        layerConfigId: 1136,
        templateId: 328,
      },
      Stone_RM_CountryFrenchChopped_Trim: {
        layerConfigId: 1138,
        templateId: 328,
      },
      Stone_RM_Sawn_BlancoChopped_Trim: {
        layerConfigId: 318,
        templateId: 328,
      },
      Stone_RM_Sawn_CafeBlend_Trim: {
        layerConfigId: 706,
        templateId: 328,
      },
      Stone_RM_Sawn_GraphiteFawnBlend_Trim: {
        layerConfigId: 708,
        templateId: 328,
      },
      Stone_RM_Sawn_LuedersChopped_Trim: {
        layerConfigId: 319,
        templateId: 328,
      },
      Stone_RM_Sawn_LuedersOnyxChopped_Trim: {
        layerConfigId: 320,
        templateId: 328,
      },
      Stone_RM_Sawn_OpalChopped_Trim: {
        layerConfigId: 321,
        templateId: 328,
      },
      Stone_RM_Sawn_TexasMixChopped_Trim: {
        layerConfigId: 322,
        templateId: 328,
      },
      Stone_RM_Sawn_WaterfordLimestone_Trim: {
        layerConfigId: 323,
        templateId: 328,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RockMaterials_12_Trim = {
  L: {
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 224,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 224,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 224,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 224,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 224,
      },
    },
    Stone_RM_Sawn_Trim: {
      Stone_RM_AspenBlendChopped_Trim: {
        layerConfigId: 1136,
        templateId: 224,
      },
      Stone_RM_CountryFrenchChopped_Trim: {
        layerConfigId: 1138,
        templateId: 224,
      },
      Stone_RM_Sawn_BlancoChopped_Trim: {
        layerConfigId: 318,
        templateId: 224,
      },
      Stone_RM_Sawn_CafeBlend_Trim: {
        layerConfigId: 706,
        templateId: 224,
      },
      Stone_RM_Sawn_GraphiteFawnBlend_Trim: {
        layerConfigId: 708,
        templateId: 224,
      },
      Stone_RM_Sawn_LuedersChopped_Trim: {
        layerConfigId: 319,
        templateId: 224,
      },
      Stone_RM_Sawn_LuedersOnyxChopped_Trim: {
        layerConfigId: 320,
        templateId: 224,
      },
      Stone_RM_Sawn_OpalChopped_Trim: {
        layerConfigId: 321,
        templateId: 224,
      },
      Stone_RM_Sawn_TexasMixChopped_Trim: {
        layerConfigId: 322,
        templateId: 224,
      },
      Stone_RM_Sawn_WaterfordLimestone_Trim: {
        layerConfigId: 323,
        templateId: 224,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RockMaterials_12_Trim_V = {
  L: {
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 329,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 329,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 329,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 329,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 329,
      },
    },
    Stone_RM_Sawn_Trim: {
      Stone_RM_AspenBlendChopped_Trim: {
        layerConfigId: 1136,
        templateId: 329,
      },
      Stone_RM_CountryFrenchChopped_Trim: {
        layerConfigId: 1138,
        templateId: 329,
      },
      Stone_RM_Sawn_BlancoChopped_Trim: {
        layerConfigId: 318,
        templateId: 329,
      },
      Stone_RM_Sawn_CafeBlend_Trim: {
        layerConfigId: 706,
        templateId: 329,
      },
      Stone_RM_Sawn_GraphiteFawnBlend_Trim: {
        layerConfigId: 708,
        templateId: 329,
      },
      Stone_RM_Sawn_LuedersChopped_Trim: {
        layerConfigId: 319,
        templateId: 329,
      },
      Stone_RM_Sawn_LuedersOnyxChopped_Trim: {
        layerConfigId: 320,
        templateId: 329,
      },
      Stone_RM_Sawn_OpalChopped_Trim: {
        layerConfigId: 321,
        templateId: 329,
      },
      Stone_RM_Sawn_TexasMixChopped_Trim: {
        layerConfigId: 322,
        templateId: 329,
      },
      Stone_RM_Sawn_WaterfordLimestone_Trim: {
        layerConfigId: 323,
        templateId: 329,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RockMaterials_24_Trim = {
  L: {
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 225,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 225,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 225,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 225,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 225,
      },
    },
    Stone_RM_Sawn_Trim: {
      Stone_RM_AspenBlendChopped_Trim: {
        layerConfigId: 1136,
        templateId: 225,
      },
      Stone_RM_CountryFrenchChopped_Trim: {
        layerConfigId: 1138,
        templateId: 225,
      },
      Stone_RM_Sawn_BlancoChopped_Trim: {
        layerConfigId: 318,
        templateId: 225,
      },
      Stone_RM_Sawn_CafeBlend_Trim: {
        layerConfigId: 706,
        templateId: 225,
      },
      Stone_RM_Sawn_GraphiteFawnBlend_Trim: {
        layerConfigId: 708,
        templateId: 225,
      },
      Stone_RM_Sawn_LuedersChopped_Trim: {
        layerConfigId: 319,
        templateId: 225,
      },
      Stone_RM_Sawn_LuedersOnyxChopped_Trim: {
        layerConfigId: 320,
        templateId: 225,
      },
      Stone_RM_Sawn_OpalChopped_Trim: {
        layerConfigId: 321,
        templateId: 225,
      },
      Stone_RM_Sawn_TexasMixChopped_Trim: {
        layerConfigId: 322,
        templateId: 225,
      },
      Stone_RM_Sawn_WaterfordLimestone_Trim: {
        layerConfigId: 323,
        templateId: 225,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RockMaterials_24_Trim_V = {
  L: {
    Stone_MGBrickAndStone_Trim: {
      Stone_MG_AustinWhite_Trim: {
        layerConfigId: 397,
        templateId: 330,
      },
      Stone_MG_Charcoal_Trim: {
        layerConfigId: 399,
        templateId: 330,
      },
      Stone_MG_PepperedWhite_Trim: {
        layerConfigId: 401,
        templateId: 330,
      },
      Stone_MG_Walnut_Trim: {
        layerConfigId: 403,
        templateId: 330,
      },
    },
    Stone_RM_RoughChopped_Trim: {
      Stone_RM_RoughChopped_SilvermistChopped_Trim: {
        layerConfigId: 317,
        templateId: 330,
      },
    },
    Stone_RM_Sawn_Trim: {
      Stone_RM_AspenBlendChopped_Trim: {
        layerConfigId: 1136,
        templateId: 330,
      },
      Stone_RM_CountryFrenchChopped_Trim: {
        layerConfigId: 1138,
        templateId: 330,
      },
      Stone_RM_Sawn_BlancoChopped_Trim: {
        layerConfigId: 318,
        templateId: 330,
      },
      Stone_RM_Sawn_CafeBlend_Trim: {
        layerConfigId: 706,
        templateId: 330,
      },
      Stone_RM_Sawn_GraphiteFawnBlend_Trim: {
        layerConfigId: 708,
        templateId: 330,
      },
      Stone_RM_Sawn_LuedersChopped_Trim: {
        layerConfigId: 319,
        templateId: 330,
      },
      Stone_RM_Sawn_LuedersOnyxChopped_Trim: {
        layerConfigId: 320,
        templateId: 330,
      },
      Stone_RM_Sawn_OpalChopped_Trim: {
        layerConfigId: 321,
        templateId: 330,
      },
      Stone_RM_Sawn_TexasMixChopped_Trim: {
        layerConfigId: 322,
        templateId: 330,
      },
      Stone_RM_Sawn_WaterfordLimestone_Trim: {
        layerConfigId: 323,
        templateId: 330,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RockMaterials_Sawn = {
  L: {
    Stone_MGBrickAndStone_AL: {
      Stone_MGBS_AustinWhite: {
        layerConfigId: 398,
        templateId: 142,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 404,
        templateId: 142,
      },
    },
    Stone_MGBrickAndStone_LL: {
      Stone_MGBS_Charcoal: {
        layerConfigId: 400,
        templateId: 142,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1274,
        templateId: 142,
      },
    },
    Stone_MGBrickAndStone_LSB: {
      Stone_MGBS_PepperedWhite: {
        layerConfigId: 402,
        templateId: 142,
      },
      Stone_MGBS_Walnut: {
        layerConfigId: 1275,
        templateId: 142,
      },
    },
    Stone_RockMaterials_RC: {
      Stone_RM_RC_SilvermistChopped: {
        layerConfigId: 310,
        templateId: 142,
      },
    },
    Stone_RockMaterials_Sawn: {
      Stone_RM_LuedersCharcoal: {
        layerConfigId: 823,
        templateId: 142,
      },
      Stone_RM_Sawn_AspenBlendChopped: {
        layerConfigId: 1137,
        templateId: 142,
      },
      Stone_RM_Sawn_BlancoChopped: {
        layerConfigId: 311,
        templateId: 142,
      },
      Stone_RM_Sawn_CafeBlend: {
        layerConfigId: 707,
        templateId: 142,
      },
      Stone_RM_Sawn_CountryFrenchChopped: {
        layerConfigId: 1139,
        templateId: 142,
      },
      Stone_RM_Sawn_LuedersBuff: {
        layerConfigId: 822,
        templateId: 142,
      },
      Stone_RM_Sawn_LuedersChopped: {
        layerConfigId: 312,
        templateId: 142,
      },
      Stone_RM_Sawn_TexasMixChopped: {
        layerConfigId: 315,
        templateId: 142,
      },
    },
    Stone_RockMaterials_SB: {
      Stone_RM_SB_BlancoChopped: {
        layerConfigId: 821,
        templateId: 142,
      },
      Stone_RM_SB_GraphiteFawnBlend: {
        layerConfigId: 709,
        templateId: 142,
      },
      Stone_RM_SB_LuedersOnyxChopped: {
        layerConfigId: 313,
        templateId: 142,
      },
      Stone_RM_SB_OpalChopped: {
        layerConfigId: 314,
        templateId: 142,
      },
    },
    Stone_RockMaterials_WS: {
      Stone_RM_WS_WaterfordLimestone: {
        layerConfigId: 316,
        templateId: 142,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_RoughAshlar = {
  L: {
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 366,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 366,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 366,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 366,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 366,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 366,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 366,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 366,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 366,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 366,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 366,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 366,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 366,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 366,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 366,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 366,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 366,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 366,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 366,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 366,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 366,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 366,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 366,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 366,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 366,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 366,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 366,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 366,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 366,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 366,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 366,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 366,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 366,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 366,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 366,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 366,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 366,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 366,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 366,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 366,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 366,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 366,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 366,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 366,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 366,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 366,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 366,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 366,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_3_5Ledgestone = {
  L: {
    Stone_StoneCreekMidwest_3_5Ledge: {
      Stone_SCM_3_5L_Chalk: {
        layerConfigId: 1312,
        templateId: 577,
      },
      Stone_SCM_3_5L_DarkGranite: {
        layerConfigId: 1313,
        templateId: 577,
      },
      Stone_SCM_Trinity: {
        layerConfigId: 1314,
        templateId: 577,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_CastleStone = {
  L: {
    Stone_StoneCreekMidwest_CS: {
      Stone_SCM_Buffalo: {
        layerConfigId: 1318,
        templateId: 578,
      },
      Stone_SCM_CS_MorningHaze: {
        layerConfigId: 1315,
        templateId: 578,
      },
      Stone_SCM_Midnight: {
        layerConfigId: 1316,
        templateId: 578,
      },
      Stone_SCM_TexasCreme: {
        layerConfigId: 1317,
        templateId: 578,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_EuropeanCastle = {
  L: {
    Stone_StoneCreekMidwest_ECastle: {
      Stone_SCM_CustomGranite: {
        layerConfigId: 1319,
        templateId: 579,
      },
      Stone_SCM_Gray: {
        layerConfigId: 1320,
        templateId: 579,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_EuropeanCobble = {
  L: {
    Stone_StoneCreekMidwest_ECobble: {
      Stone_SCM_ChalkOG: {
        layerConfigId: 1323,
        templateId: 580,
      },
      Stone_SCM_ECobble_Granite: {
        layerConfigId: 1321,
        templateId: 580,
      },
      Stone_SCM_ECobble_LightOzark: {
        layerConfigId: 1322,
        templateId: 580,
      },
      Stone_SCM_OzarkArkansas: {
        layerConfigId: 1324,
        templateId: 580,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_Hackett = {
  L: {
    Stone_StoneCreekMidwest_Hackett: {
      Stone_SCM_Arkansas: {
        layerConfigId: 1330,
        templateId: 501,
      },
      Stone_SCM_Chestnut: {
        layerConfigId: 1335,
        templateId: 501,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1244,
        templateId: 501,
      },
      Stone_SCM_Hackett_Chalk: {
        layerConfigId: 1336,
        templateId: 501,
      },
      Stone_SCM_Hackett_DirtyChalk: {
        layerConfigId: 1169,
        templateId: 501,
      },
      Stone_SCM_Hackett_LightGranite: {
        layerConfigId: 1334,
        templateId: 501,
      },
      Stone_SCM_Hackett_Ozark: {
        layerConfigId: 1191,
        templateId: 501,
      },
      Stone_SCM_Hackett_Trinity: {
        layerConfigId: 1209,
        templateId: 501,
      },
      Stone_SCM_MountainBreezeGJ: {
        layerConfigId: 1333,
        templateId: 501,
      },
      Stone_SCM_NaturalDrystack: {
        layerConfigId: 1331,
        templateId: 501,
      },
      Stone_SCM_OldCedarCreek: {
        layerConfigId: 1332,
        templateId: 501,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_KCBlend = {
  L: {
    Stone_StoneCreekMidwest_KCB: {
      Stone_SCM_Cherokee: {
        layerConfigId: 1337,
        templateId: 581,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_Ledgestone = {
  L: {
    Stone_StoneCreekMidwest_Ledge: {
      Stone_SCM_L_Chardonnay: {
        layerConfigId: 1340,
        templateId: 582,
      },
      Stone_SCM_L_Granite: {
        layerConfigId: 1339,
        templateId: 582,
      },
      Stone_SCM_Texas: {
        layerConfigId: 1338,
        templateId: 582,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_LimeStackMix = {
  L: {
    Stone_StoneCreekMidwest_LSM: {
      Stone_SCM_BrownArkansas: {
        layerConfigId: 1347,
        templateId: 502,
      },
      Stone_SCM_CustomOzark: {
        layerConfigId: 1345,
        templateId: 502,
      },
      Stone_SCM_Desert: {
        layerConfigId: 1346,
        templateId: 502,
      },
      Stone_SCM_Granite: {
        layerConfigId: 1171,
        templateId: 502,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_Limestone = {
  L: {
    Stone_StoneCreekMidwest_Lime: {
      Stone_SCM_ChalkLightOzark: {
        layerConfigId: 1344,
        templateId: 583,
      },
      Stone_SCM_KansasCream: {
        layerConfigId: 1341,
        templateId: 583,
      },
      Stone_SCM_KansasCreamGJ: {
        layerConfigId: 1343,
        templateId: 583,
      },
      Stone_SCM_Lime_BrownArkansas: {
        layerConfigId: 1342,
        templateId: 583,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_MidwestQuickfit = {
  L: {
    Stone_StoneCreekMidwest_MWQF: {
      Stone_SCM_Chalk: {
        layerConfigId: 1351,
        templateId: 584,
      },
      Stone_SCM_HarvestGold: {
        layerConfigId: 1356,
        templateId: 584,
      },
      Stone_SCM_MWQF_MorningHaze: {
        layerConfigId: 1353,
        templateId: 584,
      },
      Stone_SCM_MWQF_Sandstorm: {
        layerConfigId: 1355,
        templateId: 584,
      },
      Stone_SCM_MWQF_Slate: {
        layerConfigId: 1352,
        templateId: 584,
      },
      Stone_SCM_Sahara: {
        layerConfigId: 1354,
        templateId: 584,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_MountainRubble = {
  L: {
    Stone_StoneCreekMidwest_MR: {
      Stone_SCM_CedarCreek: {
        layerConfigId: 1349,
        templateId: 585,
      },
      Stone_SCM_MR_LightGranite: {
        layerConfigId: 1348,
        templateId: 585,
      },
      Stone_SCM_MR_Ozark: {
        layerConfigId: 1350,
        templateId: 585,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_Quickfit = {
  L: {
    Stone_StoneCreekMidwest_QF: {
      Stone_SCM_BurntUmber: {
        layerConfigId: 1362,
        templateId: 586,
      },
      Stone_SCM_DirtyChalk: {
        layerConfigId: 1360,
        templateId: 586,
      },
      Stone_SCM_QF_Arkansas: {
        layerConfigId: 1359,
        templateId: 586,
      },
      Stone_SCM_QF_Granite: {
        layerConfigId: 1357,
        templateId: 586,
      },
      Stone_SCM_QF_Natural: {
        layerConfigId: 1358,
        templateId: 586,
      },
      Stone_SCM_QF_Ozark: {
        layerConfigId: 1361,
        templateId: 586,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_RomanCastle = {
  L: {
    Stone_StoneCreekMidwest_RC: {
      Stone_SCM_Granite: {
        layerConfigId: 1245,
        templateId: 503,
      },
      Stone_SCM_RC_GraniteGJ: {
        layerConfigId: 1173,
        templateId: 503,
      },
      Stone_SCM_RC_LightOzark: {
        layerConfigId: 1179,
        templateId: 503,
      },
      Stone_SCM_RC_LightOzarkGJ: {
        layerConfigId: 1181,
        templateId: 503,
      },
      Stone_SCM_RC_SilveradoGJ: {
        layerConfigId: 1197,
        templateId: 503,
      },
      Stone_SCM_RC_Snow: {
        layerConfigId: 1199,
        templateId: 503,
      },
      Stone_SCM_RC_Suede: {
        layerConfigId: 1205,
        templateId: 503,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_SawtoothLedge = {
  L: {
    Stone_StoneCreekMidwest_STL: {
      Stone_SCM_BlackForest: {
        layerConfigId: 1369,
        templateId: 587,
      },
      Stone_SCM_Sienna: {
        layerConfigId: 1368,
        templateId: 587,
      },
      Stone_SCM_STL_Chalk: {
        layerConfigId: 1367,
        templateId: 587,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_SouthernLedge = {
  L: {
    Stone_StoneCreekMidwest_SL: {
      Stone_SCM_CaramelMountain: {
        layerConfigId: 1363,
        templateId: 588,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_StackHackett = {
  L: {
    Stone_StoneCreekMidwest_StackHackett: {
      Stone_SCM_Arizona: {
        layerConfigId: 1364,
        templateId: 589,
      },
      Stone_SCM_ReverseTexasStone: {
        layerConfigId: 1366,
        templateId: 589,
      },
      Stone_SCM_Winchester: {
        layerConfigId: 1365,
        templateId: 589,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_StackStone = {
  L: {
    Stone_StoneCreekMidwest_SS: {
      Stone_SCM_SS_Antique: {
        layerConfigId: 1159,
        templateId: 504,
      },
      Stone_SCM_SS_Buffalo: {
        layerConfigId: 1161,
        templateId: 504,
      },
      Stone_SCM_SS_Chalk: {
        layerConfigId: 1163,
        templateId: 504,
      },
      Stone_SCM_SS_Chardonnay: {
        layerConfigId: 1165,
        templateId: 504,
      },
      Stone_SCM_SS_DarkGranite: {
        layerConfigId: 1167,
        templateId: 504,
      },
      Stone_SCM_SS_Granite: {
        layerConfigId: 1201,
        templateId: 504,
      },
      Stone_SCM_SS_Greenscapes: {
        layerConfigId: 1175,
        templateId: 504,
      },
      Stone_SCM_SS_LightGranite: {
        layerConfigId: 1177,
        templateId: 504,
      },
      Stone_SCM_SS_Midnight: {
        layerConfigId: 1183,
        templateId: 504,
      },
      Stone_SCM_SS_Montana: {
        layerConfigId: 1185,
        templateId: 504,
      },
      Stone_SCM_SS_MorningHaze: {
        layerConfigId: 1187,
        templateId: 504,
      },
      Stone_SCM_SS_OldCedarCreek: {
        layerConfigId: 1189,
        templateId: 504,
      },
      Stone_SCM_SS_Ozark: {
        layerConfigId: 1203,
        templateId: 504,
      },
      Stone_SCM_SS_Pennsylvania: {
        layerConfigId: 1193,
        templateId: 504,
      },
      Stone_SCM_SS_Sandstorm: {
        layerConfigId: 1195,
        templateId: 504,
      },
      Stone_SCM_SS_Texas: {
        layerConfigId: 1207,
        templateId: 504,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_SCM_ThinkBrick = {
  C: {
    templateId: 590,
  },
  L: {
    Stone_StoneCreekMidwest_TB: {
      Stone_SCM_Antique: {
        layerConfigId: 1377,
        templateId: 590,
      },
      Stone_SCM_BrickRed: {
        layerConfigId: 1372,
        templateId: 590,
      },
      Stone_SCM_Chalk: {
        layerConfigId: 1371,
        templateId: 590,
      },
      Stone_SCM_Dusk: {
        layerConfigId: 1370,
        templateId: 590,
      },
      Stone_SCM_Schoolhouse: {
        layerConfigId: 1375,
        templateId: 590,
      },
      Stone_SCM_Slate: {
        layerConfigId: 1376,
        templateId: 590,
      },
      Stone_SCM_TB_Granite: {
        layerConfigId: 1373,
        templateId: 590,
      },
      Stone_SCM_TB_LightOzark: {
        layerConfigId: 1374,
        templateId: 590,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Sabbie_NereGrezzo = {
  Default: {
    templateId: 271,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Sabbie_NereGrezzo_Trim = {
  Default: {
    templateId: 270,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Sabbie_NereGrezzo_Trim_V = {
  Default: {
    templateId: 331,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_StackLedge = {
  L: {
    Stone_DutchQuality_SL: {
      Stone_DQ_OakBlend: {
        layerConfigId: 1264,
        templateId: 402,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1263,
        templateId: 402,
      },
      Stone_DQ_SL_Fallbrook: {
        layerConfigId: 753,
        templateId: 402,
      },
      Stone_DQ_SL_Sienna: {
        layerConfigId: 829,
        templateId: 402,
      },
      Stone_DQ_SL_Steinhaus: {
        layerConfigId: 807,
        templateId: 402,
      },
      Stone_DQ_SL_Torino: {
        layerConfigId: 802,
        templateId: 402,
      },
    },
    Stone_StoneWorks_CS: {
      Stone_Env_CS_Kentucky: {
        layerConfigId: 1290,
        templateId: 402,
      },
      Stone_Env_CS_Texas: {
        layerConfigId: 1291,
        templateId: 402,
      },
      Stone_Env_Dakota: {
        layerConfigId: 1292,
        templateId: 402,
      },
      Stone_Env_PASierra: {
        layerConfigId: 1293,
        templateId: 402,
      },
      Stone_SW_Carolina: {
        layerConfigId: 1294,
        templateId: 402,
      },
      Stone_SW_CS_AppalachianPA: {
        layerConfigId: 419,
        templateId: 402,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 109,
        templateId: 402,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 133,
        templateId: 402,
      },
      Stone_SW_Dakota: {
        layerConfigId: 1295,
        templateId: 402,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1296,
        templateId: 402,
      },
      Stone_SW_PASierra: {
        layerConfigId: 1297,
        templateId: 402,
      },
      Stone_SW_SanFrancisco: {
        layerConfigId: 929,
        templateId: 402,
      },
    },
    Stone_StoneWorks_Ledge: {
      Stone_SW_Buckeye: {
        layerConfigId: 924,
        templateId: 402,
      },
      Stone_SW_Carolina: {
        layerConfigId: 925,
        templateId: 402,
      },
      Stone_SW_CustomEpcon: {
        layerConfigId: 1304,
        templateId: 402,
      },
      Stone_SW_CustomINDakota: {
        layerConfigId: 1303,
        templateId: 402,
      },
      Stone_SW_Dakota: {
        layerConfigId: 926,
        templateId: 402,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 927,
        templateId: 402,
      },
      Stone_SW_Ledge_Breakwater: {
        layerConfigId: 1305,
        templateId: 402,
      },
      Stone_SW_Ledge_Kentucky: {
        layerConfigId: 1242,
        templateId: 402,
      },
      Stone_SW_PASierra: {
        layerConfigId: 928,
        templateId: 402,
      },
    },
    Stone_StoneWorks_PSL: {
      Stone_SW_CustomEpcon: {
        layerConfigId: 1308,
        templateId: 402,
      },
      Stone_SW_GreyDrift: {
        layerConfigId: 1307,
        templateId: 402,
      },
      Stone_SW_PSL_IronSmoke: {
        layerConfigId: 1306,
        templateId: 402,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Stonecraft_Ledgestone = {
  L: {
    Stone_MountainView_Ledge: {
      Stone_MV_Appalachian: {
        layerConfigId: 769,
        templateId: 478,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 1277,
        templateId: 478,
      },
    },
    Stone_MountainView_Lime: {
      Stone_MV_Adaline: {
        layerConfigId: 767,
        templateId: 478,
      },
      Stone_MV_Tuscany: {
        layerConfigId: 773,
        templateId: 478,
      },
    },
    Stone_MountainView_SS: {
      Stone_MV_BlackForest: {
        layerConfigId: 771,
        templateId: 478,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 478,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 478,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 478,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 478,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_TerraCut_03_Trim = {
  L: {
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 226,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 226,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 226,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 226,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 226,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_TerraCut_03_Trim_V = {
  L: {
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 332,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 332,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 332,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 332,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 332,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_TerraCut_05_Trim = {
  L: {
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 113,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 113,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 113,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 113,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 113,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_TerraCut_05_Trim_V = {
  L: {
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 333,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 333,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 333,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 333,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 333,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_TerraCut_12_Trim = {
  L: {
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 227,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 227,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 227,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 227,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 227,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_TerraCut_12_Trim_V = {
  L: {
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 334,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 334,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 334,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 334,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 334,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_TerraCut_24_Trim = {
  L: {
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 228,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 228,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 228,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 228,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 228,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_TerraCut_24_Trim_V = {
  L: {
    Stone_ProVia_Trim: {
      Stone_ProVia_BlueRidge_Trim: {
        layerConfigId: 115,
        templateId: 335,
      },
      Stone_ProVia_Flintridge_Trim: {
        layerConfigId: 116,
        templateId: 335,
      },
      Stone_ProVia_Frost_Trim: {
        layerConfigId: 117,
        templateId: 335,
      },
      Stone_ProVia_Slate_Trim: {
        layerConfigId: 118,
        templateId: 335,
      },
      Stone_ProVia_Summit_Trim: {
        layerConfigId: 119,
        templateId: 335,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Vener_Cobblestone = {
  L: {
    Masonry_Stone: {
      Stone_Vener_Cobblestone_GreyBlend: {
        layerConfigId: 71,
        templateId: 80,
      },
      Stone_Vener_Cobblestone_Lonestar: {
        layerConfigId: 73,
        templateId: 80,
      },
    },
    Stone_Centurion_Hackett: {
      Stone_Centurion_Hackett_Tulsa: {
        layerConfigId: 67,
        templateId: 80,
      },
    },
    Stone_DiamondPetra: {
      Stone_DP_Tontitown: {
        layerConfigId: 434,
        templateId: 80,
      },
    },
    Stone_Premier: {
      Stone_Premier_Stack_Walnut: {
        layerConfigId: 68,
        templateId: 80,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Vener_Cobblestone_03_Trim = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 79,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 79,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 79,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 79,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 79,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Vener_Cobblestone_03_Trim_V = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 336,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 336,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 336,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 336,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 336,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Vener_Cobblestone_05_Trim = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 229,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 229,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 229,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 229,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 229,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Vener_Cobblestone_05_Trim_V = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 337,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 337,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 337,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 337,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 337,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Vener_Cobblestone_12_Trim = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 230,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 230,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 230,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 230,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 230,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Vener_Cobblestone_12_Trim_V = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 338,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 338,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 338,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 338,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 338,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Vener_Cobblestone_24_Trim = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 231,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 231,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 231,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 231,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 231,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Vener_Cobblestone_24_Trim_V = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 339,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 339,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 339,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 339,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 339,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Vener_Cobblestone_SolidTrim = {
  L: {
    Masonry_Stone_Trim: {
      Masonry_Stone_Centurion_Hackett_Tulsa_Trim: {
        layerConfigId: 66,
        templateId: 133,
      },
      Masonry_Stone_Prostone_Sawgrass_Trim: {
        layerConfigId: 69,
        templateId: 133,
      },
      Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim: {
        layerConfigId: 70,
        templateId: 133,
      },
      Masonry_Stone_Vener_Cobblestone_Lonestar_Trim: {
        layerConfigId: 72,
        templateId: 133,
      },
    },
    Stone_DiamondPetra_Trim: {
      DiamondPetra_Tontitown_Trim: {
        layerConfigId: 433,
        templateId: 133,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Versetta_Ledgestone = {
  L: {
    Stone_Versetta: {
      Stone_Versetta_GranitePeak: {
        layerConfigId: 836,
        templateId: 591,
      },
      Stone_Versetta_NorthernAsh: {
        layerConfigId: 837,
        templateId: 591,
      },
      Stone_Versetta_PlumCreek: {
        layerConfigId: 838,
        templateId: 591,
      },
      Stone_Versetta_Sterling: {
        layerConfigId: 839,
        templateId: 591,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge = {
  L: {
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 428,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 428,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 428,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 428,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 428,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 428,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 428,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 428,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 428,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 428,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 428,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 428,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 428,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 428,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 428,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 428,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 428,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 428,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 428,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 428,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 428,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 428,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 428,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 428,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 428,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 428,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 428,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 428,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 428,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 428,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 428,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 428,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 428,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 428,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 428,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 428,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 428,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 428,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 428,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 428,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 428,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 428,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 428,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 428,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 428,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 428,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 428,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 428,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 428,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 428,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 428,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 428,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 428,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 428,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 428,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 428,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 428,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 428,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 428,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 428,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 428,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 428,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 428,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 428,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 428,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 428,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 428,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 428,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 428,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 428,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 428,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 428,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 428,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 428,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 428,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 428,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 428,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 428,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 428,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 428,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_03_Trim = {
  L: {
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 232,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 232,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 232,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 232,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 232,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 232,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 232,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 232,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 232,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 232,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 232,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 232,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 232,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 232,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 232,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 232,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 232,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 232,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 232,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 232,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 232,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 232,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 232,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 232,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 232,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 232,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 232,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 232,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 232,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 232,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 232,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 232,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 232,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 232,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 232,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 232,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 232,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 232,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 232,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 232,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 232,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 232,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 232,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 232,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 232,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 232,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 232,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 232,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 232,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 232,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 232,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 232,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 232,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 232,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 232,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 232,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 232,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 232,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 232,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 232,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 232,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 232,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 232,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 232,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 232,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 232,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 232,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 232,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 232,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 232,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 232,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 232,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 232,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 232,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 232,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 232,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 232,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 232,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 232,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 232,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 232,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 232,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 232,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 232,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 232,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 232,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 232,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 232,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_03_Trim_V = {
  L: {
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 340,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 340,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 340,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 340,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 340,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 340,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 340,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 340,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 340,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 340,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 340,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 340,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 340,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 340,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 340,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 340,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 340,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 340,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 340,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 340,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 340,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 340,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 340,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 340,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 340,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 340,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 340,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 340,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 340,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 340,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 340,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 340,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 340,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 340,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 340,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 340,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 340,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 340,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 340,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 340,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 340,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 340,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 340,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 340,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 340,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 340,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 340,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 340,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 340,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 340,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 340,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 340,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 340,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 340,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 340,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 340,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 340,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 340,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 340,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 340,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 340,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 340,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 340,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 340,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 340,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 340,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 340,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 340,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 340,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 340,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 340,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 340,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 340,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 340,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 340,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 340,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 340,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 340,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 340,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 340,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 340,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 340,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 340,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 340,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 340,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 340,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 340,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 340,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_05_Trim = {
  L: {
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 144,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 144,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 144,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 144,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 144,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 144,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 144,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 144,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 144,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 144,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 144,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 144,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 144,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 144,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 144,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 144,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 144,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 144,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 144,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 144,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 144,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 144,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 144,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 144,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 144,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 144,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 144,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 144,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 144,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 144,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 144,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 144,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 144,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 144,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 144,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 144,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 144,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 144,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 144,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 144,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 144,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 144,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 144,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 144,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 144,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 144,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 144,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 144,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 144,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 144,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 144,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 144,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 144,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 144,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 144,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 144,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 144,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 144,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 144,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 144,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 144,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 144,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 144,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 144,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 144,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 144,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 144,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 144,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 144,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 144,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 144,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 144,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 144,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 144,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 144,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 144,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 144,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 144,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 144,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 144,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 144,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 144,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 144,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 144,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 144,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 144,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 144,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 144,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_05_Trim_V = {
  L: {
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 341,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 341,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 341,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 341,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 341,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 341,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 341,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 341,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 341,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 341,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 341,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 341,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 341,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 341,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 341,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 341,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 341,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 341,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 341,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 341,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 341,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 341,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 341,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 341,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 341,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 341,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 341,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 341,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 341,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 341,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 341,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 341,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 341,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 341,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 341,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 341,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 341,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 341,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 341,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 341,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 341,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 341,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 341,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 341,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 341,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 341,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 341,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 341,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 341,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 341,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 341,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 341,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 341,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 341,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 341,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 341,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 341,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 341,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 341,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 341,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 341,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 341,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 341,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 341,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 341,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 341,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 341,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 341,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 341,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 341,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 341,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 341,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 341,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 341,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 341,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 341,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 341,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 341,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 341,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 341,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 341,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 341,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 341,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 341,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 341,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 341,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 341,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 341,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_08_Trim = {
  L: {
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 452,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 452,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 452,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 452,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 452,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 452,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 452,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 452,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 452,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 452,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 452,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 452,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 452,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 452,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 452,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 452,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 452,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 452,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 452,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 452,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 452,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 452,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 452,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 452,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 452,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 452,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 452,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 452,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 452,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 452,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 452,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 452,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 452,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 452,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 452,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 452,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 452,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 452,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 452,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 452,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 452,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 452,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 452,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 452,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 452,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 452,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 452,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 452,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 452,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 452,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 452,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 452,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 452,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 452,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 452,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 452,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 452,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 452,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 452,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 452,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 452,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 452,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 452,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 452,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 452,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 452,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 452,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 452,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 452,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 452,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 452,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 452,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 452,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 452,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 452,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 452,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 452,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 452,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 452,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 452,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 452,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 452,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 452,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 452,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_08_Trim_V = {
  L: {
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 451,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 451,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 451,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 451,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 451,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 451,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 451,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 451,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 451,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 451,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 451,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 451,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 451,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 451,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 451,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 451,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 451,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 451,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 451,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 451,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 451,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 451,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 451,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 451,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 451,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 451,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 451,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 451,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 451,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 451,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 451,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 451,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 451,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 451,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 451,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 451,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 451,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 451,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 451,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 451,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 451,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 451,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 451,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 451,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 451,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 451,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 451,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 451,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 451,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 451,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 451,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 451,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 451,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 451,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 451,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 451,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 451,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 451,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 451,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 451,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 451,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 451,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 451,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 451,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 451,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 451,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 451,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 451,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 451,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 451,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 451,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 451,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 451,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 451,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 451,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 451,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 451,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 451,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 451,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 451,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 451,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 451,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 451,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 451,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_12_Trim = {
  L: {
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 233,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 233,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 233,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 233,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 233,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 233,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 233,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 233,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 233,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 233,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 233,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 233,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 233,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 233,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 233,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 233,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 233,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 233,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 233,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 233,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 233,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 233,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 233,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 233,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 233,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 233,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 233,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 233,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 233,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 233,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 233,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 233,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 233,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 233,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 233,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 233,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 233,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 233,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 233,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 233,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 233,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 233,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 233,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 233,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 233,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 233,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 233,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 233,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 233,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 233,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 233,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 233,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 233,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 233,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 233,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 233,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 233,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 233,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 233,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 233,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 233,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 233,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 233,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 233,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 233,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 233,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 233,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 233,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 233,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 233,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 233,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 233,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 233,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 233,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 233,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 233,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 233,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 233,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 233,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 233,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 233,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 233,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 233,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 233,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 233,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 233,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 233,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 233,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_12_Trim_V = {
  L: {
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 342,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 342,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 342,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 342,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 342,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 342,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 342,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 342,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 342,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 342,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 342,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 342,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 342,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 342,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 342,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 342,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 342,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 342,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 342,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 342,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 342,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 342,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 342,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 342,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 342,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 342,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 342,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 342,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 342,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 342,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 342,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 342,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 342,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 342,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 342,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 342,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 342,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 342,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 342,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 342,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 342,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 342,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 342,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 342,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 342,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 342,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 342,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 342,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 342,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 342,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 342,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 342,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 342,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 342,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 342,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 342,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 342,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 342,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 342,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 342,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 342,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 342,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 342,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 342,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 342,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 342,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 342,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 342,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 342,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 342,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 342,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 342,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 342,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 342,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 342,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 342,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 342,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 342,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 342,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 342,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 342,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 342,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 342,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 342,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 342,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 342,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 342,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 342,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_24_Trim = {
  L: {
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 234,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 234,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 234,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 234,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 234,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 234,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 234,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 234,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 234,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 234,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 234,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 234,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 234,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 234,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 234,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 234,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 234,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 234,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 234,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 234,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 234,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 234,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 234,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 234,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 234,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 234,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 234,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 234,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 234,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 234,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 234,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 234,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 234,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 234,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 234,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 234,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 234,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 234,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 234,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 234,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 234,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 234,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 234,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 234,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 234,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 234,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 234,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 234,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 234,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 234,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 234,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 234,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 234,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 234,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 234,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 234,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 234,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 234,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 234,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 234,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 234,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 234,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 234,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 234,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 234,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 234,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 234,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 234,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 234,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 234,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 234,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 234,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 234,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 234,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 234,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 234,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 234,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 234,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 234,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 234,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 234,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 234,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 234,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 234,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 234,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 234,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 234,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 234,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_24_Trim_V = {
  L: {
    Stone_BoulderCreek_Trim: {
      Stone_BC_SpanishWheat_Trim: {
        layerConfigId: 970,
        templateId: 343,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 343,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 343,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 343,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 343,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 343,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 343,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 343,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 343,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 343,
      },
    },
    Stone_CasaDiSassi_Trim: {
      Stone_CDS_BiancoBlend_Trim: {
        layerConfigId: 349,
        templateId: 343,
      },
      Stone_CDS_NiveoVolterra_Trim: {
        layerConfigId: 351,
        templateId: 343,
      },
      Stone_CDS_Trim_Cream: {
        layerConfigId: 795,
        templateId: 343,
      },
      Stone_CDS_Trim_Fumo: {
        layerConfigId: 796,
        templateId: 343,
      },
      Stone_CDS_Trim_Mezzo: {
        layerConfigId: 797,
        templateId: 343,
      },
      Stone_CDS_Trim_Sage: {
        layerConfigId: 798,
        templateId: 343,
      },
      Stone_CDS_Trim_Terra: {
        layerConfigId: 799,
        templateId: 343,
      },
      Stone_CDS_TurinVolterra_Trim: {
        layerConfigId: 353,
        templateId: 343,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 343,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 343,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 343,
      },
    },
    Stone_Centurion_Trim: {
      Stone_Centurion_BrownsValley_Trim: {
        layerConfigId: 1082,
        templateId: 343,
      },
      Stone_Centurion_Coastal_Trim: {
        layerConfigId: 972,
        templateId: 343,
      },
      Stone_Centurion_GrayRubble_Trim: {
        layerConfigId: 898,
        templateId: 343,
      },
      Stone_Centurion_GrayStainless_Trim: {
        layerConfigId: 973,
        templateId: 343,
      },
      Stone_Centurion_GrayVillage_Trim: {
        layerConfigId: 1148,
        templateId: 343,
      },
      Stone_Centurion_Kentucky_Trim: {
        layerConfigId: 974,
        templateId: 343,
      },
      Stone_Centurion_NorrisGray_Trim: {
        layerConfigId: 975,
        templateId: 343,
      },
      Stone_Centurion_Pennsylvania_Trim: {
        layerConfigId: 1076,
        templateId: 343,
      },
      Stone_Centurion_Texas_Trim: {
        layerConfigId: 976,
        templateId: 343,
      },
      Stone_Centurion_Trim_Limestone: {
        layerConfigId: 1150,
        templateId: 343,
      },
      Stone_Centurion_Tulsa_Trim: {
        layerConfigId: 977,
        templateId: 343,
      },
    },
    Stone_DutchQuality_Trim: {
      Stone_DQ_Arizona_Trim: {
        layerConfigId: 1086,
        templateId: 343,
      },
      Stone_DQ_Ashen_Trim: {
        layerConfigId: 1088,
        templateId: 343,
      },
      Stone_DQ_DryStack_WinterPoint_Trim: {
        layerConfigId: 1025,
        templateId: 343,
      },
      Stone_DQ_Limestone_ColumbusBlend_Trim: {
        layerConfigId: 1055,
        templateId: 343,
      },
      Stone_DQ_Limestone_Elkwood_Trim: {
        layerConfigId: 1057,
        templateId: 343,
      },
      Stone_DQ_NaturalBlend_Trim: {
        layerConfigId: 1090,
        templateId: 343,
      },
      Stone_DQ_Prestige_Trim: {
        layerConfigId: 1156,
        templateId: 343,
      },
      Stone_DQ_Sienna_Trim: {
        layerConfigId: 1092,
        templateId: 343,
      },
      Stone_DQ_Weatherledge_CoalCrest_Trim: {
        layerConfigId: 1027,
        templateId: 343,
      },
      Stone_DQ_Weatherledge_Elkwood_Trim: {
        layerConfigId: 1029,
        templateId: 343,
      },
      Stone_DQ_Weatherledge_WinterPoint_Trim: {
        layerConfigId: 1065,
        templateId: 343,
      },
      Stone_DutchQuality_Arizona_Trim: {
        layerConfigId: 876,
        templateId: 343,
      },
      Stone_DutchQuality_Ashen_Trim: {
        layerConfigId: 524,
        templateId: 343,
      },
      Stone_DutchQuality_Columbus_Trim: {
        layerConfigId: 435,
        templateId: 343,
      },
      Stone_DutchQuality_Elkwood_Trim: {
        layerConfigId: 421,
        templateId: 343,
      },
      Stone_DutchQuality_GreatLakes_Trim: {
        layerConfigId: 978,
        templateId: 343,
      },
      Stone_DutchQuality_NaturalBlend_Trim: {
        layerConfigId: 852,
        templateId: 343,
      },
      Stone_DutchQuality_OakBlend_Trim: {
        layerConfigId: 980,
        templateId: 343,
      },
      Stone_DutchQuality_OhioTan_Trim: {
        layerConfigId: 982,
        templateId: 343,
      },
      Stone_DutchQuality_Pennsylvania_Trim: {
        layerConfigId: 423,
        templateId: 343,
      },
      Stone_DutchQuality_QuailGrey_Trim: {
        layerConfigId: 526,
        templateId: 343,
      },
      Stone_DutchQuality_RA_Greystone_Trim: {
        layerConfigId: 984,
        templateId: 343,
      },
      Stone_DutchQuality_RA_Trailhead_Trim: {
        layerConfigId: 986,
        templateId: 343,
      },
      Stone_DutchQuality_RA_WinterPoint_Trim: {
        layerConfigId: 988,
        templateId: 343,
      },
      Stone_DutchQuality_Sagewood_Trim: {
        layerConfigId: 804,
        templateId: 343,
      },
      Stone_DutchQuality_Sienna_Trim: {
        layerConfigId: 854,
        templateId: 343,
      },
      Stone_DutchQuality_WinterPoint_Trim: {
        layerConfigId: 528,
        templateId: 343,
      },
    },
    Stone_EdenValders_Trim: {
      Stone_EV_ChiltonMCV_Trim: {
        layerConfigId: 373,
        templateId: 343,
      },
      Stone_EV_EdenMCV_Trim: {
        layerConfigId: 375,
        templateId: 343,
      },
      Stone_EV_OakfieldMCV_Trim: {
        layerConfigId: 377,
        templateId: 343,
      },
      Stone_EV_Windsor_Trim: {
        layerConfigId: 379,
        templateId: 343,
      },
    },
    Stone_Eldorado_Trim: {
      Stone_Eldorado_Trim_Buckskin: {
        layerConfigId: 900,
        templateId: 343,
      },
      Stone_Eldorado_Trim_Earth: {
        layerConfigId: 901,
        templateId: 343,
      },
      Stone_Eldorado_Trim_Smoke: {
        layerConfigId: 902,
        templateId: 343,
      },
      Stone_Eldorado_Trim_Taupe: {
        layerConfigId: 903,
        templateId: 343,
      },
    },
    Stone_FondDuLac_Trim: {
      Stone_FDL_FondDuLacCountry_Trim: {
        layerConfigId: 383,
        templateId: 343,
      },
      Stone_FDL_GraphiteManor_Trim: {
        layerConfigId: 381,
        templateId: 343,
      },
    },
    Stone_HalquistStone_Trim: {
      Stone_HS_BasswoodGrey_Trim: {
        layerConfigId: 355,
        templateId: 343,
      },
    },
    Stone_MotherEarthStone_Trim: {
      Stone_MES_Cob_GreyBlend_Trim: {
        layerConfigId: 1059,
        templateId: 343,
      },
      Stone_MES_SEL_GainesboroGrey_Trim: {
        layerConfigId: 990,
        templateId: 343,
      },
      Stone_MES_SEL_GreyBlend_Trim: {
        layerConfigId: 992,
        templateId: 343,
      },
      Stone_MES_SEL_WestShore_Trim: {
        layerConfigId: 994,
        templateId: 343,
      },
      Stone_MES_SS_Ash_Trim: {
        layerConfigId: 996,
        templateId: 343,
      },
      Stone_MES_WL_Ash_Trim: {
        layerConfigId: 998,
        templateId: 343,
      },
    },
    Stone_PrestigeStone_Trim: {
      Stone_PS_Bluegrass_Trim: {
        layerConfigId: 357,
        templateId: 343,
      },
      Stone_PS_MoonlitForest_Trim: {
        layerConfigId: 1104,
        templateId: 343,
      },
      Stone_PS_PortlandMist_Trim: {
        layerConfigId: 359,
        templateId: 343,
      },
      Stone_PS_PortlandSmokeFlatsCarton_Trim: {
        layerConfigId: 361,
        templateId: 343,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 343,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 343,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 343,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 343,
      },
    },
    Stone_StoneCraft_Trim: {
      Stone_StoneCraft_Bucktown_Trim: {
        layerConfigId: 1067,
        templateId: 343,
      },
      Stone_StoneCraft_Chardonnay_Trim: {
        layerConfigId: 1050,
        templateId: 343,
      },
      Stone_Stonecraft_Hamilton_Trim: {
        layerConfigId: 1051,
        templateId: 343,
      },
      Stone_StoneCraft_Pennsylvania_Trim: {
        layerConfigId: 1069,
        templateId: 343,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Masonry_Stone_Weatherledge_OLD = {
  L: {
    Stone_Bello_Ledge: {
      Stone_Bello_Ledge_Brecknock: {
        layerConfigId: 908,
        templateId: 145,
      },
      Stone_Bello_Ledge_FultonLime: {
        layerConfigId: 909,
        templateId: 145,
      },
      Stone_Bello_Ledge_Greenwood: {
        layerConfigId: 910,
        templateId: 145,
      },
      Stone_Bello_Ledge_Pequea: {
        layerConfigId: 911,
        templateId: 145,
      },
    },
    Stone_BrandCo_DS: {
      Stone_BrandCo_Erie: {
        layerConfigId: 860,
        templateId: 145,
      },
    },
    Stone_BrandCo_Ledge: {
      Stone_BrandCo_Southbriar: {
        layerConfigId: 861,
        templateId: 145,
      },
    },
    Stone_CasaDiSassi_Blend: {
      Stone_CDS_Bella: {
        layerConfigId: 788,
        templateId: 145,
      },
      Stone_CDS_Blend_Bianco: {
        layerConfigId: 350,
        templateId: 145,
      },
      Stone_CDS_Terracina: {
        layerConfigId: 794,
        templateId: 145,
      },
    },
    Stone_CasaDiSassi_CR: {
      Stone_CDS_Matera: {
        layerConfigId: 1246,
        templateId: 145,
      },
      Stone_CDS_Turin: {
        layerConfigId: 793,
        templateId: 145,
      },
    },
    Stone_CasaDiSassi_Ledge: {
      Stone_CDS_Carbone: {
        layerConfigId: 789,
        templateId: 145,
      },
      Stone_CDS_Gola: {
        layerConfigId: 790,
        templateId: 145,
      },
      Stone_CDS_Matera: {
        layerConfigId: 791,
        templateId: 145,
      },
      Stone_CDS_Niveo: {
        layerConfigId: 792,
        templateId: 145,
      },
    },
    Stone_CasaDiSassi_Volterra: {
      Stone_CDS_Terracina: {
        layerConfigId: 1247,
        templateId: 145,
      },
      Stone_CDS_Volterra_Niveo: {
        layerConfigId: 352,
        templateId: 145,
      },
      Stone_CDS_Volterra_Turin: {
        layerConfigId: 354,
        templateId: 145,
      },
    },
    Stone_DutchQuality_DS: {
      Stone_DQ_Ashen: {
        layerConfigId: 1258,
        templateId: 145,
      },
      Stone_DQ_DS_Arizona: {
        layerConfigId: 877,
        templateId: 145,
      },
      Stone_DQ_DS_WinterPoint: {
        layerConfigId: 1026,
        templateId: 145,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1259,
        templateId: 145,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1260,
        templateId: 145,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1261,
        templateId: 145,
      },
    },
    Stone_DutchQuality_Ledge: {
      Stone_DQ_Arizona: {
        layerConfigId: 1087,
        templateId: 145,
      },
      Stone_DQ_Columbus: {
        layerConfigId: 436,
        templateId: 145,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1091,
        templateId: 145,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 424,
        templateId: 145,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1157,
        templateId: 145,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 862,
        templateId: 145,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 805,
        templateId: 145,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1093,
        templateId: 145,
      },
    },
    Stone_DutchQuality_Lime: {
      Stone_DQ_Lime_ColumbusBlend: {
        layerConfigId: 1056,
        templateId: 145,
      },
      Stone_DQ_Lime_Elkwood: {
        layerConfigId: 1058,
        templateId: 145,
      },
      Stone_DQ_Lime_GreatLakes: {
        layerConfigId: 979,
        templateId: 145,
      },
      Stone_DQ_Lime_OhioTan: {
        layerConfigId: 983,
        templateId: 145,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 981,
        templateId: 145,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1262,
        templateId: 145,
      },
    },
    Stone_DutchQuality_OLD: {
      Stone_DutchQuality_Ashen: {
        layerConfigId: 525,
        templateId: 145,
      },
      Stone_DutchQuality_Elkwood: {
        layerConfigId: 422,
        templateId: 145,
      },
      Stone_DutchQuality_NaturalBlend: {
        layerConfigId: 853,
        templateId: 145,
      },
      Stone_DutchQuality_QuailGrey: {
        layerConfigId: 527,
        templateId: 145,
      },
      Stone_DutchQuality_Sienna: {
        layerConfigId: 855,
        templateId: 145,
      },
      Stone_DutchQuality_WinterPoint: {
        layerConfigId: 529,
        templateId: 145,
      },
    },
    Stone_DutchQuality_RA: {
      Stone_DQ_RA_Greystone: {
        layerConfigId: 985,
        templateId: 145,
      },
      Stone_DQ_RA_Trailhead: {
        layerConfigId: 987,
        templateId: 145,
      },
      Stone_DQ_RA_WinterPoint: {
        layerConfigId: 989,
        templateId: 145,
      },
      Stone_RA_DQ_Greystone: {
        layerConfigId: 859,
        templateId: 145,
      },
      Stone_RA_DQ_WinterPoint: {
        layerConfigId: 639,
        templateId: 145,
      },
    },
    Stone_DutchQuality_WL: {
      Stone_DQ_Ashen: {
        layerConfigId: 1089,
        templateId: 145,
      },
      Stone_DQ_NaturalBlend: {
        layerConfigId: 1268,
        templateId: 145,
      },
      Stone_DQ_OakBlend: {
        layerConfigId: 1267,
        templateId: 145,
      },
      Stone_DQ_Pennsylvania: {
        layerConfigId: 1269,
        templateId: 145,
      },
      Stone_DQ_Prestige: {
        layerConfigId: 1270,
        templateId: 145,
      },
      Stone_DQ_QuailGrey: {
        layerConfigId: 1271,
        templateId: 145,
      },
      Stone_DQ_Sagewood: {
        layerConfigId: 1265,
        templateId: 145,
      },
      Stone_DQ_Sienna: {
        layerConfigId: 1266,
        templateId: 145,
      },
      Stone_DQ_WL_CoalCrest: {
        layerConfigId: 1028,
        templateId: 145,
      },
      Stone_DQ_WL_Elkwood: {
        layerConfigId: 1030,
        templateId: 145,
      },
      Stone_DQ_WL_WinterPoint: {
        layerConfigId: 1066,
        templateId: 145,
      },
    },
    Stone_EdenValders: {
      Stone_EV_ChiltonMCV: {
        layerConfigId: 374,
        templateId: 145,
      },
      Stone_EV_EdenMCV: {
        layerConfigId: 376,
        templateId: 145,
      },
      Stone_EV_OakfieldMCV: {
        layerConfigId: 378,
        templateId: 145,
      },
      Stone_EV_Windsor: {
        layerConfigId: 380,
        templateId: 145,
      },
    },
    Stone_FondDuLac_Biltmore: {
      Stone_FDL_GraphiteManor: {
        layerConfigId: 382,
        templateId: 145,
      },
    },
    Stone_FondDuLac_Country: {
      Stone_FDL_FondDuLacCountry: {
        layerConfigId: 384,
        templateId: 145,
      },
    },
    Stone_HalquistStone: {
      Stone_HS_BasswoodGrey: {
        layerConfigId: 356,
        templateId: 145,
      },
    },
    Stone_PrestigeStone_OCL: {
      Stone_PS_MoonlitForest: {
        layerConfigId: 869,
        templateId: 145,
      },
    },
    Stone_PrestigeStone_WL: {
      Stone_PS_Blanc: {
        layerConfigId: 865,
        templateId: 145,
      },
      Stone_PS_Bluegrass: {
        layerConfigId: 358,
        templateId: 145,
      },
      Stone_PS_Charcoal: {
        layerConfigId: 866,
        templateId: 145,
      },
      Stone_PS_Harvest: {
        layerConfigId: 867,
        templateId: 145,
      },
      Stone_PS_JacksonCreek: {
        layerConfigId: 868,
        templateId: 145,
      },
      Stone_PS_PortlandMist: {
        layerConfigId: 360,
        templateId: 145,
      },
      Stone_PS_PortlandSmokeFlatsCarton: {
        layerConfigId: 362,
        templateId: 145,
      },
      Stone_PS_WhiteOnyx: {
        layerConfigId: 870,
        templateId: 145,
      },
    },
    Stone_StoneCraft_Ledge: {
      Stone_StoneCraft_Bucktown: {
        layerConfigId: 1068,
        templateId: 145,
      },
      Stone_StoneCraft_Chardonnay: {
        layerConfigId: 849,
        templateId: 145,
      },
      Stone_Stonecraft_Hamilton: {
        layerConfigId: 1052,
        templateId: 145,
      },
      Stone_StoneCraft_Pennsylvania: {
        layerConfigId: 1070,
        templateId: 145,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Metal_Galvanized_01 = {
  Default: {
    templateId: 421,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Metal_Grate = {
  Default: {
    templateId: 497,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Metal_Powder = {
  C: {
    templateId: 12,
  },
  L: {
    Metal_JetMetals: {
      Metal_JetMetals_Drexlume: {
        layerConfigId: 1085,
        templateId: 12,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Metal_Screen = {
  Default: {
    templateId: 13,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Metal_Screen_Black = {
  Default: {
    templateId: 491,
  },
};

export const DM_OUTDATED_MATERIAL = {
  Default: {
    templateId: 108,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Paint_Egg = {
  C: {
    templateId: 14,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Paint_Flat = {
  C: {
    templateId: 15,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Paint_Gloss = {
  C: {
    templateId: 16,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Paint_Satin = {
  C: {
    templateId: 17,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Paint_SemiGloss = {
  C: {
    templateId: 18,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Patio_Stone_01 = {
  Default: {
    templateId: 403,
  },
  L: {
    Patio_Stone_IrwinStone: {
      Patio_Irwin_PABlueFlagstone: {
        layerConfigId: 959,
        templateId: 403,
      },
      Patio_Irwin_PennsylvaniaFullColor: {
        layerConfigId: 756,
        templateId: 403,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Paver_Tpattern_6x6_6x9 = {
  Default: {
    templateId: 296,
  },
  L: {
    Paver_Belgard_AppianStone: {
      Paver_Belgard_Napoli: {
        layerConfigId: 561,
        templateId: 296,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Prop_BlackGlass = {
  Default: {
    templateId: 235,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_RoofTile_Capistrano = {
  L: {
    EagleRoofing: {
      ER3723_AdobeBlend: {
        layerConfigId: 417,
        templateId: 156,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_RoofTile_Elabana = {
  C: {
    templateId: 368,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_RoofTile_Slate = {
  L: {
    RoofTile_Westlake: {
      RoofTile_Westlake_BlackCanyon: {
        layerConfigId: 907,
        templateId: 450,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_RoofTrim_AsphaltShingle = {
  L: {
    Atlas: {
      Atlas_BlackShadow: {
        layerConfigId: 388,
        templateId: 28,
      },
      Atlas_WeatheredWood: {
        layerConfigId: 15,
        templateId: 28,
      },
    },
    CT_Belmont: {
      CT_Belmont_BlackGranite: {
        layerConfigId: 137,
        templateId: 28,
      },
      CT_Belmont_ColonialSlate: {
        layerConfigId: 138,
        templateId: 28,
      },
      CT_Belmont_GatehouseSlate: {
        layerConfigId: 139,
        templateId: 28,
      },
      CT_Belmont_Shenandoah: {
        layerConfigId: 140,
        templateId: 28,
      },
      CT_Belmont_StonegateGray: {
        layerConfigId: 141,
        templateId: 28,
      },
      CT_Belmont_WeatheredWood: {
        layerConfigId: 142,
        templateId: 28,
      },
    },
    CT_CarriageHouse: {
      CT_CarriageHouse_BlackPearl: {
        layerConfigId: 143,
        templateId: 28,
      },
      CT_CarriageHouse_Brownstone: {
        layerConfigId: 144,
        templateId: 28,
      },
      CT_CarriageHouse_ColonialSlate: {
        layerConfigId: 145,
        templateId: 28,
      },
      CT_CarriageHouse_GatehouseSlate: {
        layerConfigId: 146,
        templateId: 28,
      },
      CT_CarriageHouse_GeorgianBrick: {
        layerConfigId: 147,
        templateId: 28,
      },
      CT_CarriageHouse_SherwoodForest: {
        layerConfigId: 148,
        templateId: 28,
      },
      CT_CarriageHouse_StonegateGray: {
        layerConfigId: 149,
        templateId: 28,
      },
      CT_CarriageHouse_VictorianBlue: {
        layerConfigId: 150,
        templateId: 28,
      },
    },
    CT_GrandManor: {
      CT_GrandManor_BlackPearl: {
        layerConfigId: 151,
        templateId: 28,
      },
      CT_GrandManor_Brownstone: {
        layerConfigId: 152,
        templateId: 28,
      },
      CT_GrandManor_ColonialSlate: {
        layerConfigId: 153,
        templateId: 28,
      },
      CT_GrandManor_GatehouseSlate: {
        layerConfigId: 154,
        templateId: 28,
      },
      CT_GrandManor_GeorgianBrick: {
        layerConfigId: 155,
        templateId: 28,
      },
      CT_GrandManor_SherwoodForest: {
        layerConfigId: 156,
        templateId: 28,
      },
      CT_GrandManor_StonegateGray: {
        layerConfigId: 157,
        templateId: 28,
      },
      CT_GrandManor_WeatheredWood: {
        layerConfigId: 158,
        templateId: 28,
      },
    },
    CT_HighlandSlate: {
      CT_HighlandSlate_BlackGranite: {
        layerConfigId: 159,
        templateId: 28,
      },
      CT_HighlandSlate_Fieldstone: {
        layerConfigId: 160,
        templateId: 28,
      },
      CT_HighlandSlate_MaxDef_WeatheredWood: {
        layerConfigId: 161,
        templateId: 28,
      },
      CT_HighlandSlate_NewEnglandSlate: {
        layerConfigId: 162,
        templateId: 28,
      },
      CT_HighlandSlate_SmokeyQuartz: {
        layerConfigId: 163,
        templateId: 28,
      },
    },
    CT_Landmark: {
      CT_Landmark_BlackShadow: {
        layerConfigId: 275,
        templateId: 28,
      },
      CT_Landmark_BlackWalnut: {
        layerConfigId: 233,
        templateId: 28,
      },
      CT_Landmark_BurntSienna: {
        layerConfigId: 234,
        templateId: 28,
      },
      CT_Landmark_CharcoalBlack: {
        layerConfigId: 20,
        templateId: 28,
      },
      CT_Landmark_CinderBlack: {
        layerConfigId: 235,
        templateId: 28,
      },
      CT_Landmark_CobblestoneGray: {
        layerConfigId: 236,
        templateId: 28,
      },
      CT_Landmark_ColonialSlate: {
        layerConfigId: 237,
        templateId: 28,
      },
      CT_Landmark_Driftwood: {
        layerConfigId: 21,
        templateId: 28,
      },
      CT_Landmark_GeorgetownGray: {
        layerConfigId: 22,
        templateId: 28,
      },
      CT_Landmark_GeorgetownGray_MaxDef: {
        layerConfigId: 88,
        templateId: 28,
      },
      CT_Landmark_HeatherBlend: {
        layerConfigId: 23,
        templateId: 28,
      },
      CT_Landmark_HunterGreen: {
        layerConfigId: 238,
        templateId: 28,
      },
      CT_Landmark_MoireBlack: {
        layerConfigId: 24,
        templateId: 28,
      },
      CT_Landmark_MoireBlack_MaxDef: {
        layerConfigId: 239,
        templateId: 28,
      },
      CT_Landmark_MojaveTan: {
        layerConfigId: 240,
        templateId: 28,
      },
      CT_Landmark_PaintedDesert: {
        layerConfigId: 241,
        templateId: 28,
      },
      CT_Landmark_Pewter: {
        layerConfigId: 242,
        templateId: 28,
      },
      CT_Landmark_Pewterwood: {
        layerConfigId: 243,
        templateId: 28,
      },
      CT_Landmark_ResawnShake: {
        layerConfigId: 244,
        templateId: 28,
      },
      CT_Landmark_SilverBirch: {
        layerConfigId: 245,
        templateId: 28,
      },
      CT_Landmark_SlateGray: {
        layerConfigId: 644,
        templateId: 28,
      },
      CT_Landmark_SunriseCedar: {
        layerConfigId: 246,
        templateId: 28,
      },
      CT_Landmark_ThunderstormGray: {
        layerConfigId: 247,
        templateId: 28,
      },
      CT_Landmark_WeatheredWood: {
        layerConfigId: 25,
        templateId: 28,
      },
      CT_Landmark_WeatheredWood_MaxDef: {
        layerConfigId: 89,
        templateId: 28,
      },
    },
    CT_Landmark_Premium: {
      CT_Landmark_Premium_MaxDef_BurntSienna: {
        layerConfigId: 164,
        templateId: 28,
      },
      CT_Landmark_Premium_MaxDef_ColonialSlate: {
        layerConfigId: 165,
        templateId: 28,
      },
      CT_Landmark_Premium_MaxDef_Driftwood: {
        layerConfigId: 166,
        templateId: 28,
      },
      CT_Landmark_Premium_MaxDef_GeorgetownGray: {
        layerConfigId: 167,
        templateId: 28,
      },
      CT_Landmark_Premium_MaxDef_HeatherBlend: {
        layerConfigId: 168,
        templateId: 28,
      },
      CT_Landmark_Premium_MaxDef_MoireBlack: {
        layerConfigId: 169,
        templateId: 28,
      },
      CT_Landmark_Premium_MaxDef_PewterWood: {
        layerConfigId: 170,
        templateId: 28,
      },
      CT_Landmark_Premium_MaxDef_ResawnShake: {
        layerConfigId: 171,
        templateId: 28,
      },
      CT_Landmark_Premium_MaxDef_WeatheredWood: {
        layerConfigId: 172,
        templateId: 28,
      },
    },
    CT_Landmark_Pro: {
      CT_Landmark_Pro_CinderBlack: {
        layerConfigId: 173,
        templateId: 28,
      },
      CT_Landmark_Pro_GraniteGray: {
        layerConfigId: 174,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_BlackWalnut: {
        layerConfigId: 175,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_BurntSienna: {
        layerConfigId: 176,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_CharcoalBlack: {
        layerConfigId: 177,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_CobblestoneGray: {
        layerConfigId: 178,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_ColonialSlate: {
        layerConfigId: 179,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_Driftwood: {
        layerConfigId: 180,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_GeorgetownGray: {
        layerConfigId: 181,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_HeatherBlend: {
        layerConfigId: 182,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_MoireBlack: {
        layerConfigId: 183,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_MojaveTan: {
        layerConfigId: 184,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_Pewter: {
        layerConfigId: 185,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_PewterWood: {
        layerConfigId: 186,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_PrairieWood: {
        layerConfigId: 187,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_ResawnShake: {
        layerConfigId: 188,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_Shenandoah: {
        layerConfigId: 189,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_SilverBirch: {
        layerConfigId: 190,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_SunriseCedar: {
        layerConfigId: 191,
        templateId: 28,
      },
      CT_Landmark_Pro_MaxDef_WeatheredWood: {
        layerConfigId: 192,
        templateId: 28,
      },
    },
    CT_Landmark_Pro_Solaris: {
      CT_Landmark_Pro_Solaris_BurntSienna: {
        layerConfigId: 193,
        templateId: 28,
      },
      CT_Landmark_Pro_Solaris_MaxDef_BurntSienna: {
        layerConfigId: 194,
        templateId: 28,
      },
      CT_Landmark_Pro_Solaris_MaxDef_GeorgetownGray: {
        layerConfigId: 195,
        templateId: 28,
      },
      CT_Landmark_Pro_Solaris_MaxDef_HeatherBlend: {
        layerConfigId: 196,
        templateId: 28,
      },
      CT_Landmark_Pro_Solaris_MaxDef_MoireBlack: {
        layerConfigId: 197,
        templateId: 28,
      },
      CT_Landmark_Pro_Solaris_MaxDef_ResawnShake: {
        layerConfigId: 198,
        templateId: 28,
      },
      CT_Landmark_Pro_Solaris_MaxDef_WeatheredWood: {
        layerConfigId: 199,
        templateId: 28,
      },
      CT_Landmark_Pro_Solaris_SilverBirch: {
        layerConfigId: 200,
        templateId: 28,
      },
    },
    CT_Landmark_Solaris: {
      CT_Landmark_Solaris_AgedCedar: {
        layerConfigId: 201,
        templateId: 28,
      },
      CT_Landmark_Solaris_Birch: {
        layerConfigId: 202,
        templateId: 28,
      },
      CT_Landmark_Solaris_BurntSienna: {
        layerConfigId: 203,
        templateId: 28,
      },
      CT_Landmark_Solaris_CrystalGray: {
        layerConfigId: 204,
        templateId: 28,
      },
      CT_Landmark_Solaris_GeorgetownGray: {
        layerConfigId: 205,
        templateId: 28,
      },
      CT_Landmark_Solaris_Graphite: {
        layerConfigId: 206,
        templateId: 28,
      },
      CT_Landmark_Solaris_HeatherBlend: {
        layerConfigId: 207,
        templateId: 28,
      },
      CT_Landmark_Solaris_MistWhite: {
        layerConfigId: 208,
        templateId: 28,
      },
      CT_Landmark_Solaris_MoireBlack: {
        layerConfigId: 209,
        templateId: 28,
      },
      CT_Landmark_Solaris_MojaveTan: {
        layerConfigId: 210,
        templateId: 28,
      },
      CT_Landmark_Solaris_ResawnShake: {
        layerConfigId: 211,
        templateId: 28,
      },
      CT_Landmark_Solaris_SilverBirch: {
        layerConfigId: 212,
        templateId: 28,
      },
      CT_Landmark_Solaris_WeatheredWood: {
        layerConfigId: 213,
        templateId: 28,
      },
    },
    CT_Landmark_TL: {
      CT_Landmark_TL_BlackWalnut: {
        layerConfigId: 214,
        templateId: 28,
      },
      CT_Landmark_TL_CountryGray: {
        layerConfigId: 215,
        templateId: 28,
      },
      CT_Landmark_TL_MoireBlack: {
        layerConfigId: 216,
        templateId: 28,
      },
      CT_Landmark_TL_Platinum: {
        layerConfigId: 217,
        templateId: 28,
      },
      CT_Landmark_TL_Shenandoah: {
        layerConfigId: 218,
        templateId: 28,
      },
    },
    CT_Landmark_TL_Solaris: {
      CT_Landmark_TL_Solaris_CountryGray: {
        layerConfigId: 219,
        templateId: 28,
      },
      CT_Landmark_TL_Solaris_MoireBlack: {
        layerConfigId: 220,
        templateId: 28,
      },
      CT_Landmark_TL_Solaris_Platinum: {
        layerConfigId: 221,
        templateId: 28,
      },
    },
    CT_Northgate_Climate_Flex: {
      CT_Northgate_ClimateFlex_MaxDef_BurntSienna: {
        layerConfigId: 222,
        templateId: 28,
      },
      CT_Northgate_ClimateFlex_MaxDef_Driftwood: {
        layerConfigId: 223,
        templateId: 28,
      },
      CT_Northgate_ClimateFlex_MaxDef_GeorgetownGray: {
        layerConfigId: 224,
        templateId: 28,
      },
      CT_Northgate_ClimateFlex_MaxDef_GraniteGray: {
        layerConfigId: 225,
        templateId: 28,
      },
      CT_Northgate_ClimateFlex_MaxDef_HeatherBlend: {
        layerConfigId: 226,
        templateId: 28,
      },
      CT_Northgate_ClimateFlex_MaxDef_HunterGreen: {
        layerConfigId: 227,
        templateId: 28,
      },
      CT_Northgate_ClimateFlex_MaxDef_MoireBlack: {
        layerConfigId: 228,
        templateId: 28,
      },
      CT_Northgate_ClimateFlex_MaxDef_Pewter: {
        layerConfigId: 229,
        templateId: 28,
      },
      CT_Northgate_ClimateFlex_MaxDef_ResawnShake: {
        layerConfigId: 230,
        templateId: 28,
      },
      CT_Northgate_ClimateFlex_MaxDef_SilverBirch: {
        layerConfigId: 231,
        templateId: 28,
      },
      CT_Northgate_ClimateFlex_MaxDef_WeatheredWood: {
        layerConfigId: 232,
        templateId: 28,
      },
    },
    CT_Patriot: {
      CT_Patriot_Sablewood: {
        layerConfigId: 1024,
        templateId: 28,
      },
    },
    GAF: {
      GAF_AppalachianSky: {
        layerConfigId: 1074,
        templateId: 28,
      },
      GAF_Barkwood: {
        layerConfigId: 922,
        templateId: 28,
      },
      GAF_BlackWalnut: {
        layerConfigId: 120,
        templateId: 28,
      },
      GAF_Charcoal: {
        layerConfigId: 17,
        templateId: 28,
      },
      GAF_MissionBrown: {
        layerConfigId: 923,
        templateId: 28,
      },
      GAF_PewterGray: {
        layerConfigId: 749,
        templateId: 28,
      },
      GAF_Shakewood: {
        layerConfigId: 1075,
        templateId: 28,
      },
      GAF_WeatheredWood: {
        layerConfigId: 18,
        templateId: 28,
      },
    },
    IKO: {
      IKO_CharcoalGrey: {
        layerConfigId: 409,
        templateId: 28,
      },
      IKO_CornerstoneWW: {
        layerConfigId: 1003,
        templateId: 28,
      },
      IKO_Driftwood: {
        layerConfigId: 410,
        templateId: 28,
      },
      IKO_DualBlack: {
        layerConfigId: 411,
        templateId: 28,
      },
      IKO_DualBrown: {
        layerConfigId: 412,
        templateId: 28,
      },
      IKO_DualGrey: {
        layerConfigId: 413,
        templateId: 28,
      },
      IKO_EarthtoneCedar: {
        layerConfigId: 414,
        templateId: 28,
      },
      IKO_GraniteBlack: {
        layerConfigId: 1004,
        templateId: 28,
      },
      IKO_HarvardSlate: {
        layerConfigId: 415,
        templateId: 28,
      },
      IKO_SummitGrey: {
        layerConfigId: 1146,
        templateId: 28,
      },
      IKO_Weatherwood: {
        layerConfigId: 416,
        templateId: 28,
      },
    },
    Malarkey: {
      Malarkey_MidnightBlack: {
        layerConfigId: 846,
        templateId: 28,
      },
      Malarkey_NaturalWood: {
        layerConfigId: 847,
        templateId: 28,
      },
      Malarkey_Silverwood: {
        layerConfigId: 848,
        templateId: 28,
      },
    },
    OwensCorning: {
      OC_Oakridge_Brownwood: {
        layerConfigId: 342,
        templateId: 28,
      },
      OC_Oakridge_DesertTan: {
        layerConfigId: 343,
        templateId: 28,
      },
      OC_Oakridge_Driftwood: {
        layerConfigId: 344,
        templateId: 28,
      },
      OC_Oakridge_EstateGray: {
        layerConfigId: 345,
        templateId: 28,
      },
      OC_Oakridge_OnyxBlack: {
        layerConfigId: 346,
        templateId: 28,
      },
      OC_Oakridge_Peppercorn: {
        layerConfigId: 562,
        templateId: 28,
      },
      OC_Oakridge_SierraGray: {
        layerConfigId: 765,
        templateId: 28,
      },
      OC_Oakridge_Teak: {
        layerConfigId: 347,
        templateId: 28,
      },
      OC_Oakridge_WilliamsburgGray: {
        layerConfigId: 348,
        templateId: 28,
      },
      OC_Supreme_WeatheredWood: {
        layerConfigId: 300,
        templateId: 28,
      },
    },
    RoofTEMP: {
      RoofTEMP_Black: {
        layerConfigId: 16,
        templateId: 28,
      },
      RoofTEMP_Gray: {
        layerConfigId: 19,
        templateId: 28,
      },
      RoofTEMP_ResawnShake: {
        layerConfigId: 26,
        templateId: 28,
      },
    },
    Tamko: {
      Tamko_AntiqueSlate: {
        layerConfigId: 824,
        templateId: 28,
      },
      Tamko_NaturalTimber: {
        layerConfigId: 121,
        templateId: 28,
      },
      Tamko_OldeEnglishPewter: {
        layerConfigId: 122,
        templateId: 28,
      },
      Tamko_OxfordGrey: {
        layerConfigId: 308,
        templateId: 28,
      },
      Tamko_RusticBlack: {
        layerConfigId: 292,
        templateId: 28,
      },
      Tamko_RusticSlate: {
        layerConfigId: 825,
        templateId: 28,
      },
      Tamko_ThunderstormGrey: {
        layerConfigId: 123,
        templateId: 28,
      },
      Tamko_VirginiaSlate: {
        layerConfigId: 293,
        templateId: 28,
      },
      Tamko_WeatheredWood: {
        layerConfigId: 309,
        templateId: 28,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_RoofTrim_StandingSeam = {
  C: {
    templateId: 32,
  },
  L: {
    Metal_JetMetals: {
      Metal_JetMetals_Drexlume: {
        layerConfigId: 1085,
        templateId: 32,
      },
    },
    Roof_StandingSeamIR: {
      Roof_StandingSeamIR_CharcoalGray: {
        layerConfigId: 27,
        templateId: 32,
      },
      Roof_StandingSeamIR_CoalBlack: {
        layerConfigId: 28,
        templateId: 32,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_Asphalt = {
  Default: {
    templateId: 19,
  },
  L: {
    Atlas: {
      Atlas_BlackShadow: {
        layerConfigId: 388,
        templateId: 19,
      },
      Atlas_WeatheredWood: {
        layerConfigId: 15,
        templateId: 19,
      },
    },
    CT_Landmark: {
      CT_Landmark_BlackShadow: {
        layerConfigId: 275,
        templateId: 19,
      },
      CT_Landmark_BlackWalnut: {
        layerConfigId: 233,
        templateId: 19,
      },
      CT_Landmark_BurntSienna: {
        layerConfigId: 234,
        templateId: 19,
      },
      CT_Landmark_CharcoalBlack: {
        layerConfigId: 20,
        templateId: 19,
      },
      CT_Landmark_CinderBlack: {
        layerConfigId: 235,
        templateId: 19,
      },
      CT_Landmark_CobblestoneGray: {
        layerConfigId: 236,
        templateId: 19,
      },
      CT_Landmark_ColonialSlate: {
        layerConfigId: 237,
        templateId: 19,
      },
      CT_Landmark_Driftwood: {
        layerConfigId: 21,
        templateId: 19,
      },
      CT_Landmark_GeorgetownGray: {
        layerConfigId: 22,
        templateId: 19,
      },
      CT_Landmark_GeorgetownGray_MaxDef: {
        layerConfigId: 88,
        templateId: 19,
      },
      CT_Landmark_HeatherBlend: {
        layerConfigId: 23,
        templateId: 19,
      },
      CT_Landmark_HunterGreen: {
        layerConfigId: 238,
        templateId: 19,
      },
      CT_Landmark_MoireBlack: {
        layerConfigId: 24,
        templateId: 19,
      },
      CT_Landmark_MoireBlack_MaxDef: {
        layerConfigId: 239,
        templateId: 19,
      },
      CT_Landmark_MojaveTan: {
        layerConfigId: 240,
        templateId: 19,
      },
      CT_Landmark_PaintedDesert: {
        layerConfigId: 241,
        templateId: 19,
      },
      CT_Landmark_Pewter: {
        layerConfigId: 242,
        templateId: 19,
      },
      CT_Landmark_Pewterwood: {
        layerConfigId: 243,
        templateId: 19,
      },
      CT_Landmark_ResawnShake: {
        layerConfigId: 244,
        templateId: 19,
      },
      CT_Landmark_SilverBirch: {
        layerConfigId: 245,
        templateId: 19,
      },
      CT_Landmark_SlateGray: {
        layerConfigId: 644,
        templateId: 19,
      },
      CT_Landmark_SunriseCedar: {
        layerConfigId: 246,
        templateId: 19,
      },
      CT_Landmark_ThunderstormGray: {
        layerConfigId: 247,
        templateId: 19,
      },
      CT_Landmark_WeatheredWood: {
        layerConfigId: 25,
        templateId: 19,
      },
      CT_Landmark_WeatheredWood_MaxDef: {
        layerConfigId: 89,
        templateId: 19,
      },
    },
    CT_Patriot: {
      CT_Patriot_Sablewood: {
        layerConfigId: 1024,
        templateId: 19,
      },
    },
    GAF: {
      GAF_AppalachianSky: {
        layerConfigId: 1074,
        templateId: 19,
      },
      GAF_Barkwood: {
        layerConfigId: 922,
        templateId: 19,
      },
      GAF_BlackWalnut: {
        layerConfigId: 120,
        templateId: 19,
      },
      GAF_Charcoal: {
        layerConfigId: 17,
        templateId: 19,
      },
      GAF_MissionBrown: {
        layerConfigId: 923,
        templateId: 19,
      },
      GAF_PewterGray: {
        layerConfigId: 749,
        templateId: 19,
      },
      GAF_Shakewood: {
        layerConfigId: 1075,
        templateId: 19,
      },
      GAF_WeatheredWood: {
        layerConfigId: 18,
        templateId: 19,
      },
    },
    IKO: {
      IKO_CharcoalGrey: {
        layerConfigId: 409,
        templateId: 19,
      },
      IKO_CornerstoneWW: {
        layerConfigId: 1003,
        templateId: 19,
      },
      IKO_Driftwood: {
        layerConfigId: 410,
        templateId: 19,
      },
      IKO_DualBlack: {
        layerConfigId: 411,
        templateId: 19,
      },
      IKO_DualBrown: {
        layerConfigId: 412,
        templateId: 19,
      },
      IKO_DualGrey: {
        layerConfigId: 413,
        templateId: 19,
      },
      IKO_EarthtoneCedar: {
        layerConfigId: 414,
        templateId: 19,
      },
      IKO_GraniteBlack: {
        layerConfigId: 1004,
        templateId: 19,
      },
      IKO_HarvardSlate: {
        layerConfigId: 415,
        templateId: 19,
      },
      IKO_SummitGrey: {
        layerConfigId: 1146,
        templateId: 19,
      },
      IKO_Weatherwood: {
        layerConfigId: 416,
        templateId: 19,
      },
    },
    Malarkey: {
      Malarkey_MidnightBlack: {
        layerConfigId: 846,
        templateId: 19,
      },
      Malarkey_NaturalWood: {
        layerConfigId: 847,
        templateId: 19,
      },
      Malarkey_Silverwood: {
        layerConfigId: 848,
        templateId: 19,
      },
    },
    OwensCorning: {
      OC_Oakridge_Brownwood: {
        layerConfigId: 342,
        templateId: 19,
      },
      OC_Oakridge_DesertTan: {
        layerConfigId: 343,
        templateId: 19,
      },
      OC_Oakridge_Driftwood: {
        layerConfigId: 344,
        templateId: 19,
      },
      OC_Oakridge_EstateGray: {
        layerConfigId: 345,
        templateId: 19,
      },
      OC_Oakridge_OnyxBlack: {
        layerConfigId: 346,
        templateId: 19,
      },
      OC_Oakridge_Peppercorn: {
        layerConfigId: 562,
        templateId: 19,
      },
      OC_Oakridge_SierraGray: {
        layerConfigId: 765,
        templateId: 19,
      },
      OC_Oakridge_Teak: {
        layerConfigId: 347,
        templateId: 19,
      },
      OC_Oakridge_WilliamsburgGray: {
        layerConfigId: 348,
        templateId: 19,
      },
      OC_Supreme_WeatheredWood: {
        layerConfigId: 300,
        templateId: 19,
      },
    },
    RoofTEMP: {
      RoofTEMP_Black: {
        layerConfigId: 16,
        templateId: 19,
      },
      RoofTEMP_Gray: {
        layerConfigId: 19,
        templateId: 19,
      },
      RoofTEMP_ResawnShake: {
        layerConfigId: 26,
        templateId: 19,
      },
    },
    Tamko: {
      Tamko_AntiqueSlate: {
        layerConfigId: 824,
        templateId: 19,
      },
      Tamko_NaturalTimber: {
        layerConfigId: 121,
        templateId: 19,
      },
      Tamko_OldeEnglishPewter: {
        layerConfigId: 122,
        templateId: 19,
      },
      Tamko_OxfordGrey: {
        layerConfigId: 308,
        templateId: 19,
      },
      Tamko_RusticBlack: {
        layerConfigId: 292,
        templateId: 19,
      },
      Tamko_RusticSlate: {
        layerConfigId: 825,
        templateId: 19,
      },
      Tamko_ThunderstormGrey: {
        layerConfigId: 123,
        templateId: 19,
      },
      Tamko_VirginiaSlate: {
        layerConfigId: 293,
        templateId: 19,
      },
      Tamko_WeatheredWood: {
        layerConfigId: 309,
        templateId: 19,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_Asphalt3Tab = {
  Default: {
    templateId: 20,
  },
  L: {
    Atlas: {
      Atlas_BlackShadow: {
        layerConfigId: 388,
        templateId: 20,
      },
      Atlas_WeatheredWood: {
        layerConfigId: 15,
        templateId: 20,
      },
    },
    CT_Landmark: {
      CT_Landmark_BlackShadow: {
        layerConfigId: 275,
        templateId: 20,
      },
      CT_Landmark_BlackWalnut: {
        layerConfigId: 233,
        templateId: 20,
      },
      CT_Landmark_BurntSienna: {
        layerConfigId: 234,
        templateId: 20,
      },
      CT_Landmark_CharcoalBlack: {
        layerConfigId: 20,
        templateId: 20,
      },
      CT_Landmark_CinderBlack: {
        layerConfigId: 235,
        templateId: 20,
      },
      CT_Landmark_CobblestoneGray: {
        layerConfigId: 236,
        templateId: 20,
      },
      CT_Landmark_ColonialSlate: {
        layerConfigId: 237,
        templateId: 20,
      },
      CT_Landmark_Driftwood: {
        layerConfigId: 21,
        templateId: 20,
      },
      CT_Landmark_GeorgetownGray: {
        layerConfigId: 22,
        templateId: 20,
      },
      CT_Landmark_GeorgetownGray_MaxDef: {
        layerConfigId: 88,
        templateId: 20,
      },
      CT_Landmark_HeatherBlend: {
        layerConfigId: 23,
        templateId: 20,
      },
      CT_Landmark_HunterGreen: {
        layerConfigId: 238,
        templateId: 20,
      },
      CT_Landmark_MoireBlack: {
        layerConfigId: 24,
        templateId: 20,
      },
      CT_Landmark_MoireBlack_MaxDef: {
        layerConfigId: 239,
        templateId: 20,
      },
      CT_Landmark_MojaveTan: {
        layerConfigId: 240,
        templateId: 20,
      },
      CT_Landmark_PaintedDesert: {
        layerConfigId: 241,
        templateId: 20,
      },
      CT_Landmark_Pewter: {
        layerConfigId: 242,
        templateId: 20,
      },
      CT_Landmark_Pewterwood: {
        layerConfigId: 243,
        templateId: 20,
      },
      CT_Landmark_ResawnShake: {
        layerConfigId: 244,
        templateId: 20,
      },
      CT_Landmark_SilverBirch: {
        layerConfigId: 245,
        templateId: 20,
      },
      CT_Landmark_SlateGray: {
        layerConfigId: 644,
        templateId: 20,
      },
      CT_Landmark_SunriseCedar: {
        layerConfigId: 246,
        templateId: 20,
      },
      CT_Landmark_ThunderstormGray: {
        layerConfigId: 247,
        templateId: 20,
      },
      CT_Landmark_WeatheredWood: {
        layerConfigId: 25,
        templateId: 20,
      },
      CT_Landmark_WeatheredWood_MaxDef: {
        layerConfigId: 89,
        templateId: 20,
      },
    },
    CT_Patriot: {
      CT_Patriot_Sablewood: {
        layerConfigId: 1024,
        templateId: 20,
      },
    },
    GAF: {
      GAF_AppalachianSky: {
        layerConfigId: 1074,
        templateId: 20,
      },
      GAF_Barkwood: {
        layerConfigId: 922,
        templateId: 20,
      },
      GAF_BlackWalnut: {
        layerConfigId: 120,
        templateId: 20,
      },
      GAF_Charcoal: {
        layerConfigId: 17,
        templateId: 20,
      },
      GAF_MissionBrown: {
        layerConfigId: 923,
        templateId: 20,
      },
      GAF_PewterGray: {
        layerConfigId: 749,
        templateId: 20,
      },
      GAF_Shakewood: {
        layerConfigId: 1075,
        templateId: 20,
      },
      GAF_WeatheredWood: {
        layerConfigId: 18,
        templateId: 20,
      },
    },
    IKO: {
      IKO_CharcoalGrey: {
        layerConfigId: 409,
        templateId: 20,
      },
      IKO_CornerstoneWW: {
        layerConfigId: 1003,
        templateId: 20,
      },
      IKO_Driftwood: {
        layerConfigId: 410,
        templateId: 20,
      },
      IKO_DualBlack: {
        layerConfigId: 411,
        templateId: 20,
      },
      IKO_DualBrown: {
        layerConfigId: 412,
        templateId: 20,
      },
      IKO_DualGrey: {
        layerConfigId: 413,
        templateId: 20,
      },
      IKO_EarthtoneCedar: {
        layerConfigId: 414,
        templateId: 20,
      },
      IKO_GraniteBlack: {
        layerConfigId: 1004,
        templateId: 20,
      },
      IKO_HarvardSlate: {
        layerConfigId: 415,
        templateId: 20,
      },
      IKO_SummitGrey: {
        layerConfigId: 1146,
        templateId: 20,
      },
      IKO_Weatherwood: {
        layerConfigId: 416,
        templateId: 20,
      },
    },
    Malarkey: {
      Malarkey_MidnightBlack: {
        layerConfigId: 846,
        templateId: 20,
      },
      Malarkey_NaturalWood: {
        layerConfigId: 847,
        templateId: 20,
      },
      Malarkey_Silverwood: {
        layerConfigId: 848,
        templateId: 20,
      },
    },
    OwensCorning: {
      OC_Oakridge_Brownwood: {
        layerConfigId: 342,
        templateId: 20,
      },
      OC_Oakridge_DesertTan: {
        layerConfigId: 343,
        templateId: 20,
      },
      OC_Oakridge_Driftwood: {
        layerConfigId: 344,
        templateId: 20,
      },
      OC_Oakridge_EstateGray: {
        layerConfigId: 345,
        templateId: 20,
      },
      OC_Oakridge_OnyxBlack: {
        layerConfigId: 346,
        templateId: 20,
      },
      OC_Oakridge_Peppercorn: {
        layerConfigId: 562,
        templateId: 20,
      },
      OC_Oakridge_SierraGray: {
        layerConfigId: 765,
        templateId: 20,
      },
      OC_Oakridge_Teak: {
        layerConfigId: 347,
        templateId: 20,
      },
      OC_Oakridge_WilliamsburgGray: {
        layerConfigId: 348,
        templateId: 20,
      },
      OC_Supreme_WeatheredWood: {
        layerConfigId: 300,
        templateId: 20,
      },
    },
    RoofTEMP: {
      RoofTEMP_Black: {
        layerConfigId: 16,
        templateId: 20,
      },
      RoofTEMP_Gray: {
        layerConfigId: 19,
        templateId: 20,
      },
      RoofTEMP_ResawnShake: {
        layerConfigId: 26,
        templateId: 20,
      },
    },
    Tamko: {
      Tamko_AntiqueSlate: {
        layerConfigId: 824,
        templateId: 20,
      },
      Tamko_NaturalTimber: {
        layerConfigId: 121,
        templateId: 20,
      },
      Tamko_OldeEnglishPewter: {
        layerConfigId: 122,
        templateId: 20,
      },
      Tamko_OxfordGrey: {
        layerConfigId: 308,
        templateId: 20,
      },
      Tamko_RusticBlack: {
        layerConfigId: 292,
        templateId: 20,
      },
      Tamko_RusticSlate: {
        layerConfigId: 825,
        templateId: 20,
      },
      Tamko_ThunderstormGrey: {
        layerConfigId: 123,
        templateId: 20,
      },
      Tamko_VirginiaSlate: {
        layerConfigId: 293,
        templateId: 20,
      },
      Tamko_WeatheredWood: {
        layerConfigId: 309,
        templateId: 20,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_AsphaltBelmont = {
  Default: {
    templateId: 127,
  },
  L: {
    CT_Belmont: {
      CT_Belmont_BlackGranite: {
        layerConfigId: 137,
        templateId: 127,
      },
      CT_Belmont_ColonialSlate: {
        layerConfigId: 138,
        templateId: 127,
      },
      CT_Belmont_GatehouseSlate: {
        layerConfigId: 139,
        templateId: 127,
      },
      CT_Belmont_Shenandoah: {
        layerConfigId: 140,
        templateId: 127,
      },
      CT_Belmont_StonegateGray: {
        layerConfigId: 141,
        templateId: 127,
      },
      CT_Belmont_WeatheredWood: {
        layerConfigId: 142,
        templateId: 127,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_AsphaltCarriageHouse = {
  L: {
    CT_CarriageHouse: {
      CT_CarriageHouse_BlackPearl: {
        layerConfigId: 143,
        templateId: 128,
      },
      CT_CarriageHouse_Brownstone: {
        layerConfigId: 144,
        templateId: 128,
      },
      CT_CarriageHouse_ColonialSlate: {
        layerConfigId: 145,
        templateId: 128,
      },
      CT_CarriageHouse_GatehouseSlate: {
        layerConfigId: 146,
        templateId: 128,
      },
      CT_CarriageHouse_GeorgianBrick: {
        layerConfigId: 147,
        templateId: 128,
      },
      CT_CarriageHouse_SherwoodForest: {
        layerConfigId: 148,
        templateId: 128,
      },
      CT_CarriageHouse_StonegateGray: {
        layerConfigId: 149,
        templateId: 128,
      },
      CT_CarriageHouse_VictorianBlue: {
        layerConfigId: 150,
        templateId: 128,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_AsphaltGrandManor = {
  L: {
    CT_GrandManor: {
      CT_GrandManor_BlackPearl: {
        layerConfigId: 151,
        templateId: 130,
      },
      CT_GrandManor_Brownstone: {
        layerConfigId: 152,
        templateId: 130,
      },
      CT_GrandManor_ColonialSlate: {
        layerConfigId: 153,
        templateId: 130,
      },
      CT_GrandManor_GatehouseSlate: {
        layerConfigId: 154,
        templateId: 130,
      },
      CT_GrandManor_GeorgianBrick: {
        layerConfigId: 155,
        templateId: 130,
      },
      CT_GrandManor_SherwoodForest: {
        layerConfigId: 156,
        templateId: 130,
      },
      CT_GrandManor_StonegateGray: {
        layerConfigId: 157,
        templateId: 130,
      },
      CT_GrandManor_WeatheredWood: {
        layerConfigId: 158,
        templateId: 130,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_AsphaltHighlandSlate = {
  Default: {
    templateId: 131,
  },
  L: {
    CT_HighlandSlate: {
      CT_HighlandSlate_BlackGranite: {
        layerConfigId: 159,
        templateId: 131,
      },
      CT_HighlandSlate_Fieldstone: {
        layerConfigId: 160,
        templateId: 131,
      },
      CT_HighlandSlate_MaxDef_WeatheredWood: {
        layerConfigId: 161,
        templateId: 131,
      },
      CT_HighlandSlate_NewEnglandSlate: {
        layerConfigId: 162,
        templateId: 131,
      },
      CT_HighlandSlate_SmokeyQuartz: {
        layerConfigId: 163,
        templateId: 131,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_AsphaltShake = {
  L: {
    Atlas: {
      Atlas_BlackShadow: {
        layerConfigId: 388,
        templateId: 21,
      },
      Atlas_WeatheredWood: {
        layerConfigId: 15,
        templateId: 21,
      },
    },
    CT_Landmark: {
      CT_Landmark_BlackShadow: {
        layerConfigId: 275,
        templateId: 21,
      },
      CT_Landmark_BlackWalnut: {
        layerConfigId: 233,
        templateId: 21,
      },
      CT_Landmark_BurntSienna: {
        layerConfigId: 234,
        templateId: 21,
      },
      CT_Landmark_CharcoalBlack: {
        layerConfigId: 20,
        templateId: 21,
      },
      CT_Landmark_CinderBlack: {
        layerConfigId: 235,
        templateId: 21,
      },
      CT_Landmark_CobblestoneGray: {
        layerConfigId: 236,
        templateId: 21,
      },
      CT_Landmark_ColonialSlate: {
        layerConfigId: 237,
        templateId: 21,
      },
      CT_Landmark_Driftwood: {
        layerConfigId: 21,
        templateId: 21,
      },
      CT_Landmark_GeorgetownGray: {
        layerConfigId: 22,
        templateId: 21,
      },
      CT_Landmark_GeorgetownGray_MaxDef: {
        layerConfigId: 88,
        templateId: 21,
      },
      CT_Landmark_HeatherBlend: {
        layerConfigId: 23,
        templateId: 21,
      },
      CT_Landmark_HunterGreen: {
        layerConfigId: 238,
        templateId: 21,
      },
      CT_Landmark_MoireBlack: {
        layerConfigId: 24,
        templateId: 21,
      },
      CT_Landmark_MoireBlack_MaxDef: {
        layerConfigId: 239,
        templateId: 21,
      },
      CT_Landmark_MojaveTan: {
        layerConfigId: 240,
        templateId: 21,
      },
      CT_Landmark_PaintedDesert: {
        layerConfigId: 241,
        templateId: 21,
      },
      CT_Landmark_Pewter: {
        layerConfigId: 242,
        templateId: 21,
      },
      CT_Landmark_Pewterwood: {
        layerConfigId: 243,
        templateId: 21,
      },
      CT_Landmark_ResawnShake: {
        layerConfigId: 244,
        templateId: 21,
      },
      CT_Landmark_SilverBirch: {
        layerConfigId: 245,
        templateId: 21,
      },
      CT_Landmark_SlateGray: {
        layerConfigId: 644,
        templateId: 21,
      },
      CT_Landmark_SunriseCedar: {
        layerConfigId: 246,
        templateId: 21,
      },
      CT_Landmark_ThunderstormGray: {
        layerConfigId: 247,
        templateId: 21,
      },
      CT_Landmark_WeatheredWood: {
        layerConfigId: 25,
        templateId: 21,
      },
      CT_Landmark_WeatheredWood_MaxDef: {
        layerConfigId: 89,
        templateId: 21,
      },
    },
    CT_Landmark_Premium: {
      CT_Landmark_Premium_MaxDef_BurntSienna: {
        layerConfigId: 164,
        templateId: 21,
      },
      CT_Landmark_Premium_MaxDef_ColonialSlate: {
        layerConfigId: 165,
        templateId: 21,
      },
      CT_Landmark_Premium_MaxDef_Driftwood: {
        layerConfigId: 166,
        templateId: 21,
      },
      CT_Landmark_Premium_MaxDef_GeorgetownGray: {
        layerConfigId: 167,
        templateId: 21,
      },
      CT_Landmark_Premium_MaxDef_HeatherBlend: {
        layerConfigId: 168,
        templateId: 21,
      },
      CT_Landmark_Premium_MaxDef_MoireBlack: {
        layerConfigId: 169,
        templateId: 21,
      },
      CT_Landmark_Premium_MaxDef_PewterWood: {
        layerConfigId: 170,
        templateId: 21,
      },
      CT_Landmark_Premium_MaxDef_ResawnShake: {
        layerConfigId: 171,
        templateId: 21,
      },
      CT_Landmark_Premium_MaxDef_WeatheredWood: {
        layerConfigId: 172,
        templateId: 21,
      },
    },
    CT_Landmark_Pro: {
      CT_Landmark_Pro_CinderBlack: {
        layerConfigId: 173,
        templateId: 21,
      },
      CT_Landmark_Pro_GraniteGray: {
        layerConfigId: 174,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_BlackWalnut: {
        layerConfigId: 175,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_BurntSienna: {
        layerConfigId: 176,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_CharcoalBlack: {
        layerConfigId: 177,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_CobblestoneGray: {
        layerConfigId: 178,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_ColonialSlate: {
        layerConfigId: 179,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_Driftwood: {
        layerConfigId: 180,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_GeorgetownGray: {
        layerConfigId: 181,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_HeatherBlend: {
        layerConfigId: 182,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_MoireBlack: {
        layerConfigId: 183,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_MojaveTan: {
        layerConfigId: 184,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_Pewter: {
        layerConfigId: 185,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_PewterWood: {
        layerConfigId: 186,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_PrairieWood: {
        layerConfigId: 187,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_ResawnShake: {
        layerConfigId: 188,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_Shenandoah: {
        layerConfigId: 189,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_SilverBirch: {
        layerConfigId: 190,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_SunriseCedar: {
        layerConfigId: 191,
        templateId: 21,
      },
      CT_Landmark_Pro_MaxDef_WeatheredWood: {
        layerConfigId: 192,
        templateId: 21,
      },
    },
    CT_Landmark_Pro_Solaris: {
      CT_Landmark_Pro_Solaris_BurntSienna: {
        layerConfigId: 193,
        templateId: 21,
      },
      CT_Landmark_Pro_Solaris_MaxDef_BurntSienna: {
        layerConfigId: 194,
        templateId: 21,
      },
      CT_Landmark_Pro_Solaris_MaxDef_GeorgetownGray: {
        layerConfigId: 195,
        templateId: 21,
      },
      CT_Landmark_Pro_Solaris_MaxDef_HeatherBlend: {
        layerConfigId: 196,
        templateId: 21,
      },
      CT_Landmark_Pro_Solaris_MaxDef_MoireBlack: {
        layerConfigId: 197,
        templateId: 21,
      },
      CT_Landmark_Pro_Solaris_MaxDef_ResawnShake: {
        layerConfigId: 198,
        templateId: 21,
      },
      CT_Landmark_Pro_Solaris_MaxDef_WeatheredWood: {
        layerConfigId: 199,
        templateId: 21,
      },
      CT_Landmark_Pro_Solaris_SilverBirch: {
        layerConfigId: 200,
        templateId: 21,
      },
    },
    CT_Landmark_Solaris: {
      CT_Landmark_Solaris_AgedCedar: {
        layerConfigId: 201,
        templateId: 21,
      },
      CT_Landmark_Solaris_Birch: {
        layerConfigId: 202,
        templateId: 21,
      },
      CT_Landmark_Solaris_BurntSienna: {
        layerConfigId: 203,
        templateId: 21,
      },
      CT_Landmark_Solaris_CrystalGray: {
        layerConfigId: 204,
        templateId: 21,
      },
      CT_Landmark_Solaris_GeorgetownGray: {
        layerConfigId: 205,
        templateId: 21,
      },
      CT_Landmark_Solaris_Graphite: {
        layerConfigId: 206,
        templateId: 21,
      },
      CT_Landmark_Solaris_HeatherBlend: {
        layerConfigId: 207,
        templateId: 21,
      },
      CT_Landmark_Solaris_MistWhite: {
        layerConfigId: 208,
        templateId: 21,
      },
      CT_Landmark_Solaris_MoireBlack: {
        layerConfigId: 209,
        templateId: 21,
      },
      CT_Landmark_Solaris_MojaveTan: {
        layerConfigId: 210,
        templateId: 21,
      },
      CT_Landmark_Solaris_ResawnShake: {
        layerConfigId: 211,
        templateId: 21,
      },
      CT_Landmark_Solaris_SilverBirch: {
        layerConfigId: 212,
        templateId: 21,
      },
      CT_Landmark_Solaris_WeatheredWood: {
        layerConfigId: 213,
        templateId: 21,
      },
    },
    CT_Landmark_TL: {
      CT_Landmark_TL_BlackWalnut: {
        layerConfigId: 214,
        templateId: 21,
      },
      CT_Landmark_TL_CountryGray: {
        layerConfigId: 215,
        templateId: 21,
      },
      CT_Landmark_TL_MoireBlack: {
        layerConfigId: 216,
        templateId: 21,
      },
      CT_Landmark_TL_Platinum: {
        layerConfigId: 217,
        templateId: 21,
      },
      CT_Landmark_TL_Shenandoah: {
        layerConfigId: 218,
        templateId: 21,
      },
    },
    CT_Landmark_TL_Solaris: {
      CT_Landmark_TL_Solaris_CountryGray: {
        layerConfigId: 219,
        templateId: 21,
      },
      CT_Landmark_TL_Solaris_MoireBlack: {
        layerConfigId: 220,
        templateId: 21,
      },
      CT_Landmark_TL_Solaris_Platinum: {
        layerConfigId: 221,
        templateId: 21,
      },
    },
    CT_Northgate_Climate_Flex: {
      CT_Northgate_ClimateFlex_MaxDef_BurntSienna: {
        layerConfigId: 222,
        templateId: 21,
      },
      CT_Northgate_ClimateFlex_MaxDef_Driftwood: {
        layerConfigId: 223,
        templateId: 21,
      },
      CT_Northgate_ClimateFlex_MaxDef_GeorgetownGray: {
        layerConfigId: 224,
        templateId: 21,
      },
      CT_Northgate_ClimateFlex_MaxDef_GraniteGray: {
        layerConfigId: 225,
        templateId: 21,
      },
      CT_Northgate_ClimateFlex_MaxDef_HeatherBlend: {
        layerConfigId: 226,
        templateId: 21,
      },
      CT_Northgate_ClimateFlex_MaxDef_HunterGreen: {
        layerConfigId: 227,
        templateId: 21,
      },
      CT_Northgate_ClimateFlex_MaxDef_MoireBlack: {
        layerConfigId: 228,
        templateId: 21,
      },
      CT_Northgate_ClimateFlex_MaxDef_Pewter: {
        layerConfigId: 229,
        templateId: 21,
      },
      CT_Northgate_ClimateFlex_MaxDef_ResawnShake: {
        layerConfigId: 230,
        templateId: 21,
      },
      CT_Northgate_ClimateFlex_MaxDef_SilverBirch: {
        layerConfigId: 231,
        templateId: 21,
      },
      CT_Northgate_ClimateFlex_MaxDef_WeatheredWood: {
        layerConfigId: 232,
        templateId: 21,
      },
    },
    CT_Patriot: {
      CT_Patriot_Sablewood: {
        layerConfigId: 1024,
        templateId: 21,
      },
    },
    GAF: {
      GAF_AppalachianSky: {
        layerConfigId: 1074,
        templateId: 21,
      },
      GAF_Barkwood: {
        layerConfigId: 922,
        templateId: 21,
      },
      GAF_BlackWalnut: {
        layerConfigId: 120,
        templateId: 21,
      },
      GAF_Charcoal: {
        layerConfigId: 17,
        templateId: 21,
      },
      GAF_MissionBrown: {
        layerConfigId: 923,
        templateId: 21,
      },
      GAF_PewterGray: {
        layerConfigId: 749,
        templateId: 21,
      },
      GAF_Shakewood: {
        layerConfigId: 1075,
        templateId: 21,
      },
      GAF_WeatheredWood: {
        layerConfigId: 18,
        templateId: 21,
      },
    },
    IKO: {
      IKO_CharcoalGrey: {
        layerConfigId: 409,
        templateId: 21,
      },
      IKO_CornerstoneWW: {
        layerConfigId: 1003,
        templateId: 21,
      },
      IKO_Driftwood: {
        layerConfigId: 410,
        templateId: 21,
      },
      IKO_DualBlack: {
        layerConfigId: 411,
        templateId: 21,
      },
      IKO_DualBrown: {
        layerConfigId: 412,
        templateId: 21,
      },
      IKO_DualGrey: {
        layerConfigId: 413,
        templateId: 21,
      },
      IKO_EarthtoneCedar: {
        layerConfigId: 414,
        templateId: 21,
      },
      IKO_GraniteBlack: {
        layerConfigId: 1004,
        templateId: 21,
      },
      IKO_HarvardSlate: {
        layerConfigId: 415,
        templateId: 21,
      },
      IKO_SummitGrey: {
        layerConfigId: 1146,
        templateId: 21,
      },
      IKO_Weatherwood: {
        layerConfigId: 416,
        templateId: 21,
      },
    },
    Malarkey: {
      Malarkey_MidnightBlack: {
        layerConfigId: 846,
        templateId: 21,
      },
      Malarkey_NaturalWood: {
        layerConfigId: 847,
        templateId: 21,
      },
      Malarkey_Silverwood: {
        layerConfigId: 848,
        templateId: 21,
      },
    },
    OwensCorning: {
      OC_Oakridge_Brownwood: {
        layerConfigId: 342,
        templateId: 21,
      },
      OC_Oakridge_DesertTan: {
        layerConfigId: 343,
        templateId: 21,
      },
      OC_Oakridge_Driftwood: {
        layerConfigId: 344,
        templateId: 21,
      },
      OC_Oakridge_EstateGray: {
        layerConfigId: 345,
        templateId: 21,
      },
      OC_Oakridge_OnyxBlack: {
        layerConfigId: 346,
        templateId: 21,
      },
      OC_Oakridge_Peppercorn: {
        layerConfigId: 562,
        templateId: 21,
      },
      OC_Oakridge_SierraGray: {
        layerConfigId: 765,
        templateId: 21,
      },
      OC_Oakridge_Teak: {
        layerConfigId: 347,
        templateId: 21,
      },
      OC_Oakridge_WilliamsburgGray: {
        layerConfigId: 348,
        templateId: 21,
      },
      OC_Supreme_WeatheredWood: {
        layerConfigId: 300,
        templateId: 21,
      },
    },
    RoofTEMP: {
      RoofTEMP_Black: {
        layerConfigId: 16,
        templateId: 21,
      },
      RoofTEMP_Gray: {
        layerConfigId: 19,
        templateId: 21,
      },
      RoofTEMP_ResawnShake: {
        layerConfigId: 26,
        templateId: 21,
      },
    },
    Tamko: {
      Tamko_AntiqueSlate: {
        layerConfigId: 824,
        templateId: 21,
      },
      Tamko_NaturalTimber: {
        layerConfigId: 121,
        templateId: 21,
      },
      Tamko_OldeEnglishPewter: {
        layerConfigId: 122,
        templateId: 21,
      },
      Tamko_OxfordGrey: {
        layerConfigId: 308,
        templateId: 21,
      },
      Tamko_RusticBlack: {
        layerConfigId: 292,
        templateId: 21,
      },
      Tamko_RusticSlate: {
        layerConfigId: 825,
        templateId: 21,
      },
      Tamko_ThunderstormGrey: {
        layerConfigId: 123,
        templateId: 21,
      },
      Tamko_VirginiaSlate: {
        layerConfigId: 293,
        templateId: 21,
      },
      Tamko_WeatheredWood: {
        layerConfigId: 309,
        templateId: 21,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_AsphaltShakeStraight = {
  L: {
    Atlas: {
      Atlas_BlackShadow: {
        layerConfigId: 388,
        templateId: 155,
      },
      Atlas_WeatheredWood: {
        layerConfigId: 15,
        templateId: 155,
      },
    },
    CT_Landmark: {
      CT_Landmark_BlackShadow: {
        layerConfigId: 275,
        templateId: 155,
      },
      CT_Landmark_BlackWalnut: {
        layerConfigId: 233,
        templateId: 155,
      },
      CT_Landmark_BurntSienna: {
        layerConfigId: 234,
        templateId: 155,
      },
      CT_Landmark_CharcoalBlack: {
        layerConfigId: 20,
        templateId: 155,
      },
      CT_Landmark_CinderBlack: {
        layerConfigId: 235,
        templateId: 155,
      },
      CT_Landmark_CobblestoneGray: {
        layerConfigId: 236,
        templateId: 155,
      },
      CT_Landmark_ColonialSlate: {
        layerConfigId: 237,
        templateId: 155,
      },
      CT_Landmark_Driftwood: {
        layerConfigId: 21,
        templateId: 155,
      },
      CT_Landmark_GeorgetownGray: {
        layerConfigId: 22,
        templateId: 155,
      },
      CT_Landmark_GeorgetownGray_MaxDef: {
        layerConfigId: 88,
        templateId: 155,
      },
      CT_Landmark_HeatherBlend: {
        layerConfigId: 23,
        templateId: 155,
      },
      CT_Landmark_HunterGreen: {
        layerConfigId: 238,
        templateId: 155,
      },
      CT_Landmark_MoireBlack: {
        layerConfigId: 24,
        templateId: 155,
      },
      CT_Landmark_MoireBlack_MaxDef: {
        layerConfigId: 239,
        templateId: 155,
      },
      CT_Landmark_MojaveTan: {
        layerConfigId: 240,
        templateId: 155,
      },
      CT_Landmark_PaintedDesert: {
        layerConfigId: 241,
        templateId: 155,
      },
      CT_Landmark_Pewter: {
        layerConfigId: 242,
        templateId: 155,
      },
      CT_Landmark_Pewterwood: {
        layerConfigId: 243,
        templateId: 155,
      },
      CT_Landmark_ResawnShake: {
        layerConfigId: 244,
        templateId: 155,
      },
      CT_Landmark_SilverBirch: {
        layerConfigId: 245,
        templateId: 155,
      },
      CT_Landmark_SlateGray: {
        layerConfigId: 644,
        templateId: 155,
      },
      CT_Landmark_SunriseCedar: {
        layerConfigId: 246,
        templateId: 155,
      },
      CT_Landmark_ThunderstormGray: {
        layerConfigId: 247,
        templateId: 155,
      },
      CT_Landmark_WeatheredWood: {
        layerConfigId: 25,
        templateId: 155,
      },
      CT_Landmark_WeatheredWood_MaxDef: {
        layerConfigId: 89,
        templateId: 155,
      },
    },
    CT_Landmark_Premium: {
      CT_Landmark_Premium_MaxDef_BurntSienna: {
        layerConfigId: 164,
        templateId: 155,
      },
      CT_Landmark_Premium_MaxDef_ColonialSlate: {
        layerConfigId: 165,
        templateId: 155,
      },
      CT_Landmark_Premium_MaxDef_Driftwood: {
        layerConfigId: 166,
        templateId: 155,
      },
      CT_Landmark_Premium_MaxDef_GeorgetownGray: {
        layerConfigId: 167,
        templateId: 155,
      },
      CT_Landmark_Premium_MaxDef_HeatherBlend: {
        layerConfigId: 168,
        templateId: 155,
      },
      CT_Landmark_Premium_MaxDef_MoireBlack: {
        layerConfigId: 169,
        templateId: 155,
      },
      CT_Landmark_Premium_MaxDef_PewterWood: {
        layerConfigId: 170,
        templateId: 155,
      },
      CT_Landmark_Premium_MaxDef_ResawnShake: {
        layerConfigId: 171,
        templateId: 155,
      },
      CT_Landmark_Premium_MaxDef_WeatheredWood: {
        layerConfigId: 172,
        templateId: 155,
      },
    },
    CT_Landmark_Pro: {
      CT_Landmark_Pro_CinderBlack: {
        layerConfigId: 173,
        templateId: 155,
      },
      CT_Landmark_Pro_GraniteGray: {
        layerConfigId: 174,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_BlackWalnut: {
        layerConfigId: 175,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_BurntSienna: {
        layerConfigId: 176,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_CharcoalBlack: {
        layerConfigId: 177,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_CobblestoneGray: {
        layerConfigId: 178,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_ColonialSlate: {
        layerConfigId: 179,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_Driftwood: {
        layerConfigId: 180,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_GeorgetownGray: {
        layerConfigId: 181,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_HeatherBlend: {
        layerConfigId: 182,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_MoireBlack: {
        layerConfigId: 183,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_MojaveTan: {
        layerConfigId: 184,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_Pewter: {
        layerConfigId: 185,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_PewterWood: {
        layerConfigId: 186,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_PrairieWood: {
        layerConfigId: 187,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_ResawnShake: {
        layerConfigId: 188,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_Shenandoah: {
        layerConfigId: 189,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_SilverBirch: {
        layerConfigId: 190,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_SunriseCedar: {
        layerConfigId: 191,
        templateId: 155,
      },
      CT_Landmark_Pro_MaxDef_WeatheredWood: {
        layerConfigId: 192,
        templateId: 155,
      },
    },
    CT_Landmark_Pro_Solaris: {
      CT_Landmark_Pro_Solaris_BurntSienna: {
        layerConfigId: 193,
        templateId: 155,
      },
      CT_Landmark_Pro_Solaris_MaxDef_BurntSienna: {
        layerConfigId: 194,
        templateId: 155,
      },
      CT_Landmark_Pro_Solaris_MaxDef_GeorgetownGray: {
        layerConfigId: 195,
        templateId: 155,
      },
      CT_Landmark_Pro_Solaris_MaxDef_HeatherBlend: {
        layerConfigId: 196,
        templateId: 155,
      },
      CT_Landmark_Pro_Solaris_MaxDef_MoireBlack: {
        layerConfigId: 197,
        templateId: 155,
      },
      CT_Landmark_Pro_Solaris_MaxDef_ResawnShake: {
        layerConfigId: 198,
        templateId: 155,
      },
      CT_Landmark_Pro_Solaris_MaxDef_WeatheredWood: {
        layerConfigId: 199,
        templateId: 155,
      },
      CT_Landmark_Pro_Solaris_SilverBirch: {
        layerConfigId: 200,
        templateId: 155,
      },
    },
    CT_Landmark_Solaris: {
      CT_Landmark_Solaris_AgedCedar: {
        layerConfigId: 201,
        templateId: 155,
      },
      CT_Landmark_Solaris_Birch: {
        layerConfigId: 202,
        templateId: 155,
      },
      CT_Landmark_Solaris_BurntSienna: {
        layerConfigId: 203,
        templateId: 155,
      },
      CT_Landmark_Solaris_CrystalGray: {
        layerConfigId: 204,
        templateId: 155,
      },
      CT_Landmark_Solaris_GeorgetownGray: {
        layerConfigId: 205,
        templateId: 155,
      },
      CT_Landmark_Solaris_Graphite: {
        layerConfigId: 206,
        templateId: 155,
      },
      CT_Landmark_Solaris_HeatherBlend: {
        layerConfigId: 207,
        templateId: 155,
      },
      CT_Landmark_Solaris_MistWhite: {
        layerConfigId: 208,
        templateId: 155,
      },
      CT_Landmark_Solaris_MoireBlack: {
        layerConfigId: 209,
        templateId: 155,
      },
      CT_Landmark_Solaris_MojaveTan: {
        layerConfigId: 210,
        templateId: 155,
      },
      CT_Landmark_Solaris_ResawnShake: {
        layerConfigId: 211,
        templateId: 155,
      },
      CT_Landmark_Solaris_SilverBirch: {
        layerConfigId: 212,
        templateId: 155,
      },
      CT_Landmark_Solaris_WeatheredWood: {
        layerConfigId: 213,
        templateId: 155,
      },
    },
    CT_Landmark_TL: {
      CT_Landmark_TL_BlackWalnut: {
        layerConfigId: 214,
        templateId: 155,
      },
      CT_Landmark_TL_CountryGray: {
        layerConfigId: 215,
        templateId: 155,
      },
      CT_Landmark_TL_MoireBlack: {
        layerConfigId: 216,
        templateId: 155,
      },
      CT_Landmark_TL_Platinum: {
        layerConfigId: 217,
        templateId: 155,
      },
      CT_Landmark_TL_Shenandoah: {
        layerConfigId: 218,
        templateId: 155,
      },
    },
    CT_Landmark_TL_Solaris: {
      CT_Landmark_TL_Solaris_CountryGray: {
        layerConfigId: 219,
        templateId: 155,
      },
      CT_Landmark_TL_Solaris_MoireBlack: {
        layerConfigId: 220,
        templateId: 155,
      },
      CT_Landmark_TL_Solaris_Platinum: {
        layerConfigId: 221,
        templateId: 155,
      },
    },
    CT_Northgate_Climate_Flex: {
      CT_Northgate_ClimateFlex_MaxDef_BurntSienna: {
        layerConfigId: 222,
        templateId: 155,
      },
      CT_Northgate_ClimateFlex_MaxDef_Driftwood: {
        layerConfigId: 223,
        templateId: 155,
      },
      CT_Northgate_ClimateFlex_MaxDef_GeorgetownGray: {
        layerConfigId: 224,
        templateId: 155,
      },
      CT_Northgate_ClimateFlex_MaxDef_GraniteGray: {
        layerConfigId: 225,
        templateId: 155,
      },
      CT_Northgate_ClimateFlex_MaxDef_HeatherBlend: {
        layerConfigId: 226,
        templateId: 155,
      },
      CT_Northgate_ClimateFlex_MaxDef_HunterGreen: {
        layerConfigId: 227,
        templateId: 155,
      },
      CT_Northgate_ClimateFlex_MaxDef_MoireBlack: {
        layerConfigId: 228,
        templateId: 155,
      },
      CT_Northgate_ClimateFlex_MaxDef_Pewter: {
        layerConfigId: 229,
        templateId: 155,
      },
      CT_Northgate_ClimateFlex_MaxDef_ResawnShake: {
        layerConfigId: 230,
        templateId: 155,
      },
      CT_Northgate_ClimateFlex_MaxDef_SilverBirch: {
        layerConfigId: 231,
        templateId: 155,
      },
      CT_Northgate_ClimateFlex_MaxDef_WeatheredWood: {
        layerConfigId: 232,
        templateId: 155,
      },
    },
    CT_Patriot: {
      CT_Patriot_Sablewood: {
        layerConfigId: 1024,
        templateId: 155,
      },
    },
    GAF: {
      GAF_AppalachianSky: {
        layerConfigId: 1074,
        templateId: 155,
      },
      GAF_Barkwood: {
        layerConfigId: 922,
        templateId: 155,
      },
      GAF_BlackWalnut: {
        layerConfigId: 120,
        templateId: 155,
      },
      GAF_Charcoal: {
        layerConfigId: 17,
        templateId: 155,
      },
      GAF_MissionBrown: {
        layerConfigId: 923,
        templateId: 155,
      },
      GAF_PewterGray: {
        layerConfigId: 749,
        templateId: 155,
      },
      GAF_Shakewood: {
        layerConfigId: 1075,
        templateId: 155,
      },
      GAF_WeatheredWood: {
        layerConfigId: 18,
        templateId: 155,
      },
    },
    IKO: {
      IKO_CharcoalGrey: {
        layerConfigId: 409,
        templateId: 155,
      },
      IKO_CornerstoneWW: {
        layerConfigId: 1003,
        templateId: 155,
      },
      IKO_Driftwood: {
        layerConfigId: 410,
        templateId: 155,
      },
      IKO_DualBlack: {
        layerConfigId: 411,
        templateId: 155,
      },
      IKO_DualBrown: {
        layerConfigId: 412,
        templateId: 155,
      },
      IKO_DualGrey: {
        layerConfigId: 413,
        templateId: 155,
      },
      IKO_EarthtoneCedar: {
        layerConfigId: 414,
        templateId: 155,
      },
      IKO_GraniteBlack: {
        layerConfigId: 1004,
        templateId: 155,
      },
      IKO_HarvardSlate: {
        layerConfigId: 415,
        templateId: 155,
      },
      IKO_SummitGrey: {
        layerConfigId: 1146,
        templateId: 155,
      },
      IKO_Weatherwood: {
        layerConfigId: 416,
        templateId: 155,
      },
    },
    Malarkey: {
      Malarkey_MidnightBlack: {
        layerConfigId: 846,
        templateId: 155,
      },
      Malarkey_NaturalWood: {
        layerConfigId: 847,
        templateId: 155,
      },
      Malarkey_Silverwood: {
        layerConfigId: 848,
        templateId: 155,
      },
    },
    OwensCorning: {
      OC_Oakridge_Brownwood: {
        layerConfigId: 342,
        templateId: 155,
      },
      OC_Oakridge_DesertTan: {
        layerConfigId: 343,
        templateId: 155,
      },
      OC_Oakridge_Driftwood: {
        layerConfigId: 344,
        templateId: 155,
      },
      OC_Oakridge_EstateGray: {
        layerConfigId: 345,
        templateId: 155,
      },
      OC_Oakridge_OnyxBlack: {
        layerConfigId: 346,
        templateId: 155,
      },
      OC_Oakridge_Peppercorn: {
        layerConfigId: 562,
        templateId: 155,
      },
      OC_Oakridge_SierraGray: {
        layerConfigId: 765,
        templateId: 155,
      },
      OC_Oakridge_Teak: {
        layerConfigId: 347,
        templateId: 155,
      },
      OC_Oakridge_WilliamsburgGray: {
        layerConfigId: 348,
        templateId: 155,
      },
      OC_Supreme_WeatheredWood: {
        layerConfigId: 300,
        templateId: 155,
      },
    },
    RoofTEMP: {
      RoofTEMP_Black: {
        layerConfigId: 16,
        templateId: 155,
      },
      RoofTEMP_Gray: {
        layerConfigId: 19,
        templateId: 155,
      },
      RoofTEMP_ResawnShake: {
        layerConfigId: 26,
        templateId: 155,
      },
    },
    Tamko: {
      Tamko_AntiqueSlate: {
        layerConfigId: 824,
        templateId: 155,
      },
      Tamko_NaturalTimber: {
        layerConfigId: 121,
        templateId: 155,
      },
      Tamko_OldeEnglishPewter: {
        layerConfigId: 122,
        templateId: 155,
      },
      Tamko_OxfordGrey: {
        layerConfigId: 308,
        templateId: 155,
      },
      Tamko_RusticBlack: {
        layerConfigId: 292,
        templateId: 155,
      },
      Tamko_RusticSlate: {
        layerConfigId: 825,
        templateId: 155,
      },
      Tamko_ThunderstormGrey: {
        layerConfigId: 123,
        templateId: 155,
      },
      Tamko_VirginiaSlate: {
        layerConfigId: 293,
        templateId: 155,
      },
      Tamko_WeatheredWood: {
        layerConfigId: 309,
        templateId: 155,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_MetalShakeStraight12 = {
  C: {
    templateId: 404,
  },
  L: {
    Roof_StandingSeamIR: {
      Roof_StandingSeamIR_CharcoalGray: {
        layerConfigId: 27,
        templateId: 404,
      },
      Roof_StandingSeamIR_CoalBlack: {
        layerConfigId: 28,
        templateId: 404,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_Rubber = {
  Default: {
    templateId: 22,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_StandingSeam12 = {
  C: {
    templateId: 24,
  },
  L: {
    Metal_JetMetals: {
      Metal_JetMetals_Drexlume: {
        layerConfigId: 1085,
        templateId: 24,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_StandingSeam14 = {
  C: {
    templateId: 461,
  },
  L: {
    Metal_JetMetals: {
      Metal_JetMetals_Drexlume: {
        layerConfigId: 1085,
        templateId: 461,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_StandingSeam15 = {
  C: {
    templateId: 423,
  },
  L: {
    Metal_JetMetals: {
      Metal_JetMetals_Drexlume: {
        layerConfigId: 1085,
        templateId: 423,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_StandingSeam16 = {
  C: {
    templateId: 25,
  },
  L: {
    Metal_JetMetals: {
      Metal_JetMetals_Drexlume: {
        layerConfigId: 1085,
        templateId: 25,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_StandingSeam18 = {
  C: {
    templateId: 257,
  },
  L: {
    Metal_JetMetals: {
      Metal_JetMetals_Drexlume: {
        layerConfigId: 1085,
        templateId: 257,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_StandingSeam24 = {
  C: {
    templateId: 459,
  },
  L: {
    Metal_JetMetals: {
      Metal_JetMetals_Drexlume: {
        layerConfigId: 1085,
        templateId: 459,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_StandingSeamIR = {
  C: {
    templateId: 26,
  },
  L: {
    Metal_JetMetals: {
      Metal_JetMetals_Drexlume: {
        layerConfigId: 1085,
        templateId: 26,
      },
    },
    Roof_StandingSeamIR: {
      Roof_StandingSeamIR_CharcoalGray: {
        layerConfigId: 27,
        templateId: 26,
      },
      Roof_StandingSeamIR_CoalBlack: {
        layerConfigId: 28,
        templateId: 26,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_StandingSeamPBU_Galvanized = {
  C: {
    templateId: 27,
  },
  L: {
    Metal_JetMetals: {
      Metal_JetMetals_Drexlume: {
        layerConfigId: 1085,
        templateId: 27,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_WoodShake_10x10 = {
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 154,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 154,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 154,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 154,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 154,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 154,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 154,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 154,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 154,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 154,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 154,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 154,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 154,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 154,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 154,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 154,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 154,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 154,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 154,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 154,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 154,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 154,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 154,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 154,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 154,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 154,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 154,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 154,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 154,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 154,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 154,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 154,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 154,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 154,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 154,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 154,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 154,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 154,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 154,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 154,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 154,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 154,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 154,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 154,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 154,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 154,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 154,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 154,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 154,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 154,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 154,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 154,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 154,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 154,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 154,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 154,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 154,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 154,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 154,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 154,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 154,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 154,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 154,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 154,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 154,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 154,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Roof_WoodShake_10xVariable = {
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 294,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 294,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 294,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 294,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 294,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 294,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 294,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 294,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 294,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 294,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 294,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 294,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 294,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 294,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 294,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 294,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 294,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 294,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 294,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 294,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 294,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 294,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 294,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 294,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 294,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 294,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 294,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 294,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 294,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 294,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 294,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 294,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 294,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 294,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 294,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 294,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 294,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 294,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 294,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 294,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 294,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 294,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 294,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 294,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 294,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 294,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 294,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 294,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 294,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 294,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 294,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 294,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 294,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 294,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 294,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 294,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 294,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 294,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 294,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 294,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 294,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 294,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 294,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 294,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 294,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 294,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Shutter = {
  C: {
    templateId: 33,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Soffit_Slat = {
  C: {
    templateId: 34,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_SolarPanel_6x6 = {
  Default: {
    templateId: 360,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Stain_Flat = {
  Default: {
    templateId: 35,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Stone_BlancoBuilders = {
  Default: {
    templateId: 361,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Stone_RattlesnakeBuilders = {
  Default: {
    templateId: 362,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Stone_SunflowerChop = {
  Default: {
    templateId: 363,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Stone_TexasMix = {
  Default: {
    templateId: 364,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Stone_TumbleweedTan = {
  Default: {
    templateId: 365,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_TileBath_4x12 = {
  Default: {
    templateId: 508,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Tile_12x12 = {
  Default: {
    templateId: 507,
  },
  L: {
    Tile_AmericanOlean: {
      Tile_DanyaBasin: {
        layerConfigId: 1210,
        templateId: 507,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Tile_17x17 = {
  Default: {
    templateId: 499,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Tree_Bark_Generic = {
  Default: {
    templateId: 36,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Tree_Foliage_Generic = {
  Default: {
    templateId: 37,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_Board48x120_Battens02h = {
  C: {
    templateId: 479,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 479,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 479,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 479,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 479,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 479,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 479,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 479,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 479,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 479,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 479,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 479,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 479,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 479,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 479,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 479,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 479,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 479,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 479,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 479,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 479,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 479,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 479,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 479,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 479,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 479,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 479,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 479,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 479,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 479,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 479,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 479,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 479,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 479,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 479,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 479,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 479,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 479,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 479,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 479,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 479,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 479,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 479,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 479,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 479,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 479,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 479,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 479,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 479,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 479,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 479,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 479,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 479,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 479,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 479,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 479,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 479,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 479,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 479,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 479,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 479,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 479,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 479,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 479,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 479,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 479,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 479,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01hx06q = {
  C: {
    templateId: 381,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 381,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 381,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 381,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 381,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 381,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 381,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 381,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 381,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 381,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 381,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 381,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 381,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 381,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 381,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 381,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 381,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 381,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 381,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 381,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 381,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 381,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 381,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 381,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 381,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 381,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 381,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 381,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 381,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 381,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 381,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 381,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 381,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 381,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 381,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 381,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 381,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 381,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 381,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 381,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 381,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 381,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 381,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 381,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 381,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 381,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 381,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 381,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 381,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 381,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 381,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 381,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 381,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 381,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 381,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 381,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 381,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 381,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 381,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 381,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 381,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 381,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 381,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 381,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 381,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 381,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 381,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01hx07 = {
  C: {
    templateId: 385,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 385,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 385,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 385,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 385,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 385,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 385,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 385,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 385,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 385,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 385,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 385,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 385,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 385,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 385,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 385,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 385,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 385,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 385,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 385,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 385,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 385,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 385,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 385,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 385,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 385,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 385,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 385,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 385,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 385,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 385,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 385,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 385,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 385,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 385,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 385,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 385,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 385,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 385,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 385,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 385,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 385,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 385,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 385,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 385,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 385,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 385,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 385,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 385,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 385,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 385,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 385,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 385,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 385,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 385,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 385,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 385,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 385,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 385,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 385,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 385,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 385,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 385,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 385,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 385,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 385,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 385,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01hx08 = {
  C: {
    templateId: 42,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 42,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 42,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 42,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 42,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 42,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 42,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 42,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 42,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 42,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 42,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 42,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 42,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 42,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 42,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 42,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 42,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 42,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 42,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 42,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 42,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 42,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 42,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 42,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 42,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 42,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 42,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 42,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 42,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 42,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 42,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 42,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 42,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 42,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 42,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 42,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 42,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 42,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 42,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 42,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 42,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 42,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 42,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 42,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 42,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 42,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 42,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 42,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 42,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 42,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 42,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 42,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 42,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 42,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 42,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 42,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 42,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 42,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 42,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 42,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 42,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 42,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 42,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 42,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 42,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 42,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 42,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01hx12 = {
  C: {
    templateId: 158,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 158,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 158,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 158,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 158,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 158,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 158,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 158,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 158,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 158,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 158,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 158,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 158,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 158,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 158,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 158,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 158,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 158,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 158,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 158,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 158,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 158,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 158,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 158,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 158,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 158,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 158,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 158,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 158,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 158,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 158,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 158,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 158,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 158,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 158,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 158,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 158,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 158,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 158,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 158,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 158,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 158,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 158,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 158,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 158,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 158,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 158,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 158,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 158,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 158,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 158,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 158,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 158,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 158,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 158,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 158,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 158,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 158,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 158,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 158,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 158,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 158,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 158,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 158,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 158,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 158,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 158,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01hx16 = {
  C: {
    templateId: 159,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 159,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 159,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 159,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 159,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 159,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 159,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 159,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 159,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 159,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 159,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 159,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 159,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 159,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 159,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 159,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 159,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 159,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 159,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 159,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 159,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 159,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 159,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 159,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 159,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 159,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 159,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 159,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 159,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 159,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 159,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 159,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 159,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 159,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 159,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 159,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 159,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 159,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 159,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 159,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 159,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 159,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 159,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 159,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 159,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 159,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 159,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 159,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 159,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 159,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 159,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 159,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 159,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 159,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 159,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 159,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 159,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 159,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 159,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 159,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 159,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 159,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 159,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 159,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 159,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 159,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 159,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01hx20 = {
  C: {
    templateId: 240,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 240,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 240,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 240,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 240,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 240,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 240,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 240,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 240,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 240,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 240,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 240,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 240,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 240,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 240,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 240,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 240,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 240,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 240,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 240,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 240,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 240,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 240,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 240,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 240,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 240,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 240,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 240,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 240,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 240,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 240,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 240,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 240,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 240,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 240,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 240,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 240,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 240,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 240,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 240,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 240,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 240,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 240,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 240,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 240,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 240,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 240,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 240,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 240,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 240,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 240,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 240,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 240,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 240,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 240,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 240,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 240,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 240,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 240,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 240,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 240,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 240,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 240,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 240,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 240,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 240,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 240,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01hx24 = {
  C: {
    templateId: 160,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 160,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 160,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 160,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 160,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 160,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 160,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 160,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 160,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 160,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 160,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 160,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 160,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 160,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 160,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 160,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 160,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 160,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 160,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 160,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 160,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 160,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 160,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 160,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 160,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 160,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 160,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 160,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 160,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 160,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 160,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 160,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 160,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 160,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 160,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 160,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 160,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 160,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 160,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 160,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 160,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 160,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 160,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 160,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 160,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 160,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 160,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 160,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 160,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 160,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 160,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 160,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 160,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 160,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 160,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 160,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 160,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 160,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 160,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 160,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 160,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 160,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 160,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 160,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 160,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 160,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 160,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01hx36 = {
  C: {
    templateId: 429,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 429,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 429,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 429,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 429,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 429,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 429,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 429,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 429,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 429,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 429,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 429,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 429,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 429,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 429,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 429,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 429,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 429,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 429,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 429,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 429,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 429,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 429,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 429,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 429,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 429,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 429,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 429,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 429,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 429,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 429,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 429,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 429,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 429,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 429,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 429,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 429,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 429,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 429,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 429,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 429,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 429,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 429,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 429,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 429,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 429,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 429,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 429,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 429,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 429,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 429,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 429,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 429,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 429,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 429,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 429,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 429,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 429,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 429,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 429,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 429,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 429,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 429,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 429,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 429,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 429,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 429,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01hx48 = {
  C: {
    templateId: 161,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 161,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 161,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 161,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 161,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 161,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 161,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 161,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 161,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 161,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 161,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 161,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 161,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 161,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 161,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 161,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 161,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 161,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 161,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 161,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 161,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 161,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 161,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 161,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 161,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 161,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 161,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 161,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 161,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 161,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 161,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 161,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 161,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 161,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 161,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 161,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 161,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 161,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 161,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 161,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 161,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 161,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 161,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 161,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 161,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 161,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 161,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 161,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 161,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 161,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 161,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 161,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 161,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 161,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 161,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 161,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 161,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 161,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 161,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 161,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 161,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 161,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 161,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 161,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 161,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 161,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 161,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01x07 = {
  C: {
    templateId: 386,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 386,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 386,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 386,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 386,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 386,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 386,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 386,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 386,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 386,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 386,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 386,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 386,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 386,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 386,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 386,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 386,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 386,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 386,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 386,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 386,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 386,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 386,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 386,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 386,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 386,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 386,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 386,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 386,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 386,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 386,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 386,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 386,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 386,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 386,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 386,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 386,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 386,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 386,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 386,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 386,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 386,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 386,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 386,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 386,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 386,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 386,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 386,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 386,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 386,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 386,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 386,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 386,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 386,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 386,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 386,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 386,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 386,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 386,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 386,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 386,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 386,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 386,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 386,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 386,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 386,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 386,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01x08 = {
  C: {
    templateId: 162,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 162,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 162,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 162,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 162,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 162,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 162,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 162,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 162,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 162,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 162,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 162,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 162,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 162,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 162,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 162,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 162,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 162,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 162,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 162,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 162,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 162,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 162,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 162,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 162,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 162,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 162,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 162,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 162,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 162,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 162,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 162,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 162,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 162,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 162,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 162,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 162,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 162,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 162,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 162,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 162,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 162,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 162,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 162,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 162,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 162,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 162,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 162,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 162,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 162,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 162,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 162,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 162,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 162,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 162,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 162,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 162,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 162,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 162,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 162,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 162,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 162,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 162,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 162,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 162,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 162,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 162,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01x12 = {
  C: {
    templateId: 163,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 163,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 163,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 163,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 163,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 163,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 163,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 163,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 163,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 163,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 163,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 163,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 163,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 163,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 163,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 163,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 163,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 163,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 163,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 163,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 163,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 163,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 163,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 163,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 163,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 163,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 163,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 163,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 163,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 163,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 163,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 163,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 163,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 163,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 163,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 163,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 163,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 163,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 163,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 163,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 163,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 163,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 163,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 163,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 163,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 163,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 163,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 163,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 163,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 163,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 163,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 163,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 163,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 163,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 163,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 163,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 163,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 163,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 163,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 163,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 163,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 163,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 163,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 163,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 163,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 163,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 163,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01x16 = {
  C: {
    templateId: 164,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 164,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 164,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 164,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 164,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 164,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 164,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 164,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 164,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 164,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 164,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 164,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 164,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 164,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 164,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 164,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 164,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 164,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 164,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 164,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 164,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 164,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 164,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 164,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 164,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 164,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 164,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 164,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 164,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 164,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 164,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 164,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 164,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 164,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 164,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 164,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 164,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 164,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 164,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 164,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 164,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 164,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 164,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 164,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 164,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 164,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 164,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 164,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 164,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 164,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 164,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 164,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 164,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 164,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 164,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 164,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 164,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 164,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 164,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 164,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 164,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 164,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 164,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 164,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 164,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 164,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 164,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01x20 = {
  C: {
    templateId: 241,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 241,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 241,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 241,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 241,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 241,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 241,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 241,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 241,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 241,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 241,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 241,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 241,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 241,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 241,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 241,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 241,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 241,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 241,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 241,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 241,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 241,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 241,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 241,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 241,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 241,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 241,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 241,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 241,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 241,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 241,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 241,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 241,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 241,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 241,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 241,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 241,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 241,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 241,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 241,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 241,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 241,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 241,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 241,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 241,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 241,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 241,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 241,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 241,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 241,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 241,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 241,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 241,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 241,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 241,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 241,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 241,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 241,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 241,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 241,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 241,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 241,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 241,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 241,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 241,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 241,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 241,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01x24 = {
  C: {
    templateId: 165,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 165,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 165,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 165,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 165,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 165,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 165,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 165,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 165,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 165,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 165,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 165,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 165,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 165,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 165,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 165,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 165,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 165,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 165,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 165,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 165,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 165,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 165,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 165,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 165,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 165,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 165,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 165,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 165,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 165,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 165,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 165,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 165,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 165,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 165,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 165,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 165,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 165,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 165,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 165,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 165,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 165,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 165,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 165,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 165,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 165,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 165,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 165,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 165,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 165,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 165,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 165,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 165,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 165,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 165,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 165,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 165,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 165,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 165,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 165,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 165,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 165,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 165,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 165,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 165,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 165,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 165,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01x36 = {
  C: {
    templateId: 430,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 430,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 430,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 430,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 430,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 430,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 430,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 430,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 430,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 430,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 430,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 430,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 430,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 430,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 430,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 430,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 430,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 430,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 430,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 430,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 430,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 430,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 430,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 430,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 430,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 430,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 430,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 430,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 430,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 430,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 430,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 430,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 430,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 430,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 430,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 430,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 430,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 430,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 430,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 430,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 430,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 430,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 430,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 430,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 430,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 430,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 430,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 430,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 430,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 430,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 430,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 430,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 430,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 430,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 430,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 430,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 430,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 430,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 430,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 430,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 430,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 430,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 430,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 430,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 430,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 430,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 430,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten01x48 = {
  C: {
    templateId: 166,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 166,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 166,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 166,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 166,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 166,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 166,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 166,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 166,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 166,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 166,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 166,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 166,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 166,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 166,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 166,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 166,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 166,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 166,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 166,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 166,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 166,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 166,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 166,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 166,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 166,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 166,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 166,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 166,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 166,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 166,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 166,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 166,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 166,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 166,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 166,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 166,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 166,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 166,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 166,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 166,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 166,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 166,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 166,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 166,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 166,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 166,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 166,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 166,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 166,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 166,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 166,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 166,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 166,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 166,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 166,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 166,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 166,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 166,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 166,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 166,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 166,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 166,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 166,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 166,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 166,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 166,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02hx07 = {
  C: {
    templateId: 387,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 387,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 387,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 387,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 387,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 387,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 387,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 387,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 387,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 387,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 387,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 387,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 387,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 387,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 387,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 387,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 387,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 387,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 387,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 387,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 387,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 387,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 387,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 387,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 387,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 387,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 387,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 387,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 387,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 387,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 387,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 387,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 387,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 387,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 387,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 387,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 387,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 387,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 387,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 387,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 387,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 387,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 387,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 387,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 387,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 387,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 387,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 387,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 387,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 387,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 387,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 387,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 387,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 387,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 387,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 387,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 387,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 387,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 387,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 387,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 387,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 387,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 387,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 387,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 387,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 387,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 387,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02hx08 = {
  C: {
    templateId: 151,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 151,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 151,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 151,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 151,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 151,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 151,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 151,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 151,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 151,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 151,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 151,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 151,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 151,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 151,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 151,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 151,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 151,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 151,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 151,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 151,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 151,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 151,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 151,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 151,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 151,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 151,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 151,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 151,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 151,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 151,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 151,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 151,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 151,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 151,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 151,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 151,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 151,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 151,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 151,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 151,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 151,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 151,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 151,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 151,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 151,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 151,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 151,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 151,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 151,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 151,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 151,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 151,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 151,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 151,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 151,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 151,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 151,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 151,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 151,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 151,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 151,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 151,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 151,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 151,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 151,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 151,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02hx09 = {
  C: {
    templateId: 401,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 401,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 401,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 401,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 401,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 401,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 401,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 401,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 401,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 401,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 401,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 401,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 401,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 401,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 401,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 401,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 401,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 401,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 401,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 401,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 401,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 401,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 401,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 401,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 401,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 401,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 401,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 401,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 401,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 401,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 401,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 401,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 401,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 401,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 401,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 401,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 401,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 401,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 401,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 401,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 401,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 401,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 401,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 401,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 401,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 401,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 401,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 401,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 401,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 401,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 401,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 401,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 401,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 401,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 401,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 401,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 401,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 401,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 401,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 401,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 401,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 401,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 401,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 401,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 401,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 401,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 401,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02hx12 = {
  C: {
    templateId: 152,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 152,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 152,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 152,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 152,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 152,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 152,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 152,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 152,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 152,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 152,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 152,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 152,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 152,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 152,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 152,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 152,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 152,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 152,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 152,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 152,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 152,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 152,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 152,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 152,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 152,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 152,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 152,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 152,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 152,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 152,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 152,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 152,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 152,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 152,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 152,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 152,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 152,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 152,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 152,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 152,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 152,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 152,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 152,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 152,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 152,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 152,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 152,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 152,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 152,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 152,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 152,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 152,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 152,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 152,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 152,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 152,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 152,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 152,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 152,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 152,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 152,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 152,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 152,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 152,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 152,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 152,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02hx16 = {
  C: {
    templateId: 105,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 105,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 105,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 105,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 105,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 105,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 105,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 105,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 105,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 105,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 105,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 105,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 105,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 105,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 105,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 105,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 105,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 105,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 105,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 105,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 105,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 105,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 105,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 105,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 105,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 105,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 105,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 105,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 105,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 105,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 105,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 105,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 105,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 105,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 105,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 105,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 105,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 105,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 105,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 105,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 105,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 105,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 105,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 105,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 105,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 105,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 105,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 105,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 105,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 105,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 105,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 105,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 105,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 105,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 105,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 105,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 105,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 105,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 105,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 105,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 105,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 105,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 105,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 105,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 105,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 105,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 105,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02hx16_Grain = {
  C: {
    templateId: 487,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 487,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 487,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 487,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 487,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 487,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 487,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 487,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 487,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 487,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 487,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 487,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 487,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 487,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 487,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 487,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 487,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 487,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 487,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 487,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 487,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 487,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 487,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 487,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 487,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 487,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 487,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 487,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 487,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 487,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 487,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 487,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 487,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 487,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 487,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 487,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 487,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 487,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 487,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 487,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 487,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 487,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 487,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 487,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 487,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 487,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 487,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 487,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 487,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 487,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 487,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 487,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 487,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 487,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 487,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 487,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 487,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 487,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 487,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 487,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 487,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 487,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 487,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 487,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 487,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 487,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 487,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02hx20 = {
  C: {
    templateId: 242,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 242,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 242,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 242,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 242,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 242,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 242,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 242,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 242,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 242,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 242,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 242,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 242,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 242,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 242,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 242,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 242,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 242,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 242,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 242,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 242,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 242,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 242,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 242,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 242,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 242,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 242,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 242,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 242,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 242,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 242,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 242,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 242,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 242,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 242,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 242,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 242,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 242,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 242,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 242,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 242,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 242,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 242,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 242,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 242,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 242,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 242,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 242,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 242,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 242,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 242,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 242,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 242,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 242,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 242,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 242,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 242,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 242,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 242,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 242,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 242,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 242,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 242,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 242,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 242,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 242,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 242,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02hx24 = {
  C: {
    templateId: 167,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 167,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 167,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 167,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 167,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 167,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 167,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 167,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 167,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 167,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 167,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 167,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 167,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 167,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 167,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 167,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 167,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 167,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 167,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 167,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 167,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 167,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 167,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 167,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 167,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 167,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 167,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 167,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 167,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 167,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 167,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 167,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 167,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 167,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 167,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 167,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 167,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 167,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 167,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 167,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 167,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 167,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 167,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 167,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 167,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 167,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 167,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 167,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 167,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 167,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 167,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 167,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 167,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 167,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 167,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 167,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 167,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 167,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 167,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 167,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 167,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 167,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 167,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 167,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 167,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 167,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 167,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02hx36 = {
  C: {
    templateId: 431,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 431,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 431,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 431,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 431,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 431,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 431,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 431,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 431,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 431,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 431,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 431,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 431,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 431,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 431,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 431,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 431,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 431,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 431,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 431,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 431,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 431,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 431,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 431,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 431,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 431,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 431,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 431,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 431,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 431,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 431,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 431,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 431,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 431,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 431,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 431,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 431,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 431,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 431,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 431,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 431,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 431,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 431,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 431,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 431,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 431,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 431,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 431,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 431,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 431,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 431,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 431,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 431,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 431,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 431,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 431,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 431,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 431,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 431,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 431,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 431,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 431,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 431,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 431,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 431,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 431,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 431,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02hx48 = {
  C: {
    templateId: 168,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 168,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 168,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 168,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 168,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 168,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 168,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 168,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 168,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 168,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 168,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 168,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 168,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 168,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 168,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 168,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 168,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 168,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 168,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 168,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 168,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 168,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 168,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 168,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 168,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 168,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 168,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 168,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 168,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 168,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 168,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 168,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 168,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 168,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 168,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 168,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 168,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 168,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 168,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 168,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 168,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 168,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 168,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 168,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 168,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 168,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 168,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 168,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 168,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 168,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 168,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 168,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 168,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 168,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 168,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 168,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 168,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 168,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 168,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 168,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 168,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 168,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 168,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 168,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 168,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 168,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 168,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02x07 = {
  C: {
    templateId: 388,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 388,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 388,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 388,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 388,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 388,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 388,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 388,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 388,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 388,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 388,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 388,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 388,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 388,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 388,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 388,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 388,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 388,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 388,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 388,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 388,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 388,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 388,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 388,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 388,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 388,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 388,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 388,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 388,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 388,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 388,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 388,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 388,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 388,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 388,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 388,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 388,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 388,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 388,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 388,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 388,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 388,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 388,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 388,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 388,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 388,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 388,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 388,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 388,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 388,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 388,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 388,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 388,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 388,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 388,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 388,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 388,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 388,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 388,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 388,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 388,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 388,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 388,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 388,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 388,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 388,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 388,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02x08 = {
  C: {
    templateId: 169,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 169,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 169,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 169,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 169,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 169,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 169,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 169,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 169,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 169,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 169,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 169,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 169,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 169,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 169,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 169,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 169,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 169,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 169,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 169,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 169,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 169,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 169,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 169,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 169,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 169,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 169,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 169,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 169,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 169,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 169,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 169,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 169,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 169,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 169,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 169,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 169,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 169,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 169,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 169,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 169,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 169,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 169,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 169,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 169,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 169,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 169,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 169,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 169,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 169,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 169,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 169,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 169,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 169,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 169,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 169,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 169,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 169,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 169,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 169,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 169,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 169,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 169,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 169,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 169,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 169,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 169,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02x12 = {
  C: {
    templateId: 43,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 43,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 43,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 43,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 43,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 43,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 43,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 43,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 43,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 43,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 43,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 43,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 43,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 43,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 43,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 43,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 43,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 43,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 43,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 43,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 43,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 43,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 43,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 43,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 43,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 43,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 43,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 43,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 43,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 43,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 43,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 43,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 43,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 43,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 43,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 43,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 43,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 43,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 43,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 43,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 43,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 43,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 43,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 43,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 43,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 43,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 43,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 43,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 43,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 43,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 43,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 43,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 43,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 43,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 43,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 43,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 43,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 43,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 43,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 43,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 43,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 43,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 43,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 43,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 43,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 43,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 43,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02x16 = {
  C: {
    templateId: 139,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 139,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 139,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 139,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 139,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 139,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 139,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 139,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 139,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 139,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 139,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 139,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 139,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 139,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 139,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 139,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 139,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 139,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 139,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 139,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 139,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 139,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 139,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 139,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 139,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 139,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 139,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 139,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 139,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 139,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 139,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 139,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 139,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 139,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 139,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 139,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 139,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 139,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 139,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 139,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 139,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 139,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 139,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 139,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 139,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 139,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 139,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 139,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 139,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 139,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 139,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 139,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 139,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 139,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 139,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 139,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 139,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 139,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 139,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 139,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 139,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 139,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 139,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 139,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 139,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 139,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 139,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02x16_Grain = {
  C: {
    templateId: 138,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 138,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 138,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 138,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 138,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 138,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 138,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 138,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 138,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 138,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 138,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 138,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 138,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 138,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 138,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 138,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 138,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 138,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 138,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 138,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 138,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 138,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 138,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 138,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 138,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 138,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 138,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 138,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 138,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 138,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 138,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 138,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 138,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 138,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 138,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 138,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 138,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 138,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 138,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 138,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 138,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 138,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 138,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 138,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 138,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 138,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 138,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 138,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 138,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 138,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 138,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 138,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 138,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 138,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 138,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 138,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 138,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 138,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 138,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 138,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 138,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 138,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 138,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 138,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 138,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 138,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 138,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02x20 = {
  C: {
    templateId: 243,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 243,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 243,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 243,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 243,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 243,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 243,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 243,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 243,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 243,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 243,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 243,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 243,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 243,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 243,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 243,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 243,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 243,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 243,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 243,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 243,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 243,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 243,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 243,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 243,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 243,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 243,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 243,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 243,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 243,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 243,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 243,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 243,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 243,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 243,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 243,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 243,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 243,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 243,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 243,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 243,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 243,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 243,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 243,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 243,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 243,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 243,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 243,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 243,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 243,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 243,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 243,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 243,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 243,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 243,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 243,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 243,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 243,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 243,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 243,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 243,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 243,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 243,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 243,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 243,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 243,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 243,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02x24 = {
  C: {
    templateId: 170,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 170,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 170,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 170,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 170,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 170,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 170,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 170,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 170,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 170,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 170,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 170,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 170,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 170,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 170,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 170,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 170,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 170,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 170,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 170,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 170,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 170,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 170,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 170,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 170,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 170,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 170,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 170,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 170,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 170,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 170,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 170,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 170,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 170,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 170,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 170,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 170,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 170,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 170,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 170,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 170,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 170,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 170,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 170,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 170,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 170,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 170,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 170,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 170,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 170,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 170,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 170,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 170,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 170,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 170,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 170,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 170,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 170,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 170,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 170,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 170,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 170,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 170,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 170,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 170,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 170,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 170,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02x36 = {
  C: {
    templateId: 432,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 432,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 432,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 432,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 432,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 432,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 432,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 432,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 432,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 432,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 432,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 432,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 432,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 432,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 432,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 432,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 432,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 432,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 432,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 432,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 432,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 432,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 432,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 432,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 432,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 432,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 432,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 432,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 432,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 432,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 432,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 432,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 432,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 432,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 432,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 432,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 432,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 432,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 432,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 432,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 432,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 432,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 432,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 432,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 432,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 432,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 432,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 432,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 432,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 432,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 432,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 432,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 432,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 432,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 432,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 432,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 432,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 432,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 432,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 432,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 432,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 432,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 432,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 432,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 432,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 432,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 432,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten02x48 = {
  C: {
    templateId: 171,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 171,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 171,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 171,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 171,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 171,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 171,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 171,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 171,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 171,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 171,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 171,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 171,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 171,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 171,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 171,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 171,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 171,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 171,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 171,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 171,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 171,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 171,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 171,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 171,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 171,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 171,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 171,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 171,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 171,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 171,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 171,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 171,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 171,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 171,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 171,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 171,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 171,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 171,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 171,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 171,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 171,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 171,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 171,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 171,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 171,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 171,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 171,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 171,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 171,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 171,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 171,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 171,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 171,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 171,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 171,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 171,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 171,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 171,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 171,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 171,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 171,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 171,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 171,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 171,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 171,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 171,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03hx07 = {
  C: {
    templateId: 389,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 389,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 389,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 389,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 389,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 389,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 389,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 389,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 389,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 389,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 389,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 389,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 389,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 389,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 389,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 389,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 389,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 389,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 389,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 389,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 389,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 389,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 389,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 389,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 389,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 389,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 389,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 389,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 389,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 389,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 389,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 389,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 389,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 389,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 389,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 389,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 389,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 389,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 389,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 389,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 389,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 389,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 389,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 389,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 389,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 389,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 389,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 389,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 389,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 389,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 389,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 389,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 389,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 389,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 389,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 389,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 389,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 389,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 389,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 389,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 389,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 389,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 389,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 389,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 389,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 389,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 389,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03hx08 = {
  C: {
    templateId: 172,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 172,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 172,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 172,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 172,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 172,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 172,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 172,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 172,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 172,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 172,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 172,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 172,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 172,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 172,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 172,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 172,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 172,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 172,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 172,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 172,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 172,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 172,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 172,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 172,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 172,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 172,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 172,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 172,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 172,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 172,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 172,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 172,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 172,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 172,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 172,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 172,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 172,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 172,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 172,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 172,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 172,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 172,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 172,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 172,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 172,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 172,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 172,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 172,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 172,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 172,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 172,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 172,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 172,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 172,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 172,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 172,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 172,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 172,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 172,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 172,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 172,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 172,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 172,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 172,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 172,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 172,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03hx12 = {
  C: {
    templateId: 173,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 173,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 173,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 173,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 173,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 173,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 173,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 173,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 173,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 173,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 173,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 173,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 173,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 173,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 173,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 173,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 173,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 173,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 173,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 173,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 173,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 173,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 173,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 173,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 173,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 173,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 173,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 173,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 173,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 173,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 173,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 173,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 173,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 173,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 173,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 173,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 173,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 173,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 173,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 173,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 173,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 173,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 173,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 173,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 173,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 173,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 173,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 173,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 173,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 173,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 173,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 173,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 173,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 173,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 173,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 173,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 173,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 173,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 173,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 173,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 173,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 173,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 173,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 173,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 173,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 173,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 173,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03hx16 = {
  C: {
    templateId: 174,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 174,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 174,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 174,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 174,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 174,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 174,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 174,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 174,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 174,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 174,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 174,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 174,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 174,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 174,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 174,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 174,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 174,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 174,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 174,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 174,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 174,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 174,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 174,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 174,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 174,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 174,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 174,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 174,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 174,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 174,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 174,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 174,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 174,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 174,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 174,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 174,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 174,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 174,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 174,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 174,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 174,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 174,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 174,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 174,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 174,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 174,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 174,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 174,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 174,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 174,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 174,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 174,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 174,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 174,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 174,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 174,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 174,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 174,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 174,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 174,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 174,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 174,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 174,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 174,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 174,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 174,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03hx20 = {
  C: {
    templateId: 244,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 244,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 244,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 244,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 244,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 244,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 244,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 244,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 244,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 244,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 244,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 244,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 244,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 244,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 244,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 244,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 244,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 244,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 244,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 244,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 244,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 244,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 244,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 244,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 244,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 244,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 244,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 244,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 244,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 244,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 244,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 244,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 244,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 244,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 244,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 244,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 244,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 244,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 244,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 244,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 244,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 244,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 244,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 244,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 244,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 244,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 244,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 244,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 244,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 244,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 244,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 244,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 244,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 244,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 244,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 244,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 244,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 244,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 244,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 244,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 244,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 244,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 244,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 244,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 244,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 244,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 244,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03hx24 = {
  C: {
    templateId: 175,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 175,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 175,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 175,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 175,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 175,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 175,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 175,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 175,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 175,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 175,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 175,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 175,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 175,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 175,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 175,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 175,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 175,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 175,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 175,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 175,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 175,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 175,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 175,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 175,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 175,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 175,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 175,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 175,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 175,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 175,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 175,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 175,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 175,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 175,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 175,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 175,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 175,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 175,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 175,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 175,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 175,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 175,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 175,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 175,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 175,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 175,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 175,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 175,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 175,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 175,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 175,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 175,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 175,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 175,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 175,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 175,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 175,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 175,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 175,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 175,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 175,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 175,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 175,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 175,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 175,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 175,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03hx36 = {
  C: {
    templateId: 433,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 433,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 433,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 433,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 433,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 433,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 433,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 433,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 433,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 433,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 433,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 433,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 433,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 433,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 433,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 433,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 433,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 433,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 433,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 433,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 433,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 433,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 433,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 433,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 433,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 433,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 433,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 433,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 433,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 433,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 433,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 433,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 433,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 433,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 433,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 433,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 433,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 433,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 433,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 433,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 433,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 433,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 433,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 433,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 433,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 433,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 433,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 433,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 433,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 433,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 433,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 433,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 433,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 433,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 433,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 433,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 433,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 433,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 433,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 433,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 433,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 433,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 433,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 433,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 433,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 433,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 433,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03hx48 = {
  C: {
    templateId: 176,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 176,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 176,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 176,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 176,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 176,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 176,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 176,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 176,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 176,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 176,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 176,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 176,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 176,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 176,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 176,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 176,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 176,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 176,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 176,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 176,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 176,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 176,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 176,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 176,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 176,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 176,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 176,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 176,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 176,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 176,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 176,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 176,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 176,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 176,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 176,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 176,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 176,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 176,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 176,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 176,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 176,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 176,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 176,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 176,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 176,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 176,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 176,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 176,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 176,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 176,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 176,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 176,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 176,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 176,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 176,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 176,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 176,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 176,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 176,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 176,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 176,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 176,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 176,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 176,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 176,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 176,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03x07 = {
  C: {
    templateId: 390,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 390,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 390,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 390,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 390,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 390,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 390,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 390,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 390,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 390,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 390,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 390,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 390,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 390,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 390,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 390,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 390,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 390,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 390,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 390,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 390,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 390,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 390,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 390,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 390,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 390,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 390,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 390,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 390,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 390,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 390,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 390,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 390,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 390,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 390,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 390,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 390,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 390,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 390,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 390,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 390,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 390,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 390,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 390,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 390,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 390,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 390,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 390,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 390,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 390,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 390,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 390,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 390,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 390,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 390,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 390,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 390,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 390,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 390,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 390,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 390,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 390,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 390,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 390,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 390,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 390,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 390,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03x08 = {
  C: {
    templateId: 117,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 117,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 117,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 117,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 117,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 117,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 117,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 117,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 117,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 117,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 117,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 117,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 117,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 117,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 117,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 117,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 117,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 117,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 117,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 117,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 117,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 117,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 117,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 117,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 117,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 117,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 117,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 117,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 117,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 117,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 117,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 117,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 117,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 117,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 117,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 117,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 117,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 117,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 117,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 117,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 117,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 117,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 117,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 117,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 117,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 117,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 117,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 117,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 117,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 117,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 117,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 117,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 117,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 117,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 117,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 117,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 117,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 117,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 117,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 117,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 117,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 117,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 117,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 117,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 117,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 117,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 117,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03x12 = {
  C: {
    templateId: 177,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 177,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 177,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 177,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 177,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 177,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 177,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 177,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 177,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 177,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 177,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 177,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 177,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 177,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 177,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 177,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 177,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 177,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 177,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 177,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 177,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 177,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 177,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 177,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 177,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 177,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 177,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 177,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 177,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 177,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 177,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 177,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 177,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 177,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 177,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 177,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 177,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 177,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 177,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 177,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 177,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 177,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 177,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 177,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 177,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 177,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 177,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 177,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 177,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 177,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 177,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 177,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 177,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 177,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 177,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 177,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 177,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 177,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 177,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 177,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 177,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 177,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 177,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 177,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 177,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 177,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 177,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03x16 = {
  C: {
    templateId: 178,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 178,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 178,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 178,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 178,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 178,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 178,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 178,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 178,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 178,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 178,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 178,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 178,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 178,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 178,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 178,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 178,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 178,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 178,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 178,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 178,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 178,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 178,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 178,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 178,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 178,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 178,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 178,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 178,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 178,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 178,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 178,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 178,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 178,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 178,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 178,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 178,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 178,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 178,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 178,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 178,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 178,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 178,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 178,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 178,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 178,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 178,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 178,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 178,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 178,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 178,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 178,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 178,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 178,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 178,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 178,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 178,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 178,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 178,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 178,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 178,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 178,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 178,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 178,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 178,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 178,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 178,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03x20 = {
  C: {
    templateId: 245,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 245,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 245,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 245,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 245,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 245,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 245,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 245,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 245,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 245,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 245,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 245,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 245,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 245,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 245,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 245,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 245,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 245,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 245,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 245,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 245,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 245,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 245,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 245,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 245,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 245,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 245,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 245,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 245,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 245,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 245,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 245,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 245,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 245,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 245,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 245,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 245,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 245,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 245,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 245,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 245,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 245,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 245,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 245,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 245,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 245,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 245,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 245,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 245,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 245,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 245,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 245,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 245,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 245,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 245,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 245,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 245,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 245,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 245,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 245,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 245,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 245,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 245,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 245,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 245,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 245,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 245,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03x24 = {
  C: {
    templateId: 179,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 179,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 179,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 179,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 179,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 179,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 179,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 179,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 179,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 179,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 179,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 179,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 179,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 179,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 179,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 179,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 179,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 179,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 179,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 179,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 179,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 179,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 179,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 179,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 179,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 179,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 179,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 179,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 179,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 179,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 179,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 179,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 179,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 179,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 179,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 179,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 179,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 179,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 179,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 179,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 179,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 179,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 179,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 179,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 179,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 179,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 179,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 179,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 179,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 179,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 179,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 179,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 179,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 179,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 179,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 179,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 179,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 179,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 179,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 179,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 179,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 179,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 179,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 179,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 179,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 179,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 179,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03x36 = {
  C: {
    templateId: 434,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 434,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 434,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 434,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 434,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 434,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 434,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 434,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 434,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 434,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 434,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 434,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 434,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 434,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 434,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 434,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 434,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 434,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 434,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 434,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 434,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 434,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 434,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 434,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 434,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 434,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 434,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 434,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 434,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 434,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 434,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 434,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 434,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 434,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 434,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 434,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 434,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 434,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 434,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 434,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 434,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 434,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 434,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 434,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 434,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 434,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 434,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 434,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 434,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 434,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 434,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 434,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 434,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 434,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 434,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 434,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 434,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 434,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 434,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 434,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 434,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 434,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 434,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 434,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 434,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 434,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 434,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten03x48 = {
  C: {
    templateId: 118,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 118,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 118,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 118,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 118,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 118,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 118,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 118,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 118,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 118,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 118,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 118,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 118,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 118,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 118,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 118,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 118,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 118,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 118,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 118,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 118,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 118,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 118,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 118,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 118,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 118,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 118,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 118,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 118,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 118,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 118,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 118,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 118,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 118,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 118,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 118,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 118,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 118,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 118,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 118,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 118,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 118,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 118,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 118,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 118,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 118,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 118,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 118,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 118,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 118,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 118,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 118,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 118,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 118,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 118,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 118,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 118,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 118,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 118,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 118,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 118,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 118,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 118,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 118,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 118,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 118,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 118,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04hx07 = {
  C: {
    templateId: 391,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 391,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 391,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 391,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 391,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 391,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 391,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 391,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 391,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 391,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 391,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 391,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 391,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 391,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 391,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 391,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 391,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 391,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 391,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 391,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 391,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 391,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 391,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 391,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 391,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 391,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 391,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 391,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 391,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 391,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 391,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 391,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 391,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 391,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 391,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 391,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 391,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 391,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 391,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 391,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 391,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 391,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 391,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 391,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 391,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 391,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 391,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 391,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 391,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 391,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 391,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 391,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 391,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 391,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 391,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 391,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 391,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 391,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 391,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 391,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 391,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 391,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 391,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 391,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 391,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 391,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 391,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04hx08 = {
  C: {
    templateId: 180,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 180,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 180,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 180,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 180,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 180,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 180,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 180,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 180,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 180,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 180,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 180,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 180,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 180,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 180,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 180,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 180,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 180,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 180,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 180,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 180,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 180,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 180,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 180,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 180,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 180,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 180,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 180,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 180,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 180,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 180,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 180,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 180,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 180,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 180,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 180,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 180,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 180,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 180,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 180,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 180,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 180,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 180,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 180,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 180,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 180,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 180,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 180,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 180,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 180,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 180,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 180,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 180,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 180,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 180,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 180,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 180,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 180,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 180,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 180,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 180,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 180,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 180,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 180,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 180,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 180,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 180,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04hx12 = {
  C: {
    templateId: 181,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 181,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 181,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 181,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 181,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 181,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 181,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 181,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 181,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 181,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 181,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 181,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 181,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 181,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 181,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 181,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 181,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 181,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 181,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 181,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 181,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 181,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 181,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 181,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 181,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 181,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 181,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 181,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 181,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 181,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 181,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 181,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 181,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 181,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 181,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 181,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 181,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 181,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 181,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 181,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 181,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 181,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 181,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 181,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 181,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 181,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 181,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 181,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 181,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 181,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 181,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 181,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 181,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 181,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 181,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 181,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 181,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 181,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 181,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 181,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 181,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 181,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 181,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 181,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 181,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 181,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 181,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04hx16 = {
  C: {
    templateId: 182,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 182,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 182,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 182,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 182,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 182,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 182,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 182,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 182,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 182,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 182,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 182,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 182,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 182,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 182,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 182,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 182,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 182,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 182,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 182,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 182,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 182,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 182,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 182,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 182,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 182,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 182,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 182,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 182,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 182,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 182,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 182,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 182,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 182,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 182,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 182,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 182,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 182,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 182,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 182,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 182,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 182,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 182,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 182,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 182,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 182,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 182,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 182,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 182,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 182,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 182,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 182,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 182,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 182,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 182,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 182,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 182,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 182,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 182,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 182,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 182,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 182,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 182,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 182,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 182,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 182,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 182,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04hx20 = {
  C: {
    templateId: 246,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 246,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 246,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 246,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 246,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 246,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 246,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 246,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 246,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 246,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 246,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 246,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 246,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 246,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 246,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 246,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 246,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 246,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 246,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 246,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 246,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 246,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 246,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 246,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 246,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 246,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 246,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 246,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 246,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 246,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 246,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 246,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 246,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 246,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 246,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 246,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 246,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 246,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 246,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 246,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 246,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 246,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 246,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 246,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 246,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 246,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 246,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 246,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 246,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 246,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 246,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 246,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 246,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 246,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 246,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 246,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 246,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 246,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 246,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 246,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 246,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 246,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 246,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 246,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 246,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 246,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 246,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04hx24 = {
  C: {
    templateId: 183,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 183,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 183,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 183,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 183,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 183,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 183,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 183,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 183,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 183,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 183,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 183,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 183,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 183,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 183,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 183,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 183,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 183,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 183,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 183,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 183,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 183,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 183,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 183,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 183,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 183,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 183,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 183,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 183,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 183,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 183,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 183,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 183,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 183,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 183,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 183,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 183,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 183,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 183,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 183,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 183,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 183,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 183,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 183,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 183,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 183,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 183,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 183,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 183,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 183,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 183,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 183,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 183,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 183,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 183,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 183,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 183,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 183,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 183,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 183,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 183,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 183,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 183,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 183,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 183,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 183,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 183,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04hx36 = {
  C: {
    templateId: 435,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 435,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 435,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 435,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 435,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 435,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 435,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 435,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 435,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 435,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 435,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 435,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 435,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 435,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 435,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 435,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 435,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 435,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 435,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 435,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 435,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 435,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 435,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 435,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 435,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 435,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 435,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 435,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 435,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 435,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 435,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 435,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 435,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 435,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 435,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 435,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 435,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 435,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 435,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 435,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 435,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 435,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 435,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 435,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 435,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 435,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 435,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 435,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 435,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 435,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 435,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 435,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 435,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 435,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 435,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 435,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 435,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 435,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 435,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 435,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 435,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 435,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 435,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 435,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 435,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 435,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 435,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04hx48 = {
  C: {
    templateId: 184,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 184,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 184,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 184,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 184,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 184,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 184,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 184,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 184,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 184,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 184,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 184,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 184,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 184,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 184,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 184,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 184,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 184,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 184,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 184,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 184,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 184,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 184,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 184,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 184,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 184,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 184,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 184,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 184,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 184,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 184,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 184,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 184,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 184,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 184,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 184,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 184,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 184,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 184,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 184,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 184,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 184,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 184,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 184,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 184,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 184,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 184,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 184,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 184,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 184,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 184,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 184,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 184,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 184,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 184,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 184,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 184,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 184,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 184,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 184,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 184,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 184,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 184,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 184,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 184,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 184,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 184,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04x07 = {
  C: {
    templateId: 392,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 392,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 392,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 392,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 392,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 392,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 392,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 392,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 392,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 392,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 392,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 392,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 392,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 392,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 392,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 392,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 392,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 392,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 392,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 392,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 392,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 392,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 392,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 392,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 392,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 392,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 392,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 392,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 392,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 392,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 392,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 392,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 392,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 392,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 392,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 392,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 392,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 392,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 392,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 392,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 392,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 392,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 392,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 392,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 392,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 392,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 392,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 392,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 392,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 392,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 392,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 392,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 392,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 392,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 392,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 392,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 392,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 392,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 392,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 392,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 392,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 392,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 392,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 392,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 392,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 392,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 392,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04x08 = {
  C: {
    templateId: 185,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 185,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 185,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 185,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 185,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 185,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 185,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 185,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 185,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 185,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 185,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 185,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 185,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 185,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 185,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 185,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 185,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 185,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 185,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 185,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 185,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 185,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 185,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 185,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 185,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 185,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 185,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 185,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 185,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 185,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 185,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 185,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 185,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 185,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 185,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 185,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 185,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 185,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 185,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 185,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 185,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 185,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 185,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 185,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 185,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 185,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 185,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 185,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 185,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 185,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 185,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 185,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 185,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 185,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 185,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 185,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 185,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 185,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 185,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 185,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 185,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 185,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 185,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 185,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 185,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 185,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 185,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04x12 = {
  C: {
    templateId: 186,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 186,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 186,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 186,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 186,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 186,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 186,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 186,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 186,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 186,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 186,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 186,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 186,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 186,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 186,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 186,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 186,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 186,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 186,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 186,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 186,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 186,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 186,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 186,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 186,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 186,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 186,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 186,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 186,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 186,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 186,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 186,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 186,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 186,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 186,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 186,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 186,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 186,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 186,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 186,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 186,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 186,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 186,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 186,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 186,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 186,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 186,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 186,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 186,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 186,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 186,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 186,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 186,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 186,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 186,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 186,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 186,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 186,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 186,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 186,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 186,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 186,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 186,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 186,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 186,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 186,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 186,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04x16 = {
  C: {
    templateId: 187,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 187,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 187,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 187,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 187,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 187,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 187,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 187,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 187,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 187,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 187,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 187,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 187,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 187,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 187,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 187,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 187,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 187,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 187,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 187,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 187,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 187,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 187,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 187,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 187,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 187,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 187,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 187,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 187,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 187,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 187,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 187,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 187,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 187,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 187,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 187,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 187,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 187,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 187,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 187,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 187,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 187,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 187,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 187,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 187,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 187,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 187,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 187,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 187,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 187,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 187,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 187,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 187,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 187,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 187,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 187,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 187,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 187,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 187,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 187,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 187,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 187,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 187,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 187,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 187,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 187,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 187,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04x20 = {
  C: {
    templateId: 247,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 247,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 247,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 247,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 247,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 247,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 247,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 247,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 247,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 247,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 247,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 247,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 247,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 247,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 247,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 247,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 247,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 247,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 247,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 247,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 247,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 247,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 247,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 247,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 247,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 247,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 247,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 247,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 247,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 247,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 247,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 247,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 247,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 247,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 247,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 247,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 247,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 247,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 247,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 247,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 247,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 247,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 247,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 247,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 247,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 247,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 247,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 247,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 247,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 247,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 247,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 247,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 247,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 247,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 247,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 247,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 247,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 247,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 247,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 247,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 247,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 247,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 247,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 247,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 247,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 247,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 247,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04x24 = {
  C: {
    templateId: 188,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 188,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 188,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 188,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 188,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 188,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 188,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 188,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 188,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 188,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 188,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 188,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 188,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 188,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 188,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 188,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 188,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 188,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 188,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 188,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 188,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 188,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 188,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 188,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 188,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 188,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 188,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 188,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 188,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 188,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 188,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 188,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 188,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 188,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 188,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 188,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 188,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 188,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 188,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 188,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 188,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 188,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 188,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 188,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 188,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 188,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 188,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 188,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 188,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 188,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 188,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 188,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 188,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 188,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 188,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 188,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 188,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 188,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 188,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 188,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 188,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 188,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 188,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 188,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 188,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 188,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 188,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04x36 = {
  C: {
    templateId: 436,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 436,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 436,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 436,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 436,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 436,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 436,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 436,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 436,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 436,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 436,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 436,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 436,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 436,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 436,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 436,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 436,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 436,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 436,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 436,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 436,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 436,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 436,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 436,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 436,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 436,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 436,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 436,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 436,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 436,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 436,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 436,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 436,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 436,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 436,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 436,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 436,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 436,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 436,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 436,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 436,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 436,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 436,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 436,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 436,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 436,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 436,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 436,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 436,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 436,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 436,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 436,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 436,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 436,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 436,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 436,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 436,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 436,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 436,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 436,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 436,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 436,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 436,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 436,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 436,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 436,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 436,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten04x48 = {
  C: {
    templateId: 189,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 189,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 189,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 189,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 189,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 189,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 189,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 189,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 189,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 189,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 189,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 189,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 189,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 189,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 189,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 189,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 189,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 189,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 189,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 189,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 189,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 189,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 189,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 189,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 189,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 189,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 189,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 189,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 189,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 189,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 189,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 189,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 189,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 189,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 189,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 189,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 189,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 189,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 189,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 189,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 189,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 189,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 189,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 189,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 189,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 189,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 189,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 189,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 189,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 189,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 189,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 189,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 189,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 189,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 189,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 189,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 189,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 189,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 189,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 189,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 189,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 189,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 189,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 189,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 189,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 189,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 189,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05hx07 = {
  C: {
    templateId: 393,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 393,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 393,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 393,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 393,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 393,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 393,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 393,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 393,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 393,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 393,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 393,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 393,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 393,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 393,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 393,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 393,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 393,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 393,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 393,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 393,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 393,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 393,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 393,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 393,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 393,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 393,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 393,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 393,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 393,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 393,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 393,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 393,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 393,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 393,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 393,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 393,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 393,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 393,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 393,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 393,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 393,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 393,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 393,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 393,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 393,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 393,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 393,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 393,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 393,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 393,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 393,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 393,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 393,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 393,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 393,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 393,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 393,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 393,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 393,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 393,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 393,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 393,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 393,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 393,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 393,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 393,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05hx08 = {
  C: {
    templateId: 190,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 190,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 190,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 190,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 190,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 190,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 190,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 190,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 190,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 190,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 190,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 190,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 190,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 190,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 190,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 190,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 190,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 190,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 190,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 190,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 190,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 190,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 190,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 190,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 190,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 190,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 190,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 190,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 190,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 190,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 190,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 190,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 190,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 190,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 190,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 190,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 190,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 190,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 190,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 190,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 190,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 190,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 190,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 190,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 190,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 190,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 190,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 190,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 190,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 190,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 190,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 190,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 190,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 190,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 190,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 190,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 190,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 190,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 190,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 190,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 190,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 190,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 190,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 190,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 190,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 190,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 190,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05hx12 = {
  C: {
    templateId: 191,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 191,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 191,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 191,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 191,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 191,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 191,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 191,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 191,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 191,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 191,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 191,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 191,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 191,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 191,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 191,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 191,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 191,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 191,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 191,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 191,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 191,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 191,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 191,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 191,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 191,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 191,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 191,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 191,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 191,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 191,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 191,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 191,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 191,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 191,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 191,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 191,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 191,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 191,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 191,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 191,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 191,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 191,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 191,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 191,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 191,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 191,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 191,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 191,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 191,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 191,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 191,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 191,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 191,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 191,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 191,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 191,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 191,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 191,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 191,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 191,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 191,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 191,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 191,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 191,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 191,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 191,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05hx16 = {
  C: {
    templateId: 192,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 192,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 192,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 192,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 192,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 192,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 192,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 192,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 192,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 192,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 192,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 192,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 192,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 192,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 192,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 192,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 192,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 192,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 192,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 192,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 192,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 192,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 192,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 192,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 192,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 192,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 192,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 192,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 192,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 192,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 192,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 192,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 192,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 192,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 192,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 192,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 192,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 192,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 192,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 192,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 192,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 192,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 192,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 192,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 192,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 192,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 192,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 192,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 192,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 192,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 192,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 192,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 192,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 192,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 192,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 192,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 192,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 192,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 192,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 192,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 192,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 192,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 192,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 192,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 192,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 192,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 192,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05hx20 = {
  C: {
    templateId: 248,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 248,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 248,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 248,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 248,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 248,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 248,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 248,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 248,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 248,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 248,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 248,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 248,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 248,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 248,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 248,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 248,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 248,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 248,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 248,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 248,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 248,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 248,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 248,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 248,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 248,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 248,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 248,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 248,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 248,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 248,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 248,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 248,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 248,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 248,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 248,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 248,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 248,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 248,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 248,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 248,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 248,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 248,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 248,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 248,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 248,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 248,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 248,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 248,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 248,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 248,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 248,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 248,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 248,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 248,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 248,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 248,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 248,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 248,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 248,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 248,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 248,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 248,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 248,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 248,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 248,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 248,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05hx24 = {
  C: {
    templateId: 193,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 193,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 193,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 193,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 193,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 193,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 193,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 193,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 193,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 193,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 193,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 193,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 193,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 193,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 193,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 193,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 193,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 193,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 193,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 193,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 193,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 193,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 193,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 193,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 193,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 193,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 193,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 193,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 193,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 193,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 193,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 193,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 193,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 193,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 193,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 193,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 193,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 193,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 193,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 193,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 193,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 193,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 193,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 193,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 193,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 193,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 193,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 193,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 193,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 193,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 193,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 193,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 193,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 193,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 193,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 193,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 193,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 193,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 193,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 193,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 193,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 193,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 193,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 193,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 193,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 193,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 193,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05hx36 = {
  C: {
    templateId: 437,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 437,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 437,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 437,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 437,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 437,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 437,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 437,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 437,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 437,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 437,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 437,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 437,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 437,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 437,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 437,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 437,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 437,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 437,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 437,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 437,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 437,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 437,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 437,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 437,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 437,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 437,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 437,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 437,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 437,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 437,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 437,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 437,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 437,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 437,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 437,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 437,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 437,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 437,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 437,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 437,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 437,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 437,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 437,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 437,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 437,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 437,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 437,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 437,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 437,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 437,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 437,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 437,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 437,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 437,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 437,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 437,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 437,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 437,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 437,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 437,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 437,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 437,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 437,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 437,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 437,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 437,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05hx48 = {
  C: {
    templateId: 194,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 194,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 194,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 194,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 194,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 194,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 194,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 194,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 194,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 194,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 194,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 194,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 194,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 194,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 194,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 194,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 194,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 194,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 194,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 194,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 194,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 194,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 194,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 194,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 194,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 194,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 194,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 194,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 194,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 194,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 194,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 194,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 194,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 194,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 194,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 194,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 194,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 194,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 194,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 194,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 194,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 194,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 194,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 194,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 194,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 194,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 194,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 194,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 194,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 194,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 194,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 194,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 194,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 194,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 194,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 194,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 194,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 194,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 194,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 194,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 194,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 194,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 194,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 194,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 194,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 194,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 194,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05x07 = {
  C: {
    templateId: 394,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 394,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 394,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 394,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 394,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 394,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 394,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 394,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 394,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 394,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 394,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 394,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 394,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 394,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 394,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 394,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 394,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 394,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 394,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 394,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 394,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 394,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 394,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 394,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 394,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 394,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 394,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 394,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 394,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 394,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 394,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 394,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 394,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 394,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 394,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 394,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 394,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 394,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 394,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 394,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 394,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 394,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 394,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 394,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 394,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 394,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 394,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 394,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 394,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 394,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 394,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 394,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 394,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 394,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 394,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 394,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 394,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 394,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 394,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 394,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 394,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 394,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 394,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 394,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 394,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 394,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 394,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05x08 = {
  C: {
    templateId: 195,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 195,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 195,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 195,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 195,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 195,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 195,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 195,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 195,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 195,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 195,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 195,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 195,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 195,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 195,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 195,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 195,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 195,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 195,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 195,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 195,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 195,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 195,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 195,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 195,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 195,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 195,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 195,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 195,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 195,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 195,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 195,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 195,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 195,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 195,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 195,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 195,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 195,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 195,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 195,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 195,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 195,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 195,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 195,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 195,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 195,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 195,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 195,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 195,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 195,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 195,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 195,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 195,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 195,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 195,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 195,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 195,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 195,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 195,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 195,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 195,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 195,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 195,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 195,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 195,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 195,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 195,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05x12 = {
  C: {
    templateId: 196,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 196,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 196,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 196,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 196,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 196,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 196,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 196,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 196,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 196,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 196,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 196,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 196,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 196,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 196,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 196,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 196,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 196,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 196,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 196,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 196,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 196,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 196,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 196,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 196,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 196,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 196,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 196,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 196,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 196,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 196,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 196,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 196,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 196,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 196,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 196,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 196,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 196,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 196,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 196,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 196,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 196,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 196,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 196,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 196,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 196,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 196,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 196,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 196,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 196,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 196,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 196,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 196,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 196,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 196,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 196,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 196,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 196,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 196,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 196,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 196,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 196,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 196,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 196,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 196,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 196,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 196,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05x16 = {
  C: {
    templateId: 197,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 197,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 197,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 197,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 197,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 197,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 197,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 197,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 197,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 197,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 197,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 197,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 197,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 197,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 197,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 197,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 197,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 197,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 197,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 197,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 197,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 197,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 197,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 197,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 197,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 197,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 197,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 197,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 197,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 197,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 197,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 197,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 197,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 197,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 197,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 197,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 197,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 197,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 197,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 197,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 197,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 197,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 197,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 197,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 197,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 197,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 197,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 197,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 197,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 197,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 197,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 197,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 197,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 197,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 197,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 197,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 197,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 197,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 197,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 197,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 197,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 197,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 197,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 197,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 197,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 197,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 197,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05x20 = {
  C: {
    templateId: 249,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 249,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 249,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 249,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 249,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 249,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 249,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 249,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 249,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 249,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 249,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 249,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 249,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 249,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 249,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 249,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 249,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 249,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 249,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 249,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 249,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 249,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 249,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 249,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 249,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 249,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 249,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 249,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 249,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 249,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 249,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 249,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 249,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 249,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 249,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 249,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 249,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 249,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 249,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 249,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 249,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 249,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 249,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 249,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 249,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 249,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 249,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 249,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 249,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 249,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 249,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 249,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 249,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 249,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 249,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 249,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 249,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 249,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 249,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 249,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 249,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 249,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 249,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 249,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 249,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 249,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 249,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05x24 = {
  C: {
    templateId: 198,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 198,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 198,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 198,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 198,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 198,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 198,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 198,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 198,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 198,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 198,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 198,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 198,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 198,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 198,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 198,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 198,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 198,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 198,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 198,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 198,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 198,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 198,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 198,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 198,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 198,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 198,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 198,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 198,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 198,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 198,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 198,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 198,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 198,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 198,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 198,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 198,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 198,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 198,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 198,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 198,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 198,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 198,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 198,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 198,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 198,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 198,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 198,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 198,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 198,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 198,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 198,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 198,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 198,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 198,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 198,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 198,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 198,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 198,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 198,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 198,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 198,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 198,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 198,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 198,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 198,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 198,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05x36 = {
  C: {
    templateId: 438,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 438,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 438,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 438,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 438,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 438,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 438,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 438,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 438,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 438,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 438,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 438,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 438,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 438,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 438,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 438,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 438,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 438,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 438,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 438,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 438,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 438,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 438,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 438,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 438,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 438,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 438,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 438,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 438,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 438,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 438,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 438,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 438,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 438,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 438,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 438,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 438,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 438,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 438,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 438,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 438,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 438,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 438,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 438,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 438,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 438,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 438,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 438,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 438,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 438,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 438,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 438,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 438,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 438,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 438,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 438,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 438,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 438,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 438,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 438,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 438,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 438,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 438,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 438,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 438,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 438,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 438,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten05x48 = {
  C: {
    templateId: 199,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 199,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 199,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 199,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 199,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 199,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 199,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 199,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 199,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 199,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 199,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 199,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 199,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 199,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 199,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 199,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 199,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 199,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 199,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 199,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 199,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 199,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 199,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 199,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 199,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 199,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 199,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 199,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 199,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 199,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 199,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 199,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 199,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 199,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 199,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 199,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 199,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 199,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 199,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 199,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 199,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 199,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 199,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 199,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 199,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 199,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 199,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 199,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 199,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 199,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 199,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 199,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 199,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 199,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 199,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 199,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 199,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 199,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 199,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 199,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 199,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 199,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 199,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 199,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 199,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 199,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 199,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06hx07 = {
  C: {
    templateId: 395,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 395,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 395,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 395,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 395,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 395,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 395,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 395,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 395,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 395,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 395,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 395,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 395,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 395,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 395,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 395,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 395,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 395,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 395,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 395,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 395,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 395,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 395,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 395,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 395,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 395,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 395,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 395,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 395,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 395,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 395,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 395,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 395,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 395,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 395,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 395,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 395,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 395,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 395,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 395,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 395,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 395,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 395,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 395,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 395,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 395,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 395,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 395,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 395,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 395,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 395,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 395,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 395,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 395,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 395,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 395,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 395,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 395,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 395,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 395,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 395,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 395,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 395,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 395,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 395,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 395,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 395,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06hx08 = {
  C: {
    templateId: 200,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 200,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 200,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 200,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 200,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 200,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 200,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 200,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 200,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 200,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 200,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 200,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 200,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 200,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 200,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 200,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 200,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 200,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 200,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 200,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 200,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 200,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 200,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 200,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 200,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 200,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 200,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 200,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 200,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 200,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 200,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 200,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 200,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 200,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 200,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 200,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 200,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 200,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 200,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 200,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 200,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 200,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 200,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 200,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 200,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 200,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 200,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 200,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 200,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 200,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 200,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 200,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 200,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 200,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 200,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 200,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 200,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 200,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 200,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 200,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 200,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 200,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 200,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 200,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 200,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 200,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 200,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06hx12 = {
  C: {
    templateId: 201,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 201,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 201,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 201,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 201,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 201,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 201,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 201,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 201,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 201,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 201,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 201,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 201,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 201,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 201,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 201,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 201,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 201,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 201,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 201,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 201,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 201,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 201,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 201,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 201,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 201,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 201,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 201,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 201,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 201,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 201,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 201,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 201,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 201,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 201,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 201,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 201,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 201,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 201,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 201,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 201,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 201,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 201,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 201,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 201,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 201,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 201,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 201,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 201,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 201,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 201,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 201,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 201,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 201,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 201,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 201,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 201,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 201,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 201,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 201,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 201,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 201,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 201,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 201,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 201,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 201,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 201,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06hx16 = {
  C: {
    templateId: 202,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 202,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 202,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 202,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 202,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 202,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 202,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 202,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 202,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 202,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 202,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 202,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 202,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 202,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 202,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 202,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 202,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 202,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 202,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 202,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 202,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 202,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 202,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 202,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 202,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 202,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 202,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 202,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 202,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 202,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 202,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 202,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 202,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 202,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 202,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 202,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 202,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 202,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 202,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 202,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 202,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 202,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 202,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 202,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 202,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 202,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 202,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 202,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 202,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 202,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 202,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 202,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 202,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 202,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 202,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 202,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 202,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 202,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 202,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 202,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 202,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 202,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 202,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 202,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 202,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 202,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 202,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06hx20 = {
  C: {
    templateId: 250,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 250,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 250,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 250,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 250,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 250,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 250,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 250,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 250,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 250,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 250,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 250,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 250,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 250,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 250,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 250,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 250,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 250,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 250,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 250,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 250,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 250,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 250,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 250,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 250,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 250,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 250,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 250,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 250,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 250,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 250,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 250,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 250,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 250,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 250,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 250,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 250,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 250,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 250,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 250,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 250,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 250,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 250,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 250,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 250,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 250,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 250,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 250,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 250,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 250,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 250,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 250,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 250,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 250,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 250,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 250,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 250,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 250,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 250,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 250,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 250,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 250,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 250,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 250,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 250,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 250,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 250,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06hx24 = {
  C: {
    templateId: 203,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 203,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 203,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 203,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 203,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 203,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 203,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 203,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 203,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 203,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 203,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 203,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 203,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 203,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 203,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 203,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 203,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 203,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 203,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 203,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 203,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 203,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 203,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 203,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 203,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 203,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 203,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 203,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 203,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 203,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 203,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 203,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 203,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 203,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 203,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 203,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 203,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 203,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 203,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 203,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 203,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 203,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 203,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 203,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 203,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 203,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 203,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 203,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 203,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 203,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 203,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 203,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 203,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 203,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 203,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 203,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 203,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 203,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 203,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 203,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 203,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 203,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 203,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 203,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 203,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 203,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 203,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06hx36 = {
  C: {
    templateId: 439,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 439,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 439,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 439,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 439,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 439,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 439,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 439,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 439,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 439,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 439,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 439,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 439,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 439,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 439,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 439,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 439,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 439,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 439,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 439,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 439,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 439,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 439,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 439,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 439,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 439,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 439,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 439,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 439,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 439,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 439,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 439,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 439,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 439,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 439,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 439,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 439,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 439,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 439,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 439,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 439,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 439,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 439,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 439,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 439,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 439,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 439,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 439,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 439,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 439,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 439,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 439,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 439,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 439,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 439,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 439,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 439,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 439,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 439,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 439,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 439,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 439,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 439,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 439,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 439,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 439,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 439,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06hx48 = {
  C: {
    templateId: 204,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 204,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 204,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 204,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 204,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 204,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 204,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 204,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 204,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 204,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 204,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 204,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 204,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 204,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 204,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 204,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 204,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 204,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 204,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 204,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 204,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 204,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 204,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 204,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 204,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 204,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 204,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 204,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 204,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 204,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 204,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 204,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 204,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 204,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 204,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 204,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 204,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 204,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 204,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 204,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 204,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 204,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 204,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 204,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 204,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 204,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 204,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 204,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 204,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 204,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 204,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 204,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 204,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 204,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 204,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 204,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 204,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 204,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 204,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 204,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 204,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 204,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 204,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 204,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 204,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 204,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 204,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06x07 = {
  C: {
    templateId: 396,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 396,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 396,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 396,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 396,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 396,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 396,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 396,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 396,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 396,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 396,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 396,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 396,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 396,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 396,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 396,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 396,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 396,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 396,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 396,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 396,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 396,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 396,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 396,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 396,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 396,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 396,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 396,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 396,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 396,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 396,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 396,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 396,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 396,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 396,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 396,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 396,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 396,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 396,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 396,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 396,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 396,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 396,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 396,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 396,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 396,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 396,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 396,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 396,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 396,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 396,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 396,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 396,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 396,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 396,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 396,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 396,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 396,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 396,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 396,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 396,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 396,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 396,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 396,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 396,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 396,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 396,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06x08 = {
  C: {
    templateId: 205,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 205,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 205,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 205,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 205,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 205,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 205,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 205,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 205,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 205,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 205,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 205,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 205,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 205,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 205,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 205,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 205,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 205,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 205,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 205,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 205,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 205,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 205,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 205,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 205,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 205,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 205,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 205,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 205,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 205,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 205,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 205,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 205,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 205,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 205,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 205,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 205,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 205,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 205,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 205,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 205,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 205,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 205,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 205,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 205,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 205,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 205,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 205,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 205,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 205,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 205,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 205,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 205,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 205,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 205,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 205,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 205,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 205,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 205,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 205,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 205,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 205,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 205,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 205,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 205,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 205,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 205,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06x12 = {
  C: {
    templateId: 206,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 206,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 206,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 206,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 206,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 206,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 206,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 206,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 206,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 206,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 206,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 206,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 206,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 206,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 206,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 206,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 206,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 206,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 206,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 206,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 206,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 206,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 206,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 206,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 206,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 206,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 206,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 206,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 206,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 206,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 206,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 206,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 206,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 206,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 206,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 206,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 206,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 206,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 206,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 206,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 206,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 206,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 206,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 206,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 206,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 206,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 206,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 206,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 206,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 206,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 206,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 206,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 206,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 206,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 206,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 206,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 206,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 206,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 206,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 206,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 206,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 206,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 206,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 206,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 206,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 206,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 206,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06x16 = {
  C: {
    templateId: 207,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 207,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 207,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 207,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 207,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 207,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 207,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 207,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 207,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 207,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 207,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 207,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 207,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 207,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 207,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 207,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 207,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 207,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 207,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 207,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 207,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 207,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 207,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 207,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 207,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 207,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 207,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 207,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 207,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 207,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 207,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 207,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 207,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 207,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 207,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 207,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 207,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 207,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 207,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 207,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 207,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 207,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 207,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 207,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 207,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 207,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 207,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 207,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 207,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 207,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 207,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 207,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 207,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 207,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 207,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 207,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 207,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 207,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 207,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 207,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 207,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 207,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 207,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 207,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 207,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 207,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 207,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06x20 = {
  C: {
    templateId: 251,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 251,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 251,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 251,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 251,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 251,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 251,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 251,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 251,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 251,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 251,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 251,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 251,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 251,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 251,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 251,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 251,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 251,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 251,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 251,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 251,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 251,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 251,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 251,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 251,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 251,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 251,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 251,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 251,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 251,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 251,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 251,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 251,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 251,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 251,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 251,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 251,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 251,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 251,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 251,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 251,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 251,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 251,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 251,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 251,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 251,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 251,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 251,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 251,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 251,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 251,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 251,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 251,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 251,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 251,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 251,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 251,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 251,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 251,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 251,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 251,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 251,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 251,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 251,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 251,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 251,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 251,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06x24 = {
  C: {
    templateId: 208,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 208,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 208,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 208,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 208,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 208,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 208,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 208,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 208,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 208,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 208,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 208,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 208,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 208,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 208,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 208,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 208,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 208,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 208,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 208,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 208,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 208,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 208,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 208,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 208,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 208,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 208,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 208,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 208,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 208,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 208,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 208,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 208,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 208,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 208,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 208,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 208,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 208,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 208,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 208,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 208,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 208,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 208,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 208,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 208,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 208,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 208,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 208,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 208,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 208,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 208,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 208,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 208,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 208,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 208,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 208,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 208,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 208,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 208,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 208,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 208,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 208,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 208,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 208,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 208,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 208,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 208,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06x36 = {
  C: {
    templateId: 440,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 440,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 440,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 440,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 440,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 440,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 440,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 440,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 440,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 440,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 440,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 440,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 440,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 440,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 440,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 440,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 440,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 440,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 440,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 440,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 440,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 440,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 440,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 440,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 440,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 440,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 440,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 440,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 440,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 440,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 440,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 440,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 440,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 440,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 440,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 440,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 440,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 440,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 440,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 440,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 440,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 440,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 440,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 440,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 440,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 440,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 440,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 440,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 440,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 440,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 440,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 440,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 440,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 440,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 440,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 440,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 440,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 440,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 440,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 440,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 440,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 440,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 440,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 440,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 440,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 440,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 440,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardBatten06x48 = {
  C: {
    templateId: 209,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 209,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 209,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 209,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 209,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 209,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 209,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 209,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 209,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 209,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 209,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 209,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 209,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 209,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 209,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 209,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 209,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 209,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 209,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 209,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 209,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 209,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 209,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 209,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 209,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 209,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 209,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 209,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 209,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 209,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 209,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 209,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 209,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 209,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 209,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 209,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 209,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 209,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 209,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 209,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 209,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 209,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 209,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 209,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 209,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 209,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 209,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 209,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 209,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 209,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 209,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 209,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 209,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 209,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 209,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 209,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 209,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 209,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 209,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 209,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 209,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 209,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 209,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 209,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 209,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 209,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 209,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap02 = {
  C: {
    templateId: 298,
  },
  Default: {
    templateId: 298,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 298,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 298,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 298,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 298,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 298,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 298,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 298,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 298,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 298,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 298,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 298,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 298,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 298,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 298,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 298,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 298,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 298,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 298,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 298,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 298,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 298,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 298,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 298,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 298,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 298,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 298,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 298,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 298,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 298,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 298,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 298,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 298,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 298,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 298,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 298,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 298,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 298,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 298,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 298,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 298,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 298,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 298,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 298,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 298,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 298,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 298,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 298,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 298,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 298,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 298,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 298,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 298,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 298,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 298,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 298,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 298,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 298,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 298,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 298,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 298,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 298,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 298,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 298,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 298,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 298,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 298,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 298,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 298,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 298,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 298,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 298,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 298,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 298,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 298,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 298,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 298,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 298,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 298,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 298,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 298,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 298,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 298,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 298,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 298,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 298,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 298,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 298,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 298,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 298,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 298,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 298,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 298,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 298,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 298,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 298,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 298,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 298,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 298,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 298,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 298,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 298,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 298,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 298,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 298,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap02_Grain = {
  C: {
    templateId: 297,
  },
  Default: {
    templateId: 297,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 297,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 297,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 297,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 297,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 297,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 297,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 297,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 297,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 297,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 297,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 297,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 297,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 297,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 297,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 297,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 297,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 297,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 297,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 297,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 297,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 297,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 297,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 297,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 297,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 297,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 297,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 297,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 297,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 297,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 297,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 297,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 297,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 297,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 297,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 297,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 297,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 297,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 297,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 297,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 297,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 297,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 297,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 297,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 297,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 297,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 297,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 297,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 297,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 297,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 297,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 297,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 297,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 297,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 297,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 297,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 297,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 297,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 297,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 297,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 297,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 297,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 297,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 297,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 297,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 297,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 297,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 297,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 297,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 297,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 297,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 297,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 297,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 297,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 297,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 297,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 297,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 297,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 297,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 297,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 297,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 297,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 297,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 297,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 297,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 297,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 297,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 297,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 297,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 297,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 297,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 297,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 297,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 297,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 297,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 297,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 297,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 297,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 297,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 297,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap03 = {
  C: {
    templateId: 593,
  },
  Default: {
    templateId: 593,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 593,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 593,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 593,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 593,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 593,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 593,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 593,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 593,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 593,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 593,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 593,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 593,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 593,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 593,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 593,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 593,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 593,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 593,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 593,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 593,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 593,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 593,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 593,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 593,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 593,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 593,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 593,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 593,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 593,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 593,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 593,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 593,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 593,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 593,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 593,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 593,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 593,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 593,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 593,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 593,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 593,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 593,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 593,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 593,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 593,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 593,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 593,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 593,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 593,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 593,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 593,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 593,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 593,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 593,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 593,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 593,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 593,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 593,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 593,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 593,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 593,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 593,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 593,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 593,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 593,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 593,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 593,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 593,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 593,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 593,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 593,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 593,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 593,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 593,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 593,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 593,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 593,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 593,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 593,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 593,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 593,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 593,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 593,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 593,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 593,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 593,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 593,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 593,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 593,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 593,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 593,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 593,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 593,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 593,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 593,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 593,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 593,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 593,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 593,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 593,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 593,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 593,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 593,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 593,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap03_Grain = {
  C: {
    templateId: 592,
  },
  Default: {
    templateId: 592,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 592,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 592,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 592,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 592,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 592,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 592,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 592,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 592,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 592,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 592,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 592,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 592,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 592,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 592,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 592,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 592,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 592,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 592,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 592,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 592,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 592,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 592,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 592,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 592,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 592,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 592,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 592,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 592,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 592,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 592,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 592,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 592,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 592,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 592,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 592,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 592,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 592,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 592,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 592,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 592,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 592,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 592,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 592,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 592,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 592,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 592,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 592,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 592,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 592,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 592,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 592,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 592,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 592,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 592,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 592,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 592,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 592,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 592,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 592,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 592,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 592,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 592,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 592,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 592,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 592,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 592,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 592,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 592,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 592,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 592,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 592,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 592,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 592,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 592,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 592,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 592,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 592,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 592,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 592,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 592,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 592,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 592,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 592,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 592,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 592,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 592,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 592,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 592,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 592,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 592,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 592,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 592,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 592,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 592,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 592,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 592,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 592,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 592,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 592,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap04 = {
  C: {
    templateId: 132,
  },
  Default: {
    templateId: 132,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 132,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 132,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 132,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 132,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 132,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 132,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 132,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 132,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 132,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 132,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 132,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 132,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 132,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 132,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 132,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 132,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 132,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 132,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 132,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 132,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 132,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 132,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 132,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 132,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 132,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 132,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 132,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 132,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 132,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 132,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 132,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 132,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 132,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 132,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 132,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 132,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 132,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 132,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 132,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 132,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 132,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 132,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 132,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 132,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 132,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 132,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 132,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 132,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 132,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 132,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 132,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 132,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 132,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 132,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 132,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 132,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 132,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 132,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 132,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 132,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 132,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 132,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 132,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 132,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 132,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 132,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 132,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 132,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 132,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 132,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 132,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 132,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 132,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 132,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 132,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 132,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 132,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 132,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 132,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 132,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 132,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 132,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 132,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 132,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 132,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 132,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 132,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 132,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 132,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 132,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 132,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 132,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 132,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 132,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 132,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 132,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 132,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 132,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 132,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 132,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 132,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 132,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 132,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 132,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap04_Grain = {
  C: {
    templateId: 252,
  },
  Default: {
    templateId: 252,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 252,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 252,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 252,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 252,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 252,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 252,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 252,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 252,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 252,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 252,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 252,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 252,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 252,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 252,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 252,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 252,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 252,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 252,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 252,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 252,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 252,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 252,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 252,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 252,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 252,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 252,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 252,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 252,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 252,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 252,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 252,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 252,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 252,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 252,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 252,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 252,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 252,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 252,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 252,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 252,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 252,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 252,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 252,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 252,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 252,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 252,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 252,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 252,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 252,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 252,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 252,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 252,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 252,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 252,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 252,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 252,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 252,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 252,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 252,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 252,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 252,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 252,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 252,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 252,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 252,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 252,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 252,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 252,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 252,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 252,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 252,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 252,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 252,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 252,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 252,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 252,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 252,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 252,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 252,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 252,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 252,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 252,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 252,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 252,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 252,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 252,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 252,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 252,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 252,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 252,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 252,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 252,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 252,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 252,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 252,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 252,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 252,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 252,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 252,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap04h = {
  C: {
    templateId: 500,
  },
  Default: {
    templateId: 500,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 500,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 500,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 500,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 500,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 500,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 500,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 500,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 500,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 500,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 500,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 500,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 500,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 500,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 500,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 500,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 500,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 500,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 500,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 500,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 500,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 500,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 500,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 500,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 500,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 500,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 500,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 500,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 500,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 500,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 500,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 500,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 500,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 500,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 500,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 500,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 500,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 500,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 500,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 500,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 500,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 500,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 500,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 500,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 500,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 500,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 500,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 500,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 500,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 500,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 500,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 500,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 500,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 500,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 500,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 500,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 500,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 500,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 500,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 500,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 500,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 500,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 500,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 500,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 500,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 500,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 500,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 500,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 500,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 500,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 500,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 500,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 500,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 500,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 500,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 500,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 500,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 500,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 500,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 500,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 500,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 500,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 500,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 500,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 500,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 500,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 500,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 500,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 500,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 500,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 500,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 500,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 500,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 500,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 500,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 500,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 500,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 500,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 500,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 500,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 500,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 500,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 500,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 500,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 500,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap04h_Dutch = {
  C: {
    templateId: 353,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 353,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 353,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 353,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 353,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 353,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 353,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 353,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 353,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 353,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 353,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 353,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 353,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 353,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 353,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 353,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 353,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 353,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 353,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 353,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 353,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 353,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 353,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 353,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 353,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 353,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 353,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 353,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 353,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 353,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 353,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 353,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 353,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 353,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 353,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 353,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 353,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 353,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 353,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 353,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 353,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 353,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 353,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 353,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 353,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 353,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 353,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 353,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 353,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 353,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 353,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 353,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 353,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 353,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 353,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 353,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 353,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 353,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 353,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 353,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 353,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 353,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 353,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 353,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 353,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 353,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 353,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 353,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 353,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 353,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 353,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 353,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 353,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 353,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 353,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 353,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 353,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 353,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 353,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 353,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 353,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 353,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 353,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 353,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 353,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 353,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 353,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 353,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 353,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 353,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 353,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 353,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 353,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 353,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 353,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 353,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 353,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 353,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 353,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 353,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 353,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 353,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 353,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 353,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 353,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap05 = {
  C: {
    templateId: 261,
  },
  Default: {
    templateId: 261,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 261,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 261,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 261,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 261,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 261,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 261,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 261,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 261,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 261,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 261,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 261,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 261,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 261,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 261,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 261,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 261,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 261,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 261,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 261,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 261,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 261,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 261,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 261,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 261,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 261,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 261,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 261,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 261,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 261,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 261,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 261,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 261,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 261,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 261,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 261,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 261,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 261,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 261,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 261,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 261,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 261,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 261,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 261,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 261,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 261,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 261,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 261,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 261,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 261,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 261,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 261,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 261,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 261,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 261,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 261,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 261,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 261,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 261,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 261,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 261,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 261,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 261,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 261,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 261,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 261,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 261,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 261,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 261,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 261,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 261,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 261,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 261,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 261,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 261,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 261,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 261,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 261,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 261,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 261,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 261,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 261,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 261,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 261,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 261,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 261,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 261,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 261,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 261,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 261,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 261,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 261,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 261,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 261,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 261,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 261,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 261,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 261,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 261,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 261,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 261,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 261,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 261,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 261,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 261,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap05_Grain = {
  C: {
    templateId: 260,
  },
  Default: {
    templateId: 260,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 260,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 260,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 260,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 260,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 260,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 260,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 260,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 260,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 260,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 260,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 260,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 260,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 260,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 260,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 260,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 260,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 260,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 260,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 260,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 260,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 260,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 260,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 260,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 260,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 260,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 260,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 260,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 260,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 260,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 260,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 260,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 260,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 260,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 260,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 260,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 260,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 260,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 260,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 260,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 260,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 260,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 260,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 260,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 260,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 260,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 260,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 260,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 260,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 260,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 260,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 260,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 260,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 260,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 260,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 260,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 260,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 260,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 260,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 260,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 260,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 260,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 260,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 260,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 260,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 260,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 260,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 260,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 260,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 260,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 260,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 260,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 260,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 260,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 260,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 260,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 260,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 260,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 260,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 260,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 260,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 260,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 260,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 260,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 260,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 260,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 260,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 260,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 260,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 260,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 260,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 260,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 260,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 260,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 260,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 260,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 260,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 260,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 260,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 260,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap06 = {
  C: {
    templateId: 44,
  },
  Default: {
    templateId: 44,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 44,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 44,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 44,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 44,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 44,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 44,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 44,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 44,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 44,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 44,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 44,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 44,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 44,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 44,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 44,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 44,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 44,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 44,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 44,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 44,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 44,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 44,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 44,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 44,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 44,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 44,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 44,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 44,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 44,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 44,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 44,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 44,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 44,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 44,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 44,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 44,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 44,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 44,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 44,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 44,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 44,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 44,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 44,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 44,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 44,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 44,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 44,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 44,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 44,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 44,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 44,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 44,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 44,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 44,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 44,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 44,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 44,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 44,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 44,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 44,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 44,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 44,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 44,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 44,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 44,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 44,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 44,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 44,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 44,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 44,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 44,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 44,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 44,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 44,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 44,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 44,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 44,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 44,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 44,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 44,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 44,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 44,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 44,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 44,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 44,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 44,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 44,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 44,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 44,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 44,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 44,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 44,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 44,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 44,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 44,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 44,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 44,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 44,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 44,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 44,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 44,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 44,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 44,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 44,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap06_Gap01h = {
  C: {
    templateId: 462,
  },
  Default: {
    templateId: 462,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 462,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 462,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 462,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 462,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 462,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 462,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 462,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 462,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 462,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 462,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 462,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 462,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 462,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 462,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 462,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 462,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 462,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 462,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 462,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 462,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 462,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 462,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 462,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 462,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 462,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 462,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 462,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 462,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 462,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 462,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 462,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 462,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 462,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 462,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 462,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 462,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 462,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 462,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 462,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 462,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 462,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 462,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 462,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 462,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 462,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 462,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 462,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 462,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 462,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 462,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 462,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 462,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 462,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 462,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 462,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 462,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 462,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 462,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 462,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 462,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 462,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 462,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 462,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 462,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 462,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 462,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 462,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 462,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 462,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 462,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 462,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 462,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 462,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 462,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 462,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 462,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 462,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 462,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 462,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 462,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 462,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 462,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 462,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 462,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 462,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 462,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 462,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 462,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 462,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 462,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 462,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 462,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 462,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 462,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 462,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 462,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 462,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 462,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 462,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 462,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 462,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 462,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 462,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 462,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap06_Grain = {
  C: {
    templateId: 253,
  },
  Default: {
    templateId: 253,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 253,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 253,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 253,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 253,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 253,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 253,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 253,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 253,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 253,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 253,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 253,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 253,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 253,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 253,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 253,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 253,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 253,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 253,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 253,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 253,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 253,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 253,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 253,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 253,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 253,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 253,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 253,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 253,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 253,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 253,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 253,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 253,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 253,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 253,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 253,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 253,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 253,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 253,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 253,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 253,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 253,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 253,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 253,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 253,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 253,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 253,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 253,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 253,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 253,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 253,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 253,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 253,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 253,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 253,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 253,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 253,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 253,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 253,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 253,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 253,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 253,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 253,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 253,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 253,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 253,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 253,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 253,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 253,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 253,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 253,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 253,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 253,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 253,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 253,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 253,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 253,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 253,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 253,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 253,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 253,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 253,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 253,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 253,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 253,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 253,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 253,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 253,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 253,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 253,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 253,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 253,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 253,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 253,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 253,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 253,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 253,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 253,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 253,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 253,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap07 = {
  C: {
    templateId: 45,
  },
  Default: {
    templateId: 45,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 45,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 45,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 45,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 45,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 45,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 45,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 45,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 45,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 45,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 45,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 45,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 45,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 45,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 45,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 45,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 45,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 45,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 45,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 45,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 45,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 45,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 45,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 45,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 45,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 45,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 45,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 45,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 45,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 45,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 45,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 45,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 45,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 45,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 45,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 45,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 45,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 45,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 45,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 45,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 45,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 45,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 45,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 45,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 45,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 45,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 45,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 45,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 45,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 45,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 45,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 45,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 45,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 45,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 45,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 45,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 45,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 45,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 45,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 45,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 45,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 45,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 45,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 45,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 45,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 45,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 45,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 45,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 45,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 45,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 45,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 45,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 45,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 45,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 45,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 45,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 45,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 45,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 45,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 45,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 45,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 45,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 45,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 45,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 45,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 45,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 45,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 45,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 45,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 45,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 45,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 45,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 45,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 45,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 45,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 45,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 45,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 45,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 45,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 45,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 45,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 45,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 45,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 45,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 45,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap07_Grain = {
  C: {
    templateId: 119,
  },
  Default: {
    templateId: 119,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 119,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 119,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 119,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 119,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 119,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 119,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 119,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 119,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 119,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 119,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 119,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 119,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 119,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 119,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 119,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 119,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 119,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 119,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 119,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 119,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 119,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 119,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 119,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 119,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 119,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 119,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 119,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 119,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 119,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 119,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 119,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 119,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 119,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 119,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 119,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 119,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 119,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 119,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 119,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 119,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 119,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 119,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 119,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 119,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 119,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 119,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 119,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 119,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 119,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 119,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 119,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 119,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 119,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 119,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 119,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 119,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 119,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 119,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 119,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 119,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 119,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 119,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 119,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 119,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 119,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 119,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 119,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 119,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 119,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 119,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 119,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 119,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 119,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 119,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 119,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 119,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 119,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 119,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 119,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 119,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 119,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 119,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 119,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 119,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 119,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 119,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 119,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 119,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 119,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 119,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 119,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 119,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 119,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 119,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 119,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 119,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 119,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 119,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 119,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap08 = {
  C: {
    templateId: 46,
  },
  Default: {
    templateId: 46,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 46,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 46,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 46,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 46,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 46,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 46,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 46,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 46,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 46,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 46,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 46,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 46,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 46,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 46,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 46,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 46,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 46,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 46,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 46,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 46,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 46,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 46,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 46,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 46,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 46,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 46,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 46,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 46,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 46,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 46,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 46,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 46,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 46,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 46,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 46,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 46,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 46,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 46,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 46,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 46,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 46,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 46,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 46,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 46,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 46,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 46,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 46,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 46,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 46,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 46,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 46,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 46,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 46,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 46,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 46,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 46,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 46,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 46,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 46,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 46,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 46,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 46,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 46,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 46,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 46,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 46,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 46,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 46,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 46,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 46,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 46,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 46,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 46,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 46,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 46,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 46,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 46,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 46,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 46,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 46,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 46,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 46,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 46,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 46,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 46,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 46,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 46,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 46,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 46,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 46,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 46,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 46,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 46,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 46,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 46,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 46,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 46,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 46,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 46,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 46,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 46,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 46,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 46,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 46,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap08_Grain = {
  C: {
    templateId: 254,
  },
  Default: {
    templateId: 254,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 254,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 254,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 254,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 254,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 254,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 254,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 254,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 254,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 254,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 254,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 254,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 254,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 254,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 254,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 254,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 254,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 254,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 254,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 254,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 254,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 254,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 254,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 254,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 254,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 254,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 254,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 254,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 254,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 254,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 254,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 254,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 254,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 254,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 254,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 254,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 254,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 254,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 254,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 254,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 254,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 254,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 254,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 254,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 254,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 254,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 254,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 254,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 254,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 254,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 254,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 254,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 254,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 254,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 254,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 254,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 254,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 254,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 254,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 254,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 254,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 254,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 254,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 254,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 254,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 254,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 254,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 254,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 254,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 254,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 254,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 254,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 254,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 254,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 254,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 254,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 254,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 254,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 254,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 254,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 254,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 254,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 254,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 254,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 254,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 254,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 254,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 254,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 254,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 254,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 254,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 254,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 254,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 254,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 254,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 254,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 254,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 254,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 254,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 254,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap10 = {
  C: {
    templateId: 486,
  },
  Default: {
    templateId: 486,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 486,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 486,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 486,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 486,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 486,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 486,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 486,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 486,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 486,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 486,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 486,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 486,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 486,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 486,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 486,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 486,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 486,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 486,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 486,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 486,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 486,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 486,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 486,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 486,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 486,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 486,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 486,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 486,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 486,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 486,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 486,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 486,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 486,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 486,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 486,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 486,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 486,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 486,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 486,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 486,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 486,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 486,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 486,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 486,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 486,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 486,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 486,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 486,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 486,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 486,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 486,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 486,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 486,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 486,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 486,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 486,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 486,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 486,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 486,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 486,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 486,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 486,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 486,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 486,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 486,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 486,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 486,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 486,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 486,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 486,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 486,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 486,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 486,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 486,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 486,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 486,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 486,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 486,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 486,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 486,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 486,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 486,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 486,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 486,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 486,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 486,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 486,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 486,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 486,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 486,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 486,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 486,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 486,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 486,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 486,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 486,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 486,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 486,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 486,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 486,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 486,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 486,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 486,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 486,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap10_Grain = {
  C: {
    templateId: 485,
  },
  Default: {
    templateId: 485,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 485,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 485,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 485,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 485,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 485,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 485,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 485,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 485,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 485,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 485,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 485,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 485,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 485,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 485,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 485,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 485,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 485,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 485,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 485,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 485,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 485,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 485,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 485,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 485,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 485,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 485,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 485,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 485,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 485,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 485,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 485,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 485,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 485,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 485,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 485,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 485,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 485,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 485,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 485,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 485,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 485,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 485,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 485,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 485,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 485,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 485,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 485,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 485,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 485,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 485,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 485,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 485,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 485,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 485,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 485,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 485,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 485,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 485,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 485,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 485,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 485,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 485,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 485,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 485,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 485,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 485,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 485,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 485,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 485,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 485,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 485,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 485,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 485,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 485,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 485,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 485,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 485,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 485,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 485,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 485,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 485,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 485,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 485,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 485,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 485,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 485,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 485,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 485,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 485,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 485,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 485,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 485,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 485,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 485,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 485,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 485,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 485,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 485,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 485,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap12 = {
  C: {
    templateId: 398,
  },
  Default: {
    templateId: 398,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 398,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 398,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 398,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 398,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 398,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 398,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 398,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 398,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 398,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 398,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 398,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 398,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 398,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 398,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 398,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 398,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 398,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 398,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 398,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 398,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 398,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 398,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 398,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 398,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 398,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 398,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 398,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 398,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 398,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 398,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 398,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 398,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 398,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 398,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 398,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 398,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 398,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 398,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 398,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 398,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 398,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 398,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 398,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 398,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 398,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 398,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 398,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 398,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 398,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 398,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 398,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 398,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 398,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 398,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 398,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 398,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 398,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 398,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 398,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 398,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 398,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 398,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 398,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 398,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 398,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 398,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 398,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 398,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 398,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 398,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 398,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 398,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 398,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 398,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 398,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 398,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 398,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 398,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 398,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 398,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 398,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 398,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 398,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 398,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 398,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 398,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 398,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 398,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 398,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 398,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 398,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 398,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 398,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 398,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 398,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 398,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 398,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 398,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 398,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 398,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 398,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 398,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 398,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 398,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLap12_Grain = {
  C: {
    templateId: 397,
  },
  Default: {
    templateId: 397,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 397,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 397,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 397,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 397,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 397,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 397,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 397,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 397,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 397,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 397,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 397,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 397,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 397,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 397,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 397,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 397,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 397,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 397,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 397,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 397,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 397,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 397,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 397,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 397,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 397,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 397,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 397,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 397,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 397,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 397,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 397,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 397,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 397,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 397,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 397,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 397,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 397,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 397,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 397,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 397,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 397,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 397,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 397,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 397,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 397,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 397,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 397,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 397,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 397,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 397,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 397,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 397,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 397,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 397,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 397,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 397,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 397,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 397,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 397,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 397,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 397,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 397,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 397,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 397,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 397,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 397,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 397,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 397,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 397,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 397,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 397,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 397,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 397,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 397,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 397,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 397,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 397,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 397,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 397,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 397,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 397,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 397,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 397,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 397,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 397,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 397,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 397,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 397,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 397,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 397,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 397,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 397,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 397,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 397,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 397,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 397,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 397,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 397,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 397,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLapAlternating04x07 = {
  C: {
    templateId: 157,
  },
  Default: {
    templateId: 157,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 157,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 157,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 157,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 157,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 157,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 157,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 157,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 157,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 157,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 157,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 157,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 157,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 157,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 157,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 157,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 157,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 157,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 157,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 157,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 157,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 157,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 157,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 157,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 157,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 157,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 157,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 157,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 157,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 157,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 157,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 157,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 157,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 157,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 157,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 157,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 157,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 157,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 157,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 157,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 157,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 157,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 157,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 157,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 157,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 157,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 157,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 157,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 157,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 157,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 157,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 157,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 157,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 157,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 157,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 157,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 157,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 157,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 157,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 157,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 157,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 157,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 157,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 157,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 157,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 157,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 157,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 157,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 157,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 157,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 157,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 157,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 157,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 157,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 157,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 157,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 157,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 157,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 157,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 157,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 157,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 157,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 157,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 157,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 157,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 157,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 157,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 157,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 157,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 157,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 157,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 157,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 157,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 157,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 157,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 157,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 157,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 157,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 157,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 157,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 157,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 157,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 157,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 157,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 157,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_BoardLapAlternating05x08 = {
  C: {
    templateId: 256,
  },
  Default: {
    templateId: 256,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 256,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 256,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 256,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 256,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 256,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 256,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 256,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 256,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 256,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 256,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 256,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 256,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 256,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 256,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 256,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 256,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 256,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 256,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 256,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 256,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 256,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 256,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 256,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 256,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 256,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 256,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 256,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 256,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 256,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 256,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 256,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 256,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 256,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 256,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 256,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 256,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 256,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 256,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 256,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 256,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 256,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 256,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 256,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 256,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 256,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 256,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 256,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 256,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 256,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 256,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 256,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 256,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 256,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 256,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 256,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 256,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 256,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 256,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 256,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 256,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 256,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 256,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 256,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 256,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 256,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 256,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 256,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 256,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 256,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 256,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 256,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 256,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 256,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 256,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 256,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 256,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 256,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 256,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 256,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 256,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 256,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 256,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 256,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 256,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 256,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 256,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 256,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 256,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 256,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 256,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 256,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 256,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 256,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 256,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 256,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 256,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 256,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 256,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 256,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 256,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 256,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 256,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 256,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 256,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard02_01hx48vertical = {
  C: {
    templateId: 295,
  },
  Default: {
    templateId: 295,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 295,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 295,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 295,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 295,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 295,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 295,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 295,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 295,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 295,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 295,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 295,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 295,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 295,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 295,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 295,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 295,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 295,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 295,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 295,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 295,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 295,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 295,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 295,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 295,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 295,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 295,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 295,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 295,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 295,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 295,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 295,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 295,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 295,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 295,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 295,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 295,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 295,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 295,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 295,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 295,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 295,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 295,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 295,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 295,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 295,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 295,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 295,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 295,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 295,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 295,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 295,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 295,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 295,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 295,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 295,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 295,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 295,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 295,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 295,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 295,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 295,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 295,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 295,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 295,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 295,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 295,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 295,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 295,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 295,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 295,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 295,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 295,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 295,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 295,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 295,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 295,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 295,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 295,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 295,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 295,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 295,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 295,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 295,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 295,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 295,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 295,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 295,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 295,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 295,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 295,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 295,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 295,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 295,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 295,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 295,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 295,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 295,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 295,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 295,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 295,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 295,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 295,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 295,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 295,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard04 = {
  C: {
    templateId: 66,
  },
  Default: {
    templateId: 66,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 66,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 66,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 66,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 66,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 66,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 66,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 66,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 66,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 66,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 66,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 66,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 66,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 66,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 66,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 66,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 66,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 66,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 66,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 66,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 66,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 66,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 66,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 66,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 66,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 66,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 66,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 66,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 66,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 66,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 66,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 66,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 66,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 66,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 66,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 66,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 66,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 66,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 66,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 66,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 66,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 66,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 66,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 66,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 66,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 66,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 66,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 66,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 66,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 66,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 66,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 66,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 66,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 66,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 66,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 66,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 66,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 66,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 66,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 66,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 66,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 66,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 66,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 66,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 66,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 66,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 66,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 66,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 66,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 66,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 66,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 66,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 66,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 66,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 66,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 66,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 66,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 66,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 66,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 66,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 66,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 66,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 66,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 66,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 66,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 66,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 66,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 66,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 66,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 66,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 66,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 66,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 66,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 66,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 66,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 66,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 66,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 66,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 66,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 66,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 66,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 66,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 66,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 66,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 66,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard04_Grain = {
  C: {
    templateId: 272,
  },
  Default: {
    templateId: 272,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 272,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 272,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 272,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 272,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 272,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 272,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 272,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 272,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 272,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 272,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 272,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 272,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 272,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 272,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 272,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 272,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 272,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 272,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 272,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 272,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 272,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 272,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 272,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 272,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 272,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 272,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 272,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 272,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 272,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 272,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 272,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 272,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 272,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 272,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 272,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 272,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 272,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 272,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 272,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 272,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 272,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 272,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 272,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 272,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 272,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 272,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 272,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 272,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 272,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 272,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 272,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 272,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 272,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 272,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 272,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 272,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 272,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 272,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 272,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 272,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 272,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 272,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 272,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 272,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 272,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 272,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 272,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 272,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 272,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 272,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 272,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 272,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 272,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 272,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 272,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 272,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 272,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 272,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 272,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 272,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 272,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 272,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 272,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 272,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 272,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 272,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 272,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 272,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 272,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 272,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 272,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 272,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 272,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 272,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 272,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 272,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 272,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 272,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 272,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 272,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 272,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 272,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 272,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 272,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard05 = {
  C: {
    templateId: 274,
  },
  Default: {
    templateId: 274,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 274,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 274,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 274,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 274,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 274,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 274,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 274,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 274,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 274,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 274,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 274,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 274,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 274,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 274,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 274,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 274,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 274,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 274,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 274,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 274,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 274,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 274,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 274,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 274,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 274,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 274,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 274,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 274,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 274,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 274,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 274,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 274,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 274,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 274,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 274,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 274,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 274,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 274,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 274,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 274,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 274,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 274,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 274,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 274,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 274,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 274,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 274,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 274,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 274,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 274,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 274,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 274,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 274,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 274,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 274,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 274,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 274,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 274,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 274,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 274,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 274,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 274,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 274,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 274,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 274,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 274,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 274,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 274,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 274,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 274,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 274,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 274,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 274,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 274,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 274,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 274,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 274,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 274,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 274,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 274,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 274,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 274,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 274,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 274,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 274,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 274,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 274,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 274,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 274,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 274,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 274,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 274,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 274,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 274,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 274,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 274,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 274,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 274,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 274,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 274,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 274,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 274,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 274,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 274,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard05_Grain = {
  C: {
    templateId: 273,
  },
  Default: {
    templateId: 273,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 273,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 273,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 273,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 273,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 273,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 273,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 273,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 273,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 273,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 273,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 273,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 273,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 273,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 273,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 273,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 273,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 273,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 273,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 273,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 273,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 273,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 273,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 273,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 273,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 273,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 273,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 273,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 273,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 273,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 273,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 273,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 273,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 273,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 273,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 273,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 273,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 273,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 273,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 273,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 273,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 273,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 273,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 273,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 273,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 273,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 273,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 273,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 273,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 273,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 273,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 273,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 273,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 273,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 273,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 273,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 273,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 273,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 273,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 273,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 273,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 273,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 273,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 273,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 273,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 273,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 273,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 273,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 273,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 273,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 273,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 273,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 273,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 273,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 273,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 273,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 273,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 273,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 273,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 273,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 273,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 273,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 273,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 273,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 273,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 273,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 273,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 273,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 273,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 273,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 273,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 273,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 273,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 273,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 273,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 273,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 273,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 273,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 273,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 273,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 273,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 273,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 273,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 273,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 273,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard05h_Grain = {
  C: {
    templateId: 275,
  },
  Default: {
    templateId: 275,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 275,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 275,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 275,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 275,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 275,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 275,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 275,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 275,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 275,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 275,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 275,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 275,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 275,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 275,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 275,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 275,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 275,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 275,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 275,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 275,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 275,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 275,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 275,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 275,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 275,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 275,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 275,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 275,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 275,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 275,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 275,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 275,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 275,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 275,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 275,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 275,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 275,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 275,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 275,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 275,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 275,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 275,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 275,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 275,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 275,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 275,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 275,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 275,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 275,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 275,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 275,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 275,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 275,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 275,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 275,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 275,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 275,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 275,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 275,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 275,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 275,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 275,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 275,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 275,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 275,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 275,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 275,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 275,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 275,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 275,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 275,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 275,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 275,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 275,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 275,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 275,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 275,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 275,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 275,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 275,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 275,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 275,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 275,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 275,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 275,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 275,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 275,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 275,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 275,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 275,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 275,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 275,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 275,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 275,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 275,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 275,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 275,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 275,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 275,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 275,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 275,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 275,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 275,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 275,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard06 = {
  C: {
    templateId: 68,
  },
  Default: {
    templateId: 68,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 68,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 68,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 68,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 68,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 68,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 68,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 68,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 68,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 68,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 68,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 68,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 68,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 68,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 68,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 68,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 68,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 68,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 68,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 68,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 68,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 68,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 68,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 68,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 68,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 68,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 68,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 68,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 68,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 68,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 68,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 68,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 68,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 68,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 68,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 68,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 68,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 68,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 68,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 68,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 68,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 68,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 68,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 68,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 68,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 68,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 68,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 68,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 68,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 68,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 68,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 68,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 68,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 68,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 68,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 68,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 68,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 68,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 68,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 68,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 68,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 68,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 68,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 68,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 68,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 68,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 68,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 68,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 68,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 68,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 68,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 68,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 68,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 68,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 68,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 68,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 68,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 68,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 68,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 68,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 68,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 68,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 68,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 68,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 68,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 68,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 68,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 68,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 68,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 68,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 68,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 68,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 68,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 68,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 68,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 68,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 68,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 68,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 68,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 68,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 68,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 68,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 68,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 68,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 68,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard06_Grain = {
  C: {
    templateId: 276,
  },
  Default: {
    templateId: 276,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 276,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 276,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 276,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 276,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 276,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 276,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 276,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 276,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 276,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 276,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 276,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 276,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 276,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 276,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 276,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 276,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 276,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 276,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 276,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 276,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 276,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 276,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 276,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 276,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 276,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 276,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 276,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 276,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 276,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 276,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 276,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 276,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 276,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 276,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 276,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 276,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 276,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 276,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 276,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 276,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 276,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 276,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 276,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 276,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 276,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 276,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 276,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 276,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 276,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 276,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 276,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 276,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 276,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 276,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 276,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 276,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 276,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 276,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 276,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 276,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 276,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 276,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 276,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 276,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 276,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 276,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 276,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 276,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 276,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 276,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 276,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 276,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 276,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 276,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 276,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 276,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 276,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 276,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 276,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 276,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 276,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 276,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 276,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 276,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 276,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 276,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 276,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 276,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 276,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 276,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 276,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 276,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 276,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 276,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 276,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 276,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 276,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 276,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 276,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 276,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 276,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 276,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 276,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 276,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard07 = {
  C: {
    templateId: 278,
  },
  Default: {
    templateId: 278,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 278,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 278,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 278,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 278,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 278,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 278,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 278,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 278,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 278,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 278,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 278,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 278,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 278,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 278,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 278,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 278,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 278,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 278,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 278,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 278,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 278,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 278,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 278,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 278,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 278,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 278,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 278,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 278,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 278,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 278,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 278,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 278,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 278,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 278,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 278,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 278,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 278,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 278,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 278,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 278,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 278,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 278,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 278,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 278,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 278,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 278,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 278,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 278,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 278,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 278,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 278,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 278,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 278,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 278,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 278,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 278,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 278,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 278,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 278,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 278,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 278,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 278,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 278,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 278,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 278,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 278,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 278,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 278,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 278,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 278,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 278,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 278,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 278,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 278,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 278,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 278,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 278,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 278,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 278,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 278,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 278,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 278,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 278,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 278,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 278,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 278,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 278,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 278,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 278,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 278,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 278,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 278,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 278,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 278,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 278,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 278,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 278,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 278,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 278,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 278,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 278,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 278,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 278,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 278,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard07_Grain = {
  C: {
    templateId: 277,
  },
  Default: {
    templateId: 277,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 277,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 277,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 277,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 277,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 277,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 277,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 277,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 277,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 277,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 277,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 277,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 277,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 277,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 277,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 277,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 277,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 277,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 277,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 277,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 277,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 277,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 277,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 277,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 277,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 277,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 277,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 277,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 277,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 277,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 277,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 277,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 277,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 277,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 277,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 277,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 277,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 277,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 277,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 277,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 277,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 277,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 277,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 277,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 277,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 277,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 277,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 277,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 277,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 277,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 277,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 277,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 277,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 277,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 277,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 277,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 277,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 277,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 277,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 277,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 277,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 277,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 277,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 277,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 277,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 277,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 277,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 277,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 277,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 277,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 277,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 277,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 277,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 277,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 277,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 277,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 277,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 277,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 277,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 277,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 277,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 277,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 277,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 277,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 277,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 277,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 277,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 277,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 277,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 277,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 277,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 277,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 277,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 277,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 277,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 277,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 277,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 277,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 277,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 277,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 277,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 277,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 277,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 277,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 277,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard08 = {
  C: {
    templateId: 280,
  },
  Default: {
    templateId: 280,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 280,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 280,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 280,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 280,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 280,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 280,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 280,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 280,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 280,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 280,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 280,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 280,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 280,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 280,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 280,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 280,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 280,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 280,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 280,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 280,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 280,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 280,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 280,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 280,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 280,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 280,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 280,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 280,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 280,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 280,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 280,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 280,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 280,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 280,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 280,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 280,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 280,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 280,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 280,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 280,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 280,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 280,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 280,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 280,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 280,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 280,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 280,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 280,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 280,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 280,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 280,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 280,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 280,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 280,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 280,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 280,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 280,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 280,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 280,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 280,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 280,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 280,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 280,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 280,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 280,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 280,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 280,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 280,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 280,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 280,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 280,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 280,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 280,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 280,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 280,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 280,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 280,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 280,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 280,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 280,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 280,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 280,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 280,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 280,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 280,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 280,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 280,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 280,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 280,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 280,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 280,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 280,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 280,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 280,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 280,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 280,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 280,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 280,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 280,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 280,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 280,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 280,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 280,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 280,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard08_Angle45L = {
  C: {
    templateId: 418,
  },
  Default: {
    templateId: 418,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 418,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 418,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 418,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 418,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 418,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 418,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 418,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 418,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 418,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 418,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 418,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 418,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 418,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 418,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 418,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 418,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 418,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 418,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 418,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 418,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 418,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 418,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 418,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 418,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 418,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 418,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 418,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 418,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 418,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 418,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 418,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 418,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 418,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 418,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 418,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 418,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 418,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 418,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 418,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 418,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 418,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 418,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 418,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 418,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 418,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 418,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 418,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 418,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 418,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 418,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 418,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 418,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 418,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 418,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 418,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 418,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 418,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 418,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 418,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 418,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 418,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 418,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 418,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 418,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 418,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 418,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 418,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 418,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 418,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 418,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 418,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 418,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 418,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 418,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 418,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 418,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 418,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 418,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 418,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 418,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 418,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 418,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 418,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 418,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 418,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 418,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 418,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 418,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 418,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 418,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 418,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 418,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 418,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 418,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 418,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 418,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 418,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 418,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 418,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 418,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 418,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 418,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 418,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 418,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard08_Angle45R = {
  C: {
    templateId: 419,
  },
  Default: {
    templateId: 419,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 419,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 419,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 419,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 419,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 419,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 419,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 419,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 419,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 419,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 419,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 419,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 419,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 419,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 419,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 419,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 419,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 419,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 419,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 419,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 419,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 419,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 419,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 419,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 419,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 419,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 419,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 419,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 419,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 419,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 419,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 419,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 419,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 419,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 419,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 419,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 419,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 419,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 419,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 419,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 419,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 419,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 419,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 419,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 419,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 419,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 419,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 419,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 419,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 419,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 419,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 419,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 419,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 419,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 419,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 419,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 419,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 419,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 419,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 419,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 419,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 419,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 419,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 419,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 419,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 419,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 419,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 419,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 419,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 419,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 419,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 419,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 419,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 419,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 419,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 419,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 419,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 419,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 419,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 419,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 419,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 419,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 419,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 419,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 419,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 419,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 419,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 419,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 419,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 419,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 419,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 419,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 419,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 419,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 419,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 419,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 419,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 419,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 419,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 419,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 419,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 419,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 419,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 419,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 419,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_HorizontalBoard08_Grain = {
  C: {
    templateId: 279,
  },
  Default: {
    templateId: 279,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 279,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 279,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 279,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 279,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 279,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 279,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 279,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 279,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 279,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 279,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 279,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 279,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 279,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 279,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 279,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 279,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 279,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 279,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 279,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 279,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 279,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 279,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 279,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 279,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 279,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 279,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 279,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 279,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 279,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 279,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 279,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 279,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 279,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 279,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 279,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 279,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 279,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 279,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 279,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 279,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 279,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 279,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 279,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 279,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 279,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 279,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 279,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 279,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 279,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 279,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 279,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 279,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 279,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 279,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 279,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 279,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 279,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 279,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 279,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 279,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 279,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 279,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 279,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 279,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 279,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 279,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 279,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 279,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 279,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 279,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 279,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 279,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 279,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 279,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 279,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 279,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 279,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 279,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 279,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 279,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 279,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 279,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 279,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 279,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 279,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 279,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 279,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 279,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 279,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 279,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 279,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 279,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 279,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 279,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 279,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 279,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 279,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 279,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 279,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 279,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 279,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 279,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 279,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 279,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_PanelBoard_48x24 = {
  C: {
    templateId: 554,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_PanelBoard_V_48 = {
  C: {
    templateId: 555,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_ReverseBatten05hx01 = {
  C: {
    templateId: 255,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 255,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 255,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 255,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 255,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 255,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 255,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 255,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 255,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 255,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 255,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 255,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 255,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 255,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 255,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 255,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 255,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 255,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 255,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 255,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 255,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 255,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 255,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 255,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 255,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 255,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 255,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 255,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 255,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 255,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 255,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 255,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 255,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 255,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 255,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 255,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 255,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 255,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 255,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 255,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 255,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 255,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 255,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 255,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 255,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 255,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 255,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 255,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 255,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 255,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 255,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 255,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 255,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 255,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 255,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 255,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 255,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 255,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 255,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 255,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 255,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 255,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 255,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 255,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 255,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 255,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 255,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_ScaleShingle07 = {
  C: {
    templateId: 104,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_ShakeShingle06 = {
  C: {
    templateId: 153,
  },
  L: {
    ShakeShingle: {
      ShakeShingle_Foundry_034_Eggshell: {
        layerConfigId: 56,
        templateId: 153,
      },
      ShakeShingle_Foundry_112_Moss: {
        layerConfigId: 57,
        templateId: 153,
      },
      ShakeShingle_Gray: {
        layerConfigId: 58,
        templateId: 153,
      },
      ShakeShingle_JH_AgedPewter: {
        layerConfigId: 59,
        templateId: 153,
      },
      ShakeShingle_JH_BoothbayBlue: {
        layerConfigId: 60,
        templateId: 153,
      },
      ShakeShingle_JH_TimberBark: {
        layerConfigId: 61,
        templateId: 153,
      },
      ShakeShingle_White: {
        layerConfigId: 65,
        templateId: 153,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_ShakeShingle07 = {
  C: {
    templateId: 73,
  },
  L: {
    ShakeShingle: {
      ShakeShingle_Foundry_034_Eggshell: {
        layerConfigId: 56,
        templateId: 73,
      },
      ShakeShingle_Foundry_112_Moss: {
        layerConfigId: 57,
        templateId: 73,
      },
      ShakeShingle_Gray: {
        layerConfigId: 58,
        templateId: 73,
      },
      ShakeShingle_JH_AgedPewter: {
        layerConfigId: 59,
        templateId: 73,
      },
      ShakeShingle_JH_BoothbayBlue: {
        layerConfigId: 60,
        templateId: 73,
      },
      ShakeShingle_JH_TimberBark: {
        layerConfigId: 61,
        templateId: 73,
      },
      ShakeShingle_White: {
        layerConfigId: 65,
        templateId: 73,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_ShakeShingle09 = {
  C: {
    templateId: 417,
  },
  L: {
    ShakeShingle: {
      ShakeShingle_Foundry_034_Eggshell: {
        layerConfigId: 56,
        templateId: 417,
      },
      ShakeShingle_Foundry_112_Moss: {
        layerConfigId: 57,
        templateId: 417,
      },
      ShakeShingle_Gray: {
        layerConfigId: 58,
        templateId: 417,
      },
      ShakeShingle_JH_AgedPewter: {
        layerConfigId: 59,
        templateId: 417,
      },
      ShakeShingle_JH_BoothbayBlue: {
        layerConfigId: 60,
        templateId: 417,
      },
      ShakeShingle_JH_TimberBark: {
        layerConfigId: 61,
        templateId: 417,
      },
      ShakeShingle_White: {
        layerConfigId: 65,
        templateId: 417,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_ShakeShingleStraight05 = {
  C: {
    templateId: 399,
  },
  L: {
    ShakeShingle: {
      ShakeShingle_Foundry_034_Eggshell: {
        layerConfigId: 56,
        templateId: 399,
      },
      ShakeShingle_Foundry_112_Moss: {
        layerConfigId: 57,
        templateId: 399,
      },
      ShakeShingle_Gray: {
        layerConfigId: 58,
        templateId: 399,
      },
      ShakeShingle_JH_AgedPewter: {
        layerConfigId: 59,
        templateId: 399,
      },
      ShakeShingle_JH_BoothbayBlue: {
        layerConfigId: 60,
        templateId: 399,
      },
      ShakeShingle_JH_TimberBark: {
        layerConfigId: 61,
        templateId: 399,
      },
      ShakeShingle_White: {
        layerConfigId: 65,
        templateId: 399,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_ShakeShingleStraight06 = {
  C: {
    templateId: 400,
  },
  L: {
    ShakeShingle: {
      ShakeShingle_Foundry_034_Eggshell: {
        layerConfigId: 56,
        templateId: 400,
      },
      ShakeShingle_Foundry_112_Moss: {
        layerConfigId: 57,
        templateId: 400,
      },
      ShakeShingle_Gray: {
        layerConfigId: 58,
        templateId: 400,
      },
      ShakeShingle_JH_AgedPewter: {
        layerConfigId: 59,
        templateId: 400,
      },
      ShakeShingle_JH_BoothbayBlue: {
        layerConfigId: 60,
        templateId: 400,
      },
      ShakeShingle_JH_TimberBark: {
        layerConfigId: 61,
        templateId: 400,
      },
      ShakeShingle_White: {
        layerConfigId: 65,
        templateId: 400,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_ShakeShingleStraight07 = {
  C: {
    templateId: 126,
  },
  L: {
    ShakeShingle: {
      ShakeShingle_Foundry_034_Eggshell: {
        layerConfigId: 56,
        templateId: 126,
      },
      ShakeShingle_Foundry_112_Moss: {
        layerConfigId: 57,
        templateId: 126,
      },
      ShakeShingle_Gray: {
        layerConfigId: 58,
        templateId: 126,
      },
      ShakeShingle_JH_AgedPewter: {
        layerConfigId: 59,
        templateId: 126,
      },
      ShakeShingle_JH_BoothbayBlue: {
        layerConfigId: 60,
        templateId: 126,
      },
      ShakeShingle_JH_TimberBark: {
        layerConfigId: 61,
        templateId: 126,
      },
      ShakeShingle_White: {
        layerConfigId: 65,
        templateId: 126,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StaggerBoard05 = {
  C: {
    templateId: 65,
  },
  Default: {
    templateId: 65,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_Stucco = {
  C: {
    templateId: 88,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoFine = {
  C: {
    templateId: 89,
  },
  Default: {
    templateId: 89,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored04 = {
  C: {
    templateId: 236,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored06 = {
  C: {
    templateId: 237,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored07 = {
  C: {
    templateId: 238,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored08 = {
  C: {
    templateId: 239,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored10 = {
  C: {
    templateId: 369,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored12 = {
  C: {
    templateId: 370,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored14 = {
  C: {
    templateId: 371,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored16 = {
  C: {
    templateId: 372,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored18 = {
  C: {
    templateId: 373,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored20 = {
  C: {
    templateId: 374,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored22 = {
  C: {
    templateId: 375,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_StuccoScored24 = {
  C: {
    templateId: 376,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_Tile = {
  Default: {
    templateId: 125,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_Tile06x12_Carrara = {
  Default: {
    templateId: 124,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard02 = {
  C: {
    templateId: 90,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 90,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 90,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 90,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 90,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 90,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 90,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 90,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 90,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 90,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 90,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 90,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 90,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 90,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 90,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 90,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 90,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 90,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 90,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 90,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 90,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 90,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 90,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 90,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 90,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 90,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 90,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 90,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 90,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 90,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 90,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 90,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 90,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 90,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 90,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 90,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 90,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 90,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 90,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 90,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 90,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 90,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 90,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 90,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 90,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 90,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 90,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 90,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 90,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 90,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 90,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 90,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 90,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 90,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 90,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 90,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 90,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 90,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 90,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 90,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 90,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 90,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 90,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 90,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 90,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 90,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 90,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 90,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 90,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 90,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 90,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 90,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard02_Grain = {
  C: {
    templateId: 441,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 441,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 441,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 441,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 441,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 441,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 441,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 441,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 441,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 441,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 441,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 441,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 441,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 441,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 441,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 441,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 441,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 441,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 441,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 441,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 441,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 441,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 441,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 441,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 441,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 441,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 441,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 441,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 441,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 441,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 441,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 441,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 441,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 441,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 441,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 441,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 441,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 441,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 441,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 441,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 441,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 441,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 441,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 441,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 441,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 441,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 441,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 441,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 441,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 441,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 441,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 441,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 441,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 441,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 441,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 441,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 441,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 441,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 441,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 441,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 441,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 441,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 441,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 441,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 441,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 441,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 441,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 441,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 441,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 441,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 441,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 441,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard03 = {
  C: {
    templateId: 595,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 595,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 595,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 595,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 595,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 595,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 595,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 595,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 595,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 595,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 595,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 595,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 595,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 595,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 595,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 595,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 595,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 595,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 595,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 595,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 595,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 595,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 595,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 595,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 595,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 595,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 595,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 595,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 595,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 595,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 595,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 595,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 595,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 595,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 595,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 595,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 595,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 595,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 595,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 595,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 595,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 595,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 595,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 595,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 595,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 595,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 595,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 595,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 595,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 595,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 595,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 595,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 595,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 595,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 595,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 595,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 595,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 595,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 595,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 595,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 595,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 595,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 595,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 595,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 595,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 595,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 595,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 595,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 595,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 595,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 595,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 595,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard03_Grain = {
  C: {
    templateId: 594,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 594,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 594,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 594,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 594,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 594,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 594,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 594,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 594,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 594,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 594,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 594,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 594,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 594,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 594,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 594,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 594,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 594,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 594,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 594,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 594,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 594,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 594,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 594,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 594,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 594,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 594,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 594,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 594,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 594,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 594,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 594,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 594,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 594,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 594,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 594,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 594,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 594,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 594,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 594,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 594,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 594,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 594,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 594,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 594,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 594,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 594,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 594,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 594,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 594,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 594,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 594,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 594,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 594,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 594,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 594,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 594,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 594,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 594,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 594,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 594,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 594,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 594,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 594,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 594,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 594,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 594,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 594,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 594,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 594,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 594,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 594,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard04 = {
  C: {
    templateId: 91,
  },
  Default: {
    templateId: 91,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 91,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 91,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 91,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 91,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 91,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 91,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 91,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 91,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 91,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 91,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 91,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 91,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 91,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 91,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 91,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 91,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 91,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 91,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 91,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 91,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 91,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 91,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 91,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 91,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 91,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 91,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 91,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 91,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 91,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 91,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 91,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 91,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 91,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 91,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 91,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 91,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 91,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 91,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 91,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 91,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 91,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 91,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 91,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 91,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 91,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 91,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 91,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 91,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 91,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 91,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 91,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 91,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 91,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 91,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 91,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 91,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 91,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 91,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 91,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 91,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 91,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 91,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 91,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 91,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 91,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 91,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 91,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 91,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 91,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 91,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 91,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard04_Grain = {
  C: {
    templateId: 442,
  },
  Default: {
    templateId: 442,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 442,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 442,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 442,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 442,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 442,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 442,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 442,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 442,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 442,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 442,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 442,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 442,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 442,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 442,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 442,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 442,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 442,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 442,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 442,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 442,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 442,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 442,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 442,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 442,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 442,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 442,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 442,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 442,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 442,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 442,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 442,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 442,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 442,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 442,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 442,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 442,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 442,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 442,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 442,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 442,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 442,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 442,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 442,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 442,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 442,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 442,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 442,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 442,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 442,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 442,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 442,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 442,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 442,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 442,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 442,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 442,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 442,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 442,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 442,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 442,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 442,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 442,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 442,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 442,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 442,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 442,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 442,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 442,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 442,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 442,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 442,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard05 = {
  C: {
    templateId: 92,
  },
  Default: {
    templateId: 92,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 92,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 92,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 92,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 92,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 92,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 92,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 92,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 92,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 92,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 92,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 92,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 92,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 92,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 92,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 92,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 92,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 92,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 92,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 92,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 92,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 92,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 92,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 92,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 92,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 92,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 92,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 92,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 92,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 92,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 92,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 92,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 92,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 92,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 92,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 92,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 92,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 92,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 92,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 92,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 92,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 92,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 92,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 92,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 92,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 92,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 92,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 92,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 92,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 92,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 92,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 92,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 92,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 92,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 92,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 92,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 92,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 92,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 92,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 92,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 92,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 92,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 92,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 92,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 92,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 92,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 92,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 92,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 92,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 92,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 92,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 92,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard05H = {
  C: {
    templateId: 93,
  },
  Default: {
    templateId: 93,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 93,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 93,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 93,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 93,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 93,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 93,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 93,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 93,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 93,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 93,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 93,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 93,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 93,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 93,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 93,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 93,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 93,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 93,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 93,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 93,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 93,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 93,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 93,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 93,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 93,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 93,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 93,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 93,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 93,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 93,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 93,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 93,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 93,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 93,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 93,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 93,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 93,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 93,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 93,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 93,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 93,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 93,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 93,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 93,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 93,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 93,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 93,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 93,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 93,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 93,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 93,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 93,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 93,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 93,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 93,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 93,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 93,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 93,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 93,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 93,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 93,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 93,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 93,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 93,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 93,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 93,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 93,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 93,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 93,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 93,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 93,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard05H_Grain = {
  C: {
    templateId: 444,
  },
  Default: {
    templateId: 444,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 444,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 444,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 444,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 444,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 444,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 444,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 444,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 444,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 444,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 444,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 444,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 444,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 444,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 444,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 444,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 444,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 444,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 444,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 444,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 444,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 444,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 444,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 444,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 444,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 444,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 444,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 444,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 444,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 444,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 444,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 444,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 444,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 444,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 444,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 444,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 444,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 444,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 444,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 444,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 444,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 444,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 444,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 444,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 444,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 444,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 444,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 444,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 444,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 444,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 444,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 444,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 444,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 444,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 444,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 444,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 444,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 444,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 444,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 444,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 444,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 444,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 444,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 444,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 444,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 444,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 444,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 444,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 444,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 444,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 444,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 444,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard05_Grain = {
  C: {
    templateId: 443,
  },
  Default: {
    templateId: 443,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 443,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 443,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 443,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 443,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 443,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 443,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 443,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 443,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 443,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 443,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 443,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 443,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 443,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 443,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 443,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 443,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 443,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 443,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 443,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 443,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 443,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 443,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 443,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 443,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 443,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 443,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 443,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 443,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 443,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 443,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 443,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 443,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 443,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 443,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 443,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 443,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 443,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 443,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 443,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 443,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 443,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 443,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 443,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 443,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 443,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 443,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 443,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 443,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 443,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 443,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 443,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 443,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 443,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 443,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 443,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 443,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 443,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 443,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 443,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 443,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 443,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 443,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 443,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 443,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 443,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 443,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 443,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 443,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 443,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 443,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 443,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard06 = {
  C: {
    templateId: 94,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 94,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 94,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 94,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 94,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 94,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 94,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 94,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 94,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 94,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 94,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 94,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 94,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 94,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 94,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 94,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 94,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 94,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 94,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 94,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 94,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 94,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 94,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 94,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 94,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 94,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 94,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 94,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 94,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 94,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 94,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 94,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 94,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 94,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 94,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 94,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 94,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 94,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 94,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 94,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 94,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 94,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 94,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 94,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 94,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 94,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 94,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 94,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 94,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 94,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 94,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 94,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 94,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 94,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 94,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 94,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 94,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 94,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 94,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 94,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 94,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 94,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 94,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 94,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 94,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 94,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 94,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 94,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 94,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 94,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 94,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 94,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard06_Beaded01h = {
  C: {
    templateId: 463,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 463,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 463,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 463,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 463,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 463,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 463,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 463,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 463,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 463,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 463,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 463,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 463,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 463,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 463,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 463,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 463,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 463,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 463,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 463,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 463,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 463,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 463,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 463,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 463,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 463,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 463,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 463,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 463,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 463,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 463,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 463,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 463,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 463,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 463,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 463,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 463,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 463,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 463,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 463,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 463,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 463,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 463,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 463,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 463,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 463,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 463,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 463,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 463,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 463,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 463,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 463,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 463,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 463,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 463,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 463,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 463,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 463,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 463,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 463,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 463,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 463,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 463,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 463,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 463,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 463,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 463,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 463,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 463,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 463,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 463,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 463,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard06_Grain = {
  C: {
    templateId: 445,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 445,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 445,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 445,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 445,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 445,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 445,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 445,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 445,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 445,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 445,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 445,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 445,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 445,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 445,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 445,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 445,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 445,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 445,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 445,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 445,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 445,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 445,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 445,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 445,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 445,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 445,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 445,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 445,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 445,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 445,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 445,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 445,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 445,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 445,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 445,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 445,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 445,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 445,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 445,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 445,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 445,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 445,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 445,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 445,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 445,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 445,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 445,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 445,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 445,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 445,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 445,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 445,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 445,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 445,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 445,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 445,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 445,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 445,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 445,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 445,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 445,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 445,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 445,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 445,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 445,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 445,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 445,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 445,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 445,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 445,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 445,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard08 = {
  C: {
    templateId: 95,
  },
  Default: {
    templateId: 95,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 95,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 95,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 95,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 95,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 95,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 95,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 95,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 95,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 95,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 95,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 95,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 95,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 95,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 95,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 95,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 95,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 95,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 95,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 95,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 95,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 95,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 95,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 95,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 95,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 95,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 95,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 95,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 95,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 95,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 95,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 95,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 95,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 95,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 95,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 95,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 95,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 95,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 95,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 95,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 95,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 95,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 95,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 95,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 95,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 95,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 95,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 95,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 95,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 95,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 95,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 95,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 95,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 95,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 95,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 95,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 95,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 95,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 95,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 95,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 95,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 95,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 95,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 95,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 95,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 95,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 95,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 95,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 95,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 95,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 95,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 95,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wall_VerticalBoard08_Grain = {
  C: {
    templateId: 446,
  },
  Default: {
    templateId: 446,
  },
  L: {
    CHI_Garage_Wood_V: {
      CHI_Wood_AccentsCedar_V: {
        layerConfigId: 363,
        templateId: 446,
      },
      CHI_Wood_AccentsDarkOak_V: {
        layerConfigId: 364,
        templateId: 446,
      },
      CHI_Wood_AccentsDriftwood_V: {
        layerConfigId: 365,
        templateId: 446,
      },
      CHI_Wood_AccentsMahogany_V: {
        layerConfigId: 366,
        templateId: 446,
      },
      CHI_Wood_AccentsWalnut_V: {
        layerConfigId: 367,
        templateId: 446,
      },
      CHI_Wood_CarbonOak_V: {
        layerConfigId: 368,
        templateId: 446,
      },
      CHI_Wood_ClassicWoodgrain_V: {
        layerConfigId: 369,
        templateId: 446,
      },
      CHI_Wood_ModernWoodgrain_V: {
        layerConfigId: 370,
        templateId: 446,
      },
      CHI_Wood_NaturalOak_V: {
        layerConfigId: 371,
        templateId: 446,
      },
    },
    LS_Custom_DualColor: {
      LS_JH_AgedPewter_ArcticWhite: {
        layerConfigId: 800,
        templateId: 446,
      },
      LS_JH_ArcticWhite_Cobblestone: {
        layerConfigId: 774,
        templateId: 446,
      },
      LS_JH_MontereyTaupe_ArcticWhite: {
        layerConfigId: 801,
        templateId: 446,
      },
      LS_JH_TimberBark_ArcticWhite: {
        layerConfigId: 775,
        templateId: 446,
      },
      LS_JH_TimberBark_RichEspresso: {
        layerConfigId: 776,
        templateId: 446,
      },
    },
    VerticalBoard: {
      VerticalBoard_BM_936_MeadowMist: {
        layerConfigId: 76,
        templateId: 446,
      },
      VerticalBoard_NaturallyDistressedCharcoal: {
        layerConfigId: 74,
        templateId: 446,
      },
      VerticalBoard_NaturallyDistressedWhite: {
        layerConfigId: 75,
        templateId: 446,
      },
      VerticalBoard_Nichia_Cedar: {
        layerConfigId: 77,
        templateId: 446,
      },
      VerticalBoard_Thermory_Ignite: {
        layerConfigId: 86,
        templateId: 446,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 446,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 446,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 446,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 446,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 446,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 446,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 446,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 446,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 446,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 446,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 446,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 446,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 446,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 446,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 446,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 446,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 446,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 446,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 446,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 446,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 446,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 446,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 446,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 446,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 446,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 446,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 446,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 446,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 446,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 446,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 446,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 446,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 446,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 446,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 446,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 446,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 446,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 446,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 446,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 446,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 446,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 446,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 446,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 446,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 446,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 446,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 446,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 446,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 446,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 446,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 446,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 446,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Window = {
  C: {
    templateId: 97,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wood_Generic = {
  C: {
    templateId: 39,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 39,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 39,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 39,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 39,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 39,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 39,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 39,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 39,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 39,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 39,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 39,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 39,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 39,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 39,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 39,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 39,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 39,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 39,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 39,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 39,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 39,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 39,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 39,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 39,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 39,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 39,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 39,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 39,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 39,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 39,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 39,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 39,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 39,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 39,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 39,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 39,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 39,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 39,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 39,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 39,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 39,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 39,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 39,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 39,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 39,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 39,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 39,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 39,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 39,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 39,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 39,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 39,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 39,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 39,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 39,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 39,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 39,
      },
    },
    Wood_Pella_V: {
      Pella_Wood_Black_V: {
        layerConfigId: 612,
        templateId: 39,
      },
      Pella_Wood_Charcoal_V: {
        layerConfigId: 614,
        templateId: 39,
      },
      Pella_Wood_DarkMahogany_V: {
        layerConfigId: 616,
        templateId: 39,
      },
      Pella_Wood_EarlyAmerican_V: {
        layerConfigId: 618,
        templateId: 39,
      },
      Pella_Wood_Espresso_V: {
        layerConfigId: 620,
        templateId: 39,
      },
      Pella_Wood_GoldenOak_V: {
        layerConfigId: 622,
        templateId: 39,
      },
      Pella_Wood_Mahogany_V: {
        layerConfigId: 1125,
        templateId: 39,
      },
      Pella_Wood_Natural_V: {
        layerConfigId: 624,
        templateId: 39,
      },
      Pella_Wood_Pecan_V: {
        layerConfigId: 1127,
        templateId: 39,
      },
      Pella_Wood_Provincial_V: {
        layerConfigId: 626,
        templateId: 39,
      },
      Pella_Wood_RedMahogany_V: {
        layerConfigId: 628,
        templateId: 39,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 39,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 39,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 39,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 39,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 39,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 39,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 39,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 39,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 39,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 39,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 39,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 39,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 39,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 39,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 39,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 39,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 39,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 39,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 39,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 39,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 39,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 39,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 39,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 39,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 39,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 39,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 39,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 39,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 39,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 39,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 39,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 39,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 39,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 39,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 39,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 39,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 39,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 39,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 39,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 39,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 39,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 39,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 39,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 39,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 39,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 39,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 39,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 39,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 39,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 39,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 39,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 39,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 39,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 39,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 39,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 39,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 39,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 39,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 39,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 39,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 39,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 39,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 39,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 39,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 39,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 39,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 39,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 39,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 39,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 39,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 39,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 39,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 39,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 39,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 39,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 39,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 39,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 39,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 39,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 39,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 39,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 39,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 39,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 39,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 39,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 39,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 39,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 39,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 39,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wood_Generic_V = {
  C: {
    templateId: 490,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 490,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 490,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 490,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 490,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 490,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 490,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 490,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 490,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 490,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 490,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 490,
      },
    },
    Wood_DCM: {
      Wood_DCM_Cedar: {
        layerConfigId: 1095,
        templateId: 490,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 490,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 490,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 490,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 490,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 490,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 490,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 490,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 490,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 490,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 490,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 490,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 490,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 490,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 490,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 490,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 490,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 490,
      },
    },
    Wood_Minwax_Stains_V: {
      Wood_GS_Stain_AgedOak1024_V: {
        layerConfigId: 547,
        templateId: 490,
      },
      Wood_GS_Stain_Black1173_V: {
        layerConfigId: 548,
        templateId: 490,
      },
      Wood_GS_Stain_Chestnut1176_V: {
        layerConfigId: 549,
        templateId: 490,
      },
      Wood_GS_Stain_Coffee1177_V: {
        layerConfigId: 550,
        templateId: 490,
      },
      Wood_GS_Stain_Hickory1178_V: {
        layerConfigId: 551,
        templateId: 490,
      },
      Wood_GS_Stain_HoneyMaple1179_V: {
        layerConfigId: 552,
        templateId: 490,
      },
      Wood_GS_Stain_Mahogany1180_V: {
        layerConfigId: 553,
        templateId: 490,
      },
      Wood_Minwax_Stain_DarkWalnut_V: {
        layerConfigId: 1140,
        templateId: 490,
      },
      Wood_Minwax_Stain_Jacobean_V: {
        layerConfigId: 1000,
        templateId: 490,
      },
      Wood_Minwax_Stain_TrueBlack_V: {
        layerConfigId: 1142,
        templateId: 490,
      },
      Wood_Minwax_Stain_Walnut_V: {
        layerConfigId: 958,
        templateId: 490,
      },
      Wood_Stain_Alluvium417_V: {
        layerConfigId: 555,
        templateId: 490,
      },
      Wood_Stain_Carbon409_V: {
        layerConfigId: 556,
        templateId: 490,
      },
      Wood_Stain_Greenwood413_V: {
        layerConfigId: 557,
        templateId: 490,
      },
      Wood_Stain_Oakwood435_V: {
        layerConfigId: 558,
        templateId: 490,
      },
      Wood_Stain_Smokewood407_V: {
        layerConfigId: 559,
        templateId: 490,
      },
      Wood_Stain_ToastedBarrell405_V: {
        layerConfigId: 560,
        templateId: 490,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 490,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 490,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 490,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 490,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 490,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 490,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 490,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 490,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 490,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 490,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 490,
      },
    },
    Wood_Pella_V: {
      Pella_Wood_Black_V: {
        layerConfigId: 612,
        templateId: 490,
      },
      Pella_Wood_Charcoal_V: {
        layerConfigId: 614,
        templateId: 490,
      },
      Pella_Wood_DarkMahogany_V: {
        layerConfigId: 616,
        templateId: 490,
      },
      Pella_Wood_EarlyAmerican_V: {
        layerConfigId: 618,
        templateId: 490,
      },
      Pella_Wood_Espresso_V: {
        layerConfigId: 620,
        templateId: 490,
      },
      Pella_Wood_GoldenOak_V: {
        layerConfigId: 622,
        templateId: 490,
      },
      Pella_Wood_Mahogany_V: {
        layerConfigId: 1125,
        templateId: 490,
      },
      Pella_Wood_Natural_V: {
        layerConfigId: 624,
        templateId: 490,
      },
      Pella_Wood_Pecan_V: {
        layerConfigId: 1127,
        templateId: 490,
      },
      Pella_Wood_Provincial_V: {
        layerConfigId: 626,
        templateId: 490,
      },
      Pella_Wood_RedMahogany_V: {
        layerConfigId: 628,
        templateId: 490,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 490,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 490,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 490,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 490,
      },
    },
    Wood_ReadySeal_Stains_V: {
      Wood_RS_Stain_NaturalCedar_V: {
        layerConfigId: 554,
        templateId: 490,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 490,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 490,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 490,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 490,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 490,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 490,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 490,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 490,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 490,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 490,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 490,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 490,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 490,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 490,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 490,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 490,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 490,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 490,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 490,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 490,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 490,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 490,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 490,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 490,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 490,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 490,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 490,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 490,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 490,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 490,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 490,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 490,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 490,
      },
    },
    Wood_SherwinWilliams_Stains_V: {
      Wood_SW_Stain_3023_Flagstone_V: {
        layerConfigId: 1144,
        templateId: 490,
      },
      Wood_SW_Stain_3025_Caribou_V: {
        layerConfigId: 605,
        templateId: 490,
      },
      Wood_SW_Stain_3027_Driftwood_V: {
        layerConfigId: 651,
        templateId: 490,
      },
      Wood_SW_Stain_3039_Tobacco_V: {
        layerConfigId: 1152,
        templateId: 490,
      },
      Wood_SW_Stain_3125_RanchOak_V: {
        layerConfigId: 385,
        templateId: 490,
      },
      Wood_SW_Stain_3501_Redwood_V: {
        layerConfigId: 477,
        templateId: 490,
      },
      Wood_SW_Stain_3502_MissionWall_V: {
        layerConfigId: 478,
        templateId: 490,
      },
      Wood_SW_Stain_3503_WhiteBirch_V: {
        layerConfigId: 479,
        templateId: 490,
      },
      Wood_SW_Stain_3504_Woodridge_V: {
        layerConfigId: 480,
        templateId: 490,
      },
      Wood_SW_Stain_3505_YankeeBarn_V: {
        layerConfigId: 481,
        templateId: 490,
      },
      Wood_SW_Stain_3507_Riverwood_V: {
        layerConfigId: 386,
        templateId: 490,
      },
      Wood_SW_Stain_3508_CoveredBridge_V: {
        layerConfigId: 482,
        templateId: 490,
      },
      Wood_SW_Stain_3509_BajaBeige_V: {
        layerConfigId: 483,
        templateId: 490,
      },
      Wood_SW_Stain_3511_CedarBark_V: {
        layerConfigId: 484,
        templateId: 490,
      },
      Wood_SW_Stain_3512_CiderMill_V: {
        layerConfigId: 485,
        templateId: 490,
      },
      Wood_SW_Stain_3513_SpiceChest_V: {
        layerConfigId: 486,
        templateId: 490,
      },
      Wood_SW_Stain_3518_Hawthorne_V: {
        layerConfigId: 487,
        templateId: 490,
      },
      Wood_SW_Stain_3520_Ficus_V: {
        layerConfigId: 488,
        templateId: 490,
      },
      Wood_SW_Stain_3521_Crossroads_V: {
        layerConfigId: 489,
        templateId: 490,
      },
      Wood_SW_Stain_3522_BanyanBrown_V: {
        layerConfigId: 490,
        templateId: 490,
      },
      Wood_SW_Stain_3524_Chestnut_V: {
        layerConfigId: 387,
        templateId: 490,
      },
      Wood_SW_Stain_3530_MossOlive_V: {
        layerConfigId: 491,
        templateId: 490,
      },
      Wood_SW_Stain_3531_BlueShadow_V: {
        layerConfigId: 492,
        templateId: 490,
      },
      Wood_SW_Stain_3532_HillCountry_V: {
        layerConfigId: 493,
        templateId: 490,
      },
      Wood_SW_Stain_3533_Leeward_V: {
        layerConfigId: 494,
        templateId: 490,
      },
      Wood_SW_Stain_3535_Foliage_V: {
        layerConfigId: 495,
        templateId: 490,
      },
      Wood_SW_Stain_3540_MountainAsh_V: {
        layerConfigId: 496,
        templateId: 490,
      },
      Wood_SW_Stain_3541_HarborMist_V: {
        layerConfigId: 497,
        templateId: 490,
      },
      Wood_SW_Stain_3542_Charwood_V: {
        layerConfigId: 450,
        templateId: 490,
      },
      Wood_SW_Stain_3561_Cedar_V: {
        layerConfigId: 595,
        templateId: 490,
      },
      Wood_SW_Stain_3566_DouglasFir_V: {
        layerConfigId: 663,
        templateId: 490,
      },
      Wood_SW_Stain_DB2317_Fig_V: {
        layerConfigId: 661,
        templateId: 490,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 490,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 490,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 490,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 490,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 490,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 490,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 490,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 490,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 490,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 490,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 490,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 490,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 490,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 490,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 490,
      },
    },
    Wood_WayneDalton: {
      Wood_WD_Beachwood: {
        layerConfigId: 1096,
        templateId: 490,
      },
      Wood_WD_Black: {
        layerConfigId: 1097,
        templateId: 490,
      },
      Wood_WD_CarbonOak: {
        layerConfigId: 1098,
        templateId: 490,
      },
      Wood_WD_MediumOak: {
        layerConfigId: 1099,
        templateId: 490,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wood_HorizontalPlank = {
  C: {
    templateId: 98,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 98,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 98,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 98,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 98,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 98,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 98,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 98,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 98,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 98,
      },
    },
    HorizontalBoard: {
      HorizontalBoard_Nichia_Cedar: {
        layerConfigId: 53,
        templateId: 98,
      },
      HorizontalBoard_Thermory_Ignite: {
        layerConfigId: 85,
        templateId: 98,
      },
      HorizontalBoard_TimberBlend: {
        layerConfigId: 54,
        templateId: 98,
      },
      HorizontalBoard_White: {
        layerConfigId: 55,
        templateId: 98,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 98,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 98,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 98,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 98,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 98,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 98,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 98,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 98,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 98,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 98,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 98,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 98,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 98,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 98,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 98,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 98,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 98,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 98,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 98,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 98,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 98,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 98,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 98,
      },
    },
    Wood_Pella: {
      Pella_Wood_Black: {
        layerConfigId: 613,
        templateId: 98,
      },
      Pella_Wood_Charcoal: {
        layerConfigId: 615,
        templateId: 98,
      },
      Pella_Wood_DarkMahogany: {
        layerConfigId: 617,
        templateId: 98,
      },
      Pella_Wood_EarlyAmerican: {
        layerConfigId: 619,
        templateId: 98,
      },
      Pella_Wood_Espresso: {
        layerConfigId: 621,
        templateId: 98,
      },
      Pella_Wood_GoldenOak: {
        layerConfigId: 623,
        templateId: 98,
      },
      Pella_Wood_Mahogany: {
        layerConfigId: 1126,
        templateId: 98,
      },
      Pella_Wood_Natural: {
        layerConfigId: 625,
        templateId: 98,
      },
      Pella_Wood_Pecan: {
        layerConfigId: 1128,
        templateId: 98,
      },
      Pella_Wood_Provincial: {
        layerConfigId: 627,
        templateId: 98,
      },
      Pella_Wood_RedMahogany: {
        layerConfigId: 629,
        templateId: 98,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 98,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 98,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 98,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 98,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 98,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 98,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 98,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 98,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 98,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 98,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 98,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 98,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 98,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 98,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 98,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 98,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 98,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 98,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 98,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 98,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 98,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 98,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 98,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 98,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 98,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 98,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 98,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 98,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 98,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 98,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 98,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 98,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 98,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 98,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 98,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 98,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 98,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 98,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 98,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 98,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 98,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 98,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 98,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 98,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 98,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 98,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 98,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 98,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 98,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 98,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 98,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 98,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wood_Sheathing96x48 = {
  Default: {
    templateId: 281,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_Wood_StaggeredPlank = {
  C: {
    templateId: 99,
  },
  L: {
    CHI_Garage_Wood: {
      CHI_Wood_AccentsCedar: {
        layerConfigId: 333,
        templateId: 99,
      },
      CHI_Wood_AccentsDarkOak: {
        layerConfigId: 334,
        templateId: 99,
      },
      CHI_Wood_AccentsDriftwood: {
        layerConfigId: 335,
        templateId: 99,
      },
      CHI_Wood_AccentsMahogany: {
        layerConfigId: 336,
        templateId: 99,
      },
      CHI_Wood_AccentsWalnut: {
        layerConfigId: 337,
        templateId: 99,
      },
      CHI_Wood_CarbonOak: {
        layerConfigId: 338,
        templateId: 99,
      },
      CHI_Wood_ClassicWoodgrain: {
        layerConfigId: 339,
        templateId: 99,
      },
      CHI_Wood_ModernWoodgrain: {
        layerConfigId: 340,
        templateId: 99,
      },
      CHI_Wood_NaturalOak: {
        layerConfigId: 341,
        templateId: 99,
      },
    },
    Wood_ChamClad: {
      Wood_ChamClad_ChaiCedar: {
        layerConfigId: 1154,
        templateId: 99,
      },
      Wood_ChamClad_Charwood: {
        layerConfigId: 1094,
        templateId: 99,
      },
    },
    Wood_HorizontalPlank: {
      HorizontalPlank_Cedar: {
        layerConfigId: 248,
        templateId: 99,
      },
      HorizontalPlank_Morado: {
        layerConfigId: 78,
        templateId: 99,
      },
      HorizontalPlank_Oyster: {
        layerConfigId: 79,
        templateId: 99,
      },
      HorizontalPlank_SlateGray: {
        layerConfigId: 80,
        templateId: 99,
      },
    },
    Wood_Minwax_Stains: {
      Wood_GS_Stain_AgedOak1024: {
        layerConfigId: 396,
        templateId: 99,
      },
      Wood_GS_Stain_Black1173: {
        layerConfigId: 325,
        templateId: 99,
      },
      Wood_GS_Stain_Chestnut1176: {
        layerConfigId: 326,
        templateId: 99,
      },
      Wood_GS_Stain_Coffee1177: {
        layerConfigId: 327,
        templateId: 99,
      },
      Wood_GS_Stain_Hickory1178: {
        layerConfigId: 328,
        templateId: 99,
      },
      Wood_GS_Stain_HoneyMaple1179: {
        layerConfigId: 329,
        templateId: 99,
      },
      Wood_GS_Stain_Mahogany1180: {
        layerConfigId: 330,
        templateId: 99,
      },
      Wood_Minwax_Stain_DarkWalnut: {
        layerConfigId: 1141,
        templateId: 99,
      },
      Wood_Minwax_Stain_Jacobean: {
        layerConfigId: 1001,
        templateId: 99,
      },
      Wood_Minwax_Stain_TrueBlack: {
        layerConfigId: 1143,
        templateId: 99,
      },
      Wood_Minwax_Stain_Walnut: {
        layerConfigId: 957,
        templateId: 99,
      },
      Wood_Stain_Alluvium417: {
        layerConfigId: 539,
        templateId: 99,
      },
      Wood_Stain_Carbon409: {
        layerConfigId: 540,
        templateId: 99,
      },
      Wood_Stain_Greenwood413: {
        layerConfigId: 541,
        templateId: 99,
      },
      Wood_Stain_Oakwood435: {
        layerConfigId: 542,
        templateId: 99,
      },
      Wood_Stain_Smokewood407: {
        layerConfigId: 543,
        templateId: 99,
      },
      Wood_Stain_ToastedBarrell405: {
        layerConfigId: 544,
        templateId: 99,
      },
    },
    Wood_PPGstains: {
      PPG_Wood_BlackOak: {
        layerConfigId: 895,
        templateId: 99,
      },
      PPG_Wood_DriftwoodGray: {
        layerConfigId: 896,
        templateId: 99,
      },
      PPG_Wood_Ebony: {
        layerConfigId: 897,
        templateId: 99,
      },
    },
    Wood_ReadySeal_Stains: {
      Wood_RS_Stain_NaturalCedar: {
        layerConfigId: 301,
        templateId: 99,
      },
    },
    Wood_RMFP: {
      Wood_RMFP_WesternRedCedar: {
        layerConfigId: 1084,
        templateId: 99,
      },
    },
    Wood_SherwinWilliams_Stains: {
      Wood_SW_Stain_3023_Flagstone: {
        layerConfigId: 1145,
        templateId: 99,
      },
      Wood_SW_Stain_3025_Caribou: {
        layerConfigId: 606,
        templateId: 99,
      },
      Wood_SW_Stain_3027_Driftwood: {
        layerConfigId: 652,
        templateId: 99,
      },
      Wood_SW_Stain_3039_Tobacco: {
        layerConfigId: 1153,
        templateId: 99,
      },
      Wood_SW_Stain_3125_RanchOak: {
        layerConfigId: 372,
        templateId: 99,
      },
      Wood_SW_Stain_3501_Redwood: {
        layerConfigId: 456,
        templateId: 99,
      },
      Wood_SW_Stain_3502_MissionWall: {
        layerConfigId: 457,
        templateId: 99,
      },
      Wood_SW_Stain_3503_WhiteBirch: {
        layerConfigId: 458,
        templateId: 99,
      },
      Wood_SW_Stain_3504_Woodridge: {
        layerConfigId: 459,
        templateId: 99,
      },
      Wood_SW_Stain_3505_YankeeBarn: {
        layerConfigId: 460,
        templateId: 99,
      },
      Wood_SW_Stain_3507_Riverwood: {
        layerConfigId: 331,
        templateId: 99,
      },
      Wood_SW_Stain_3508_CoveredBridge: {
        layerConfigId: 461,
        templateId: 99,
      },
      Wood_SW_Stain_3509_BajaBeige: {
        layerConfigId: 462,
        templateId: 99,
      },
      Wood_SW_Stain_3511_CedarBark: {
        layerConfigId: 463,
        templateId: 99,
      },
      Wood_SW_Stain_3512_CiderMill: {
        layerConfigId: 464,
        templateId: 99,
      },
      Wood_SW_Stain_3513_SpiceChest: {
        layerConfigId: 465,
        templateId: 99,
      },
      Wood_SW_Stain_3518_Hawthorne: {
        layerConfigId: 466,
        templateId: 99,
      },
      Wood_SW_Stain_3520_Ficus: {
        layerConfigId: 467,
        templateId: 99,
      },
      Wood_SW_Stain_3521_Crossroads: {
        layerConfigId: 468,
        templateId: 99,
      },
      Wood_SW_Stain_3522_BanyanBrown: {
        layerConfigId: 469,
        templateId: 99,
      },
      Wood_SW_Stain_3524_Chestnut: {
        layerConfigId: 332,
        templateId: 99,
      },
      Wood_SW_Stain_3530_MossOlive: {
        layerConfigId: 470,
        templateId: 99,
      },
      Wood_SW_Stain_3531_BlueShadow: {
        layerConfigId: 471,
        templateId: 99,
      },
      Wood_SW_Stain_3532_HillCountry: {
        layerConfigId: 472,
        templateId: 99,
      },
      Wood_SW_Stain_3533_Leeward: {
        layerConfigId: 473,
        templateId: 99,
      },
      Wood_SW_Stain_3535_Foliage: {
        layerConfigId: 474,
        templateId: 99,
      },
      Wood_SW_Stain_3540_MountainAsh: {
        layerConfigId: 475,
        templateId: 99,
      },
      Wood_SW_Stain_3541_HarborMist: {
        layerConfigId: 476,
        templateId: 99,
      },
      Wood_SW_Stain_3542_Charwood: {
        layerConfigId: 451,
        templateId: 99,
      },
      Wood_SW_Stain_3561_Cedar: {
        layerConfigId: 596,
        templateId: 99,
      },
      Wood_SW_Stain_3566_DouglasFir: {
        layerConfigId: 664,
        templateId: 99,
      },
      Wood_SW_Stain_DB2317_Fig: {
        layerConfigId: 662,
        templateId: 99,
      },
    },
    Wood_StaggeredPlank: {
      StaggeredPlank_Cherry: {
        layerConfigId: 81,
        templateId: 99,
      },
      StaggeredPlank_Gunstock: {
        layerConfigId: 82,
        templateId: 99,
      },
      StaggeredPlank_Tower: {
        layerConfigId: 83,
        templateId: 99,
      },
    },
    Wood_TeddWood_Stains: {
      Wood_NaturalCherry_Alamo: {
        layerConfigId: 289,
        templateId: 99,
      },
    },
    Wood_TimberTech: {
      TT_MaritimeGray: {
        layerConfigId: 878,
        templateId: 99,
      },
    },
    Wood_Trim: {
      Wood_Brown: {
        layerConfigId: 34,
        templateId: 99,
      },
      Wood_Cedar: {
        layerConfigId: 35,
        templateId: 99,
      },
      Wood_Cedar_Beachwood: {
        layerConfigId: 276,
        templateId: 99,
      },
      Wood_Cedar_BlackOak: {
        layerConfigId: 277,
        templateId: 99,
      },
      Wood_Cedar_DriftwoodGray: {
        layerConfigId: 278,
        templateId: 99,
      },
      Wood_Cedar_Ebony: {
        layerConfigId: 279,
        templateId: 99,
      },
      Wood_Cedar_Mink: {
        layerConfigId: 280,
        templateId: 99,
      },
      Wood_Cedar_Natural: {
        layerConfigId: 281,
        templateId: 99,
      },
      Wood_Cedar_Sandstone: {
        layerConfigId: 282,
        templateId: 99,
      },
      Wood_Morado: {
        layerConfigId: 36,
        templateId: 99,
      },
      Wood_NaturallyDistressedCharcoal: {
        layerConfigId: 37,
        templateId: 99,
      },
      Wood_NaturallyDistressedWhite: {
        layerConfigId: 38,
        templateId: 99,
      },
      Wood_Oak: {
        layerConfigId: 39,
        templateId: 99,
      },
    },
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_X_CheckerTest = {
  Default: {
    templateId: 103,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_X_FrostedGlass = {
  Default: {
    templateId: 521,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_X_PerfTest01 = {
  Default: {
    templateId: 101,
  },
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DM_X_ReflectionTest01 = {
  Default: {
    templateId: 102,
  },
};
export const DesignMaterialPath: { [templateName: string]: any } = {
  Asphalt_Default: DM_Asphalt_Default,
  CT_Landmark_Pro: DM_CT_Landmark_Pro,
  Carpet: DM_Carpet,
  Color: DM_Color,
  Color_PlanFloor: DM_Color_PlanFloor,
  Floor_Concrete: DM_Floor_Concrete,
  Floor_ConcreteBroomFinish: DM_Floor_ConcreteBroomFinish,
  Floor_Tile: DM_Floor_Tile,
  Floor_Tile_Carrara: DM_Floor_Tile_Carrara,
  Floor_Vinyl: DM_Floor_Vinyl,
  Floor_Vinyl_NaturalStone: DM_Floor_Vinyl_NaturalStone,
  Floor_Wood: DM_Floor_Wood,
  Garage: DM_Garage,
  Glass_Base: DM_Glass_Base,
  Grass_Lawn_01: DM_Grass_Lawn_01,
  Gravel: DM_Gravel,
  Gutter: DM_Gutter,
  Lattice_45deg_1x1: DM_Lattice_45deg_1x1,
  Masonry_BrickDoubleMonarch_StackBond: DM_Masonry_BrickDoubleMonarch_StackBond,
  Masonry_BrickEngineer: DM_Masonry_BrickEngineer,
  Masonry_BrickEstate: DM_Masonry_BrickEstate,
  Masonry_BrickExecutive: DM_Masonry_BrickExecutive,
  Masonry_BrickExecutive_HalfHeight: DM_Masonry_BrickExecutive_HalfHeight,
  Masonry_BrickExecutive_Header: DM_Masonry_BrickExecutive_Header,
  Masonry_BrickExecutive_Herringbone: DM_Masonry_BrickExecutive_Herringbone,
  Masonry_BrickExecutive_Rowlock: DM_Masonry_BrickExecutive_Rowlock,
  Masonry_BrickExecutive_ThinCut: DM_Masonry_BrickExecutive_ThinCut,
  Masonry_BrickKing: DM_Masonry_BrickKing,
  Masonry_BrickKing_HalfHeight: DM_Masonry_BrickKing_HalfHeight,
  Masonry_BrickKing_Header: DM_Masonry_BrickKing_Header,
  Masonry_BrickKing_Herringbone: DM_Masonry_BrickKing_Herringbone,
  Masonry_BrickKing_Rowlock: DM_Masonry_BrickKing_Rowlock,
  Masonry_BrickKing_ThinCut: DM_Masonry_BrickKing_ThinCut,
  Masonry_BrickModular: DM_Masonry_BrickModular,
  Masonry_BrickModular_HalfHeight: DM_Masonry_BrickModular_HalfHeight,
  Masonry_BrickModular_Header: DM_Masonry_BrickModular_Header,
  Masonry_BrickModular_Herringbone: DM_Masonry_BrickModular_Herringbone,
  Masonry_BrickModular_Rowlock: DM_Masonry_BrickModular_Rowlock,
  Masonry_BrickModular_Weave3: DM_Masonry_BrickModular_Weave3,
  Masonry_BrickQueen: DM_Masonry_BrickQueen,
  Masonry_BrickQueen_HalfHeight: DM_Masonry_BrickQueen_HalfHeight,
  Masonry_BrickQueen_Header: DM_Masonry_BrickQueen_Header,
  Masonry_BrickQueen_Herringbone: DM_Masonry_BrickQueen_Herringbone,
  Masonry_BrickQueen_Rowlock: DM_Masonry_BrickQueen_Rowlock,
  Masonry_BrickQueen_ThinCut: DM_Masonry_BrickQueen_ThinCut,
  Masonry_Brick_03: DM_Masonry_Brick_03,
  Masonry_Brick_03_Header: DM_Masonry_Brick_03_Header,
  Masonry_Brick_03_Rowlock: DM_Masonry_Brick_03_Rowlock,
  Masonry_Brick_05: DM_Masonry_Brick_05,
  Masonry_Brick_05_Header: DM_Masonry_Brick_05_Header,
  Masonry_Brick_05_Rowlock: DM_Masonry_Brick_05_Rowlock,
  Masonry_Brick_075: DM_Masonry_Brick_075,
  Masonry_Brick_075_Header: DM_Masonry_Brick_075_Header,
  Masonry_Brick_075_Rowlock: DM_Masonry_Brick_075_Rowlock,
  Masonry_Brick_Bracciano: DM_Masonry_Brick_Bracciano,
  Masonry_Brick_Bracciano_Header: DM_Masonry_Brick_Bracciano_Header,
  Masonry_Brick_Bracciano_Rowlock: DM_Masonry_Brick_Bracciano_Rowlock,
  Masonry_CinderBlock08x16: DM_Masonry_CinderBlock08x16,
  Masonry_Porcelain_Mandarin_CementoLightGrey: DM_Masonry_Porcelain_Mandarin_CementoLightGrey,
  Masonry_Stone: DM_Masonry_Stone,
  Masonry_StoneField_Tan: DM_Masonry_StoneField_Tan,
  Masonry_StoneLimestone_Banks: DM_Masonry_StoneLimestone_Banks,
  Masonry_StoneLimestone_Bridgeport: DM_Masonry_StoneLimestone_Bridgeport,
  Masonry_StoneMixedStack_GrayWarm: DM_Masonry_StoneMixedStack_GrayWarm,
  Masonry_StoneRoughCut_Moonlight: DM_Masonry_StoneRoughCut_Moonlight,
  Masonry_StoneThinStack_Gray: DM_Masonry_StoneThinStack_Gray,
  Masonry_Stone_05_Trim: DM_Masonry_Stone_05_Trim,
  Masonry_Stone_05_Trim_V: DM_Masonry_Stone_05_Trim_V,
  Masonry_Stone_12_Trim: DM_Masonry_Stone_12_Trim,
  Masonry_Stone_12_Trim_V: DM_Masonry_Stone_12_Trim_V,
  Masonry_Stone_24_Trim: DM_Masonry_Stone_24_Trim,
  Masonry_Stone_24_Trim_V: DM_Masonry_Stone_24_Trim_V,
  Masonry_Stone_BC_CountryLedge: DM_Masonry_Stone_BC_CountryLedge,
  Masonry_Stone_BC_MontanaLedge: DM_Masonry_Stone_BC_MontanaLedge,
  Masonry_Stone_BC_OhioRubble: DM_Masonry_Stone_BC_OhioRubble,
  Masonry_Stone_BC_PrairieBluff: DM_Masonry_Stone_BC_PrairieBluff,
  Masonry_Stone_BC_StoneVeneerSangria: DM_Masonry_Stone_BC_StoneVeneerSangria,
  Masonry_Stone_Bello_Cobblestone: DM_Masonry_Stone_Bello_Cobblestone,
  Masonry_Stone_Bello_Fieldstone: DM_Masonry_Stone_Bello_Fieldstone,
  Masonry_Stone_Bello_Ledgestone: DM_Masonry_Stone_Bello_Ledgestone,
  Masonry_Stone_BrandCo_Drystack: DM_Masonry_Stone_BrandCo_Drystack,
  Masonry_Stone_BrandCo_Ledgestone: DM_Masonry_Stone_BrandCo_Ledgestone,
  Masonry_Stone_CDS_Blend: DM_Masonry_Stone_CDS_Blend,
  Masonry_Stone_CDS_CountryRubble: DM_Masonry_Stone_CDS_CountryRubble,
  Masonry_Stone_CDS_Ledgestone: DM_Masonry_Stone_CDS_Ledgestone,
  Masonry_Stone_CDS_Volterra: DM_Masonry_Stone_CDS_Volterra,
  Masonry_Stone_CH_ChiseledEdge: DM_Masonry_Stone_CH_ChiseledEdge,
  Masonry_Stone_Centurion_Elkmont: DM_Masonry_Stone_Centurion_Elkmont,
  Masonry_Stone_Centurion_Hackett: DM_Masonry_Stone_Centurion_Hackett,
  Masonry_Stone_Centurion_Ledgestone: DM_Masonry_Stone_Centurion_Ledgestone,
  Masonry_Stone_Centurion_Rubble: DM_Masonry_Stone_Centurion_Rubble,
  Masonry_Stone_Centurion_Stack: DM_Masonry_Stone_Centurion_Stack,
  Masonry_Stone_Cobblestone: DM_Masonry_Stone_Cobblestone,
  Masonry_Stone_Cobra_TexasLimestone: DM_Masonry_Stone_Cobra_TexasLimestone,
  Masonry_Stone_Cultured_AlpineLedgestone: DM_Masonry_Stone_Cultured_AlpineLedgestone,
  Masonry_Stone_Cultured_CountryLedgestone: DM_Masonry_Stone_Cultured_CountryLedgestone,
  Masonry_Stone_Cultured_CountryLedgestone_03_Trim: DM_Masonry_Stone_Cultured_CountryLedgestone_03_Trim,
  Masonry_Stone_Cultured_CountryLedgestone_03_Trim_V: DM_Masonry_Stone_Cultured_CountryLedgestone_03_Trim_V,
  Masonry_Stone_Cultured_CountryLedgestone_05_Trim: DM_Masonry_Stone_Cultured_CountryLedgestone_05_Trim,
  Masonry_Stone_Cultured_CountryLedgestone_05_Trim_V: DM_Masonry_Stone_Cultured_CountryLedgestone_05_Trim_V,
  Masonry_Stone_Cultured_CountryLedgestone_12_Trim: DM_Masonry_Stone_Cultured_CountryLedgestone_12_Trim,
  Masonry_Stone_Cultured_CountryLedgestone_12_Trim_V: DM_Masonry_Stone_Cultured_CountryLedgestone_12_Trim_V,
  Masonry_Stone_Cultured_CountryLedgestone_24_Trim: DM_Masonry_Stone_Cultured_CountryLedgestone_24_Trim,
  Masonry_Stone_Cultured_CountryLedgestone_24_Trim_V: DM_Masonry_Stone_Cultured_CountryLedgestone_24_Trim_V,
  Masonry_Stone_Cultured_DrystackLedgestone: DM_Masonry_Stone_Cultured_DrystackLedgestone,
  Masonry_Stone_Cultured_Limestone: DM_Masonry_Stone_Cultured_Limestone,
  Masonry_Stone_Cultured_SouthernLedgestone: DM_Masonry_Stone_Cultured_SouthernLedgestone,
  Masonry_Stone_DP_Vener_Cobblestone: DM_Masonry_Stone_DP_Vener_Cobblestone,
  Masonry_Stone_DQ_Drystack: DM_Masonry_Stone_DQ_Drystack,
  Masonry_Stone_DQ_Ledgestone: DM_Masonry_Stone_DQ_Ledgestone,
  Masonry_Stone_DQ_Limestone: DM_Masonry_Stone_DQ_Limestone,
  Masonry_Stone_DQ_RoughAshlar: DM_Masonry_Stone_DQ_RoughAshlar,
  Masonry_Stone_DQ_StackLedge: DM_Masonry_Stone_DQ_StackLedge,
  Masonry_Stone_DQ_Weatherledge: DM_Masonry_Stone_DQ_Weatherledge,
  Masonry_Stone_Drystack: DM_Masonry_Stone_Drystack,
  Masonry_Stone_Eco_CountryRidge: DM_Masonry_Stone_Eco_CountryRidge,
  Masonry_Stone_Eco_Ridgestone: DM_Masonry_Stone_Eco_Ridgestone,
  Masonry_Stone_Eldorado_Bluffstone: DM_Masonry_Stone_Eldorado_Bluffstone,
  Masonry_Stone_Eldorado_Cliffstone: DM_Masonry_Stone_Eldorado_Cliffstone,
  Masonry_Stone_Eldorado_Cliffstone_OLD: DM_Masonry_Stone_Eldorado_Cliffstone_OLD,
  Masonry_Stone_Eldorado_CoarseCutStone: DM_Masonry_Stone_Eldorado_CoarseCutStone,
  Masonry_Stone_Eldorado_CypressRidge: DM_Masonry_Stone_Eldorado_CypressRidge,
  Masonry_Stone_Eldorado_EuropeanLedge: DM_Masonry_Stone_Eldorado_EuropeanLedge,
  Masonry_Stone_Eldorado_FieldLedge: DM_Masonry_Stone_Eldorado_FieldLedge,
  Masonry_Stone_Eldorado_Limestone: DM_Masonry_Stone_Eldorado_Limestone,
  Masonry_Stone_Eldorado_Monument: DM_Masonry_Stone_Eldorado_Monument,
  Masonry_Stone_Eldorado_MountainLedge: DM_Masonry_Stone_Eldorado_MountainLedge,
  Masonry_Stone_Eldorado_MountainLedge_03_Trim: DM_Masonry_Stone_Eldorado_MountainLedge_03_Trim,
  Masonry_Stone_Eldorado_MountainLedge_03_Trim_V: DM_Masonry_Stone_Eldorado_MountainLedge_03_Trim_V,
  Masonry_Stone_Eldorado_MountainLedge_05_Trim: DM_Masonry_Stone_Eldorado_MountainLedge_05_Trim,
  Masonry_Stone_Eldorado_MountainLedge_05_Trim_V: DM_Masonry_Stone_Eldorado_MountainLedge_05_Trim_V,
  Masonry_Stone_Eldorado_MountainLedge_12_Trim: DM_Masonry_Stone_Eldorado_MountainLedge_12_Trim,
  Masonry_Stone_Eldorado_MountainLedge_12_Trim_V: DM_Masonry_Stone_Eldorado_MountainLedge_12_Trim_V,
  Masonry_Stone_Eldorado_MountainLedge_24_Trim: DM_Masonry_Stone_Eldorado_MountainLedge_24_Trim,
  Masonry_Stone_Eldorado_MountainLedge_24_Trim_V: DM_Masonry_Stone_Eldorado_MountainLedge_24_Trim_V,
  Masonry_Stone_Eldorado_Ridgetop: DM_Masonry_Stone_Eldorado_Ridgetop,
  Masonry_Stone_Eldorado_Roughcut: DM_Masonry_Stone_Eldorado_Roughcut,
  Masonry_Stone_Eldorado_RusticLedge: DM_Masonry_Stone_Eldorado_RusticLedge,
  Masonry_Stone_Eldorado_SierraCut: DM_Masonry_Stone_Eldorado_SierraCut,
  Masonry_Stone_Eldorado_StackedStone: DM_Masonry_Stone_Eldorado_StackedStone,
  Masonry_Stone_Eldorado_TundraBrick: DM_Masonry_Stone_Eldorado_TundraBrick,
  Masonry_Stone_Env_Chisel: DM_Masonry_Stone_Env_Chisel,
  Masonry_Stone_Env_Cutstone: DM_Masonry_Stone_Env_Cutstone,
  Masonry_Stone_Env_Fieldstone: DM_Masonry_Stone_Env_Fieldstone,
  Masonry_Stone_Env_Grezzo: DM_Masonry_Stone_Env_Grezzo,
  Masonry_Stone_Env_Ledgestone: DM_Masonry_Stone_Env_Ledgestone,
  Masonry_Stone_Env_ProstackLite: DM_Masonry_Stone_Env_ProstackLite,
  Masonry_Stone_Env_Tivoli: DM_Masonry_Stone_Env_Tivoli,
  Masonry_Stone_Environmental_CreamChisel: DM_Masonry_Stone_Environmental_CreamChisel,
  Masonry_Stone_Environmental_CreamChisel_Trim: DM_Masonry_Stone_Environmental_CreamChisel_Trim,
  Masonry_Stone_Environmental_CreamChisel_Trim_V: DM_Masonry_Stone_Environmental_CreamChisel_Trim_V,
  Masonry_Stone_Environmental_CreamTivoli: DM_Masonry_Stone_Environmental_CreamTivoli,
  Masonry_Stone_Environmental_CreamTivoli_Trim: DM_Masonry_Stone_Environmental_CreamTivoli_Trim,
  Masonry_Stone_Environmental_CreamTivoli_Trim_V: DM_Masonry_Stone_Environmental_CreamTivoli_Trim_V,
  Masonry_Stone_Environmental_Cutstone_03_Trim: DM_Masonry_Stone_Environmental_Cutstone_03_Trim,
  Masonry_Stone_Environmental_Cutstone_03_Trim_V: DM_Masonry_Stone_Environmental_Cutstone_03_Trim_V,
  Masonry_Stone_Environmental_Cutstone_05_Trim: DM_Masonry_Stone_Environmental_Cutstone_05_Trim,
  Masonry_Stone_Environmental_Cutstone_05_Trim_V: DM_Masonry_Stone_Environmental_Cutstone_05_Trim_V,
  Masonry_Stone_Environmental_Cutstone_12_Trim: DM_Masonry_Stone_Environmental_Cutstone_12_Trim,
  Masonry_Stone_Environmental_Cutstone_12_Trim_V: DM_Masonry_Stone_Environmental_Cutstone_12_Trim_V,
  Masonry_Stone_Environmental_Cutstone_24_Trim: DM_Masonry_Stone_Environmental_Cutstone_24_Trim,
  Masonry_Stone_Environmental_Cutstone_24_Trim_V: DM_Masonry_Stone_Environmental_Cutstone_24_Trim_V,
  Masonry_Stone_Environmental_GrezzoRosa: DM_Masonry_Stone_Environmental_GrezzoRosa,
  Masonry_Stone_Environmental_GrezzoRosa_Trim: DM_Masonry_Stone_Environmental_GrezzoRosa_Trim,
  Masonry_Stone_Environmental_GrezzoRosa_Trim_V: DM_Masonry_Stone_Environmental_GrezzoRosa_Trim_V,
  Masonry_Stone_FDL_Biltmore: DM_Masonry_Stone_FDL_Biltmore,
  Masonry_Stone_FDL_Country: DM_Masonry_Stone_FDL_Country,
  Masonry_Stone_Fieldstone: DM_Masonry_Stone_Fieldstone,
  Masonry_Stone_General_03_Trim: DM_Masonry_Stone_General_03_Trim,
  Masonry_Stone_General_03_Trim_V: DM_Masonry_Stone_General_03_Trim_V,
  Masonry_Stone_General_05_Trim: DM_Masonry_Stone_General_05_Trim,
  Masonry_Stone_General_05_Trim_V: DM_Masonry_Stone_General_05_Trim_V,
  Masonry_Stone_General_08_Trim: DM_Masonry_Stone_General_08_Trim,
  Masonry_Stone_General_08_Trim_V: DM_Masonry_Stone_General_08_Trim_V,
  Masonry_Stone_General_12_Trim: DM_Masonry_Stone_General_12_Trim,
  Masonry_Stone_General_12_Trim_V: DM_Masonry_Stone_General_12_Trim_V,
  Masonry_Stone_General_16_Trim: DM_Masonry_Stone_General_16_Trim,
  Masonry_Stone_General_16_Trim_V: DM_Masonry_Stone_General_16_Trim_V,
  Masonry_Stone_General_20_Trim: DM_Masonry_Stone_General_20_Trim,
  Masonry_Stone_General_20_Trim_V: DM_Masonry_Stone_General_20_Trim_V,
  Masonry_Stone_General_24_Trim: DM_Masonry_Stone_General_24_Trim,
  Masonry_Stone_General_24_Trim_V: DM_Masonry_Stone_General_24_Trim_V,
  Masonry_Stone_General_48_Trim: DM_Masonry_Stone_General_48_Trim,
  Masonry_Stone_General_48_Trim_V: DM_Masonry_Stone_General_48_Trim_V,
  Masonry_Stone_General_Trim: DM_Masonry_Stone_General_Trim,
  Masonry_Stone_General_Trim_V: DM_Masonry_Stone_General_Trim_V,
  Masonry_Stone_Halquist_Ledge: DM_Masonry_Stone_Halquist_Ledge,
  Masonry_Stone_Harristone_Divino: DM_Masonry_Stone_Harristone_Divino,
  Masonry_Stone_Harristone_Drystone: DM_Masonry_Stone_Harristone_Drystone,
  Masonry_Stone_Harristone_Leuders: DM_Masonry_Stone_Harristone_Leuders,
  Masonry_Stone_Harristone_Limestone: DM_Masonry_Stone_Harristone_Limestone,
  Masonry_Stone_Harristone_Tumbled: DM_Masonry_Stone_Harristone_Tumbled,
  Masonry_Stone_Harristone_Uintah: DM_Masonry_Stone_Harristone_Uintah,
  Masonry_Stone_Horizon_19thCenturyStone: DM_Masonry_Stone_Horizon_19thCenturyStone,
  Masonry_Stone_IS_Fieldstone: DM_Masonry_Stone_IS_Fieldstone,
  Masonry_Stone_Ledgestone: DM_Masonry_Stone_Ledgestone,
  Masonry_Stone_Ledgestone_03_Trim: DM_Masonry_Stone_Ledgestone_03_Trim,
  Masonry_Stone_Ledgestone_03_Trim_V: DM_Masonry_Stone_Ledgestone_03_Trim_V,
  Masonry_Stone_Ledgestone_05_Trim: DM_Masonry_Stone_Ledgestone_05_Trim,
  Masonry_Stone_Ledgestone_05_Trim_V: DM_Masonry_Stone_Ledgestone_05_Trim_V,
  Masonry_Stone_Ledgestone_12_Trim: DM_Masonry_Stone_Ledgestone_12_Trim,
  Masonry_Stone_Ledgestone_12_Trim_V: DM_Masonry_Stone_Ledgestone_12_Trim_V,
  Masonry_Stone_Ledgestone_24_Trim: DM_Masonry_Stone_Ledgestone_24_Trim,
  Masonry_Stone_Ledgestone_24_Trim_V: DM_Masonry_Stone_Ledgestone_24_Trim_V,
  Masonry_Stone_Ledgestone_Breakwater: DM_Masonry_Stone_Ledgestone_Breakwater,
  Masonry_Stone_Ledgestone_OLD: DM_Masonry_Stone_Ledgestone_OLD,
  Masonry_Stone_Limestone: DM_Masonry_Stone_Limestone,
  Masonry_Stone_Limestone_03_Trim: DM_Masonry_Stone_Limestone_03_Trim,
  Masonry_Stone_Limestone_03_Trim_V: DM_Masonry_Stone_Limestone_03_Trim_V,
  Masonry_Stone_Limestone_05_Trim: DM_Masonry_Stone_Limestone_05_Trim,
  Masonry_Stone_Limestone_05_Trim_V: DM_Masonry_Stone_Limestone_05_Trim_V,
  Masonry_Stone_Limestone_12_Trim: DM_Masonry_Stone_Limestone_12_Trim,
  Masonry_Stone_Limestone_12_Trim_V: DM_Masonry_Stone_Limestone_12_Trim_V,
  Masonry_Stone_Limestone_24_Trim: DM_Masonry_Stone_Limestone_24_Trim,
  Masonry_Stone_Limestone_24_Trim_V: DM_Masonry_Stone_Limestone_24_Trim_V,
  Masonry_Stone_Limestone_OLD: DM_Masonry_Stone_Limestone_OLD,
  Masonry_Stone_Lurveys_Cobblestone: DM_Masonry_Stone_Lurveys_Cobblestone,
  Masonry_Stone_MES_Cobblestone: DM_Masonry_Stone_MES_Cobblestone,
  Masonry_Stone_MES_SoutheasternLedge: DM_Masonry_Stone_MES_SoutheasternLedge,
  Masonry_Stone_MES_StackedStone: DM_Masonry_Stone_MES_StackedStone,
  Masonry_Stone_MES_Weatheredledge: DM_Masonry_Stone_MES_Weatheredledge,
  Masonry_Stone_MGBS_AustinLimestone: DM_Masonry_Stone_MGBS_AustinLimestone,
  Masonry_Stone_MGBS_LeudersLimestone: DM_Masonry_Stone_MGBS_LeudersLimestone,
  Masonry_Stone_MGBS_LimestoneBlends: DM_Masonry_Stone_MGBS_LimestoneBlends,
  Masonry_Stone_MV_HackettStone: DM_Masonry_Stone_MV_HackettStone,
  Masonry_Stone_MV_Ledgestone: DM_Masonry_Stone_MV_Ledgestone,
  Masonry_Stone_MV_Limestone: DM_Masonry_Stone_MV_Limestone,
  Masonry_Stone_MV_StackStone: DM_Masonry_Stone_MV_StackStone,
  Masonry_Stone_Metrobrick_Limestone: DM_Masonry_Stone_Metrobrick_Limestone,
  Masonry_Stone_MountainLedge_GreyDrift: DM_Masonry_Stone_MountainLedge_GreyDrift,
  Masonry_Stone_MountainLedge_GreyDrift_Trim: DM_Masonry_Stone_MountainLedge_GreyDrift_Trim,
  Masonry_Stone_MountainLedge_GreyDrift_Trim_V: DM_Masonry_Stone_MountainLedge_GreyDrift_Trim_V,
  Masonry_Stone_PS_OldCountyLedge: DM_Masonry_Stone_PS_OldCountyLedge,
  Masonry_Stone_PS_SouthernLimestone: DM_Masonry_Stone_PS_SouthernLimestone,
  Masonry_Stone_PS_Weatherledge: DM_Masonry_Stone_PS_Weatherledge,
  Masonry_Stone_PV_Ledgestone: DM_Masonry_Stone_PV_Ledgestone,
  Masonry_Stone_PV_WesternLedge: DM_Masonry_Stone_PV_WesternLedge,
  Masonry_Stone_Pioneer_StackEase: DM_Masonry_Stone_Pioneer_StackEase,
  Masonry_Stone_PlyGem_CanyonLedge: DM_Masonry_Stone_PlyGem_CanyonLedge,
  Masonry_Stone_PlyGem_CascadeLedge: DM_Masonry_Stone_PlyGem_CascadeLedge,
  Masonry_Stone_PlyGem_Fieldstone: DM_Masonry_Stone_PlyGem_Fieldstone,
  Masonry_Stone_PlyGem_Manorstone: DM_Masonry_Stone_PlyGem_Manorstone,
  Masonry_Stone_PlyGem_ShadowLedgestone: DM_Masonry_Stone_PlyGem_ShadowLedgestone,
  Masonry_Stone_Premier_HavannaRubble: DM_Masonry_Stone_Premier_HavannaRubble,
  Masonry_Stone_Premier_Stack: DM_Masonry_Stone_Premier_Stack,
  Masonry_Stone_ProVia_ChiselCut: DM_Masonry_Stone_ProVia_ChiselCut,
  Masonry_Stone_ProVia_DryStack: DM_Masonry_Stone_ProVia_DryStack,
  Masonry_Stone_ProVia_Edgecut: DM_Masonry_Stone_ProVia_Edgecut,
  Masonry_Stone_ProVia_Ledgestone: DM_Masonry_Stone_ProVia_Ledgestone,
  Masonry_Stone_ProVia_Limestone: DM_Masonry_Stone_ProVia_Limestone,
  Masonry_Stone_ProVia_NaturalCut: DM_Masonry_Stone_ProVia_NaturalCut,
  Masonry_Stone_ProVia_PrecisionFit: DM_Masonry_Stone_ProVia_PrecisionFit,
  Masonry_Stone_ProVia_RidgeCut: DM_Masonry_Stone_ProVia_RidgeCut,
  Masonry_Stone_ProVia_TerraCut: DM_Masonry_Stone_ProVia_TerraCut,
  Masonry_Stone_ProstackLite_IronSmoke: DM_Masonry_Stone_ProstackLite_IronSmoke,
  Masonry_Stone_ProstackLite_IronSmoke_Trim: DM_Masonry_Stone_ProstackLite_IronSmoke_Trim,
  Masonry_Stone_ProstackLite_IronSmoke_Trim_V: DM_Masonry_Stone_ProstackLite_IronSmoke_Trim_V,
  Masonry_Stone_Prostone_Ledgestone: DM_Masonry_Stone_Prostone_Ledgestone,
  Masonry_Stone_Prostone_Sawgrass: DM_Masonry_Stone_Prostone_Sawgrass,
  Masonry_Stone_QR_Cobblestone: DM_Masonry_Stone_QR_Cobblestone,
  Masonry_Stone_QR_CountryLedgestone: DM_Masonry_Stone_QR_CountryLedgestone,
  Masonry_Stone_QR_DressedFieldstone: DM_Masonry_Stone_QR_DressedFieldstone,
  Masonry_Stone_QR_RusticLedgestone: DM_Masonry_Stone_QR_RusticLedgestone,
  Masonry_Stone_QR_WeatheredEdge: DM_Masonry_Stone_QR_WeatheredEdge,
  Masonry_Stone_QS_Cobblestone: DM_Masonry_Stone_QS_Cobblestone,
  Masonry_Stone_QS_Drystack: DM_Masonry_Stone_QS_Drystack,
  Masonry_Stone_QS_Fieldstone: DM_Masonry_Stone_QS_Fieldstone,
  Masonry_Stone_RM_Bluebonnet: DM_Masonry_Stone_RM_Bluebonnet,
  Masonry_Stone_RM_Chopped: DM_Masonry_Stone_RM_Chopped,
  Masonry_Stone_RM_ChoppedLimestone: DM_Masonry_Stone_RM_ChoppedLimestone,
  Masonry_Stone_RM_Sawn: DM_Masonry_Stone_RM_Sawn,
  Masonry_Stone_RM_SawnBuilding: DM_Masonry_Stone_RM_SawnBuilding,
  Masonry_Stone_RM_Waterford: DM_Masonry_Stone_RM_Waterford,
  Masonry_Stone_RockMaterials_03_Trim: DM_Masonry_Stone_RockMaterials_03_Trim,
  Masonry_Stone_RockMaterials_03_Trim_V: DM_Masonry_Stone_RockMaterials_03_Trim_V,
  Masonry_Stone_RockMaterials_05_Trim: DM_Masonry_Stone_RockMaterials_05_Trim,
  Masonry_Stone_RockMaterials_05_Trim_V: DM_Masonry_Stone_RockMaterials_05_Trim_V,
  Masonry_Stone_RockMaterials_12_Trim: DM_Masonry_Stone_RockMaterials_12_Trim,
  Masonry_Stone_RockMaterials_12_Trim_V: DM_Masonry_Stone_RockMaterials_12_Trim_V,
  Masonry_Stone_RockMaterials_24_Trim: DM_Masonry_Stone_RockMaterials_24_Trim,
  Masonry_Stone_RockMaterials_24_Trim_V: DM_Masonry_Stone_RockMaterials_24_Trim_V,
  Masonry_Stone_RockMaterials_Sawn: DM_Masonry_Stone_RockMaterials_Sawn,
  Masonry_Stone_RoughAshlar: DM_Masonry_Stone_RoughAshlar,
  Masonry_Stone_SCM_3_5Ledgestone: DM_Masonry_Stone_SCM_3_5Ledgestone,
  Masonry_Stone_SCM_CastleStone: DM_Masonry_Stone_SCM_CastleStone,
  Masonry_Stone_SCM_EuropeanCastle: DM_Masonry_Stone_SCM_EuropeanCastle,
  Masonry_Stone_SCM_EuropeanCobble: DM_Masonry_Stone_SCM_EuropeanCobble,
  Masonry_Stone_SCM_Hackett: DM_Masonry_Stone_SCM_Hackett,
  Masonry_Stone_SCM_KCBlend: DM_Masonry_Stone_SCM_KCBlend,
  Masonry_Stone_SCM_Ledgestone: DM_Masonry_Stone_SCM_Ledgestone,
  Masonry_Stone_SCM_LimeStackMix: DM_Masonry_Stone_SCM_LimeStackMix,
  Masonry_Stone_SCM_Limestone: DM_Masonry_Stone_SCM_Limestone,
  Masonry_Stone_SCM_MidwestQuickfit: DM_Masonry_Stone_SCM_MidwestQuickfit,
  Masonry_Stone_SCM_MountainRubble: DM_Masonry_Stone_SCM_MountainRubble,
  Masonry_Stone_SCM_Quickfit: DM_Masonry_Stone_SCM_Quickfit,
  Masonry_Stone_SCM_RomanCastle: DM_Masonry_Stone_SCM_RomanCastle,
  Masonry_Stone_SCM_SawtoothLedge: DM_Masonry_Stone_SCM_SawtoothLedge,
  Masonry_Stone_SCM_SouthernLedge: DM_Masonry_Stone_SCM_SouthernLedge,
  Masonry_Stone_SCM_StackHackett: DM_Masonry_Stone_SCM_StackHackett,
  Masonry_Stone_SCM_StackStone: DM_Masonry_Stone_SCM_StackStone,
  Masonry_Stone_SCM_ThinkBrick: DM_Masonry_Stone_SCM_ThinkBrick,
  Masonry_Stone_Sabbie_NereGrezzo: DM_Masonry_Stone_Sabbie_NereGrezzo,
  Masonry_Stone_Sabbie_NereGrezzo_Trim: DM_Masonry_Stone_Sabbie_NereGrezzo_Trim,
  Masonry_Stone_Sabbie_NereGrezzo_Trim_V: DM_Masonry_Stone_Sabbie_NereGrezzo_Trim_V,
  Masonry_Stone_StackLedge: DM_Masonry_Stone_StackLedge,
  Masonry_Stone_Stonecraft_Ledgestone: DM_Masonry_Stone_Stonecraft_Ledgestone,
  Masonry_Stone_TerraCut_03_Trim: DM_Masonry_Stone_TerraCut_03_Trim,
  Masonry_Stone_TerraCut_03_Trim_V: DM_Masonry_Stone_TerraCut_03_Trim_V,
  Masonry_Stone_TerraCut_05_Trim: DM_Masonry_Stone_TerraCut_05_Trim,
  Masonry_Stone_TerraCut_05_Trim_V: DM_Masonry_Stone_TerraCut_05_Trim_V,
  Masonry_Stone_TerraCut_12_Trim: DM_Masonry_Stone_TerraCut_12_Trim,
  Masonry_Stone_TerraCut_12_Trim_V: DM_Masonry_Stone_TerraCut_12_Trim_V,
  Masonry_Stone_TerraCut_24_Trim: DM_Masonry_Stone_TerraCut_24_Trim,
  Masonry_Stone_TerraCut_24_Trim_V: DM_Masonry_Stone_TerraCut_24_Trim_V,
  Masonry_Stone_Vener_Cobblestone: DM_Masonry_Stone_Vener_Cobblestone,
  Masonry_Stone_Vener_Cobblestone_03_Trim: DM_Masonry_Stone_Vener_Cobblestone_03_Trim,
  Masonry_Stone_Vener_Cobblestone_03_Trim_V: DM_Masonry_Stone_Vener_Cobblestone_03_Trim_V,
  Masonry_Stone_Vener_Cobblestone_05_Trim: DM_Masonry_Stone_Vener_Cobblestone_05_Trim,
  Masonry_Stone_Vener_Cobblestone_05_Trim_V: DM_Masonry_Stone_Vener_Cobblestone_05_Trim_V,
  Masonry_Stone_Vener_Cobblestone_12_Trim: DM_Masonry_Stone_Vener_Cobblestone_12_Trim,
  Masonry_Stone_Vener_Cobblestone_12_Trim_V: DM_Masonry_Stone_Vener_Cobblestone_12_Trim_V,
  Masonry_Stone_Vener_Cobblestone_24_Trim: DM_Masonry_Stone_Vener_Cobblestone_24_Trim,
  Masonry_Stone_Vener_Cobblestone_24_Trim_V: DM_Masonry_Stone_Vener_Cobblestone_24_Trim_V,
  Masonry_Stone_Vener_Cobblestone_SolidTrim: DM_Masonry_Stone_Vener_Cobblestone_SolidTrim,
  Masonry_Stone_Versetta_Ledgestone: DM_Masonry_Stone_Versetta_Ledgestone,
  Masonry_Stone_Weatherledge: DM_Masonry_Stone_Weatherledge,
  Masonry_Stone_Weatherledge_03_Trim: DM_Masonry_Stone_Weatherledge_03_Trim,
  Masonry_Stone_Weatherledge_03_Trim_V: DM_Masonry_Stone_Weatherledge_03_Trim_V,
  Masonry_Stone_Weatherledge_05_Trim: DM_Masonry_Stone_Weatherledge_05_Trim,
  Masonry_Stone_Weatherledge_05_Trim_V: DM_Masonry_Stone_Weatherledge_05_Trim_V,
  Masonry_Stone_Weatherledge_08_Trim: DM_Masonry_Stone_Weatherledge_08_Trim,
  Masonry_Stone_Weatherledge_08_Trim_V: DM_Masonry_Stone_Weatherledge_08_Trim_V,
  Masonry_Stone_Weatherledge_12_Trim: DM_Masonry_Stone_Weatherledge_12_Trim,
  Masonry_Stone_Weatherledge_12_Trim_V: DM_Masonry_Stone_Weatherledge_12_Trim_V,
  Masonry_Stone_Weatherledge_24_Trim: DM_Masonry_Stone_Weatherledge_24_Trim,
  Masonry_Stone_Weatherledge_24_Trim_V: DM_Masonry_Stone_Weatherledge_24_Trim_V,
  Masonry_Stone_Weatherledge_OLD: DM_Masonry_Stone_Weatherledge_OLD,
  Metal_Galvanized_01: DM_Metal_Galvanized_01,
  Metal_Grate: DM_Metal_Grate,
  Metal_Powder: DM_Metal_Powder,
  Metal_Screen: DM_Metal_Screen,
  Metal_Screen_Black: DM_Metal_Screen_Black,
  OUTDATED_MATERIAL: DM_OUTDATED_MATERIAL,
  Paint_Egg: DM_Paint_Egg,
  Paint_Flat: DM_Paint_Flat,
  Paint_Gloss: DM_Paint_Gloss,
  Paint_Satin: DM_Paint_Satin,
  Paint_SemiGloss: DM_Paint_SemiGloss,
  Patio_Stone_01: DM_Patio_Stone_01,
  Paver_Tpattern_6x6_6x9: DM_Paver_Tpattern_6x6_6x9,
  Prop_BlackGlass: DM_Prop_BlackGlass,
  RoofTile_Capistrano: DM_RoofTile_Capistrano,
  RoofTile_Elabana: DM_RoofTile_Elabana,
  RoofTile_Slate: DM_RoofTile_Slate,
  RoofTrim_AsphaltShingle: DM_RoofTrim_AsphaltShingle,
  RoofTrim_StandingSeam: DM_RoofTrim_StandingSeam,
  Roof_Asphalt: DM_Roof_Asphalt,
  Roof_Asphalt3Tab: DM_Roof_Asphalt3Tab,
  Roof_AsphaltBelmont: DM_Roof_AsphaltBelmont,
  Roof_AsphaltCarriageHouse: DM_Roof_AsphaltCarriageHouse,
  Roof_AsphaltGrandManor: DM_Roof_AsphaltGrandManor,
  Roof_AsphaltHighlandSlate: DM_Roof_AsphaltHighlandSlate,
  Roof_AsphaltShake: DM_Roof_AsphaltShake,
  Roof_AsphaltShakeStraight: DM_Roof_AsphaltShakeStraight,
  Roof_MetalShakeStraight12: DM_Roof_MetalShakeStraight12,
  Roof_Rubber: DM_Roof_Rubber,
  Roof_StandingSeam12: DM_Roof_StandingSeam12,
  Roof_StandingSeam14: DM_Roof_StandingSeam14,
  Roof_StandingSeam15: DM_Roof_StandingSeam15,
  Roof_StandingSeam16: DM_Roof_StandingSeam16,
  Roof_StandingSeam18: DM_Roof_StandingSeam18,
  Roof_StandingSeam24: DM_Roof_StandingSeam24,
  Roof_StandingSeamIR: DM_Roof_StandingSeamIR,
  Roof_StandingSeamPBU_Galvanized: DM_Roof_StandingSeamPBU_Galvanized,
  Roof_WoodShake_10x10: DM_Roof_WoodShake_10x10,
  Roof_WoodShake_10xVariable: DM_Roof_WoodShake_10xVariable,
  Shutter: DM_Shutter,
  Soffit_Slat: DM_Soffit_Slat,
  SolarPanel_6x6: DM_SolarPanel_6x6,
  Stain_Flat: DM_Stain_Flat,
  Stone_BlancoBuilders: DM_Stone_BlancoBuilders,
  Stone_RattlesnakeBuilders: DM_Stone_RattlesnakeBuilders,
  Stone_SunflowerChop: DM_Stone_SunflowerChop,
  Stone_TexasMix: DM_Stone_TexasMix,
  Stone_TumbleweedTan: DM_Stone_TumbleweedTan,
  TileBath_4x12: DM_TileBath_4x12,
  Tile_12x12: DM_Tile_12x12,
  Tile_17x17: DM_Tile_17x17,
  Tree_Bark_Generic: DM_Tree_Bark_Generic,
  Tree_Foliage_Generic: DM_Tree_Foliage_Generic,
  Wall_Board48x120_Battens02h: DM_Wall_Board48x120_Battens02h,
  Wall_BoardBatten01hx06q: DM_Wall_BoardBatten01hx06q,
  Wall_BoardBatten01hx07: DM_Wall_BoardBatten01hx07,
  Wall_BoardBatten01hx08: DM_Wall_BoardBatten01hx08,
  Wall_BoardBatten01hx12: DM_Wall_BoardBatten01hx12,
  Wall_BoardBatten01hx16: DM_Wall_BoardBatten01hx16,
  Wall_BoardBatten01hx20: DM_Wall_BoardBatten01hx20,
  Wall_BoardBatten01hx24: DM_Wall_BoardBatten01hx24,
  Wall_BoardBatten01hx36: DM_Wall_BoardBatten01hx36,
  Wall_BoardBatten01hx48: DM_Wall_BoardBatten01hx48,
  Wall_BoardBatten01x07: DM_Wall_BoardBatten01x07,
  Wall_BoardBatten01x08: DM_Wall_BoardBatten01x08,
  Wall_BoardBatten01x12: DM_Wall_BoardBatten01x12,
  Wall_BoardBatten01x16: DM_Wall_BoardBatten01x16,
  Wall_BoardBatten01x20: DM_Wall_BoardBatten01x20,
  Wall_BoardBatten01x24: DM_Wall_BoardBatten01x24,
  Wall_BoardBatten01x36: DM_Wall_BoardBatten01x36,
  Wall_BoardBatten01x48: DM_Wall_BoardBatten01x48,
  Wall_BoardBatten02hx07: DM_Wall_BoardBatten02hx07,
  Wall_BoardBatten02hx08: DM_Wall_BoardBatten02hx08,
  Wall_BoardBatten02hx09: DM_Wall_BoardBatten02hx09,
  Wall_BoardBatten02hx12: DM_Wall_BoardBatten02hx12,
  Wall_BoardBatten02hx16: DM_Wall_BoardBatten02hx16,
  Wall_BoardBatten02hx16_Grain: DM_Wall_BoardBatten02hx16_Grain,
  Wall_BoardBatten02hx20: DM_Wall_BoardBatten02hx20,
  Wall_BoardBatten02hx24: DM_Wall_BoardBatten02hx24,
  Wall_BoardBatten02hx36: DM_Wall_BoardBatten02hx36,
  Wall_BoardBatten02hx48: DM_Wall_BoardBatten02hx48,
  Wall_BoardBatten02x07: DM_Wall_BoardBatten02x07,
  Wall_BoardBatten02x08: DM_Wall_BoardBatten02x08,
  Wall_BoardBatten02x12: DM_Wall_BoardBatten02x12,
  Wall_BoardBatten02x16: DM_Wall_BoardBatten02x16,
  Wall_BoardBatten02x16_Grain: DM_Wall_BoardBatten02x16_Grain,
  Wall_BoardBatten02x20: DM_Wall_BoardBatten02x20,
  Wall_BoardBatten02x24: DM_Wall_BoardBatten02x24,
  Wall_BoardBatten02x36: DM_Wall_BoardBatten02x36,
  Wall_BoardBatten02x48: DM_Wall_BoardBatten02x48,
  Wall_BoardBatten03hx07: DM_Wall_BoardBatten03hx07,
  Wall_BoardBatten03hx08: DM_Wall_BoardBatten03hx08,
  Wall_BoardBatten03hx12: DM_Wall_BoardBatten03hx12,
  Wall_BoardBatten03hx16: DM_Wall_BoardBatten03hx16,
  Wall_BoardBatten03hx20: DM_Wall_BoardBatten03hx20,
  Wall_BoardBatten03hx24: DM_Wall_BoardBatten03hx24,
  Wall_BoardBatten03hx36: DM_Wall_BoardBatten03hx36,
  Wall_BoardBatten03hx48: DM_Wall_BoardBatten03hx48,
  Wall_BoardBatten03x07: DM_Wall_BoardBatten03x07,
  Wall_BoardBatten03x08: DM_Wall_BoardBatten03x08,
  Wall_BoardBatten03x12: DM_Wall_BoardBatten03x12,
  Wall_BoardBatten03x16: DM_Wall_BoardBatten03x16,
  Wall_BoardBatten03x20: DM_Wall_BoardBatten03x20,
  Wall_BoardBatten03x24: DM_Wall_BoardBatten03x24,
  Wall_BoardBatten03x36: DM_Wall_BoardBatten03x36,
  Wall_BoardBatten03x48: DM_Wall_BoardBatten03x48,
  Wall_BoardBatten04hx07: DM_Wall_BoardBatten04hx07,
  Wall_BoardBatten04hx08: DM_Wall_BoardBatten04hx08,
  Wall_BoardBatten04hx12: DM_Wall_BoardBatten04hx12,
  Wall_BoardBatten04hx16: DM_Wall_BoardBatten04hx16,
  Wall_BoardBatten04hx20: DM_Wall_BoardBatten04hx20,
  Wall_BoardBatten04hx24: DM_Wall_BoardBatten04hx24,
  Wall_BoardBatten04hx36: DM_Wall_BoardBatten04hx36,
  Wall_BoardBatten04hx48: DM_Wall_BoardBatten04hx48,
  Wall_BoardBatten04x07: DM_Wall_BoardBatten04x07,
  Wall_BoardBatten04x08: DM_Wall_BoardBatten04x08,
  Wall_BoardBatten04x12: DM_Wall_BoardBatten04x12,
  Wall_BoardBatten04x16: DM_Wall_BoardBatten04x16,
  Wall_BoardBatten04x20: DM_Wall_BoardBatten04x20,
  Wall_BoardBatten04x24: DM_Wall_BoardBatten04x24,
  Wall_BoardBatten04x36: DM_Wall_BoardBatten04x36,
  Wall_BoardBatten04x48: DM_Wall_BoardBatten04x48,
  Wall_BoardBatten05hx07: DM_Wall_BoardBatten05hx07,
  Wall_BoardBatten05hx08: DM_Wall_BoardBatten05hx08,
  Wall_BoardBatten05hx12: DM_Wall_BoardBatten05hx12,
  Wall_BoardBatten05hx16: DM_Wall_BoardBatten05hx16,
  Wall_BoardBatten05hx20: DM_Wall_BoardBatten05hx20,
  Wall_BoardBatten05hx24: DM_Wall_BoardBatten05hx24,
  Wall_BoardBatten05hx36: DM_Wall_BoardBatten05hx36,
  Wall_BoardBatten05hx48: DM_Wall_BoardBatten05hx48,
  Wall_BoardBatten05x07: DM_Wall_BoardBatten05x07,
  Wall_BoardBatten05x08: DM_Wall_BoardBatten05x08,
  Wall_BoardBatten05x12: DM_Wall_BoardBatten05x12,
  Wall_BoardBatten05x16: DM_Wall_BoardBatten05x16,
  Wall_BoardBatten05x20: DM_Wall_BoardBatten05x20,
  Wall_BoardBatten05x24: DM_Wall_BoardBatten05x24,
  Wall_BoardBatten05x36: DM_Wall_BoardBatten05x36,
  Wall_BoardBatten05x48: DM_Wall_BoardBatten05x48,
  Wall_BoardBatten06hx07: DM_Wall_BoardBatten06hx07,
  Wall_BoardBatten06hx08: DM_Wall_BoardBatten06hx08,
  Wall_BoardBatten06hx12: DM_Wall_BoardBatten06hx12,
  Wall_BoardBatten06hx16: DM_Wall_BoardBatten06hx16,
  Wall_BoardBatten06hx20: DM_Wall_BoardBatten06hx20,
  Wall_BoardBatten06hx24: DM_Wall_BoardBatten06hx24,
  Wall_BoardBatten06hx36: DM_Wall_BoardBatten06hx36,
  Wall_BoardBatten06hx48: DM_Wall_BoardBatten06hx48,
  Wall_BoardBatten06x07: DM_Wall_BoardBatten06x07,
  Wall_BoardBatten06x08: DM_Wall_BoardBatten06x08,
  Wall_BoardBatten06x12: DM_Wall_BoardBatten06x12,
  Wall_BoardBatten06x16: DM_Wall_BoardBatten06x16,
  Wall_BoardBatten06x20: DM_Wall_BoardBatten06x20,
  Wall_BoardBatten06x24: DM_Wall_BoardBatten06x24,
  Wall_BoardBatten06x36: DM_Wall_BoardBatten06x36,
  Wall_BoardBatten06x48: DM_Wall_BoardBatten06x48,
  Wall_BoardLap02: DM_Wall_BoardLap02,
  Wall_BoardLap02_Grain: DM_Wall_BoardLap02_Grain,
  Wall_BoardLap03: DM_Wall_BoardLap03,
  Wall_BoardLap03_Grain: DM_Wall_BoardLap03_Grain,
  Wall_BoardLap04: DM_Wall_BoardLap04,
  Wall_BoardLap04_Grain: DM_Wall_BoardLap04_Grain,
  Wall_BoardLap04h: DM_Wall_BoardLap04h,
  Wall_BoardLap04h_Dutch: DM_Wall_BoardLap04h_Dutch,
  Wall_BoardLap05: DM_Wall_BoardLap05,
  Wall_BoardLap05_Grain: DM_Wall_BoardLap05_Grain,
  Wall_BoardLap06: DM_Wall_BoardLap06,
  Wall_BoardLap06_Gap01h: DM_Wall_BoardLap06_Gap01h,
  Wall_BoardLap06_Grain: DM_Wall_BoardLap06_Grain,
  Wall_BoardLap07: DM_Wall_BoardLap07,
  Wall_BoardLap07_Grain: DM_Wall_BoardLap07_Grain,
  Wall_BoardLap08: DM_Wall_BoardLap08,
  Wall_BoardLap08_Grain: DM_Wall_BoardLap08_Grain,
  Wall_BoardLap10: DM_Wall_BoardLap10,
  Wall_BoardLap10_Grain: DM_Wall_BoardLap10_Grain,
  Wall_BoardLap12: DM_Wall_BoardLap12,
  Wall_BoardLap12_Grain: DM_Wall_BoardLap12_Grain,
  Wall_BoardLapAlternating04x07: DM_Wall_BoardLapAlternating04x07,
  Wall_BoardLapAlternating05x08: DM_Wall_BoardLapAlternating05x08,
  Wall_HorizontalBoard02_01hx48vertical: DM_Wall_HorizontalBoard02_01hx48vertical,
  Wall_HorizontalBoard04: DM_Wall_HorizontalBoard04,
  Wall_HorizontalBoard04_Grain: DM_Wall_HorizontalBoard04_Grain,
  Wall_HorizontalBoard05: DM_Wall_HorizontalBoard05,
  Wall_HorizontalBoard05_Grain: DM_Wall_HorizontalBoard05_Grain,
  Wall_HorizontalBoard05h_Grain: DM_Wall_HorizontalBoard05h_Grain,
  Wall_HorizontalBoard06: DM_Wall_HorizontalBoard06,
  Wall_HorizontalBoard06_Grain: DM_Wall_HorizontalBoard06_Grain,
  Wall_HorizontalBoard07: DM_Wall_HorizontalBoard07,
  Wall_HorizontalBoard07_Grain: DM_Wall_HorizontalBoard07_Grain,
  Wall_HorizontalBoard08: DM_Wall_HorizontalBoard08,
  Wall_HorizontalBoard08_Angle45L: DM_Wall_HorizontalBoard08_Angle45L,
  Wall_HorizontalBoard08_Angle45R: DM_Wall_HorizontalBoard08_Angle45R,
  Wall_HorizontalBoard08_Grain: DM_Wall_HorizontalBoard08_Grain,
  Wall_PanelBoard_48x24: DM_Wall_PanelBoard_48x24,
  Wall_PanelBoard_V_48: DM_Wall_PanelBoard_V_48,
  Wall_ReverseBatten05hx01: DM_Wall_ReverseBatten05hx01,
  Wall_ScaleShingle07: DM_Wall_ScaleShingle07,
  Wall_ShakeShingle06: DM_Wall_ShakeShingle06,
  Wall_ShakeShingle07: DM_Wall_ShakeShingle07,
  Wall_ShakeShingle09: DM_Wall_ShakeShingle09,
  Wall_ShakeShingleStraight05: DM_Wall_ShakeShingleStraight05,
  Wall_ShakeShingleStraight06: DM_Wall_ShakeShingleStraight06,
  Wall_ShakeShingleStraight07: DM_Wall_ShakeShingleStraight07,
  Wall_StaggerBoard05: DM_Wall_StaggerBoard05,
  Wall_Stucco: DM_Wall_Stucco,
  Wall_StuccoFine: DM_Wall_StuccoFine,
  Wall_StuccoScored04: DM_Wall_StuccoScored04,
  Wall_StuccoScored06: DM_Wall_StuccoScored06,
  Wall_StuccoScored07: DM_Wall_StuccoScored07,
  Wall_StuccoScored08: DM_Wall_StuccoScored08,
  Wall_StuccoScored10: DM_Wall_StuccoScored10,
  Wall_StuccoScored12: DM_Wall_StuccoScored12,
  Wall_StuccoScored14: DM_Wall_StuccoScored14,
  Wall_StuccoScored16: DM_Wall_StuccoScored16,
  Wall_StuccoScored18: DM_Wall_StuccoScored18,
  Wall_StuccoScored20: DM_Wall_StuccoScored20,
  Wall_StuccoScored22: DM_Wall_StuccoScored22,
  Wall_StuccoScored24: DM_Wall_StuccoScored24,
  Wall_Tile: DM_Wall_Tile,
  Wall_Tile06x12_Carrara: DM_Wall_Tile06x12_Carrara,
  Wall_VerticalBoard02: DM_Wall_VerticalBoard02,
  Wall_VerticalBoard02_Grain: DM_Wall_VerticalBoard02_Grain,
  Wall_VerticalBoard03: DM_Wall_VerticalBoard03,
  Wall_VerticalBoard03_Grain: DM_Wall_VerticalBoard03_Grain,
  Wall_VerticalBoard04: DM_Wall_VerticalBoard04,
  Wall_VerticalBoard04_Grain: DM_Wall_VerticalBoard04_Grain,
  Wall_VerticalBoard05: DM_Wall_VerticalBoard05,
  Wall_VerticalBoard05H: DM_Wall_VerticalBoard05H,
  Wall_VerticalBoard05H_Grain: DM_Wall_VerticalBoard05H_Grain,
  Wall_VerticalBoard05_Grain: DM_Wall_VerticalBoard05_Grain,
  Wall_VerticalBoard06: DM_Wall_VerticalBoard06,
  Wall_VerticalBoard06_Beaded01h: DM_Wall_VerticalBoard06_Beaded01h,
  Wall_VerticalBoard06_Grain: DM_Wall_VerticalBoard06_Grain,
  Wall_VerticalBoard08: DM_Wall_VerticalBoard08,
  Wall_VerticalBoard08_Grain: DM_Wall_VerticalBoard08_Grain,
  Window: DM_Window,
  Wood_Generic: DM_Wood_Generic,
  Wood_Generic_V: DM_Wood_Generic_V,
  Wood_HorizontalPlank: DM_Wood_HorizontalPlank,
  Wood_Sheathing96x48: DM_Wood_Sheathing96x48,
  Wood_StaggeredPlank: DM_Wood_StaggeredPlank,
  X_CheckerTest: DM_X_CheckerTest,
  X_FrostedGlass: DM_X_FrostedGlass,
  X_PerfTest01: DM_X_PerfTest01,
  X_ReflectionTest01: DM_X_ReflectionTest01,
};
